// ===== firebase-init.jsx =====
(function(){
// Firebase initialization for Precision Cabinets LLC
// Uses compat SDK loaded via CDN in index.html

const firebaseConfig = {
  apiKey: "AIzaSyCirHKSvnpvWd9Kx4Ox2ceG4AfM0sgAt54",
  authDomain: "precision-cabinets-llc.firebaseapp.com",
  projectId: "precision-cabinets-llc",
  storageBucket: "precision-cabinets-llc.firebasestorage.app",
  messagingSenderId: "883508520152",
  appId: "1:883508520152:web:bcd58ba64177fa510223ad",
};

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

// Enable Firestore persistence for offline support
db.enablePersistence({ synchronizeTabs: true }).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Firestore persistence unavailable: multiple tabs open');
  } else if (err.code === 'unimplemented') {
    console.warn('Firestore persistence not supported in this browser');
  }
});

// Helper: get current user's custom claims
async function getUserClaims() {
  const user = auth.currentUser;
  if (!user) return null;
  const token = await user.getIdTokenResult();
  return token.claims;
}

// Helper: check if user is a vendor
async function isVendorUser() {
  const claims = await getUserClaims();
  return claims && claims.role === 'vendor';
}

// Helper: check if user is an employee/admin
async function isEmployeeUser() {
  const claims = await getUserClaims();
  return claims && (claims.role === 'employee' || claims.role === 'admin');
}

// Helper: get the vendor ID from claims
async function getVendorId() {
  const claims = await getUserClaims();
  return claims ? claims.vendorId || null : null;
}

// Helper: call a Cloud Function
async function callFunction(name, data) {
  const fn = firebase.app().functions('us-central1');
  const callable = fn.httpsCallable(name);
  const result = await callable(data);
  return result.data;
}

// Helper: upload a file to Storage and return the download URL
async function uploadFile(path, file, onProgress) {
  const ref = storage.ref(path);
  const task = ref.put(file);

  return new Promise((resolve, reject) => {
    task.on('state_changed',
      (snap) => {
        if (onProgress) {
          onProgress(Math.round((snap.bytesTransferred / snap.totalBytes) * 100));
        }
      },
      reject,
      async () => {
        const url = await task.snapshot.ref.getDownloadURL();
        resolve(url);
      }
    );
  });
}

// Generate a draft ID for photo uploads before order submission
function generateDraftId() {
  return 'draft_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
}

Object.assign(window, {
  db, auth, storage,
  getUserClaims, isVendorUser, isEmployeeUser, getVendorId,
  callFunction, uploadFile, generateDraftId,
});

// Admin-controlled mobile debug HUD.
// The admin Danger Zone writes config/app.debugHud (public-read, admin-write).
// We mirror it to the on-device HUD live AND to localStorage, so the next boot
// starts in the right state and captures boot errors from the first paint.
// A ?pcdebug= URL override (window.__pcDebugForced) wins for the session, so we
// skip applying the remote flag in that case. The HUD (debug-hud.jsx) loads
// right after this file, so window.pcDebugHud is defined by the time this async
// snapshot first fires; we guard + fall back to localStorage just in case.
try {
  db.doc('config/app').onSnapshot(
    (snap) => {
      if (window.__pcDebugForced) return;
      const on = !!(snap && snap.exists && snap.data() && snap.data().debugHud);
      if (window.pcDebugHud && window.pcDebugHud.setEnabled) {
        window.pcDebugHud.setEnabled(on);
      } else {
        try { localStorage.setItem('pcDebugHud', on ? 'on' : 'off'); } catch { /* private mode */ }
      }
    },
    () => { /* offline / transient — ignore; HUD falls back to localStorage */ }
  );
} catch (e) { /* ignore */ }

})();

// ===== debug-hud.jsx =====
(function(){
// On-screen debug HUD for the vendor PWA.
//
// Captures runtime errors on-device so we can debug the mobile PWA without a
// USB console. Sources captured (ALWAYS, from boot):
//   1. window.onerror (uncaught errors) + resource-load failures (capture phase
//      catches <script>/<img>/<link> load errors that don't bubble — a common
//      "blank screen" cause)
//   2. unhandledrejection (promise / Firestore await failures)
//   3. console.error / console.warn passthrough
//   4. window.pcDebugLog(type, message, detail) — deliberate traces from app code
//
// VISIBILITY MODEL (2026-06-30):
//   - CAPTURE is always on so no error is ever missed, even while hidden.
//   - DISPLAY is OFF by default in production. It turns on via, in priority:
//       a) URL ?pcdebug=1 / ?pcdebug=0 — dev override, wins for the session
//       b) Admin toggle — config/app.debugHud in Firestore, applied live by
//          firebase-init via window.pcDebugHud.setEnabled() (also persisted)
//       c) localStorage 'pcDebugHud' = 'on' | 'off' — mirror of the above, read
//          at boot so an admin-enabled HUD is visible from the very first paint
//   - Default: hidden.
//
// Control API (window.pcDebugHud):
//   setEnabled(on, {persist, force})  enable()  disable()  toggle()
//   isEnabled()  show()  hide()  clear()  log(type, message, detail)
// Legacy aliases kept: window.pcDebugLog, pcDebugHudOff, pcDebugHudShow,
// pcDebugHudClear.
//
// Loaded early in the bundle (right after firebase-init, before any app code)
// so its listeners are armed before anything can throw.

(function () {
  // ---------- enabled-state resolution ----------
  function readLS() {
    try { return localStorage.getItem('pcDebugHud'); } catch { return null; }
  }
  function writeLS(v) {
    try { localStorage.setItem('pcDebugHud', v); } catch { /* private mode */ }
  }

  // A ?pcdebug= URL param forces a state for the session and wins over the
  // remote admin flag (so a dev can always force the HUD on/off on a device).
  let forced = false;
  let enabled = false;
  try {
    const qs = new URLSearchParams(location.search);
    if (qs.has('pcdebug')) {
      const raw = (qs.get('pcdebug') || '').toLowerCase();
      enabled = raw === '' || raw === '1' || raw === 'true' || raw === 'on';
      forced = true;
      writeLS(enabled ? 'on' : 'off');
    } else {
      enabled = readLS() === 'on'; // default OFF in production
    }
  } catch { enabled = false; }
  window.__pcDebugForced = forced;

  // ---------- event buffers ----------
  // Two buffers so a flood of trace/state events can't evict real errors:
  //   errors[] — error-type events only, retained
  //   trace[]  — everything, rolling timeline for the expand view
  const errors = [];
  const trace = [];
  const ERR_MAX = 25;
  const TRACE_MAX = 60;
  const ERROR_RE = /error|fail|denied|reject|exception|throw/i;

  function record(type, message, detail) {
    const entry = {
      type: String(type || 'log'),
      message: String(message == null ? '' : message).slice(0, 1000),
      detail: detail ? String(detail).slice(0, 4000) : '',
      at: new Date(),
      isError: ERROR_RE.test(String(type || '')),
    };
    trace.push(entry);
    if (trace.length > TRACE_MAX) trace.shift();
    if (entry.isError) {
      errors.push(entry);
      if (errors.length > ERR_MAX) errors.shift();
    }
    render();
  }
  // Expose so app code can push errors/traces deliberately:
  //   window.pcDebugLog('submit', 'Firestore denied', err.message + '\n' + err.stack)
  window.pcDebugLog = record;

  // ---------- capture: always armed ----------
  function safeJson(o) { try { return JSON.stringify(o).slice(0, 1500); } catch { return String(o); } }
  function fmtArg(a) {
    if (a instanceof Error) return (a.message || a.name) + (a.stack ? '\n' + a.stack : '');
    if (a && typeof a === 'object') return safeJson(a);
    return String(a);
  }

  // Uncaught errors. Capture phase (true) also catches resource-load failures
  // (<script>/<img>/<link>) that don't bubble. iOS Safari strips message/stack
  // for cross-origin scripts without CORS — we still log filename:line:col.
  window.addEventListener('error', (ev) => {
    const tgt = ev.target;
    if (tgt && tgt !== window && (tgt.tagName === 'SCRIPT' || tgt.tagName === 'IMG' || tgt.tagName === 'LINK')) {
      record('resource.error', tgt.tagName.toLowerCase() + ' failed to load', tgt.src || tgt.href || '');
      return;
    }
    const m = ev.message || 'Script error (cross-origin strip)';
    const where = [ev.filename, ev.lineno, ev.colno].filter(Boolean).join(':');
    const stack = (ev.error && ev.error.stack) || where || '';
    record('window.error', m, stack);
  }, true);

  window.addEventListener('unhandledrejection', (ev) => {
    const r = ev.reason;
    // Firestore errors have `.code` (e.g. 'permission-denied') even when the
    // message is opaque; surface it explicitly.
    const code = r && r.code ? '[' + r.code + '] ' : '';
    const msg = code + ((r && r.message) || String(r));
    const stack = (r && r.stack) || (r ? safeJson(r) : '');
    record('unhandledrejection', msg, stack);
  });

  // console.error / console.warn passthrough — catches logged-but-not-thrown
  // failures. Guard against re-entrancy so our own render() errors can't loop.
  let inConsoleHook = false;
  ['error', 'warn'].forEach((level) => {
    const orig = typeof console[level] === 'function' ? console[level].bind(console) : null;
    console[level] = function () {
      if (!inConsoleHook) {
        inConsoleHook = true;
        try {
          const parts = Array.prototype.map.call(arguments, fmtArg);
          record('console.' + level, parts.join(' '), '');
        } catch { /* ignore */ } finally { inConsoleHook = false; }
      }
      if (orig) orig.apply(console, arguments);
    };
  });

  // ---------- DOM ----------
  let root, banner, msgEl, expandPane, listEl, expandBtn;
  let expanded = false;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function ensureDom() {
    if (root) return;
    root = document.createElement('div');
    root.id = 'pc-debug-hud';
    root.style.cssText = [
      'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:99999',
      'pointer-events:none', 'display:none',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
      'font-size:12px', 'line-height:1.35',
    ].join(';');

    banner = document.createElement('div');
    banner.style.cssText = [
      'background:#b91c1c', 'color:#fff', 'padding:6px 10px',
      'padding-top:calc(6px + env(safe-area-inset-top,0px))',
      'display:none', 'align-items:flex-start', 'gap:8px', 'pointer-events:auto',
      'box-shadow:0 2px 6px rgba(0,0,0,0.2)', 'word-break:break-word',
    ].join(';');

    msgEl = document.createElement('div');
    msgEl.style.cssText = 'flex:1;min-width:0';
    banner.appendChild(msgEl);

    expandBtn = mkBtn('▾', 'Expand', () => {
      expanded = !expanded;
      expandBtn.textContent = expanded ? '▴' : '▾';
      expandPane.style.display = expanded ? 'block' : 'none';
      if (expanded) renderList();
    });
    banner.appendChild(expandBtn);

    banner.appendChild(mkBtn('⧉', 'Copy all events', (btn) => {
      const all = trace.map((e) => `[${e.at.toISOString()}] ${e.type}: ${e.message}${e.detail ? '\n' + e.detail : ''}`).join('\n---\n');
      copyText(all, btn);
    }));

    banner.appendChild(mkBtn('×', 'Dismiss (re-enable from admin Danger Zone)', () => {
      banner.style.display = 'none';
      expandPane.style.display = 'none';
      expanded = false;
    }));

    expandPane = document.createElement('div');
    expandPane.style.cssText = [
      'background:rgba(0,0,0,0.92)', 'color:#fef2f2', 'padding:8px 10px',
      'max-height:60vh', 'overflow-y:auto', 'display:none', 'pointer-events:auto',
      'font-family:ui-monospace,"SFMono-Regular",Menlo,monospace',
      'font-size:11px', 'line-height:1.4',
    ].join(';');
    listEl = document.createElement('div');
    expandPane.appendChild(listEl);

    root.appendChild(banner);
    root.appendChild(expandPane);
    (document.body || document.documentElement).appendChild(root);
  }

  function mkBtn(label, title, onClick) {
    const b = document.createElement('button');
    b.type = 'button';
    b.textContent = label;
    b.title = title;
    b.style.cssText = 'background:rgba(255,255,255,0.15);color:#fff;border:0;border-radius:4px;padding:2px 8px;font-weight:600;cursor:pointer;flex-shrink:0';
    b.addEventListener('click', () => onClick(b));
    return b;
  }

  function copyText(text, btn) {
    const done = () => { if (btn) { btn.textContent = '✓'; setTimeout(() => { btn.textContent = '⧉'; }, 1500); } };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, () => fallback());
      } else { fallback(); }
    } catch { /* ignore */ }
    function fallback() {
      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.top = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      } catch { /* ignore */ }
    }
  }

  function render() {
    ensureDom();
    if (!enabled) { root.style.display = 'none'; return; }
    root.style.display = 'block';

    // Idle: enabled but nothing captured yet — confirm the HUD is live so the
    // admin/debugger isn't left wondering whether it's working.
    if (trace.length === 0) {
      msgEl.innerHTML = '<div style="font-weight:600">Debug HUD on</div>' +
        '<div style="font-size:10px;opacity:.8">Capturing errors · none yet</div>';
      banner.style.display = 'flex';
      return;
    }

    // Lead with the most recent real error (retained) if any, then show a short
    // tail of the timeline for context.
    const latestErr = errors.length ? errors[errors.length - 1] : null;
    const tail = trace.slice(-3);
    let html = '';
    if (latestErr) {
      html += '<div style="font-weight:700">⚠ ' + escapeHtml(latestErr.type) + ' · ' +
        latestErr.at.toLocaleTimeString() + '</div>' +
        '<div style="font-weight:600;margin-bottom:2px">' + escapeHtml(latestErr.message) + '</div>';
    }
    html += tail.map((e, i) => {
      const isLatest = i === tail.length - 1;
      return '<div style="' + (isLatest ? 'font-weight:600' : 'opacity:.7;font-size:11px') +
        ';margin-top:' + (i === 0 ? 0 : 3) + 'px">' +
        escapeHtml(e.type) + ' · ' + e.at.toLocaleTimeString() + ' — ' + escapeHtml(e.message) + '</div>';
    }).join('');
    const errCount = errors.length;
    html += '<div style="margin-top:4px;font-size:10px;opacity:.7">' +
      (errCount ? errCount + ' error' + (errCount === 1 ? '' : 's') + ' · ' : '') +
      'Tap ▾ for full trace · ⧉ to copy · × to dismiss</div>';
    msgEl.innerHTML = html;
    banner.style.display = 'flex';
    if (expanded) renderList();
  }

  function renderList() {
    if (!listEl) return;
    const section = (title, items, color) => {
      if (!items.length) return '';
      return '<div style="color:' + color + ';font-weight:700;margin:6px 0 2px;text-transform:uppercase;font-size:10px;letter-spacing:.04em">' + title + '</div>' +
        items.slice().reverse().map((e) => (
          '<div style="border-bottom:1px solid #4b5563;padding:6px 0">' +
          '<div style="color:#fca5a5;font-weight:600">' + escapeHtml(e.type) +
          ' <span style="color:#9ca3af;font-weight:400">' + e.at.toLocaleTimeString() + '</span></div>' +
          '<div>' + escapeHtml(e.message) + '</div>' +
          (e.detail ? '<pre style="margin:4px 0 0;white-space:pre-wrap;color:#fed7aa">' + escapeHtml(e.detail) + '</pre>' : '') +
          '</div>'
        )).join('');
    };
    listEl.innerHTML =
      section('Errors (' + errors.length + ')', errors, '#fca5a5') +
      section('Timeline (' + trace.length + ')', trace, '#93c5fd');
  }

  // ---------- control API ----------
  function setEnabled(on, opts) {
    const next = !!on;
    // A ?pcdebug= URL override wins for the session: ignore remote/admin
    // changes unless an explicit force is passed (manual console/legacy calls).
    if (forced && !(opts && opts.force)) return;
    enabled = next;
    if (!opts || opts.persist !== false) writeLS(enabled ? 'on' : 'off');
    if (!enabled) { hide(); } else { render(); }
  }
  function hide() { ensureDom(); root.style.display = 'none'; }
  function show() { render(); }

  window.pcDebugHud = {
    setEnabled,
    enable: (opts) => setEnabled(true, opts),
    disable: (opts) => setEnabled(false, opts),
    toggle: () => setEnabled(!enabled, { force: true }),
    isEnabled: () => enabled,
    show,
    hide,
    clear: () => { errors.length = 0; trace.length = 0; render(); },
    log: record,
  };

  // Legacy aliases (console / older app code).
  window.pcDebugHudOff = () => setEnabled(false, { force: true });
  window.pcDebugHudShow = () => setEnabled(true, { force: true });
  window.pcDebugHudClear = () => { errors.length = 0; trace.length = 0; render(); };

  // Reflect the initial resolved state (hidden by default in production).
  render();
})();

})();

// ===== tweaks-panel.jsx =====
(function(){

// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;width:100%;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;height:22px;
    border-radius:6px;cursor:default;padding:0}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  const setTweak = React.useCallback((key, val) => {
    setValues((prev) => ({ ...prev, [key]: val }));
    window.parent.postMessage({ type: '__edit_mode_set_keys', edits: { [key]: val } }, '*');
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({ title = 'Tweaks', children }) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({ x: 16, y: 16 });
  const PAD = 16;

  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth, h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y)),
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);

  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);

  React.useEffect(() => {
    const onMsg = (e) => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);
      else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({ type: '__edit_mode_available' }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);

  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({ type: '__edit_mode_dismissed' }, '*');
  };

  const onDragStart = (e) => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX, sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = (ev) => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy),
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };

  if (!open) return null;
  return (
    <>
      <style>{__TWEAKS_STYLE}</style>
      <div ref={dragRef} className="twk-panel"
           style={{ right: offsetRef.current.x, bottom: offsetRef.current.y }}>
        <div className="twk-hd" onMouseDown={onDragStart}>
          <b>{title}</b>
          <button className="twk-x" aria-label="Close tweaks"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={dismiss}>✕</button>
        </div>
        <div className="twk-body">{children}</div>
      </div>
    </>
  );
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({ label, children }) {
  return (
    <>
      <div className="twk-sect">{label}</div>
      {children}
    </>
  );
}

function TweakRow({ label, value, children, inline = false }) {
  return (
    <div className={inline ? 'twk-row twk-row-h' : 'twk-row'}>
      <div className="twk-lbl">
        <span>{label}</span>
        {value != null && <span className="twk-val">{value}</span>}
      </div>
      {children}
    </div>
  );
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({ label, value, min = 0, max = 100, step = 1, unit = '', onChange }) {
  return (
    <TweakRow label={label} value={`${value}${unit}`}>
      <input type="range" className="twk-slider" min={min} max={max} step={step}
             value={value} onChange={(e) => onChange(Number(e.target.value))} />
    </TweakRow>
  );
}

function TweakToggle({ label, value, onChange }) {
  return (
    <div className="twk-row twk-row-h">
      <div className="twk-lbl"><span>{label}</span></div>
      <button type="button" className="twk-toggle" data-on={value ? '1' : '0'}
              role="switch" aria-checked={!!value}
              onClick={() => onChange(!value)}><i /></button>
    </div>
  );
}

function TweakRadio({ label, value, options, onChange }) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  const opts = options.map((o) => (typeof o === 'object' ? o : { value: o, label: o }));
  const idx = Math.max(0, opts.findIndex((o) => o.value === value));
  const n = opts.length;

  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  const segAt = (clientX) => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor(((clientX - r.left - 2) / inner) * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };

  const onPointerDown = (e) => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = (ev) => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };

  return (
    <TweakRow label={label}>
      <div ref={trackRef} role="radiogroup" onPointerDown={onPointerDown}
           className={dragging ? 'twk-seg dragging' : 'twk-seg'}>
        <div className="twk-seg-thumb"
             style={{ left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
                      width: `calc((100% - 4px) / ${n})` }} />
        {opts.map((o) => (
          <button key={o.value} type="button" role="radio" aria-checked={o.value === value}>
            {o.label}
          </button>
        ))}
      </div>
    </TweakRow>
  );
}

function TweakSelect({ label, value, options, onChange }) {
  return (
    <TweakRow label={label}>
      <select className="twk-field" value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((o) => {
          const v = typeof o === 'object' ? o.value : o;
          const l = typeof o === 'object' ? o.label : o;
          return <option key={v} value={v}>{l}</option>;
        })}
      </select>
    </TweakRow>
  );
}

function TweakText({ label, value, placeholder, onChange }) {
  return (
    <TweakRow label={label}>
      <input className="twk-field" type="text" value={value} placeholder={placeholder}
             onChange={(e) => onChange(e.target.value)} />
    </TweakRow>
  );
}

function TweakNumber({ label, value, min, max, step = 1, unit = '', onChange }) {
  const clamp = (n) => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({ x: 0, val: 0 });
  const onScrubStart = (e) => {
    e.preventDefault();
    startRef.current = { x: e.clientX, val: value };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = (ev) => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return (
    <div className="twk-num">
      <span className="twk-num-lbl" onPointerDown={onScrubStart}>{label}</span>
      <input type="number" value={value} min={min} max={max} step={step}
             onChange={(e) => onChange(clamp(Number(e.target.value)))} />
      {unit && <span className="twk-num-unit">{unit}</span>}
    </div>
  );
}

function TweakColor({ label, value, onChange }) {
  return (
    <div className="twk-row twk-row-h">
      <div className="twk-lbl"><span>{label}</span></div>
      <input type="color" className="twk-swatch" value={value}
             onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}

function TweakButton({ label, onClick, secondary = false }) {
  return (
    <button type="button" className={secondary ? 'twk-btn secondary' : 'twk-btn'}
            onClick={onClick}>{label}</button>
  );
}

Object.assign(window, {
  useTweaks, TweaksPanel, TweakSection, TweakRow,
  TweakSlider, TweakToggle, TweakRadio, TweakSelect,
  TweakText, TweakNumber, TweakColor, TweakButton,
});

})();

// ===== icons.jsx =====
(function(){
// Shared icon set — minimal line icons
const Icon = {
  Camera: (p) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
      <circle cx="12" cy="13" r="4"/>
    </svg>
  ),
  Upload: (p) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  ),
  Plus: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...p}>
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  Minus: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...p}>
      <line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  X: (p) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...p}>
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  Check: (p) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  ArrowR: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
  ),
  ArrowL: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
    </svg>
  ),
  Pencil: (p) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4z"/>
    </svg>
  ),
  Pin: (p) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  Ruler: (p) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21.3 8.7l-6 6-4.3-4.3 6-6z"/>
      <path d="M3 21l12-12"/>
      <path d="M4.5 19.5l-1.5-1.5"/>
      <path d="M7.5 16.5l-1.5-1.5"/>
      <path d="M10.5 13.5l-1.5-1.5"/>
    </svg>
  ),
  Undo: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M3 7v6h6"/><path d="M3 13a9 9 0 1 0 3-7.7L3 8"/>
    </svg>
  ),
  Trash: (p) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polyline points="3 6 5 6 21 6"/>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    </svg>
  ),
  Printer: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polyline points="6 9 6 2 18 2 18 9"/>
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
      <rect x="6" y="14" width="12" height="8"/>
    </svg>
  ),
  Mail: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  Home: (p) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  ),
  Link: (p) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    </svg>
  ),
  LogOut: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <polyline points="16 17 21 12 16 7"/>
      <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
};

Object.assign(window, { Icon });

})();

// ===== bottom-sheet.jsx =====
(function(){
// BottomSheet — shared modal primitive for the Precision Cabinets vendor PWA.
//
// Slides up from the bottom on phones (.pc-bottom-sheet-backdrop aligns
// flex-end on mobile, center on desktop via the CSS in styles.css).
// Used to replace every native window.confirm/alert/prompt across the PWA,
// and to host any modal that should be a bottom-sheet on phones / centered
// card on desktop.
//
// Exports on window:
//   BottomSheet         — declarative React component
//   BottomSheetActions  — action-row wrapper (column-reverse on mobile)
//   bsConfirm({...})    — Promise<boolean>
//   bsAlert({...})      — Promise<void>
//   bsPrompt({...})     — Promise<string|null>
//
// Imperative helpers mount into a singleton div on document.body via
// ReactDOM.createRoot (matches the render call in app.jsx).

const { useState, useEffect, useRef, useCallback } = React;

// ---------------------------------------------------------------------------
// BottomSheet — declarative component.
// Props: { open, onClose, title?, children, hideClose? }
// Renders into document.body via React portal, locks body scroll while open,
// closes on backdrop click or Escape, returns null when !open.
// ---------------------------------------------------------------------------
function BottomSheet({ open, onClose, title, children, hideClose }) {
  const sheetRef = useRef(null);
  const dragStartY = useRef(null);
  const dragCurrentY = useRef(0);

  // Body scroll lock while open. Restore the previous value on close so we
  // don't trample app code that may set its own overflow.
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  // Escape key closes the sheet.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose && onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  // Backdrop click — only fire when the click target IS the backdrop, not a
  // child. Prevents accidental dismiss when releasing a drag inside the card.
  const onBackdropClick = useCallback((e) => {
    if (e.target === e.currentTarget) {
      onClose && onClose();
    }
  }, [onClose]);

  // Drag-to-dismiss (touch only). Threshold 100px.
  const onTouchStart = useCallback((e) => {
    const t = e.touches?.[0];
    if (!t) return;
    // Only initiate a drag from the top portion of the sheet — if the user
    // is touching deep inside scrollable content, let the scroll happen.
    const el = sheetRef.current;
    if (!el) return;
    if (el.scrollTop > 0) return;
    dragStartY.current = t.clientY;
    dragCurrentY.current = 0;
  }, []);

  const onTouchMove = useCallback((e) => {
    if (dragStartY.current == null) return;
    const t = e.touches?.[0];
    if (!t) return;
    const dy = t.clientY - dragStartY.current;
    if (dy <= 0) return; // only allow downward drag
    dragCurrentY.current = dy;
    const el = sheetRef.current;
    if (el) el.style.transform = `translateY(${dy}px)`;
  }, []);

  const onTouchEnd = useCallback(() => {
    if (dragStartY.current == null) return;
    const dy = dragCurrentY.current;
    const el = sheetRef.current;
    dragStartY.current = null;
    dragCurrentY.current = 0;
    if (el) el.style.transform = '';
    if (dy > 100) {
      onClose && onClose();
    }
  }, [onClose]);

  if (!open) return null;

  const sheet = (
    <div
      className="pc-bottom-sheet-backdrop"
      onClick={onBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-label={title || 'Dialog'}
    >
      <div
        ref={sheetRef}
        className="pc-bottom-sheet"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onTouchCancel={onTouchEnd}
      >
        {(title || !hideClose) && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 12,
              marginBottom: 12,
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: 18,
                fontWeight: 600,
                flex: 1,
                minWidth: 0,
              }}
            >
              {title || ''}
            </h3>
            {!hideClose && (
              <button
                type="button"
                className="btn ghost"
                aria-label="Close"
                onClick={() => onClose && onClose()}
                style={{
                  padding: '4px 10px',
                  fontSize: 22,
                  lineHeight: 1,
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                ×
              </button>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );

  return ReactDOM.createPortal(sheet, document.body);
}

// ---------------------------------------------------------------------------
// BottomSheetActions — wraps action buttons. On mobile we stack
// column-reverse so the primary CTA sits at the bottom (thumb reach). On
// desktop we use a row, primary on the right.
// ---------------------------------------------------------------------------
function BottomSheetActions({ children }) {
  // We can't reliably read CSS breakpoint state at render time without a
  // matchMedia listener. matchMedia is cheap, so we wire one up so the
  // component reacts to rotation / window resize.
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(min-width: 600px)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(min-width: 600px)');
    const onChange = (e) => setIsDesktop(e.matches);
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  const style = isDesktop
    ? {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        gap: 10,
        marginTop: 20,
      }
    : {
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: 10,
        marginTop: 20,
      };

  return <div className="pc-bottom-sheet-actions" style={style}>{children}</div>;
}

// ---------------------------------------------------------------------------
// Imperative helpers — bsConfirm / bsAlert / bsPrompt.
//
// We keep ONE singleton mount node + ONE createRoot on document.body. Each
// helper renders into the singleton root, awaits user interaction, then
// unmounts (renders null) so the next call is clean.
// ---------------------------------------------------------------------------

let _bsMountNode = null;
let _bsRoot = null;

function _ensureBsRoot() {
  if (_bsRoot && _bsMountNode && document.body.contains(_bsMountNode)) {
    return _bsRoot;
  }
  if (!_bsMountNode || !document.body.contains(_bsMountNode)) {
    _bsMountNode = document.createElement('div');
    _bsMountNode.setAttribute('data-bs-mount', '');
    document.body.appendChild(_bsMountNode);
  }
  if (ReactDOM.createRoot) {
    _bsRoot = ReactDOM.createRoot(_bsMountNode);
  } else {
    // Legacy fallback (React 17 / older). The PWA pins React 18 today but
    // keep the code resilient to a version downgrade.
    _bsRoot = {
      render: (el) => ReactDOM.render(el, _bsMountNode),
      unmount: () => ReactDOM.unmountComponentAtNode(_bsMountNode),
    };
  }
  return _bsRoot;
}

function _clearBsRoot() {
  if (!_bsRoot) return;
  try {
    _bsRoot.render(null);
  } catch (_) {
    // ignore — render(null) on createRoot is supported but cheap to swallow.
  }
}

// --- bsConfirm -------------------------------------------------------------
function bsConfirm({
  title = 'Confirm',
  body = '',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
} = {}) {
  return new Promise((resolve) => {
    const root = _ensureBsRoot();

    function ConfirmHost() {
      const [open, setOpen] = useState(true);

      const finish = (value) => {
        setOpen(false);
        // Tiny delay lets the close animation start before unmount.
        setTimeout(() => {
          _clearBsRoot();
          resolve(value);
        }, 0);
      };

      return (
        <BottomSheet open={open} onClose={() => finish(false)} title={title} hideClose>
          {body && (
            <div style={{ fontSize: 15, lineHeight: 1.5, color: 'var(--ink, #222)' }}>
              {typeof body === 'string' ? <p style={{ margin: 0 }}>{body}</p> : body}
            </div>
          )}
          <BottomSheetActions>
            <button
              type="button"
              className="btn ghost"
              onClick={() => finish(false)}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              className={danger ? 'btn danger' : 'btn primary'}
              onClick={() => finish(true)}
              autoFocus
            >
              {confirmLabel}
            </button>
          </BottomSheetActions>
        </BottomSheet>
      );
    }

    root.render(<ConfirmHost />);
  });
}

// --- bsAlert ---------------------------------------------------------------
function bsAlert({ title = 'Notice', body = '', okLabel = 'OK' } = {}) {
  return new Promise((resolve) => {
    const root = _ensureBsRoot();

    function AlertHost() {
      const [open, setOpen] = useState(true);

      const finish = () => {
        setOpen(false);
        setTimeout(() => {
          _clearBsRoot();
          resolve();
        }, 0);
      };

      return (
        <BottomSheet open={open} onClose={finish} title={title} hideClose>
          {body && (
            <div style={{ fontSize: 15, lineHeight: 1.5, color: 'var(--ink, #222)' }}>
              {typeof body === 'string' ? <p style={{ margin: 0 }}>{body}</p> : body}
            </div>
          )}
          <BottomSheetActions>
            <button
              type="button"
              className="btn primary"
              onClick={finish}
              autoFocus
            >
              {okLabel}
            </button>
          </BottomSheetActions>
        </BottomSheet>
      );
    }

    root.render(<AlertHost />);
  });
}

// --- bsPrompt --------------------------------------------------------------
function bsPrompt({
  title = 'Prompt',
  body = '',
  placeholder = '',
  defaultValue = '',
  inputMode = 'text',
  type = 'text',
} = {}) {
  return new Promise((resolve) => {
    const root = _ensureBsRoot();

    function PromptHost() {
      const [open, setOpen] = useState(true);
      const [value, setValue] = useState(defaultValue);
      const inputRef = useRef(null);

      useEffect(() => {
        // Focus the input after mount so the keyboard pops on phones.
        const t = setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
            // Select existing default so re-entering a value is one-tap.
            try { inputRef.current.select(); } catch (_) {}
          }
        }, 30);
        return () => clearTimeout(t);
      }, []);

      const finish = (result) => {
        setOpen(false);
        setTimeout(() => {
          _clearBsRoot();
          resolve(result);
        }, 0);
      };

      const onKey = (e) => {
        if (e.key === 'Enter' && type !== 'textarea') {
          e.preventDefault();
          finish(value);
        }
      };

      return (
        <BottomSheet open={open} onClose={() => finish(null)} title={title} hideClose>
          {body && (
            <div style={{ fontSize: 15, lineHeight: 1.5, color: 'var(--ink, #222)', marginBottom: 10 }}>
              {typeof body === 'string' ? <p style={{ margin: 0 }}>{body}</p> : body}
            </div>
          )}
          {type === 'textarea' ? (
            <textarea
              ref={inputRef}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              rows={4}
              className="input"
              style={{ width: '100%', resize: 'vertical', minHeight: 80, padding: 10 }}
            />
          ) : (
            <input
              ref={inputRef}
              type={type}
              inputMode={inputMode}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={onKey}
              placeholder={placeholder}
              className="input"
              style={{ width: '100%', padding: 10, fontSize: 16 }}
            />
          )}
          <BottomSheetActions>
            <button type="button" className="btn ghost" onClick={() => finish(null)}>
              Cancel
            </button>
            <button type="button" className="btn primary" onClick={() => finish(value)}>
              OK
            </button>
          </BottomSheetActions>
        </BottomSheet>
      );
    }

    root.render(<PromptHost />);
  });
}

// ---------------------------------------------------------------------------
// Phone-number input formatter.
//
// Vendors enter phones on iPhone where iOS numeric keypads do NOT auto-format,
// so we live-format to (xxx) xxx-xxxx as they type. Pasted values that include
// "+1" or country prefixes are stripped to the 10-digit US number; existing
// drafts with unformatted digits get cleaned up on first edit.
//
// formatPhoneInput(next):
//   - keeps only digits, drops a leading 1 (US country code),
//   - caps at 10 digits,
//   - re-renders as "", "(480)", "(480) 555", or "(480) 555-0142".
// Idempotent: feeding the formatted output back in returns the same string.
function formatPhoneInput(input) {
  if (input == null) return '';
  // Strip everything that isn't a digit.
  let digits = String(input).replace(/\D+/g, '');
  // Drop leading 1 country code when paired with a full 10-digit US number.
  if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
  digits = digits.slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return '(' + digits;
  if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
  return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
}

// ---------------------------------------------------------------------------
// Cabinet photo helpers — multi-photo per cabinet with single-photo
// back-compat.
//
// Schema as of 2026-06-17:
//   cab.photos      — array of { id, src, annotations: [], createdAt }
//   cab.photo       — LEGACY (string|null) — first capture in older drafts
//   cab.annotations — LEGACY array — annotations for cab.photo
//
// getCabinetPhotos(cab) returns a normalized array. It promotes a legacy
// single photo into a one-element list so every caller can iterate
// uniformly. Writers should use the new array form; readers should ONLY
// touch cab.photos via this helper so the legacy fields keep working
// across older drafts/orders that haven't been re-saved.
//
// MAX_PHOTOS_PER_CABINET — vendor-requested 15-photo cap (2026-06-18).
// PHOTO STORAGE (2026-06-18): photos are uploaded to Firebase Storage
// at capture time. The cabinet doc only carries the download URL — a
// few hundred bytes per photo — so the per-cabinet media doc is tiny
// and the 1MB Firestore cap is no longer in play. Resize for bandwidth
// only, not for doc-size headroom.
// LEGACY (pre-2026-06-18): photos shipped as inline base64 to a per-
// cabinet doc at orders/{id}/media/cab_{cabId} (split off the main
// stay under Firestore's 1MB ceiling). At 600px / q=0.65 each photo
// averages ~55KB; 15 × 55KB ≈ 825KB per cabinet — safely under the
// 1MB doc limit with headroom for metadata and annotations.
const MAX_PHOTOS_PER_CABINET = 15;

function _photoId() {
  return 'p_' + Math.random().toString(36).slice(2, 10) + '_' + (Date.now() % 1e7);
}

function getCabinetPhotos(cab) {
  if (!cab) return [];
  const arr = Array.isArray(cab.photos) ? cab.photos : [];
  if (arr.length > 0) return arr;
  // Legacy fallback — promote cab.photo into a one-element array on read.
  if (cab.photo) {
    return [{
      id: 'legacy',
      src: cab.photo,
      annotations: Array.isArray(cab.annotations) ? cab.annotations : [],
      createdAt: null,
    }];
  }
  return [];
}

// Returns a NEW cabinet object with the given photo appended to
// cab.photos. Mirrors the first photo into cab.photo / cab.annotations
// so legacy readers (review.jsx render path, insurance PDF) keep
// rendering even if they haven't been migrated.
//
// Accepts either a string (legacy: data URL or remote URL goes into
// .src) OR an object { src, storagePath } from a completed Storage
// upload. The object form lets callers carry the Storage path through
// so admin / submit code can reason about where the file lives.
function appendCabinetPhoto(cab, srcOrEntry) {
  const photos = getCabinetPhotos(cab).slice();
  const base = typeof srcOrEntry === 'string'
    ? { src: srcOrEntry }
    : (srcOrEntry || {});
  const entry = {
    id: _photoId(),
    annotations: [],
    createdAt: new Date().toISOString(),
    ...base,
  };
  photos.push(entry);
  return {
    ...cab,
    photos,
    photo: photos[0].src,
    annotations: photos[0].annotations || [],
    noPhotoChosen: false,
  };
}

// Upload a single resized JPEG data URL to Firebase Storage under the
// signed-in vendor contact's namespace. Returns { src, storagePath }
// where `src` is the download URL — caller stores this directly as the
// photo's src so all existing <img src={p.src}> code keeps working.
//
// Path: vendorUploads/{authUid}/cab_{cabId}/{photoId}.jpg
//   - Scoped by uid so Storage rules can enforce per-vendor write
//   - Per-cabinet folder so admin can browse + delete a cabinet's
//     photos cleanly
//   - Survives the submit boundary — no copy/move needed, the order
//     doc just stores the resulting download URL
async function uploadCabinetPhotoToStorage(dataUrl, cabId, photoId) {
  if (typeof firebase === 'undefined' || !firebase.storage) {
    throw new Error('Firebase Storage SDK not loaded');
  }
  const user = firebase.auth().currentUser;
  if (!user) throw new Error('Not signed in — cannot upload photo');
  const blob = await (await fetch(dataUrl)).blob();
  const storagePath = `vendorUploads/${user.uid}/cab_${cabId}/${photoId}.jpg`;
  const ref = firebase.storage().ref(storagePath);
  await ref.put(blob, { contentType: 'image/jpeg' });
  const downloadUrl = await ref.getDownloadURL();
  return { src: downloadUrl, storagePath };
}

// Bulk-append variant for multi-file uploads (gallery picker). Threads
// the cab object through each append so all new entries land in one
// onChange call — avoids stale-state issues that hit when you call
// appendCabinetPhoto N times synchronously.
function appendCabinetPhotos(cab, srcs) {
  if (!Array.isArray(srcs) || srcs.length === 0) return cab;
  let next = cab;
  for (const src of srcs) next = appendCabinetPhoto(next, src);
  return next;
}

function removeCabinetPhotoAt(cab, idx) {
  const photos = getCabinetPhotos(cab).slice();
  photos.splice(idx, 1);
  return {
    ...cab,
    photos,
    photo: photos[0]?.src || null,
    annotations: photos[0]?.annotations || [],
  };
}

function updateCabinetPhotoAnnotations(cab, idx, annotations) {
  const photos = getCabinetPhotos(cab).slice();
  if (!photos[idx]) return cab;
  photos[idx] = { ...photos[idx], annotations };
  return {
    ...cab,
    photos,
    // Keep legacy mirror in sync when it's the first photo.
    ...(idx === 0 ? { annotations } : {}),
  };
}

Object.assign(window, {
  BottomSheet, BottomSheetActions, bsConfirm, bsAlert, bsPrompt, formatPhoneInput,
  getCabinetPhotos, appendCabinetPhoto, appendCabinetPhotos, removeCabinetPhotoAt, updateCabinetPhotoAnnotations,
  uploadCabinetPhotoToStorage,
  MAX_PHOTOS_PER_CABINET,
});

})();

// ===== pricing.jsx =====
(function(){
// Pricing engine — linear-foot driven with side-panel exceptions
// All prices flow from these defaults; admin can edit them live.

const DEFAULT_PRICING = {
  // Core linear-foot rates
  linear_ft_rate:     { label: 'Standard linear foot rate',  unit: 'per lin. ft', price: 145, note: 'Covers face frames, doors, drawers, shelves, refinishing — the bulk of the work.' },
  toe_kick_rate:      { label: 'Toe kick',                   unit: 'per lin. ft', price: 38,  note: 'Toe kick fabrication & install per linear foot.' },

  // Per-side finished panels (the exception to the linear-ft model)
  side_panel_one:     { label: 'Finished side panel — single (L or R)', unit: 'per cabinet', price: 185, note: 'One finished end panel.' },
  side_panel_both:    { label: 'Finished side panels — both ends',      unit: 'per cabinet', price: 320, note: 'Both ends finished.' },

  // Surcharges. Rush is greater-of (flat $ or % of subtotal) per D9.
  // Both keys seed at 0 so no rush applies until admin configures.
  rush_upcharge_flat:  { label: 'Rush upcharge (flat)',     unit: 'flat',         price: 0, note: 'Flat $ added when the order is flagged RUSH. Final rush charge is max(flat, subtotal × pct).' },
  rush_upcharge_pct:   { label: 'Rush upcharge (%)',        unit: '% of subtotal', price: 0, note: 'Percent-of-subtotal alternative to the flat rush fee. Final rush charge is max(flat, subtotal × pct).' },
  island_surcharge_pct:{ label: 'Island / peninsula surcharge', unit: '% of cabinet line', price: 10, note: 'Applied per cabinet flagged Island or Peninsula.' },

  // Scribe — added at the end of the order
  scribe_matched:     { label: 'Scribe — matched material',  unit: 'per lin. ft', price: 18, note: 'Match the cabinet box material (cost mirrors order materials).' },
  scribe_unmatched:   { label: 'Scribe — cheapest material', unit: 'per lin. ft', price: 9,  note: 'Used when match-material is "No" — uses our cheapest stock.' },

  // Material multipliers — rebaselined per 5-29 enhancements so particle
  // board (the cheapest commodity option) = 1.0. Everything else scales
  // up from there. Existing live pricing docs in Firestore are NOT
  // updated by this default — admins re-tune in the cost builder.
  mat_particle:       { label: 'Particle board',    unit: 'multiplier', price: 1.00, note: 'Baseline.' },
  mat_mdf:            { label: 'MDF',               unit: 'multiplier', price: 1.07 },
  mat_melamine_white: { label: 'Melamine — white',  unit: 'multiplier', price: 1.13 },
  mat_melamine_wood:  { label: 'Melamine — wood-look', unit: 'multiplier', price: 1.20 },
  mat_birch:          { label: 'Birch plywood',     unit: 'multiplier', price: 1.33 },
  mat_oak:            { label: 'Oak plywood',       unit: 'multiplier', price: 1.44 },
  mat_maple_ply:      { label: 'Maple plywood',     unit: 'multiplier', price: 1.47 },
  mat_maple:          { label: 'Hardrock maple',    unit: 'multiplier', price: 1.57 },
  mat_cherry:         { label: 'Cherry plywood',    unit: 'multiplier', price: 1.63 },
  mat_walnut:         { label: 'Walnut plywood',    unit: 'multiplier', price: 1.73 },
  mat_other:          { label: 'Unknown / custom',  unit: 'multiplier', price: 1.33, note: 'Vendor-facing label is "Unknown". Used when box material isn\'t identified — defaults to baseline-ish (birch) until shop measures.' },

  // Flat fees
  trip_charge:        { label: 'Trip charge',  unit: 'flat', price: 95 },
  minimum_job:        { label: 'Minimum job',  unit: 'flat', price: 350 },
  tax_rate_pct:       { label: 'Tax rate',     unit: '% of subtotal', price: 0 },

  // ----- Service-type fees -----
  // Applied based on the vendor's intake answer (Step 2 in the wizard,
  // or the end-of-intake decision screen for "Potential" orders).
  pickup_flat:        { label: 'Pickup (flat fee, ≤25 mi)',  unit: 'flat', price: 150, note: 'Flat charge when Precision picks up cabinets within 25 miles. Charged once per order.' },
  dropoff_flat:       { label: 'Drop-off (flat fee, ≤25 mi)', unit: 'flat', price: 150, note: 'Flat charge for delivery to the jobsite within 25 miles. Charged once per order. Stacks with installation unless the "Installation includes drop-off" flag is set.' },
  install_per_cabinet:{ label: 'Installation per cabinet',   unit: 'per cabinet', price: 85, note: 'Per-cabinet labor for installing finished cabinets at the jobsite. Multiplied by the number of cabinets on the order.' },
  install_includes_dropoff: { label: 'Installation includes drop-off', unit: 'flag', price: 0, note: 'When 1, orders that include installation are NOT also charged the separate drop-off flat fee. When 0 (default), drop-off and installation stack.' },

  // ----- Optional per-cabinet add-ons -----
  adjustable_feet_per_cabinet: { label: 'Adjustable feet (under-counter)', unit: 'per cabinet', price: 0, note: 'Added when the vendor opts to install adjustable feet on an under-counter cabinet. Charged once per cabinet that has the option toggled on.' },
  // Soft-close hardware — applied only when Precision supplies the hardware
  // (cab.hardware.sourcedByVendor === false) AND the vendor chose soft-close.
  // Both seed at 0 so no charge fires until admin tunes the rates.
  soft_close_slide_per_drawer: { label: 'Soft-close drawer slide', unit: 'per drawer', price: 0, note: 'Charged per drawer when Precision supplies soft-close hardware. 0 = inactive.' },
  soft_close_hinge_per_door:   { label: 'Soft-close door hinge',   unit: 'per door',   price: 0, note: 'Charged per door when Precision supplies soft-close hardware. 0 = inactive.' },
  // Standard hardware — applied only when Precision supplies the hardware
  // (cab.hardware.sourcedByVendor === false) AND the vendor chose Standard
  // (not soft-close). Rates should bake in hardware cost + markup + install
  // labor. Both seed at 0 — admin sets rates in Cost Builder.
  standard_slide_per_drawer:   { label: 'Standard drawer slide', unit: 'per drawer', price: 0, note: 'Charged per drawer when Precision supplies standard (non-soft-close) hardware. Bake in cost + markup + install.' },
  standard_hinge_per_door:     { label: 'Standard door hinge',   unit: 'per door',   price: 0, note: 'Charged per door when Precision supplies standard (non-soft-close) hardware. Bake in cost + markup + install.' },
};

// Map BOX_MATERIALS dropdown labels → pricing keys
const MATERIAL_KEY_MAP = {
  'Particle board': 'mat_particle',
  'Hardrock maple': 'mat_maple',
  'Birch plywood': 'mat_birch',
  'Cherry plywood': 'mat_cherry',
  'Maple plywood': 'mat_maple_ply',
  'MDF': 'mat_mdf',
  'Melamine — white': 'mat_melamine_white',
  'Melamine — wood-look': 'mat_melamine_wood',
  'Oak plywood': 'mat_oak',
  'Walnut plywood': 'mat_walnut',
  // 'Unknown' is the new vendor-facing label; the underlying pricing key
  // stays `mat_other` so existing Firestore pricing docs keep working.
  'Unknown': 'mat_other',
  'Other': 'mat_other',
};

// Convert a dimension value+unit to inches
function toInches(val, unit) {
  const v = parseFloat(val);
  if (!v || isNaN(v)) return 0;
  if (unit === 'mm') return v / 25.4;
  return v;
}

// Billable linear feet for a single cabinet — the PURE physical width
// in feet, nothing else (2026-06-22 refactor).
//
// Previously this added "component uplifts" for doors/drawers/shelves
// so a wide cabinet with lots of components priced more than an empty
// box. That conflated cabinet-box-rebuild cost with component-repair
// cost and confused vendors ("why does a 24" cabinet show 3.4 LF?").
// Now door/drawer/shelf/new-shelf repair are first-class per-unit
// line items in computeEstimate() — see addPerComponentRepairLines().
function cabinetLinearFt(cab) {
  const wIn = toInches(cab.w, cab.wu);
  const widthFt = wIn / 12;
  if (!widthFt) return 0;
  return widthFt;
}

// Count of items in a category that the vendor flagged for repair.
// Reads the position-chip array (e.g. doorRepairPositions: ['L','R'])
// when present so a vendor with 4 doors but only 2 flagged gets billed
// for 2. Falls back to the full count when positions aren't captured
// (single door, legacy draft) so existing orders price reasonably.
function repairCountFromPositions(positions, total, repairFlag) {
  if (repairFlag !== true) return 0;
  const t = parseInt(total) || 0;
  if (t === 0) return 0;
  if (Array.isArray(positions) && positions.length > 0) {
    return Math.min(positions.length, t);
  }
  return t;
}

// Resolve which services are applied for an order. Reads new
// `serviceMode` + `serviceToggles` fields, falls back to legacy
// `installNeeded` ('Yes' / 'No' / 'Potential') for old drafts.
//
// Returns: { pickup: bool, dropoff: bool, install: bool, mode: string }
function getEffectiveServices(data, pricing) {
  const mode = (() => {
    if (data?.serviceMode) return data.serviceMode;
    // Legacy migration
    if (data?.installNeeded === 'Yes') return 'install';      // best-guess
    if (data?.installNeeded === 'No') return 'none';
    if (data?.installNeeded === 'Potential') return 'potential';
    return 'none';
  })();

  const installIncludesDropoff =
    !!(pricing?.install_includes_dropoff?.price);

  // 'multi' (Yes branch with independent toggles) and 'potential' (vendor
  // resolves at submit time) both use the serviceToggles object. The
  // install_includes_dropoff admin flag suppresses the drop-off charge when
  // both install and dropoff are toggled on and the flag is set.
  if (mode === 'multi' || mode === 'potential') {
    const t = data?.serviceToggles || {};
    const install = !!t.install;
    const dropoffEffective = !!t.dropoff && !(install && installIncludesDropoff);
    return { pickup: !!t.pickup, dropoff: dropoffEffective, install, mode };
  }

  if (mode === 'install') {
    return {
      pickup: false,
      dropoff: !installIncludesDropoff,   // stacked unless admin combined them
      install: true,
      mode,
    };
  }

  return {
    pickup: mode === 'pickup',
    dropoff: mode === 'dropoff',
    install: false,
    mode,
  };
}

// Build pre-computed Maps from repairTypes once per pricing load. Avoids
// re-scanning the variant array for every line item in an estimate (a
// single compute can call lookupVariantRate 30+ times — at ~50 variants
// per pricing doc, that was 1500 string compares each render).
//
// Indexes attached as non-enumerable so JSON.stringify of pricing for
// localStorage / Firestore writes stays clean.
function buildPricingIndexes(pricing) {
  const rt = Array.isArray(pricing.repairTypes) ? pricing.repairTypes : [];
  const variantMap = new Map();          // `${op}|${species}|${thickness}` → entry
  const firstByOp = new Map();           // op → first matching entry (fallback)
  for (const r of rt) {
    if (!r || !r.operation) continue;
    const species = r.variantSpecies || 'Unknown';
    const thickness = r.variantThickness || 'Unknown';
    variantMap.set(`${r.operation}|${species}|${thickness}`, r);
    if (!firstByOp.has(r.operation)) firstByOp.set(r.operation, r);
  }
  Object.defineProperty(pricing, '__variantMap', { value: variantMap, enumerable: false, configurable: true });
  Object.defineProperty(pricing, '__firstByOp', { value: firstByOp, enumerable: false, configurable: true });
  return pricing;
}

// Look up the per-unit rate for a given (operation, species, thickness)
// from the variant array (`pricing.repairTypes`). Falls back through:
//   exact match → Unknown thickness → Unknown species → any active entry
// Returns 0 if no entry priced for that operation at all (admin hasn't
// set anything yet — vendor sees a $0 line).
function lookupVariantRate(pricing, operation, species, thickness) {
  const map = pricing.__variantMap;
  if (!map) {
    // Pricing wasn't loaded through our loaders (legacy callers / tests).
    // Build the index on demand so this stays a drop-in replacement.
    buildPricingIndexes(pricing);
    return lookupVariantRate(pricing, operation, species, thickness);
  }
  const sp = species || 'Unknown';
  const th = thickness || 'Unknown';
  let hit = map.get(`${operation}|${sp}|${th}`);
  if (!hit) hit = map.get(`${operation}|${sp}|Unknown`);
  if (!hit) hit = map.get(`${operation}|Unknown|${th}`);
  if (!hit) hit = map.get(`${operation}|Unknown|Unknown`);
  if (!hit) hit = pricing.__firstByOp?.get(operation);
  return hit ? hit.price : 0;
}

// Single-variant operation rate (no species/thickness needed).
function lookupOperationRate(pricing, operation) {
  if (!pricing.__firstByOp) buildPricingIndexes(pricing);
  const hit = pricing.__firstByOp.get(operation);
  return hit ? hit.price : 0;
}

// Compute the full estimate for an order
function computeEstimate(data, pricing) {
  const cabinets = data.cabinets || [];
  // Toe kicks come in as an array in the new model; legacy single object
  // is wrapped for back-compat.
  const toeKicks = Array.isArray(data.toeKicks)
    ? data.toeKicks
    : (data.toeKick ? [data.toeKick] : []);
  // Default per-LF rate (fallback when the variant array isn't present —
  // e.g. an old vendor PWA reading a fresh `pricing/current` that does
  // have it). New model uses lookupVariantRate per cabinet below.
  const linePrice = pricing.linear_ft_rate?.price || 0;
  const islandPct = (pricing.island_surcharge_pct?.price || 0) / 100;
  const rushFlat = pricing.rush_upcharge_flat?.price || 0;
  const rushPct = pricing.rush_upcharge_pct?.price || 0;
  const taxPct = (pricing.tax_rate_pct?.price || 0) / 100;

  const lineItems = [];
  let subtotal = 0;

  // Per-cabinet line items
  for (let i = 0; i < cabinets.length; i++) {
    const c = cabinets[i];
    const lf = cabinetLinearFt(c);

    // Per-variant rate (6-2 model). Falls through to legacy linear_ft_rate
    // when no variant array is present.
    const variantRate = lookupVariantRate(
      pricing, 'cabinet-box-rebuild',
      c.boxMaterial || 'Unknown',
      c.boxThickness || 'Unknown',
    );
    const cabRate = variantRate > 0 ? variantRate : linePrice;

    let cabBase = lf * cabRate;
    let islandUplift = 0;
    if (c.cabType === 'Island' || c.cabType === 'Peninsula') {
      islandUplift = cabBase * islandPct;
    }
    const cabTotal = cabBase + islandUplift;

    const variantTag = c.boxMaterial && c.boxThickness
      ? ` (${c.boxThickness} ${c.boxMaterial})`
      : '';
    lineItems.push({
      type: 'cabinet',
      label: `Cab ${String(i + 1).padStart(2, '0')}${c.name ? ' — ' + c.name : ''}`,
      detail: `${lf.toFixed(2)} lin. ft × $${cabRate}${variantTag}${islandUplift > 0 ? ` + ${(islandPct * 100).toFixed(0)}% ${c.cabType.toLowerCase()}` : ''}`,
      qty: lf, rate: cabRate, amount: cabTotal,
    });
    subtotal += cabTotal;

    // Per-component repair line items (2026-06-22 refactor — moved out
    // of cabinet LF uplift). For each category the vendor flagged for
    // repair, charge the per-unit rate × the count of flagged items
    // (positions array, falling back to total count for legacy drafts).
    const doorRepairCount   = repairCountFromPositions(c.doorRepairPositions,   c.doors,   c.doorsRepair);
    const drawerRepairCount = repairCountFromPositions(c.drawerRepairPositions, c.drawers, c.drawersRepair);
    const shelfRepairCount  = repairCountFromPositions(c.shelfRepairPositions,  c.shelves, c.shelvesRepair);
    const newShelfCount     = (c.newShelfNeeded === true) ? (parseInt(c.newShelfCount) || 0) : 0;

    const doorRepairRate   = lookupOperationRate(pricing, 'door-repair');
    const drawerRepairRate = lookupOperationRate(pricing, 'drawer-repair');
    const shelfRepairRate  = lookupOperationRate(pricing, 'shelf-repair');
    const newShelfRate     = lookupOperationRate(pricing, 'new-shelf-built');

    if (doorRepairCount > 0 && doorRepairRate > 0) {
      const amt = doorRepairCount * doorRepairRate;
      lineItems.push({
        type: 'repair',
        label: `↳ Door repair`,
        detail: `${doorRepairCount} door${doorRepairCount === 1 ? '' : 's'} × $${doorRepairRate}`,
        qty: doorRepairCount, rate: doorRepairRate, amount: amt,
      });
      subtotal += amt;
    }
    if (drawerRepairCount > 0 && drawerRepairRate > 0) {
      const amt = drawerRepairCount * drawerRepairRate;
      lineItems.push({
        type: 'repair',
        label: `↳ Drawer repair`,
        detail: `${drawerRepairCount} drawer${drawerRepairCount === 1 ? '' : 's'} × $${drawerRepairRate}`,
        qty: drawerRepairCount, rate: drawerRepairRate, amount: amt,
      });
      subtotal += amt;
    }
    if (shelfRepairCount > 0 && shelfRepairRate > 0) {
      const amt = shelfRepairCount * shelfRepairRate;
      lineItems.push({
        type: 'repair',
        label: `↳ Shelf repair`,
        detail: `${shelfRepairCount} shelf${shelfRepairCount === 1 ? '' : 'ves'} × $${shelfRepairRate}`,
        qty: shelfRepairCount, rate: shelfRepairRate, amount: amt,
      });
      subtotal += amt;
    }
    if (newShelfCount > 0 && newShelfRate > 0) {
      const amt = newShelfCount * newShelfRate;
      lineItems.push({
        type: 'repair',
        label: `↳ New shelf built`,
        detail: `${newShelfCount} shelf${newShelfCount === 1 ? '' : 'ves'} × $${newShelfRate}`,
        qty: newShelfCount, rate: newShelfRate, amount: amt,
      });
      subtotal += amt;
    }

    // Adjustable feet add-on — per cabinet, only when the under-counter
    // toggle is on AND the vendor opted into feet.
    if (c.underCounterAdjustableFeet === true) {
      const feetRate = pricing.adjustable_feet_per_cabinet?.price || 0;
      if (feetRate > 0) {
        lineItems.push({
          type: 'addon',
          label: `↳ Adjustable feet`,
          detail: 'Under-counter install — feet add-on',
          qty: 1, rate: feetRate, amount: feetRate,
        });
        subtotal += feetRate;
      }
    }

    // Hardware add-on — only when Precision supplies the hardware
    // (vendor didn't ship it) AND the vendor has explicitly picked
    // soft-close vs standard. Without the softClose guard, an
    // unanswered draft would default-bill Standard rates the moment
    // sourcedByVendor flipped to false. The wizard hides the
    // soft-close question entirely when sourcedByVendor === true, so
    // softClose === null/undefined is the explicit "vendor hasn't
    // decided yet" state on the No branch.
    const hw = c.hardware;
    if (hw && hw.sourcedByVendor === false && hw.softClose != null) {
      const drawerCount = parseInt(c.drawers) || 0;
      const doorCount = parseInt(c.doors) || 0;
      const isSoft = hw.softClose === true;
      const slideRate = isSoft
        ? (pricing.soft_close_slide_per_drawer?.price || 0)
        : (pricing.standard_slide_per_drawer?.price || 0);
      const hingeRate = isSoft
        ? (pricing.soft_close_hinge_per_door?.price || 0)
        : (pricing.standard_hinge_per_door?.price || 0);
      const slideLabel = isSoft ? 'Soft-close slides' : 'Standard slides';
      const hingeLabel = isSoft ? 'Soft-close hinges' : 'Standard hinges';
      if (slideRate > 0 && drawerCount > 0) {
        const amt = slideRate * drawerCount;
        lineItems.push({
          type: 'addon',
          label: `↳ ${slideLabel}`,
          detail: `${drawerCount} drawer${drawerCount === 1 ? '' : 's'} × $${slideRate}`,
          qty: drawerCount, rate: slideRate, amount: amt,
        });
        subtotal += amt;
      }
      if (hingeRate > 0 && doorCount > 0) {
        const amt = hingeRate * doorCount;
        lineItems.push({
          type: 'addon',
          label: `↳ ${hingeLabel}`,
          detail: `${doorCount} door${doorCount === 1 ? '' : 's'} × $${hingeRate}`,
          qty: doorCount, rate: hingeRate, amount: amt,
        });
        subtotal += amt;
      }
    }

    // Finished side panel(s) — separate line
    if (c.finishedSide === 'Yes' && c.finishedWhich) {
      const isBoth = c.finishedWhich === 'Both';
      const sp = isBoth ? pricing.side_panel_both : pricing.side_panel_one;
      if (sp) {
        lineItems.push({
          type: 'side_panel',
          label: `↳ Finished side — ${c.finishedWhich}`,
          detail: sp.label,
          qty: 1, rate: sp.price, amount: sp.price,
        });
        subtotal += sp.price;
      }
    }
  }

  // Toe kick lines — one entry per spec in the toeKicks array. Legacy
  // single-object data.toeKick was wrapped above.
  const tkRate = lookupOperationRate(pricing, 'rebuild-toe-kick') || (pricing.toe_kick_rate?.price || 0);
  for (let k = 0; k < toeKicks.length; k++) {
    const t = toeKicks[k] || {};
    const ft = parseFloat(t.linearFt) || 0;
    if (ft <= 0) continue;
    const amt = ft * tkRate;
    const dims = [];
    if (t.height) dims.push(`${t.height}" H`);
    if (t.setback) dims.push(`${t.setback}" setback`);
    if (t.thickness) dims.push(`${t.thickness}`);
    lineItems.push({
      type: 'toe_kick',
      label: toeKicks.length > 1 ? `Toe kick #${k + 1}` : 'Toe kick',
      detail: `${ft} lin. ft × $${tkRate}${dims.length ? ` · ${dims.join(' · ')}` : ''}`,
      qty: ft, rate: tkRate, amount: amt,
    });
    subtotal += amt;
  }

  // Scribe line — auto-calc by stick count (new 6-2 model) when the
  // vendor wizard provides `data.scribe.sticks`. Legacy `linearFeet`
  // path still honored when only that's present.
  const scribe = data.scribe || {};
  const scribeRate = lookupOperationRate(pricing, 'scribe')
    || (pricing.scribe_matched?.price || 0);
  if (scribe.needed === 'Yes') {
    const sticks = parseFloat(scribe.sticks) || 0;
    const legacyFt = parseFloat(scribe.linearFeet) || 0;
    if (sticks > 0) {
      const amt = sticks * scribeRate;
      lineItems.push({
        type: 'scribe',
        label: 'Scribe',
        detail: `${sticks} stick${sticks === 1 ? '' : 's'} (8') × $${scribeRate}`,
        qty: sticks, rate: scribeRate, amount: amt,
      });
      subtotal += amt;
    } else if (legacyFt > 0) {
      // Legacy LF path — treat rate as per-LF (matches old data shape).
      const amt = legacyFt * scribeRate;
      lineItems.push({
        type: 'scribe',
        label: 'Scribe',
        detail: `${legacyFt} lin. ft × $${scribeRate}`,
        qty: legacyFt, rate: scribeRate, amount: amt,
      });
      subtotal += amt;
    }
  }

  // ----- 6-2 end-of-intake add-ons -----
  // data.addons = { needed: 'Yes'|'No', items: [...] }
  // Each item.type maps to an operation in pricing.repairTypes.
  // Admin can disable an addon type by toggling active=false in the
  // wizard config — those items are skipped here so an order draft from
  // before the toggle stops contributing to the total.
  const addons = data.addons || {};
  const wizardAddons = Array.isArray(pricing?.wizardConfig?.addons) ? pricing.wizardConfig.addons : null;
  const activeAddonIds = wizardAddons
    ? new Set(wizardAddons.filter(a => a && a.active !== false).map(a => a.id))
    : null;
  if (addons.needed === 'Yes' && Array.isArray(addons.items)) {
    for (const it of addons.items) {
      if (!it || !it.type) continue;
      if (activeAddonIds && !activeAddonIds.has(it.type)) continue;
      let operation = null;
      let qtyLabel = '';
      let qty = 1;
      switch (it.type) {
        case 'fridge-panel':
          operation = 'fridge-end-panel';
          qty = Math.max(1, parseInt(it.count) || 1);
          qtyLabel = `${qty} panel${qty === 1 ? '' : 's'}${it.height ? `, ${it.height}" H` : ''}${it.depth ? ` × ${it.depth}" D` : ''}${it.side ? ` (${it.side})` : ''}`;
          break;
        case 'dishwasher-panel':
          operation = 'dishwasher-end-panel';
          qty = Math.max(1, parseInt(it.count) || 1);
          qtyLabel = `${qty} panel${qty === 1 ? '' : 's'}${it.height ? `, ${it.height}" H` : ''}${it.side ? ` (${it.side})` : ''}`;
          break;
        case 'filler': {
          const w = it.width === 6 ? 6 : 3;
          const profile = it.profile === 'fullheight' ? 'fullheight' : 'base';
          operation = `filler-${profile}-${w}`;
          qty = Math.max(1, parseInt(it.count) || 1);
          qtyLabel = `${qty} × ${w}" ${profile === 'fullheight' ? 'full-height' : 'base'} filler`;
          break;
        }
        case 'corner-mold': {
          const sizeMap = { '3/4x3/4': 'corner-mold-3434', '3/4x1': 'corner-mold-341', '3/4x1.25': 'corner-mold-34114' };
          operation = sizeMap[it.size] || 'corner-mold-3434';
          qty = Math.max(1, parseInt(it.sticks) || 1);
          qtyLabel = `${qty} stick${qty === 1 ? '' : 's'} (${it.size || '3/4×3/4'})`;
          break;
        }
        case 'quarter-round':
          operation = 'quarter-round';
          qty = Math.max(1, parseInt(it.sticks) || 1);
          qtyLabel = `${qty} stick${qty === 1 ? '' : 's'} (8')`;
          break;
        case 'other':
          operation = 'addon-other';
          qty = Math.max(1, parseInt(it.qty) || 1);
          qtyLabel = it.description ? it.description : '(no description)';
          break;
        default: {
          // Generic fallback for admin-added wizard add-ons that aren't one
          // of the six hardcoded types above. Without this, any add-on an
          // admin creates in the Wizard Config editor would emit no line
          // item and silently price at $0. Look up the add-on's own
          // definition in the wizardConfig and use its `pricingOperation`.
          // KEEP IN SYNC with functions/src/pricing.ts add-on fallback.
          const def = wizardAddons ? wizardAddons.find(a => a && a.id === it.type) : null;
          if (def && def.pricingOperation) {
            operation = def.pricingOperation;
            qty = Math.max(1, parseInt(it.qty || it.count || it.sticks) || 1);
            qtyLabel = it.description ? it.description : `${qty} unit${qty === 1 ? '' : 's'}`;
          }
          break;
        }
      }
      if (!operation) continue;
      const rate = lookupOperationRate(pricing, operation);
      if (rate <= 0) continue;
      const amt = rate * qty;
      lineItems.push({
        type: 'addon',
        label: `Add-on — ${it.type.replace(/-/g, ' ')}`,
        detail: `${qtyLabel} × $${rate}`,
        qty, rate, amount: amt,
      });
      subtotal += amt;
    }
  }

  // ----- Roll-out shelves -----
  // Three operations (install / rebuild / repair) × two cabinet-width
  // tiers (≤30" → legacy un-suffixed op id; >30" → -large suffix). Six
  // possible line items total. The -large rate falls back to the
  // un-suffixed rate when admin hasn't set a different value, so admin
  // can keep flat pricing by leaving -large at $0.
  const rolloutRebuildSmall  = lookupOperationRate(pricing, 'roll-out-shelf');
  const rolloutRebuildLarge  = lookupOperationRate(pricing, 'roll-out-shelf-large')         || rolloutRebuildSmall;
  const rolloutInstallSmall  = lookupOperationRate(pricing, 'roll-out-shelf-install');
  const rolloutInstallLarge  = lookupOperationRate(pricing, 'roll-out-shelf-install-large') || rolloutInstallSmall;
  const rolloutRepairSmall   = lookupOperationRate(pricing, 'roll-out-shelf-repair');
  const rolloutRepairLarge   = lookupOperationRate(pricing, 'roll-out-shelf-repair-large')  || rolloutRepairSmall;

  // Bucketize each cabinet's roll-out counts by host-cabinet width:
  // ≤30" wide → "small" bucket; >30" wide → "large" bucket.
  const sumRolloutsByTier = (field) => {
    let small = 0, large = 0;
    for (const c of cabinets) {
      const count = Math.max(0, parseInt(c[field]) || 0);
      if (count === 0) continue;
      const widthIn = toInches(c.w, c.wu);
      if (widthIn > 30) large += count;
      else small += count;
    }
    return { small, large };
  };
  // Migrate legacy `rolloutCount` → rebuild bucket so the line item
  // labelling is consistent. Legacy drafts treated as small-cab (≤30").
  const legacyRolloutTotal = (() => {
    let t = 0;
    for (const c of cabinets) t += Math.max(0, parseInt(c.rolloutCount) || 0);
    return t;
  })();
  const rebuild = sumRolloutsByTier('rolloutRebuildCount');
  const install = sumRolloutsByTier('rolloutInstallCount');
  const repair  = sumRolloutsByTier('rolloutRepairCount');
  rebuild.small += legacyRolloutTotal;

  const pushRollout = (label, qty, rate, tierLabel) => {
    if (rate <= 0 || qty <= 0) return;
    const amt = rate * qty;
    lineItems.push({
      type: 'addon',
      label: `Roll-out shelves — ${label}`,
      detail: `${qty} tray${qty === 1 ? '' : 's'} (${tierLabel}) × $${rate}`,
      qty, rate, amount: amt,
    });
    subtotal += amt;
  };
  pushRollout('rebuild',      rebuild.small, rolloutRebuildSmall, '≤30" cab');
  pushRollout('rebuild',      rebuild.large, rolloutRebuildLarge, '>30" cab');
  pushRollout('install only', install.small, rolloutInstallSmall, '≤30" cab');
  pushRollout('install only', install.large, rolloutInstallLarge, '>30" cab');
  pushRollout('repair',       repair.small,  rolloutRepairSmall,  '≤30" cab');
  pushRollout('repair',       repair.large,  rolloutRepairLarge,  '>30" cab');

  // ----- Finished back panel (Island / Peninsula with backFinished: true) -----
  const backPanelRate = lookupOperationRate(pricing, 'finished-back-panel');
  if (backPanelRate > 0) {
    const backCount = cabinets.filter(c =>
      (c.cabType === 'Island' || c.cabType === 'Peninsula') && c.backFinished === true
    ).length;
    if (backCount > 0) {
      const amt = backPanelRate * backCount;
      lineItems.push({
        type: 'addon',
        label: 'Finished back panel(s)',
        detail: `${backCount} cabinet${backCount === 1 ? '' : 's'} × $${backPanelRate}`,
        qty: backCount, rate: backPanelRate, amount: amt,
      });
      subtotal += amt;
    }
  }

  // Service-type fees — pickup, drop-off, installation. Resolved
  // from the vendor's intake answer (Step 2 or the end-of-intake
  // decision screen).
  const services = getEffectiveServices(data, pricing);
  const pickupRate = pricing.pickup_flat?.price || 0;
  const dropoffRate = pricing.dropoff_flat?.price || 0;
  const installRate = pricing.install_per_cabinet?.price || 0;
  if (subtotal > 0 && services.pickup && pickupRate > 0) {
    lineItems.push({ type: 'service', label: 'Pickup', detail: 'Flat fee — within 25 miles', qty: 1, rate: pickupRate, amount: pickupRate });
    subtotal += pickupRate;
  }
  if (subtotal > 0 && services.dropoff && dropoffRate > 0) {
    lineItems.push({ type: 'service', label: 'Drop-off', detail: 'Flat fee — within 25 miles', qty: 1, rate: dropoffRate, amount: dropoffRate });
    subtotal += dropoffRate;
  }
  if (subtotal > 0 && services.install && installRate > 0 && cabinets.length > 0) {
    const installAmt = installRate * cabinets.length;
    lineItems.push({
      type: 'service',
      label: 'Installation',
      detail: `${cabinets.length} cabinet${cabinets.length === 1 ? '' : 's'} × $${installRate}`,
      qty: cabinets.length, rate: installRate, amount: installAmt,
    });
    subtotal += installAmt;
  }

  // Trip charge — only when Precision drives somewhere. Drop-off-only
  // (vendor brings cabinets to the warehouse + picks them back up) gets
  // no trip charge. Install always implies a trip.
  const trip = pricing.trip_charge?.price || 0;
  const needsTrip = services.pickup || services.dropoff || services.install;
  if (subtotal > 0 && trip > 0 && needsTrip) {
    lineItems.push({ type: 'fee', label: 'Trip charge', detail: 'Flat fee', qty: 1, rate: trip, amount: trip });
    subtotal += trip;
  }

  // Rush upcharge — greater of flat $ or % of pre-rush subtotal. Both
  // pricing keys default to 0 so no rush applies until admin configures.
  let rushAmount = 0;
  if (subtotal > 0 && data.rush === true) {
    const pctAmount = subtotal * (rushPct / 100);
    rushAmount = Math.max(rushFlat, pctAmount);
    if (rushAmount > 0) {
      const detail = rushAmount === rushFlat && rushFlat > pctAmount
        ? `Flat fee — order flagged RUSH`
        : `${rushPct}% of $${Math.round(subtotal)} subtotal — order flagged RUSH`;
      lineItems.push({
        type: 'surcharge',
        label: 'Rush upcharge',
        detail,
        qty: 1, rate: rushAmount, amount: rushAmount,
      });
      subtotal += rushAmount;
    }
  }

  // Minimum job
  const minimum = pricing.minimum_job?.price || 0;
  let minimumApplied = 0;
  if (subtotal > 0 && subtotal < minimum) {
    minimumApplied = minimum - subtotal;
    lineItems.push({
      type: 'fee',
      label: 'Minimum job adjustment',
      detail: `Brings total to $${minimum} minimum`,
      qty: 1, rate: minimumApplied, amount: minimumApplied,
    });
    subtotal = minimum;
  }

  // Approved change-order charges (order.additionalCharges) — folded in so the
  // total stays inclusive. No-op for wizard/draft data (which has none). KEEP IN
  // SYNC with functions/src/pricing.ts computeEstimate.
  const appliedCharges = Array.isArray(data && data.additionalCharges) ? data.additionalCharges : [];
  for (const ch of appliedCharges) {
    const amt = Number(ch && ch.amount) || 0;
    if (!amt || (ch && ch.voided)) continue;
    lineItems.push({
      type: 'change_order',
      label: (ch && ch.label) ? String(ch.label) : 'Change order',
      detail: amt < 0 ? 'Approved credit' : 'Approved change charge',
      qty: 1, rate: amt, amount: amt,
    });
    subtotal += amt;
  }

  // Tax
  let tax = 0;
  if (taxPct > 0 && subtotal > 0) {
    tax = subtotal * taxPct;
  }

  const total = subtotal + tax;

  return {
    lineItems,
    subtotal: Math.round(subtotal * 100) / 100,
    tax: Math.round(tax * 100) / 100,
    total: Math.round(total * 100) / 100,
    rushApplied: rushAmount > 0,
    minimumApplied: minimumApplied > 0,
  };
}

function fmtMoney(n) {
  if (n == null || isNaN(n)) return '$0';
  return '$' + Math.round(n).toLocaleString();
}

// Pricing persistence — Firestore primary, localStorage fallback
const PRICING_STORAGE_KEY = 'cabinet_intake_pricing_v1';
// In-memory session cache for the Firestore load. A vendor opening
// multiple drafts, navigating between dashboard and wizard, etc. used
// to re-read pricing/current every time. Cache survives until the page
// is closed; admin Push-Live calls invalidatePricingCache() so vendors
// in the same session pick up new rates on next compute.
let __PRICING_CACHE = null;
let __PRICING_FETCHING = null;
const PRICING_CACHE_TTL_MS = 5 * 60 * 1000;

function invalidatePricingCache() {
  __PRICING_CACHE = null;
  __PRICING_FETCHING = null;
}

function loadPricingLocal() {
  try {
    const raw = localStorage.getItem(PRICING_STORAGE_KEY);
    if (!raw) return buildPricingIndexes({ ...DEFAULT_PRICING });
    const saved = JSON.parse(raw);
    const merged = { ...DEFAULT_PRICING };
    for (const [k, v] of Object.entries(saved)) {
      if (v == null) continue;
      if (Array.isArray(v)) merged[k] = v;                                   // repairTypes
      else if (k === 'wizardConfig') merged[k] = v;                          // admin-managed wizard schema
      else if (typeof v === 'object' && typeof v.price === 'number') {
        merged[k] = { ...(merged[k] || {}), ...v };
      }
    }
    return buildPricingIndexes(merged);
  } catch { return buildPricingIndexes({ ...DEFAULT_PRICING }); }
}

async function loadPricingFromFirestore(opts) {
  // opts.force (6-11): skip the in-memory cache so a NEW quote session
  // always starts on the freshest pushed pricing. Param is optional —
  // older cached JSX calling with no args keeps the old behavior.
  const force = !!(opts && opts.force);
  // Serve the in-memory cache when it's fresh enough.
  if (!force && __PRICING_CACHE && Date.now() - __PRICING_CACHE.at < PRICING_CACHE_TTL_MS) {
    return __PRICING_CACHE.value;
  }
  // Coalesce concurrent calls so we never fire two reads for one tick.
  if (__PRICING_FETCHING) return __PRICING_FETCHING;

  __PRICING_FETCHING = (async () => {
    try {
      const doc = await db.doc('pricing/current').get();
      if (!doc.exists) {
        const local = loadPricingLocal();
        __PRICING_CACHE = { value: local, at: Date.now() };
        return local;
      }
      const saved = doc.data() || {};
      // Start with the bundled DEFAULT_PRICING for any keys not in Firestore,
      // then overlay everything the bridge wrote.
      const merged = { ...DEFAULT_PRICING };
      for (const [k, v] of Object.entries(saved)) {
        if (v == null) continue;
        if (Array.isArray(v)) {
          merged[k] = v;                                       // e.g. repairTypes
        } else if (k === 'wizardConfig') {
          merged[k] = v;                                       // admin-managed wizard schema
        } else if (typeof v === 'object' && typeof v.price === 'number') {
          merged[k] = { ...(merged[k] || {}), ...v };          // pricing entry
        }
      }
      buildPricingIndexes(merged);
      // Cache locally for offline.
      try {
        const slim = {};
        for (const [k, v] of Object.entries(merged)) {
          if (Array.isArray(v)) slim[k] = v;
          else if (k === 'wizardConfig') slim[k] = v;
          else if (v && typeof v === 'object' && typeof v.price === 'number') slim[k] = { price: v.price };
        }
        localStorage.setItem(PRICING_STORAGE_KEY, JSON.stringify(slim));
      } catch {}
      __PRICING_CACHE = { value: merged, at: Date.now() };
      return merged;
    } catch (err) {
      console.warn('Firestore pricing load failed, using local:', err);
      const local = loadPricingLocal();
      __PRICING_CACHE = { value: local, at: Date.now() };
      return local;
    } finally {
      __PRICING_FETCHING = null;
    }
  })();
  return __PRICING_FETCHING;
}

function loadPricing() {
  return loadPricingLocal();
}

// Rehydrate a stored order pricingSnapshot into a usable pricing object,
// INCLUDING the repairTypes variant array + wizardConfig (the old inline
// rebuild in order-detail dropped those, which zeroed every per-op rate and
// silently collapsed order totals on edit). Mirrors the server's
// pricingFromSnapshot so the price preview matches what pc_editOrder computes.
function pricingFromSnapshot(snapshot) {
  const merged = { ...DEFAULT_PRICING };
  if (snapshot && typeof snapshot === 'object') {
    for (const [k, v] of Object.entries(snapshot)) {
      if (v == null) continue;
      if (Array.isArray(v)) merged[k] = v;                                   // repairTypes
      else if (k === 'wizardConfig') merged[k] = v;                          // add-on active-state
      else if (typeof v === 'object' && typeof v.price === 'number') {
        merged[k] = { ...(merged[k] || {}), ...v };
      }
    }
  }
  return buildPricingIndexes(merged);
}

async function savePricing(pricing) {
  // Save locally
  try {
    const slim = {};
    for (const [k, v] of Object.entries(pricing)) slim[k] = { price: v.price };
    localStorage.setItem(PRICING_STORAGE_KEY, JSON.stringify(slim));
  } catch {}
  // Save to Firestore
  try {
    const user = auth.currentUser;
    if (!user) return;
    const update = {};
    for (const [k, v] of Object.entries(pricing)) {
      update[k] = { ...v };
    }
    update.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    update.updatedBy = user.uid;
    await db.doc('pricing/current').set(update, { merge: true });
  } catch (err) {
    console.warn('Firestore pricing save failed:', err);
  }
}

Object.assign(window, {
  DEFAULT_PRICING, MATERIAL_KEY_MAP, cabinetLinearFt, computeEstimate, fmtMoney, toInches,
  loadPricing, savePricing, loadPricingFromFirestore, loadPricingLocal,
  invalidatePricingCache, pricingFromSnapshot,
  getEffectiveServices,
});

})();

// ===== vendors.jsx =====
(function(){
// vendors.jsx — slug-based access RETIRED in v14.
//
// The vendor PWA now signs in with email + password and resolves the
// active vendor from custom-token claims (vendorId) + the vendorContacts
// /{uid} doc. The slug-based functions in this file are kept as no-op
// shims so any stale references in other modules don't blow up — they
// just warn once and return safe defaults.
//
// `applyVendorToData` is the only helper still doing real work; it now
// takes the signed-in contact as well so it can seed the intake form
// with the contact's name/phone/email instead of a vendor-wide default.
//
// `VendorsAdmin` (legacy in-PWA admin) renders a deprecation notice —
// vendor management lives in the admin-portal now.

let _slugWarned = false;
function _warnSlugRetired(fn) {
  if (_slugWarned) return;
  _slugWarned = true;
  console.warn(`[vendors] ${fn} is a no-op — slug-based access was retired in v14.`);
}

// ---------- No-op slug helpers (kept for back-compat) ----------

function slugify(s) {
  // Still useful for incidental UI bits, so keep the real impl.
  return (s || '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
}

function makeVendor(name = '') {
  _warnSlugRetired('makeVendor');
  return {
    id: '',
    name,
    isActive: true,
    poPrefix: '',
    welcomeMessage: '',
    contactCount: 0,
  };
}

function loadVendors()           { _warnSlugRetired('loadVendors'); return []; }
function saveVendors()           { _warnSlugRetired('saveVendors'); }
function saveVendorsLocal()      { _warnSlugRetired('saveVendorsLocal'); }
async function loadVendorsFromFirestore() { _warnSlugRetired('loadVendorsFromFirestore'); return []; }
async function saveVendorToFirestore()    { _warnSlugRetired('saveVendorToFirestore'); }

function getVendorFromURL()      { _warnSlugRetired('getVendorFromURL');     return null; }
function getStoredVendorSlug()   { _warnSlugRetired('getStoredVendorSlug');  return null; }
function setStoredVendorSlug()   { _warnSlugRetired('setStoredVendorSlug'); }
function clearStoredVendorSlug() { _warnSlugRetired('clearStoredVendorSlug'); }
function buildVendorLink()       { _warnSlugRetired('buildVendorLink');     return ''; }

// ---------- Real helper: pre-fill intake from vendor + contact ----------

// Apply the signed-in contact's defaults to a fresh intake form. The
// PO prefix still comes from the vendor doc; the contact name/phone/
// email come from the signed-in contact. Existing values on `data` are
// preserved (the caller may already have a draft loaded).
function applyVendorToData(data, vendor, contact) {
  if (!vendor) return data;
  return {
    ...data,
    vendorName:    data.vendorName    || vendor.name    || '',
    vendorContact: data.vendorContact || (contact && contact.name)  || '',
    vendorPhone:   data.vendorPhone   || (contact && contact.phone) || '',
    vendorEmail:   data.vendorEmail   || (contact && contact.email) || '',
    vendorPO:      data.vendorPO      || vendor.poPrefix || '',
  };
}

// ---------- Legacy in-PWA admin (deprecated) ----------

function VendorsAdmin() {
  return (
    <div className="vendors-admin" style={{ padding: 20 }}>
      <div style={{
        background: '#fef9c3', border: '1px solid #facc15', color: '#854d0e',
        padding: 14, borderRadius: 8, fontSize: 14, lineHeight: 1.5,
      }}>
        <strong>Vendor management moved.</strong><br/>
        Vendor companies and their per-contact accounts are now managed in
        the Precision Cabinets admin portal. This in-PWA editor is retired.
      </div>
    </div>
  );
}

// Export shims. VendorBanner / VendorCodeEntry are no longer rendered
// anywhere; keeping the names as no-op components avoids a runtime
// crash if some legacy code path still references them.
function VendorBanner()    { return null; }
function VendorCodeEntry() { return null; }

Object.assign(window, {
  // Real helpers still in use:
  slugify, applyVendorToData, VendorsAdmin,
  // No-op shims (slug-era surface):
  loadVendors, saveVendors, saveVendorsLocal, makeVendor,
  getVendorFromURL, buildVendorLink,
  loadVendorsFromFirestore, saveVendorToFirestore,
  getStoredVendorSlug, setStoredVendorSlug, clearStoredVendorSlug,
  VendorBanner, VendorCodeEntry,
});

})();

// ===== admin.jsx =====
(function(){
// Admin panel — edit pricing live
// Persisted via Tweaks-style EDITMODE block in app.jsx

const PRICING_GROUPS = [
  {
    id: 'vendors',
    title: 'Vendors',
    desc: 'Per-vendor profiles + custom prefilled links.',
    keys: [],
  },
  {
    id: 'core',
    title: 'Core rates',
    desc: 'The two linear-foot rates that drive most of the order.',
    keys: ['linear_ft_rate', 'toe_kick_rate'],
  },
  {
    id: 'panels',
    title: 'Finished side panels',
    desc: 'Per-cabinet flat fees — the exception to the linear-foot model.',
    keys: ['side_panel_one', 'side_panel_both'],
  },
  {
    id: 'surcharges',
    title: 'Surcharges',
    desc: 'Percent uplifts applied to the subtotal.',
    keys: ['rush_surcharge_pct', 'island_surcharge_pct'],
  },
  {
    id: 'materials',
    title: 'Box material multipliers',
    desc: 'Each cabinet\u2019s line is multiplied by this based on its box material.',
    keys: [
      'mat_birch', 'mat_maple', 'mat_maple_ply', 'mat_cherry', 'mat_oak',
      'mat_walnut', 'mat_melamine_white', 'mat_melamine_wood', 'mat_mdf',
      'mat_particle', 'mat_other',
    ],
  },
  {
    id: 'fees',
    title: 'Fees & tax',
    desc: 'Flat fees and tax applied at the end.',
    keys: ['trip_charge', 'minimum_job', 'tax_rate_pct'],
  },
];

function AdminScreen({ pricing, setPricing, vendors, setVendors, onClose, onReset }) {
  const [activeGroup, setActiveGroup] = React.useState('vendors');
  const [savedPulse, setSavedPulse] = React.useState(false);

  const update = (key, price) => {
    setPricing({ ...pricing, [key]: { ...pricing[key], price } });
    setSavedPulse(true);
    clearTimeout(window.__adminSavedTimer);
    window.__adminSavedTimer = setTimeout(() => setSavedPulse(false), 1200);
  };

  const group = PRICING_GROUPS.find(g => g.id === activeGroup);

  return (
    <div className="admin-overlay">
      <div className="admin-shell">
        <div className="admin-head">
          <div>
            <span className="eyebrow">Admin · Pricing</span>
            <h1 style={{ marginTop: 4 }}>Set the rates</h1>
            <p style={{ margin: '6px 0 0', color: 'var(--ink-soft)', fontSize: 14, maxWidth: 580 }}>
              Edit the rates below. Vendors see live totals as they fill out the cabinet form.
              Most work bills by the linear foot — finished side panels are the exception.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <span className={'admin-saved' + (savedPulse ? ' on' : '')}>
              <Icon.Check/> Saved
            </span>
            <button className="btn ghost" onClick={onReset} title="Reset all prices to defaults">
              Reset to defaults
            </button>
            <button className="btn primary" onClick={onClose}>
              <Icon.X/> Close admin
            </button>
          </div>
        </div>

        <div className="admin-body">
          <nav className="admin-nav">
            {PRICING_GROUPS.map(g => (
              <button key={g.id}
                className={'admin-nav-item' + (activeGroup === g.id ? ' active' : '')}
                onClick={() => setActiveGroup(g.id)}>
                <div className="t">{g.title}</div>
                <div className="s">{g.keys.length} item{g.keys.length === 1 ? '' : 's'}</div>
              </button>
            ))}
          </nav>

          <section className="admin-content">
            <div className="admin-group-head">
              <h2>{group.title}</h2>
              <p>{group.desc}</p>
            </div>

            {activeGroup === 'vendors' ? (
              <VendorsAdmin vendors={vendors} setVendors={setVendors}/>
            ) : (
              <div className="admin-rows">
              {group.keys.map(k => {
                const p = pricing[k] || DEFAULT_PRICING[k];
                if (!p) return null;
                const isPercent = p.unit && p.unit.startsWith('%');
                const isMultiplier = p.unit === 'multiplier';
                const prefix = isPercent || isMultiplier ? '' : '$';
                const suffix = isPercent ? '%' : isMultiplier ? '×' : '';
                return (
                  <div className="admin-row" key={k}>
                    <div className="row-info">
                      <div className="row-label">{p.label}</div>
                      <div className="row-meta">{p.unit}</div>
                      {p.note && <div className="row-note">{p.note}</div>}
                    </div>
                    <div className="row-input">
                      {prefix && <span className="affix">{prefix}</span>}
                      <input className="input mono"
                        type="number"
                        step={isMultiplier ? 0.01 : isPercent ? 0.5 : 1}
                        value={p.price}
                        onChange={e => update(k, parseFloat(e.target.value) || 0)}/>
                      {suffix && <span className="affix">{suffix}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
            )}

            {activeGroup === 'core' && (
              <div className="admin-formula">
                <div className="eyebrow" style={{ marginBottom: 8 }}>How a cabinet line is calculated</div>
                <code>
                  cab_lf = (width_ft) + (doors × 0.5) + (drawers × 0.4) + (shelves × 0.25)<br/>
                  cab_total = cab_lf × ${pricing.linear_ft_rate?.price} × material_multiplier {'(+ island/peninsula uplift)'}
                </code>
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}

Object.assign(window, { AdminScreen, PRICING_GROUPS });

})();

// ===== markup.jsx =====
(function(){
// Photo markup canvas — draw and pin directly on uploaded photos.
// Measure tool was removed (intake redesign). Old orders that had
// measure annotations keep the data on the doc but render nothing.
// Annotations: { id, type: 'draw'|'pin', color, points: [{x,y}...], data: {...} }

const MARKUP_COLORS = [
  { id: 'amber', hex: 'oklch(65% 0.14 60)', label: 'Repair' },
  { id: 'red',   hex: 'oklch(55% 0.2 28)',  label: 'Damage' },
  { id: 'blue',  hex: 'oklch(55% 0.16 245)', label: 'Note' },
  { id: 'green', hex: 'oklch(55% 0.14 150)', label: 'Detail' },
];

const TOOLS = [
  // 'view' is the default — touches pass through to the page so users
  // can scroll past the photo without dropping accidental pins. They
  // must tap "Pin" or "Draw" to enter annotation mode (which captures
  // touches). Fixes user-reported bug 2026-06-18: "the tool that
  // allows draw and pin takes over the picture and scroll with the
  // screen as it moves. So inadvertant pin drops happen by accident."
  { id: 'view', label: 'View',  icon: 'X' },
  { id: 'draw', label: 'Draw', icon: 'Pencil' },
  { id: 'pin',  label: 'Pin',  icon: 'Pin' },
];

function MarkupCanvasImpl({ photo, annotations, setAnnotations }) {
  const [tool, setTool] = React.useState('view');
  const [color, setColor] = React.useState('amber');
  const [drawing, setDrawing] = React.useState(null); // in-progress annotation (object identity stable across moves)
  const [, forceRender] = React.useReducer((x) => x + 1, 0);   // bump to repaint the live stroke after mutating points
  const rafPendingRef = React.useRef(false);
  const [editingPin, setEditingPin] = React.useState(null);
  const stageRef = React.useRef(null);
  const svgRef = React.useRef(null);

  // Mobile breakpoint: under 640px the pin editor becomes a BottomSheet
  // instead of an inline popover. Widened from 480 → 640 on 2026-06-18
  // because the inline popover (240px wide) was shooting off-screen on
  // 480-640px viewports (typical iPhone Plus / Android XL phones in
  // landscape). BottomSheet is always reachable.
  const [isNarrow, setIsNarrow] = React.useState(
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(max-width: 640px)').matches : false
  );
  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const m = window.matchMedia('(max-width: 640px)');
    const h = () => setIsNarrow(m.matches);
    if (m.addEventListener) m.addEventListener('change', h);
    else m.addListener(h);
    return () => {
      if (m.removeEventListener) m.removeEventListener('change', h);
      else m.removeListener(h);
    };
  }, []);

  // 6-2 fix: cursor / draw offset. Previously read the bounding rect of
  // the parent stage div, which can drift from the SVG's actual render
  // box (image baseline gap, parent CSS, mobile -14px margin trick).
  // Reading from the SVG's own getBoundingClientRect guarantees the
  // coordinates we compute land exactly under the cursor.
  const getRelPos = (e) => {
    const el = svgRef.current || stageRef.current;
    if (!el) return { x: 0, y: 0 };
    const r = el.getBoundingClientRect();
    const t = e.touches?.[0] || e.changedTouches?.[0] || e;
    return {
      x: Math.max(0, Math.min(1, (t.clientX - r.left) / r.width)),
      y: Math.max(0, Math.min(1, (t.clientY - r.top) / r.height)),
    };
  };

  const nextPinNum = () => {
    const pins = annotations.filter(a => a.type === 'pin');
    return pins.length + 1;
  };

  const onPointerDown = (e) => {
    // VIEW mode = no annotation. Touches must pass through so the
    // user can scroll the page past the photo without dropping pins.
    if (tool === 'view') return;
    // Block multi-touch: pinch/zoom should never start a stroke.
    if (e.touches && e.touches.length > 1) {
      setDrawing(null);
      return;
    }
    if (editingPin) return;
    e.preventDefault();
    const pos = getRelPos(e);
    const id = 'a' + Date.now() + Math.random().toString(36).slice(2, 6);
    const c = MARKUP_COLORS.find(c => c.id === color).hex;
    if (tool === 'draw') {
      setDrawing({ id, type: 'draw', color: c, points: [pos] });
    } else if (tool === 'pin') {
      const num = nextPinNum();
      const newPin = { id, type: 'pin', color: c, points: [pos], data: { num, label: '', dim: '' } };
      setAnnotations([...annotations, newPin]);
      setEditingPin(id);
    }
  };

  const onPointerMove = (e) => {
    // Block multi-touch mid-stroke too — abort and clear.
    if (e.touches && e.touches.length > 1) {
      setDrawing(null);
      return;
    }
    if (!drawing) return;
    e.preventDefault();
    const pos = getRelPos(e);
    if (drawing.type === 'draw') {
      // Mutate the points array in place; the drawing object identity
      // is stable. Old behaviour allocated a fresh array AND object on
      // every pointermove (60fps × O(N) for a long stroke = O(N²) churn
      // per stroke). The actual paint happens via a rAF-coalesced render
      // bump below so we re-render at most once per frame even when
      // touchmove fires faster.
      drawing.points.push(pos);
      if (!rafPendingRef.current) {
        rafPendingRef.current = true;
        requestAnimationFrame(() => {
          rafPendingRef.current = false;
          forceRender();
        });
      }
    }
  };

  const onPointerUp = () => {
    if (!drawing) return;
    setAnnotations([...annotations, drawing]);
    setDrawing(null);
  };

  const undo = () => {
    setAnnotations(annotations.slice(0, -1));
  };
  const clear = () => setAnnotations([]);

  const deleteAnnotation = (id) => {
    setAnnotations(annotations.filter(a => a.id !== id));
    if (editingPin === id) setEditingPin(null);
  };

  const updateAnnotation = (id, patch) => {
    setAnnotations(annotations.map(a => a.id === id ? { ...a, data: { ...a.data, ...patch } } : a));
  };

  const pathFromPoints = (pts) => {
    if (!pts.length) return '';
    return pts.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x * 100} ${p.y * 100}`).join(' ');
  };

  const allAnnos = drawing ? [...annotations, drawing] : annotations;
  const editingPinData = annotations.find(a => a.id === editingPin);

  const handleClearWithConfirm = async () => {
    if (window.bsConfirm) {
      const ok = await window.bsConfirm({
        title: 'Clear all annotations?',
        body: 'This removes every pin and stroke. Cannot be undone.',
        confirmLabel: 'Clear',
        danger: true,
      });
      if (ok) clear();
    } else {
      if (confirm('Clear all annotations? This cannot be undone.')) clear();
    }
  };

  return (
    <div className="markup">
      <style>{`
        @media (max-width: 640px) {
          .pc-tool-palette-mobile {
            position: sticky;
            bottom: 0;
            background: var(--bg, white);
            padding-bottom: calc(8px + var(--safe-bottom, 0px));
            z-index: 5;
            border-top: 1px solid var(--rule, #e5e5e5);
          }
          .pc-tool-palette-mobile .tool-btn { min-height: 44px; min-width: 44px; font-size: 13px; }
          .pc-tool-palette-mobile .btn { min-height: 44px; font-size: 13px; }
          .pc-tool-palette-mobile .color-swatch-wrap { width: 44px; height: 44px; padding: 2px; }
          .pc-tool-palette-mobile .color-swatch-wrap > button { width: 40px; height: 40px; }
        }
      `}</style>
      <div className="markup-stage" ref={stageRef}>
        <img src={photo} className="photo" alt="Cabinet" draggable={false}/>
        <svg
          ref={svgRef}
          className="overlay"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          // VIEW mode: pointer-events:none + touch-action:auto so the
          // user can scroll past the photo without dropping pins.
          // PIN/DRAW mode: capture touches and block native scroll so
          // strokes don't pan the page.
          style={{
            touchAction: tool === 'view' ? 'auto' : 'none',
            pointerEvents: tool === 'view' ? 'none' : 'auto',
          }}
          onMouseDown={onPointerDown}
          onMouseMove={onPointerMove}
          onMouseUp={onPointerUp}
          onMouseLeave={onPointerUp}
          onTouchStart={onPointerDown}
          onTouchMove={onPointerMove}
          onTouchEnd={onPointerUp}
        >
          {allAnnos.map(a => {
            if (a.type === 'draw') {
              return (
                <path key={a.id}
                  d={pathFromPoints(a.points)}
                  stroke={a.color} strokeWidth="0.6" fill="none"
                  strokeLinecap="round" strokeLinejoin="round"
                  vectorEffect="non-scaling-stroke"
                  style={{ strokeWidth: 3 }}
                />
              );
            }
            return null;
          })}
        </svg>

        {/* Pins rendered as absolute DOM for crisp typography.
            Outer 44x44 transparent button is the actual hit target
            so phones get a Material-spec touch surface; the visible
            32px circle sits inside with pointer-events:none. */}
        {annotations.filter(a => a.type === 'pin').map(a => {
          const p = a.points[0];
          return (
            <button
              key={a.id}
              type="button"
              onClick={(e) => { e.stopPropagation(); setEditingPin(a.id); }}
              style={{
                position: 'absolute',
                left: `${p.x * 100}%`,
                top: `${p.y * 100}%`,
                width: 44,
                height: 44,
                transform: 'translate(-50%, -50%)',
                background: 'none',
                border: 0,
                padding: 0,
                cursor: 'pointer',
                touchAction: 'manipulation',
              }}
            >
              <span style={{
                display: 'grid',
                placeItems: 'center',
                width: 32,
                height: 32,
                borderRadius: '50%',
                background: a.color,
                color: 'white',
                fontSize: 13,
                fontWeight: 600,
                fontFamily: 'var(--mono)',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                pointerEvents: 'none',
                margin: '0 auto',
              }}>{a.data.num}</span>
              {a.data.dim && (
                <span style={{
                  position: 'absolute',
                  top: '100%', left: '50%',
                  transform: 'translateX(-50%)',
                  marginTop: 4,
                  background: 'rgba(0,0,0,0.85)',
                  color: 'white',
                  fontFamily: 'var(--mono)',
                  fontSize: 10,
                  padding: '2px 6px',
                  borderRadius: 3,
                  whiteSpace: 'nowrap',
                  pointerEvents: 'none',
                }}>{a.data.dim}</span>
              )}
            </button>
          );
        })}

        {/* Pin editor — inline popover on desktop, BottomSheet under 480px */}
        {editingPinData && !isNarrow && (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'absolute',
              left: `${editingPinData.points[0].x * 100}%`,
              top: `${editingPinData.points[0].y * 100}%`,
              transform: `translate(${editingPinData.points[0].x > 0.5 ? '-105%' : '5%'}, ${editingPinData.points[0].y > 0.6 ? '-105%' : '5%'})`,
              background: 'white',
              borderRadius: 10,
              padding: 14,
              boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
              width: 240,
              zIndex: 10,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <div style={{
                width: 22, height: 22, borderRadius: '50%',
                background: editingPinData.color, color: 'white',
                display: 'grid', placeItems: 'center',
                fontFamily: 'JetBrains Mono', fontSize: 11, fontWeight: 600,
              }}>{editingPinData.data.num}</div>
              <div style={{ fontSize: 13, fontWeight: 500, flex: 1 }}>Pin details</div>
              <button onClick={() => setEditingPin(null)}
                style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 4, color: 'var(--ink-soft)' }}>
                <Icon.X/>
              </button>
            </div>
            <input
              autoFocus
              autoCapitalize="sentences"
              placeholder="Describe the issue…"
              value={editingPinData.data.label}
              onChange={(e) => updateAnnotation(editingPinData.id, { label: e.target.value })}
              style={{ width: '100%', padding: '8px 10px', fontSize: 13, border: '1px solid var(--rule)', borderRadius: 6, marginBottom: 8, fontFamily: 'inherit' }}
            />
            <input
              inputMode="decimal"
              pattern="[0-9.]*"
              placeholder="Dimensions (e.g. 24×30)"
              value={editingPinData.data.dim}
              onChange={(e) => updateAnnotation(editingPinData.id, { dim: e.target.value })}
              style={{ width: '100%', padding: '8px 10px', fontSize: 13, border: '1px solid var(--rule)', borderRadius: 6, fontFamily: 'JetBrains Mono, monospace' }}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
              <button onClick={() => { deleteAnnotation(editingPinData.id); }}
                className="btn danger" style={{ padding: '6px 10px', fontSize: 12 }}>
                <Icon.Trash/> Remove
              </button>
              <button onClick={() => setEditingPin(null)}
                className="btn primary" style={{ padding: '6px 14px', fontSize: 12 }}>Done</button>
            </div>
          </div>
        )}
      </div>

      {/* Pin editor as BottomSheet on narrow phones */}
      {editingPinData && isNarrow && window.BottomSheet && (
        <window.BottomSheet open={!!editingPinData} onClose={() => setEditingPin(null)} title={`Pin ${editingPinData.data.num}`}>
          <input
            autoFocus
            autoCapitalize="sentences"
            placeholder="Describe the issue…"
            value={editingPinData.data.label}
            onChange={(e) => updateAnnotation(editingPinData.id, { label: e.target.value })}
            style={{ width: '100%', padding: '10px 12px', fontSize: 14, border: '1px solid var(--rule)', borderRadius: 6, marginBottom: 8, fontFamily: 'inherit' }}
          />
          <input
            inputMode="decimal"
            pattern="[0-9.]*"
            placeholder="Dimensions (e.g. 24×30)"
            value={editingPinData.data.dim}
            onChange={(e) => updateAnnotation(editingPinData.id, { dim: e.target.value })}
            style={{ width: '100%', padding: '10px 12px', fontSize: 14, border: '1px solid var(--rule)', borderRadius: 6, fontFamily: 'JetBrains Mono, monospace' }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginTop: 12 }}>
            <button type="button" onClick={() => { deleteAnnotation(editingPinData.id); }}
              className="btn danger" style={{ padding: '10px 14px', fontSize: 13, minHeight: 44 }}>
              <Icon.Trash/> Remove
            </button>
            <button type="button" onClick={() => setEditingPin(null)}
              className="btn primary" style={{ padding: '10px 18px', fontSize: 13, minHeight: 44 }}>Done</button>
          </div>
        </window.BottomSheet>
      )}

      <div className="tool-palette pc-tool-palette-mobile">
        <div style={{ fontSize: 11, fontWeight: 500, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-faint)', fontFamily: 'var(--mono)' }}>
          Tool
        </div>
        <div className="tool-row">
          {TOOLS.map(t => {
            const TIcon = Icon[t.icon];
            return (
              <button key={t.id}
                type="button"
                className={'tool-btn' + (tool === t.id ? ' active' : '')}
                style={{ minHeight: 44, minWidth: 44, fontSize: 13 }}
                onClick={() => setTool(t.id)}>
                <TIcon/>
                {t.label}
              </button>
            );
          })}
        </div>

        <div style={{ fontSize: 11, fontWeight: 500, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-faint)', fontFamily: 'var(--mono)', marginTop: 4 }}>
          Color
        </div>
        <div className="color-swatches">
          {MARKUP_COLORS.map(c => (
            <span key={c.id} className="color-swatch-wrap" style={{
              display: 'inline-grid',
              placeItems: 'center',
              width: 44,
              height: 44,
              padding: 2,
              boxSizing: 'border-box',
            }}>
              <button
                type="button"
                className={color === c.id ? 'active' : ''}
                onClick={() => setColor(c.id)}
                style={{ background: c.hex, width: 40, height: 40 }}
                title={c.label}
                aria-label={c.label}
              />
            </span>
          ))}
        </div>

        <div className="tool-row" style={{ marginTop: 4 }}>
          <button type="button" className="btn secondary" style={{ flex: 1, justifyContent: 'center', minHeight: 44, fontSize: 13 }} onClick={undo} disabled={!annotations.length}>
            <Icon.Undo/> Undo
          </button>
          <button type="button" className="btn ghost" style={{ flex: 1, justifyContent: 'center', minHeight: 44, fontSize: 13 }} onClick={handleClearWithConfirm} disabled={!annotations.length}>
            Clear all
          </button>
        </div>

        <div className="markup-legend">
          <div style={{ fontSize: 11, fontWeight: 500, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-faint)', fontFamily: 'var(--mono)', marginBottom: 6 }}>
            Pinned items ({annotations.filter(a => a.type === 'pin').length})
          </div>
          {annotations.filter(a => a.type === 'pin').length === 0 && (
            <div style={{ fontSize: 12, color: 'var(--ink-faint)', padding: '8px 6px' }}>
              Drop pins on the photo to call out specific repair locations.
            </div>
          )}
          {annotations.filter(a => a.type === 'pin').map(a => (
            <div key={a.id} className="legend-item">
              <div className="num" style={{ background: a.color }}>{a.data.num}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="label" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {a.data.label || <span style={{ color: 'var(--ink-faint)' }}>Untitled</span>}
                </div>
                {a.data.dim && <div className="dim">{a.data.dim}</div>}
              </div>
              <button type="button" className="btn ghost" onClick={() => setEditingPin(a.id)} style={{ padding: 4, minHeight: 44, minWidth: 44 }}>
                <Icon.Pencil/>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Memoised on photo + annotations. setAnnotations identity is ignored on
// purpose — the parent recreates that lambda on every render, but the
// callback chain underneath uses functional setData (see app.jsx
// updateCabinet), so a stale closure still writes against the latest
// state. Photo (dataURL string) and annotations (committed array) are
// the only props that actually affect what the canvas paints.
function sameAnns(a, b) {
  if (a === b) return true;
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
  return true;
}
const MarkupCanvas = React.memo(MarkupCanvasImpl, (prev, next) => {
  return prev.photo === next.photo && sameAnns(prev.annotations, next.annotations);
});

Object.assign(window, { MarkupCanvas });

})();

// ===== cabinet-schematic.jsx =====
(function(){
// Vendor PWA cabinet schematic — read-only viewer that opens in a
// modal when the vendor clicks "View Schematic" on a cabinet card in
// the order detail page. The cut list is gated by the order's
// `showCutListToVendor` flag (admins toggle this per-order).
//
// This file ports the rules-engine math from the admin-portal's
// TypeScript implementation. It is intentionally kept in sync with
// `admin-portal/src/lib/cabinetSchematic/rulesEngine.ts` — when you
// change one, mirror the change here.

const { useState: useStCab, useEffect: useEfCab, useMemo: useMeCab } = React;

const INDUSTRY_DEFAULT_SC = {
  dadoDepth: 0.375, dadoSetback: 0.5, pocketScrewClearance: 0,
  confirmatEdgeOffset: 0.375, confirmatScrewSpacing: 4,
  scribeAllowance: 0.25, finishedSideOverhang: 0.25,
  faceFrameStileWidth: 1.5, faceFrameRailWidth: 1.5, faceFrameThickness: 0.75,
  toeKickHeight: 4.5, toeKickSetback: 3, toeKickThickness: 0.75,
  drawerSlideClearancePerSide: 0.5, shelfSetbackFromFace: 0.25, topStretcherWidth: 4,
  backPanelArea864ThresholdSqIn: 864, defaultBackThickness: 0.25, defaultBoxThickness: 0.75,
  sheetGoodWidth: 48, sheetGoodHeight: 96,
};

function fmtIn(v) {
  if (v == null || isNaN(v)) return '0"';
  const whole = Math.floor(v);
  const frac = v - whole;
  const sixteenths = Math.round(frac * 16);
  if (sixteenths === 0) return whole + '"';
  if (sixteenths === 16) return (whole + 1) + '"';
  const gcdf = (a, b) => (b === 0 ? a : gcdf(b, a % b));
  const g = gcdf(sixteenths, 16);
  const num = sixteenths / g;
  const den = 16 / g;
  return whole > 0 ? whole + '-' + num + '/' + den + '"' : num + '/' + den + '"';
}

function joineryOffset(joinery, sc) {
  if (joinery === 'dado') return 2 * sc.dadoDepth;
  return 0;
}

function pickBackThickness(w, h, sc, override) {
  if (override != null) return override;
  return (w * h) > sc.backPanelArea864ThresholdSqIn ? 0.5 : sc.defaultBackThickness;
}

// Simplified standard rules — matches admin computeStandard() output
function computeCabinetPanels(input, sc) {
  const boxT = input.boxThickness || sc.defaultBoxThickness;
  const backT = pickBackThickness(input.w, input.h, sc, input.backThickness);
  const joinery = input.joinery || 'confirmat';
  const off = joineryOffset(joinery, sc);
  const sideDepth = input.d;

  const panels = [];
  panels.push({ name: 'Side panel (×2)', qty: 2, w: sideDepth, h: input.h, t: boxT, joinery });

  const bottomW = (input.w - 2 * boxT) + off;
  panels.push({ name: 'Bottom', qty: 1, w: bottomW, h: sideDepth - sc.faceFrameThickness, t: boxT, joinery });

  const stretcherW = (input.w - 2 * boxT) + off;
  panels.push({ name: 'Top stretcher (front)', qty: 1, w: stretcherW, h: sc.topStretcherWidth, t: boxT, joinery });
  panels.push({ name: 'Top stretcher (back)', qty: 1, w: stretcherW, h: sc.topStretcherWidth, t: boxT, joinery });

  const backH = input.h + (joinery === 'dado' ? off : 0);
  panels.push({ name: 'Back panel', qty: 1, w: stretcherW, h: backH, t: backT, joinery });

  if (input.hasToeKick) {
    panels.push({ name: 'Toe kick', qty: 1, w: input.w - 2 * boxT, h: sc.toeKickHeight, t: sc.toeKickThickness, joinery: 'pocketScrew' });
  }
  if (input.shelves > 0) {
    panels.push({ name: 'Adjustable shelf', qty: input.shelves, w: input.w - 2 * boxT - 0.0625, h: input.d - sc.faceFrameThickness - sc.shelfSetbackFromFace, t: boxT, joinery: 'pocketScrew' });
  }
  if (input.drawers > 0) {
    panels.push({ name: 'Drawer box', qty: input.drawers, w: input.w - 2 * boxT - 2 * sc.drawerSlideClearancePerSide, h: 4, t: 0.5, joinery: 'pocketScrew' });
  }
  return panels;
}

function CabinetSchematicVendor({ cab, idx, showCutList }) {
  const [open, setOpen] = useStCab(false);
  const [view, setView] = useStCab('front');
  const [sc, setSc] = useStCab(INDUSTRY_DEFAULT_SC);

  useEfCab(() => {
    if (!open || !window.db) return;
    db.doc('shopConstants/current').get().then((snap) => {
      if (snap.exists) setSc({ ...INDUSTRY_DEFAULT_SC, ...snap.data() });
    }).catch(() => {});
  }, [open]);

  const w = parseFloat(cab.w) || 0;
  const h = parseFloat(cab.h) || 0;
  const d = parseFloat(cab.d) || 0;
  const doors = parseInt(cab.doors) || 0;
  const drawers = parseInt(cab.drawers) || 0;
  const shelves = parseInt(cab.shelves) || 0;
  const hasToeKick = h < 60 && d > 16; // base / drawer base / sink base

  const panels = useMeCab(() => {
    if (!w || !h || !d) return [];
    return computeCabinetPanels({ w, h, d, doors, drawers, shelves, hasToeKick }, sc);
  }, [w, h, d, doors, drawers, shelves, hasToeKick, sc]);

  if (!w || !h || !d) return null;

  return (
    <>
      <button className="btn ghost sm" onClick={() => setOpen(true)} style={{ marginTop: 6 }}>
        View Schematic
      </button>
      {open && (
        <div className="schematic-overlay" onClick={() => setOpen(false)}>
          <div className="schematic-modal" onClick={(e) => e.stopPropagation()}>
            <div className="schematic-head">
              <div>
                <div className="eyebrow">Cab {String(idx + 1).padStart(2, '0')}{cab.name ? ' — ' + cab.name : ''}</div>
                <h3>{w}" × {h}" × {d}"</h3>
              </div>
              <button className="schematic-close" onClick={() => setOpen(false)}>×</button>
            </div>
            <div className="schematic-tabs">
              {['front', 'back', 'left', 'right', 'top'].map((v) => (
                <button key={v} className={'schematic-tab' + (view === v ? ' on' : '')} onClick={() => setView(v)}>
                  {v.charAt(0).toUpperCase() + v.slice(1)}
                </button>
              ))}
            </div>
            <div className="schematic-body">
              <SchematicSvgVendor view={view} w={w} h={h} d={d} boxT={sc.defaultBoxThickness} hasToeKick={hasToeKick} sc={sc} />
              {showCutList ? (
                <div className="schematic-cutlist">
                  <h4>Cut List</h4>
                  <table>
                    <thead>
                      <tr>
                        <th>Panel</th>
                        <th style={{ textAlign: 'right' }}>Qty</th>
                        <th style={{ textAlign: 'right' }}>W</th>
                        <th style={{ textAlign: 'right' }}>H</th>
                        <th style={{ textAlign: 'right' }}>Thick</th>
                      </tr>
                    </thead>
                    <tbody>
                      {panels.map((p, i) => (
                        <tr key={i}>
                          <td>{p.name}</td>
                          <td style={{ textAlign: 'right' }} className="mono">{p.qty}</td>
                          <td style={{ textAlign: 'right' }} className="mono">{fmtIn(p.w)}</td>
                          <td style={{ textAlign: 'right' }} className="mono">{fmtIn(p.h)}</td>
                          <td style={{ textAlign: 'right' }} className="mono">{fmtIn(p.t)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="schematic-cutlist-hidden">
                  Cut list is hidden for this order. Contact Precision Cabinets if you need it.
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function SchematicSvgVendor({ view, w, h, d, boxT, hasToeKick, sc }) {
  const outerW = view === 'left' || view === 'right' ? d : w;
  const outerH = view === 'top' ? d : h;
  const padding = 50;
  const targetMax = 360;
  const scale = Math.min(targetMax / outerW, targetMax / outerH);
  const dW = outerW * scale;
  const dH = outerH * scale;
  const total = padding * 2;

  return (
    <svg viewBox={`0 0 ${dW + total} ${dH + total}`} width="100%" style={{ maxHeight: 360 }}>
      <rect x={padding} y={padding} width={dW} height={dH} fill="#fef3c7" stroke="#b45309" strokeWidth={2} />
      {(view === 'front' || view === 'back') && (
        <>
          <rect x={padding} y={padding} width={boxT * scale} height={dH} fill="#fde68a" stroke="#b45309" />
          <rect x={padding + dW - boxT * scale} y={padding} width={boxT * scale} height={dH} fill="#fde68a" stroke="#b45309" />
        </>
      )}
      {hasToeKick && (view === 'front' || view === 'back') && (
        <rect
          x={padding + boxT * scale}
          y={padding + dH - sc.toeKickHeight * scale}
          width={dW - 2 * boxT * scale}
          height={sc.toeKickHeight * scale}
          fill="#92400e" opacity={0.3} stroke="#92400e"
        />
      )}
      {/* Top dimension */}
      <line x1={padding} y1={padding - 14} x2={padding + dW} y2={padding - 14} stroke="#92400e" strokeWidth={0.75} />
      <text x={padding + dW / 2} y={padding - 18} textAnchor="middle" fill="#92400e" fontSize={10}>{fmtIn(outerW)}</text>
      {/* Left dimension */}
      <text
        x={padding - 24} y={padding + dH / 2}
        textAnchor="middle" fill="#92400e" fontSize={10}
        transform={`rotate(-90 ${padding - 24} ${padding + dH / 2})`}
      >{fmtIn(outerH)}</text>
      <text x={(dW + total) / 2} y={dH + total - 8} textAnchor="middle" fill="#92400e" fontSize={11} fontWeight={600}>{view.toUpperCase()} VIEW</text>
    </svg>
  );
}

Object.assign(window, { CabinetSchematicVendor });

})();

// ===== steps.jsx =====
(function(){
// Cabinet-by-cabinet intake — replaces the old "Areas" model
// Each area now holds a list of cabinets, each with structured fields,
// plus a toe-kick block, special instructions, and a pre-review checklist.

const { useState, useEffect, useMemo, useRef } = React;

// 6-2 narrowing: only the 5 species the shop actively works with, plus
// Unknown as a catch-all. These map 1:1 to the variant rows in the new
// cost-builder model (each repair operation has one entry per species).
// Naming MUST match the variantSpecies values in admin-portal/src/types/pricing.ts
// VARIANT_SPECIES — the vendor pricing engine uses string equality.
const BOX_MATERIALS = [
  'Hardrock Maple',
  'Birch',
  'White Melamine',
  'Almond Melamine',
  'Particle Board',
  'Unknown',
];

const TOE_KICK_THICKNESS = ['1/4"', '1/2"', '5/8"', '3/4"'];

// ============================================================
// Client info
// ============================================================
function ClientStep({ data, setData }) {
  const update = (k, v) => setData(d => ({ ...d, [k]: v }));
  return (
    <>
      <div className="page-head">
        <span className="eyebrow">Step 01 · Your Info & Customer</span>
        <h1>Who and where?</h1>
        <p>Your contact info, the customer details, and the project site.</p>
      </div>

      <div className="card">
        <div className="card-head">
          <h3>Your Info <span style={{ fontSize: 12, color: 'var(--ink-faint)', fontFamily: 'var(--mono)', fontWeight: 400, marginLeft: 8, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Contact & reference</span></h3>
        </div>
        <div className="field-grid">
          <div className="field">
            <label>Vendor / company name <span className="req">*</span></label>
            <input className="input" value={data.vendorName || ''} onChange={e => update('vendorName', e.target.value)} placeholder="e.g. Sun Valley Cabinets"/>
          </div>
          <div className="field">
            <label>Vendor contact</label>
            <input className="input" value={data.vendorContact || ''} onChange={e => update('vendorContact', e.target.value)} placeholder="Project manager / point of contact"/>
          </div>
          <div className="field">
            <label>Vendor phone</label>
            <input className="input mono" type="tel" inputMode="tel" maxLength={14} value={data.vendorPhone || ''} onChange={e => update('vendorPhone', window.formatPhoneInput(e.target.value))} placeholder="(480) 555-0100"/>
          </div>
          <div className="field">
            <label>Vendor email</label>
            <input className="input" type="email" inputMode="email" autoCapitalize="none" value={data.vendorEmail || ''} onChange={e => update('vendorEmail', e.target.value)} placeholder="pm@sunvalleycabinets.com"/>
          </div>
          <div className="field span-2">
            <label>PO / job reference</label>
            <input className="input mono" value={data.vendorPO || ''} onChange={e => update('vendorPO', e.target.value)} placeholder="Vendor's PO or job number"/>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-head">
          <h3>Customer <span style={{ fontSize: 12, color: 'var(--ink-faint)', fontFamily: 'var(--mono)', fontWeight: 400, marginLeft: 8, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Homeowner / end client</span></h3>
        </div>
        <div className="field-grid">
          <div className="field">
            <label>Customer name <span className="req">*</span></label>
            <input className="input" value={data.clientName || ''} onChange={e => update('clientName', e.target.value)} placeholder="e.g. Sarah Coleman"/>
          </div>
          <div className="field">
            <label>Phone</label>
            <input className="input mono" type="tel" inputMode="tel" maxLength={14} value={data.clientPhone || ''} onChange={e => update('clientPhone', window.formatPhoneInput(e.target.value))} placeholder="(480) 555-0142"/>
          </div>
          <div className="field">
            <label>Email</label>
            <input className="input" type="email" inputMode="email" autoCapitalize="none" value={data.clientEmail || ''} onChange={e => update('clientEmail', e.target.value)} placeholder="sarah@example.com"/>
          </div>
          <div className="field">
            <label>Preferred contact</label>
            <div className="segmented">
              {['Phone', 'Text', 'Email'].map(opt => (
                <button key={opt} className={data.preferredContact === opt ? 'on' : ''}
                  onClick={() => update('preferredContact', opt)}>{opt}</button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-head"><h3>Project Site</h3></div>
        <div className="field-grid">
          <div className="field span-2">
            <label>Project address <span className="req">*</span></label>
            <input className="input" value={data.address || ''} onChange={e => update('address', e.target.value)} placeholder="Street, city, state, ZIP"/>
          </div>
          <div className="field">
            <label>Install needed?</label>
            <div className="segmented">
              {['Yes', 'No', 'Unsure'].map(opt => (
                <button key={opt} className={data.installNeeded === opt ? 'on' : ''}
                  onClick={() => update('installNeeded', opt)}>{opt}</button>
              ))}
            </div>
          </div>
          <div className="field">
            <label>Home type</label>
            <div className="segmented">
              {['Residential', 'Condo', 'Rental', 'Commercial'].map(opt => (
                <button key={opt} className={data.homeType === opt ? 'on' : ''}
                  onClick={() => update('homeType', opt)}>{opt}</button>
              ))}
            </div>
          </div>
          <div className="field span-2">
            <label>Access notes</label>
            <textarea className="textarea" value={data.accessNotes || ''} onChange={e => update('accessNotes', e.target.value)}
              placeholder="Gate code, pets, parking, best entry…"/>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-head"><h3>Timeframe</h3></div>
        <div className="field-grid one">
          <div className="field">
            <label>Completion date requested</label>
            <input className="input mono" type="date" value={data.completionRequested || ''} onChange={e => update('completionRequested', e.target.value)} style={{ maxWidth: 240 }}/>
            <div className="hint">Date received auto-stamps on submit ({new Date().toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}).</div>
          </div>
          <div className="field">
            <label>Priority</label>
            <div className="chips">
              {[
                { v: 'asap', l: 'ASAP' },
                { v: '2wk', l: 'Within 2 weeks' },
                { v: '1mo', l: 'Within 1 month' },
                { v: '3mo', l: 'Within 3 months' },
                { v: 'flex', l: 'Flexible' },
              ].map(o => (
                <button key={o.v} className={'chip' + (data.timeframe === o.v ? ' on' : '')}
                  onClick={() => update('timeframe', o.v)}>
                  <span className="dot"></span>{o.l}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// ============================================================
// CabinetsStep — list of cabinets with detailed specs
// ============================================================
function CabinetsStep({ data, setData, onProceed }) {
  const cabinets = data.cabinets || [];
  const [activeIdx, setActiveIdx] = useState(0);
  const [showChecklist, setShowChecklist] = useState(false);
  const activeTabRef = useRef(null);

  useEffect(() => {
    if (cabinets.length === 0) {
      setData(d => ({ ...d, cabinets: [makeCabinet(1)] }));
      setActiveIdx(0);
    }
  }, []);

  useEffect(() => {
    if (activeTabRef.current && typeof activeTabRef.current.scrollIntoView === 'function') {
      activeTabRef.current.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
    }
  }, [activeIdx, cabinets.length]);

  const active = cabinets[activeIdx];

  const updateActive = (patch) => {
    const next = cabinets.map((c, i) => i === activeIdx ? { ...c, ...patch } : c);
    setData(d => ({ ...d, cabinets: next }));
  };

  const updateField = (key, value) => updateActive({ [key]: value });

  const addCabinet = () => {
    const next = [...cabinets, makeCabinet(cabinets.length + 1)];
    setData(d => ({ ...d, cabinets: next }));
    setActiveIdx(next.length - 1);
  };

  const removeCabinet = (idx) => {
    if (cabinets.length <= 1) return;
    const next = cabinets.filter((_, i) => i !== idx);
    setData(d => ({ ...d, cabinets: next }));
    setActiveIdx(Math.max(0, Math.min(activeIdx, next.length - 1)));
  };

  const updateToeKick = (patch) => {
    setData(d => ({ ...d, toeKick: { ...(data.toeKick || {}), ...patch } }));
  };

  const tk = data.toeKick || {};

  if (!active) return null;

  return (
    <>
      <div className="page-head">
        <span className="eyebrow">Step 02 · Cabinets & Toe Kick</span>
        <h1>Build the order</h1>
        <p>Add each cabinet with its construction details. After all cabinets are entered, fill in the toe kick spec and any special instructions.</p>
      </div>

      <div className="area-tabs">
        {cabinets.map((c, i) => (
          <button key={c.id}
            ref={activeIdx === i ? activeTabRef : null}
            className={'area-tab' + (activeIdx === i ? ' active' : '')}
            onClick={() => setActiveIdx(i)}>
            <span>Cab {String(i + 1).padStart(2, '0')}</span>
            <span className="badge">{c.w && c.h ? `${c.w}×${c.h}` : '—'}</span>
          </button>
        ))}
        <button className="area-tab add" onClick={addCabinet}>
          <Icon.Plus/> Add cabinet
        </button>
      </div>

      <div className="card">
        <div className="card-head">
          <div>
            <div className="eyebrow">Cabinet {String(activeIdx + 1).padStart(2, '0')}</div>
            <input className="input" value={active.name || ''}
              onChange={e => updateField('name', e.target.value)}
              placeholder="Label this cabinet (e.g. Sink base, Upper L)"
              style={{ fontFamily: 'var(--serif)', fontSize: 20, border: 'none', background: 'transparent', padding: 0, width: '100%', fontWeight: 500, marginTop: 4 }}/>
          </div>
          {cabinets.length > 1 && (
            <button className="btn danger" onClick={() => removeCabinet(activeIdx)}>
              <Icon.Trash/> Remove cabinet
            </button>
          )}
        </div>

        {/* Photo + markup (optional) */}
        <div className="section" style={{ marginTop: 16 }}>
          <div className="section-head"><h3>Photo & markup</h3><span className="eyebrow">Optional · pin damage</span></div>
          {!active.photo ? (
            <div className="photo-dropzone">
              <div className="icon"><Icon.Camera/></div>
              <p>Capture or upload a photo of this cabinet</p>
              <div className="capture-buttons" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                <PhotoCaptureButton kind="camera" onSet={(src) => updateField('photo', src)}/>
                <PhotoCaptureButton kind="upload" onSet={(src) => updateField('photo', src)}/>
                <button className="btn ghost" style={{ flex: '1 1 140px', minHeight: 44 }} onClick={() => updateField('photo', PLACEHOLDER_PHOTO)}>
                  Use sample photo
                </button>
              </div>
              <div className="tiny">Camera uses your device lens · JPG, PNG, HEIC up to 20MB</div>
            </div>
          ) : (
            <>
              <MarkupCanvas
                photo={active.photo}
                annotations={active.annotations || []}
                setAnnotations={(ann) => updateField('annotations', ann)}
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                <button className="btn ghost" onClick={() => { updateField('photo', null); updateField('annotations', []); }}>
                  <Icon.X/> Replace photo
                </button>
              </div>
            </>
          )}
        </div>

        {/* Dimensions */}
        <div className="section">
          <div className="section-head"><h3>Dimensions</h3><span className="eyebrow">Cabinet body</span></div>
          <div className="field-grid three">
            <DimField label="Width" value={active.w} unit={active.wu} onValue={v => updateField('w', v)} onUnit={u => updateField('wu', u)}/>
            <DimField label="Height" value={active.h} unit={active.hu} onValue={v => updateField('h', v)} onUnit={u => updateField('hu', u)}/>
            <DimField label="Depth" value={active.d} unit={active.du} onValue={v => updateField('d', v)} onUnit={u => updateField('du', u)}/>
          </div>
        </div>

        {/* Components */}
        <div className="section">
          <div className="section-head"><h3>Components</h3><span className="eyebrow">Counts & shelf size</span></div>
          <div className="field-grid three">
            <div className="field">
              <label># of doors</label>
              <NumberStepper value={active.doors} onChange={v => updateField('doors', v)}/>
            </div>
            <div className="field">
              <label># of drawers</label>
              <NumberStepper value={active.drawers} onChange={v => updateField('drawers', v)}/>
            </div>
            <div className="field">
              <label># of shelves</label>
              <NumberStepper value={active.shelves} onChange={v => updateField('shelves', v)}/>
            </div>
            <div className="field span-2">
              <label>Shelf size (W × D)</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input className="input mono" type="number" inputMode="decimal" pattern="[0-9.]*" value={active.shelfW || ''} onChange={e => updateField('shelfW', e.target.value)} placeholder="W"/>
                <span style={{ alignSelf: 'center', color: 'var(--ink-faint)' }}>×</span>
                <input className="input mono" type="number" inputMode="decimal" pattern="[0-9.]*" value={active.shelfD || ''} onChange={e => updateField('shelfD', e.target.value)} placeholder="D"/>
                <select className="select" style={{ width: 80 }} value={active.shelfU || 'in'} onChange={e => updateField('shelfU', e.target.value)}>
                  <option>in</option><option>mm</option>
                </select>
              </div>
              <div className="hint">Leave blank if no shelves.</div>
            </div>
          </div>
        </div>

        {/* Finished side */}
        <div className="section">
          <div className="section-head"><h3>Finished side</h3><span className="eyebrow">Exposed end panel</span></div>
          <div className="field-grid">
            <div className="field">
              <label>Finished side?</label>
              <div className="segmented">
                {['Yes', 'No'].map(opt => (
                  <button key={opt} className={active.finishedSide === opt ? 'on' : ''}
                    onClick={() => updateField('finishedSide', opt)}>{opt}</button>
                ))}
              </div>
            </div>
            {active.finishedSide === 'Yes' && (
              <div className="field">
                <label>Which side?</label>
                <div className="segmented">
                  {['Left', 'Right', 'Both'].map(opt => (
                    <button key={opt} className={active.finishedWhich === opt ? 'on' : ''}
                      onClick={() => updateField('finishedWhich', opt)}>{opt}</button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Box material */}
        <div className="section">
          <div className="section-head"><h3>Box material</h3><span className="eyebrow">Species & thickness</span></div>
          <div className="field-grid">
            <div className="field">
              <label>Material</label>
              <select className="select" value={active.boxMaterial || ''} onChange={e => updateField('boxMaterial', e.target.value)}>
                <option value="">Select material…</option>
                {BOX_MATERIALS.map(m => <option key={m}>{m}</option>)}
              </select>
            </div>
            <div className="field">
              <label>Thickness</label>
              <div style={{ display: 'flex', gap: 6 }}>
                <input className="input mono" inputMode="decimal" pattern="[0-9./]*" value={active.boxThickness || ''} onChange={e => updateField('boxThickness', e.target.value)} placeholder='e.g. 3/4"'/>
                <div className="segmented" style={{ flex: 'none' }}>
                  {['1/2"', '5/8"', '3/4"'].map(opt => (
                    <button key={opt} className={active.boxThickness === opt ? 'on' : ''}
                      onClick={() => updateField('boxThickness', opt)}>{opt}</button>
                  ))}
                </div>
              </div>
            </div>
            {(active.boxMaterial === 'Unknown' || active.boxMaterial === 'Other') && (
              <div className="field span-2">
                <label>Notes (optional)</label>
                <input className="input" value={active.boxMaterialOther || ''} onChange={e => updateField('boxMaterialOther', e.target.value)} placeholder="Anything you know about the material — shop will confirm by measuring."/>
              </div>
            )}
          </div>
        </div>

        {/* Cabinet type */}
        <div className="section">
          <div className="section-head"><h3>Cabinet type</h3><span className="eyebrow">Layout</span></div>
          <div className="field-grid one">
            <div className="field">
              <label>Is this an island or peninsula?</label>
              <div className="segmented" style={{ maxWidth: 460 }}>
                {['Standard wall', 'Island', 'Peninsula'].map(opt => (
                  <button key={opt} className={active.cabType === opt ? 'on' : ''}
                    onClick={() => updateField('cabType', opt)}>{opt}</button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="section">
          <div className="section-head"><h3>Cabinet notes</h3><span className="eyebrow">Optional</span></div>
          <textarea className="textarea" value={active.notes || ''}
            onChange={e => updateField('notes', e.target.value)}
            placeholder="Anything specific to this cabinet — damage callouts, finish details, hardware to match…"/>
        </div>
      </div>

      {/* TOE KICK BLOCK */}
      <div className="card">
        <div className="card-head">
          <h3>Toe kick</h3>
          <span className="eyebrow">For the whole order</span>
        </div>
        <div className="field-grid three">
          <DimField label="Height" value={tk.height} unit={tk.heightU} onValue={v => updateToeKick({ height: v })} onUnit={u => updateToeKick({ heightU: u })}/>
          <DimField label="Depth" value={tk.depth} unit={tk.depthU} onValue={v => updateToeKick({ depth: v })} onUnit={u => updateToeKick({ depthU: u })}/>
          <DimField label="Setback from face edge" value={tk.setback} unit={tk.setbackU} onValue={v => updateToeKick({ setback: v })} onUnit={u => updateToeKick({ setbackU: u })}/>
        </div>
        <div className="field-grid" style={{ marginTop: 16 }}>
          <div className="field">
            <label>Thickness</label>
            <div className="segmented">
              {TOE_KICK_THICKNESS.map(opt => (
                <button key={opt} className={tk.thickness === opt ? 'on' : ''}
                  onClick={() => updateToeKick({ thickness: opt })}>{opt}</button>
              ))}
            </div>
          </div>
          <div className="field">
            <label>Total length needed (linear feet)</label>
            <div style={{ display: 'flex', gap: 6 }}>
              <input className="input mono" type="number" inputMode="decimal" pattern="[0-9.]*" value={tk.linearFt || ''} onChange={e => updateToeKick({ linearFt: e.target.value })} placeholder="0"/>
              <span style={{ alignSelf: 'center', color: 'var(--ink-faint)', fontFamily: 'var(--mono)', fontSize: 13 }}>lin. ft</span>
            </div>
          </div>
        </div>
      </div>

      {/* SPECIAL INSTRUCTIONS */}
      <div className="card">
        <div className="card-head">
          <h3>Special instructions</h3>
          <span className="eyebrow">Optional</span>
        </div>
        <textarea className="textarea" value={data.specialInstructions || ''}
          onChange={e => setData(d => ({ ...d, specialInstructions: e.target.value }))}
          placeholder="Color match notes, hardware preferences, scheduling constraints, anything else we need to know…"
          style={{ minHeight: 100 }}/>
      </div>

      {/* Continue → checklist popup */}
      <div className="nav-foot no-print">
        <div></div>
        <button className="btn primary lg" onClick={() => setShowChecklist(true)}>
          Continue to review <Icon.ArrowR/>
        </button>
      </div>

      {showChecklist && (
        <ChecklistModal onClose={() => setShowChecklist(false)} onProceed={() => { setShowChecklist(false); onProceed(); }}/>
      )}
    </>
  );
}

// ============================================================
// Checklist popup — shown before review
// ============================================================
function ChecklistModal({ onClose, onProceed }) {
  const [shippingNote, setShippingNote] = useState('');
  const BS = (typeof window !== 'undefined' && window.BottomSheet) || null;
  const BSActions = (typeof window !== 'undefined' && window.BottomSheetActions) || null;

  // Trace mount + BottomSheet availability so we know the modal is
  // actually showing on the vendor's screen (blank-screen-after-submit
  // diagnostics, 2026-06-18).
  React.useEffect(() => {
    try {
      if (window.pcDebugLog) {
        window.pcDebugLog(
          'checklist-mount',
          'ChecklistModal mounted; usingBottomSheet=' + !!BS + ', BSActions=' + !!BSActions,
          ''
        );
      }
    } catch {}
    return () => {
      try {
        if (window.pcDebugLog) window.pcDebugLog('checklist-unmount', 'ChecklistModal unmounted', '');
      } catch {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const body = (
    <>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, marginBottom: 18 }}>
        <div style={{
          width: 44, height: 44, borderRadius: 10,
          background: 'var(--accent)', color: 'var(--ink)',
          display: 'grid', placeItems: 'center', flexShrink: 0,
          border: '1px solid var(--ink)',
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <polyline points="9 14 11 16 15 12"/>
          </svg>
        </div>
        <div style={{ flex: 1 }}>
          <p style={{ margin: 0, color: 'var(--ink-soft)', fontSize: 14 }}>
            Please confirm you are sending the following with the cabinets:
          </p>
        </div>
      </div>

      <ul style={{ listStyle: 'none', padding: 0, margin: '20px 0', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {[
          { t: 'All face frames', s: 'Every face frame from every cabinet in the order.' },
          { t: 'At least one side panel (if available)', s: 'Preferably a finished side so we can color-match.' },
          { t: 'All drawers and slides', s: 'Including hardware — track on slides, screws, anything attached.' },
        ].map((it, i) => (
          <li key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: '12px 14px', background: 'var(--bg)', borderRadius: 8, border: '1px solid var(--rule)' }}>
            <div style={{
              width: 22, height: 22, borderRadius: '50%',
              background: 'var(--accent)', color: 'var(--ink)',
              display: 'grid', placeItems: 'center', flexShrink: 0, marginTop: 1,
            }}>
              <Icon.Check/>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 500, fontSize: 14 }}>{it.t}</div>
              <div style={{ fontSize: 12, color: 'var(--ink-soft)', marginTop: 2 }}>{it.s}</div>
            </div>
          </li>
        ))}
      </ul>

      <div style={{ background: 'var(--accent-soft)', border: '1px solid var(--accent)', borderRadius: 8, padding: '12px 14px', fontSize: 13, color: 'var(--ink)', marginBottom: 16 }}>
        <strong>Why we need this:</strong> face frames define the profile, side panels confirm color match, and intact drawer hardware lets us replicate the original action and fit.
      </div>

      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: 12, fontWeight: 500, display: 'block', marginBottom: 6, color: 'var(--ink-soft)' }}>
          What's missing or being shipped separately? <span style={{ fontWeight: 'normal', color: 'var(--ink-faint)' }}>(optional)</span>
        </label>
        <textarea
          className="textarea"
          value={shippingNote}
          onChange={e => setShippingNote(e.target.value)}
          placeholder="e.g. drawer slides shipping FedEx tomorrow, face frame for Cab 03 not included…"
          style={{ minHeight: 70, fontSize: 13 }}
        />
      </div>
    </>
  );

  if (BS) {
    const actions = BSActions ? (
      <BSActions>
        <button className="btn primary" onClick={() => onProceed({ shippingNote: shippingNote.trim() })}>OK — review the order <Icon.ArrowR/></button>
        <button className="btn ghost" onClick={onClose}>Back to cabinets</button>
      </BSActions>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column-reverse', gap: 10, marginTop: 8 }}>
        <button className="btn ghost" onClick={onClose}>Back to cabinets</button>
        <button className="btn primary" onClick={() => onProceed({ shippingNote: shippingNote.trim() })}>OK — review the order <Icon.ArrowR/></button>
      </div>
    );
    return (
      <BS open={true} onClose={onClose} title="Pre-Submit Checklist">
        {body}
        {actions}
      </BS>
    );
  }

  // Fallback (BottomSheet not loaded yet) — keep original modal so flow still works.
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'oklch(22% 0.01 80 / 0.55)',
      display: 'grid', placeItems: 'center', zIndex: 100, padding: 20,
      backdropFilter: 'blur(2px)',
    }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()}
        style={{
          background: 'var(--bg-raised)', borderRadius: 14,
          maxWidth: 540, width: '100%', padding: 32,
          boxShadow: '0 30px 80px rgba(0,0,0,0.3)',
        }}>
        <h2 style={{ fontFamily: 'var(--serif)', fontSize: 22, marginBottom: 4 }}>Before we send this order</h2>
        {body}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button className="btn ghost" onClick={onClose}>Back to cabinets</button>
          <button className="btn primary" onClick={() => onProceed({ shippingNote: shippingNote.trim() })}>OK — review the order <Icon.ArrowR/></button>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// Small reusable controls
// ============================================================
// Standard cabinet dimension quickpicks. Per 6-2: width is strict 3"
// increments from 6 to 60 (every cabinet shop builds at 3" multiples).
const QUICKPICKS_MAP = {
  'Width': ['6', '9', '12', '15', '18', '21', '24', '27', '30', '33', '36', '39', '42', '45', '48', '51', '54', '57', '60'],
  'Height': ['30', '34.5', '36', '42', '84', '90', '96'],
  'Depth': ['12', '15', '18', '21', '24'],
  'Setback': ['2', '3', '4'],
  'Toe Kick Height': ['2', '3', '4', '5', '6'],
  'Total length': ['8', '16', '24', '32', '40', '48'],
};

function DimField({ label, value, unit, onValue, onUnit }) {
  const picks = QUICKPICKS_MAP[label] || null;
  // All three cabinet dimensions (Width/Height/Depth) share one native
  // <select> picker so the entry style is identical across the row.
  // Width has 19 options that used to scroll off-screen on phones; the
  // dropdown delegates scrolling to the OS picker so everything fits.
  // Short list fields (Setback, Toe Kick Height, Total length) keep
  // their chip rows.
  const DIM_LABELS = new Set(['Width', 'Height', 'Depth']);
  const useDropdown = picks && DIM_LABELS.has(label);
  const isCustom = picks && value && !picks.includes(value);
  const selectVal = useDropdown
    ? (isCustom ? '__custom' : (value || ''))
    : null;
  return (
    <div className="field dim-field-qp">
      <label>{label}</label>
      {picks && !useDropdown && (
        <div className="qp-chips">
          {picks.map(p => (
            <button key={p} type="button"
              className={'qp-chip' + (value === p ? ' on' : '')}
              style={{ minWidth: 44, minHeight: 44, padding: '10px 14px' }}
              onClick={() => onValue(p)}>{p}</button>
          ))}
        </div>
      )}
      <div style={{ display: 'flex', gap: 6, alignItems: 'stretch' }}>
        {useDropdown && (
          <select
            className="select mono"
            value={selectVal}
            onChange={e => {
              const v = e.target.value;
              if (v === '__custom') return;  // keep current custom value in the input
              onValue(v);
            }}
            style={{ flex: 1, fontSize: 16 }}
          >
            <option value="">— pick {label.toLowerCase()} —</option>
            {picks.map(p => <option key={p} value={p}>{p}"</option>)}
            <option value="__custom">Custom…</option>
          </select>
        )}
        <input
          className="input mono"
          type="number"
          inputMode="decimal"
          pattern="[0-9.]*"
          value={value || ''}
          onChange={e => onValue(e.target.value)}
          placeholder={useDropdown ? 'Custom' : 'Custom'}
          style={useDropdown ? { width: 88 } : { flex: 1 }}
        />
        {onUnit && (
          <select className="select" style={{ width: 72 }} value={unit || 'in'} onChange={e => onUnit(e.target.value)}>
            <option>in</option><option>mm</option>
          </select>
        )}
      </div>
    </div>
  );
}

function NumberStepper({ value, onChange }) {
  const v = parseInt(value) || 0;
  return (
    <div className="qty-box" style={{ display: 'flex', alignItems: 'center', gap: 6, width: 'fit-content' }}>
      <button type="button"
        onClick={() => onChange(Math.max(0, v - 1))}
        style={{ width: 44, height: 44, display: 'grid', placeItems: 'center' }}>
        <Icon.Minus/>
      </button>
      <input
        type="number"
        inputMode="numeric"
        pattern="[0-9]*"
        value={v}
        onChange={e => onChange(Math.max(0, parseInt(e.target.value) || 0))}
        style={{ width: 64, height: 44, fontSize: 16, textAlign: 'center' }}/>
      <button type="button"
        onClick={() => onChange(v + 1)}
        style={{ width: 44, height: 44, display: 'grid', placeItems: 'center' }}>
        <Icon.Plus/>
      </button>
    </div>
  );
}

// Resize cabinet photos before upload. Annotations are normalized
// 0–1 coords (see markup.jsx) so resolution changes do NOT shift pins.
//
// History: 1200/0.82 (initial) → 900/0.72 (multi-photo intro) → 600/0.65
// (15-photo cap). With photos now living in Firebase Storage instead
// of inline base64 in Firestore docs (2026-06-18), the 1MB doc cap is
// no longer in play — we resize purely for upload bandwidth + render
// performance, NOT for doc-size headroom. Back up to 1200/0.85 so
// adjusters see full quality.
async function resizeImageForOrder(file, maxEdge = 1200, quality = 0.85) {
  const bitmap = await createImageBitmap(file);
  const { width: w0, height: h0 } = bitmap;
  const scale = Math.min(1, maxEdge / Math.max(w0, h0));
  const w = Math.max(1, Math.round(w0 * scale));
  const h = Math.max(1, Math.round(h0 * scale));
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close?.();
  const dataUrl = canvas.toDataURL('image/jpeg', quality);
  return dataUrl;
}

// Multi-file capable since 2026-06-18. Two paths:
//   kind='upload' → file input gets `multiple` so iOS / Android
//     galleries return all selected photos in one shot.
//   kind='camera' → iOS ignores the `multiple` attribute when
//     `capture` is set, so we implement "burst mode" by auto-re-
//     firing the input click after each successful camera shot.
//     The vendor taps Take Photo once, takes a shot, iOS comes back
//     to the app for a heartbeat with the new photo added, then iOS
//     re-opens the camera. Tapping Cancel on the camera ends the
//     chain. Android lets the native multi-shot UI handle it too
//     (multiple attribute is set there since some Android builds
//     honor it with capture).
// If a parent supplies onSetMany it gets the full array; otherwise
// we fall back to looping onSet for each file (legacy single-file
// callers).
function PhotoCaptureButton({ kind, onSet, onSetMany, compact, multiple, cabId }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [busyLabel, setBusyLabel] = useState('Processing…');
  // Gallery uploads = multi-select by default. Camera = also opt-in
  // multi (Android may honor it; iOS will not but the auto-reprompt
  // below handles iOS).
  const allowMulti = multiple !== false;
  const onFile = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setBusy(true);
    setBusyLabel('Processing…');
    try {
      const resized = [];
      for (const f of files) {
        try {
          const r = await resizeImageForOrder(f);
          if (r) {
            resized.push(r);
            continue;
          }
        } catch (err) {
          console.warn('Photo resize failed, using original:', err);
        }
        // Fallback for older iOS that can't createImageBitmap — read
        // as data URL (no resize, but preserves the photo).
        try {
          const dataUrl = await new Promise((res, rej) => {
            const reader = new FileReader();
            reader.onload = () => res(reader.result);
            reader.onerror = rej;
            reader.readAsDataURL(f);
          });
          resized.push(dataUrl);
        } catch (err) { console.warn('Photo read failed:', err); }
      }
      if (resized.length === 0) return;
      // STORAGE UPLOAD (2026-06-18): every photo goes to Firebase
      // Storage as soon as it lands here. The resulting download URL
      // becomes the photo's `src` field — no more base64 in form state
      // or Firestore docs. Failed uploads alert the vendor and the
      // photo is dropped (they re-take rather than silently losing it
      // at submit time).
      setBusyLabel('Uploading…');
      // Upload with retry + backoff (HI-6). Transient Storage failures on a
      // spotty jobsite connection used to drop the photo after one attempt;
      // now we retry twice (500ms / 1500ms) before giving up.
      const uploadWithRetry = async (dataUrl, cId, photoId) => {
        const delays = [500, 1500]; // two retries after the first attempt
        let lastErr;
        for (let attempt = 0; attempt <= delays.length; attempt++) {
          try {
            return await window.uploadCabinetPhotoToStorage(dataUrl, cId, photoId);
          } catch (err) {
            lastErr = err;
            if (attempt < delays.length) {
              await new Promise((r) => setTimeout(r, delays[attempt]));
            }
          }
        }
        throw lastErr;
      };
      const uploaded = [];       // successful { src, storagePath }
      const failedEntries = [];  // placeholders kept on the cabinet
      for (let i = 0; i < resized.length; i++) {
        const dataUrl = resized[i];
        const photoId = 'p_' + Math.random().toString(36).slice(2, 10) + '_' + (Date.now() % 1e7);
        try {
          // appendCabinetPhoto now accepts {src, storagePath} objects.
          const result = await uploadWithRetry(dataUrl, cabId || 'unbound', photoId);
          uploaded.push(result);
        } catch (err) {
          console.warn('Photo upload failed after retries:', err);
          try { if (window.pcDebugLog) window.pcDebugLog('photo-upload-failed', err?.message || String(err), err?.stack || ''); } catch {}
          // Keep a placeholder instead of silently dropping the photo. It
          // carries the local data: URL so the tile can preview it, flags
          // itself as failed for the tile indicator, and gets re-uploaded
          // (rescued) by the submit path. Vendors can also tap Retry.
          failedEntries.push({ id: photoId, src: dataUrl, uploadFailed: true });
        }
      }
      if (failedEntries.length > 0 && window.bsAlert) {
        window.bsAlert({
          title: `${failedEntries.length} photo${failedEntries.length === 1 ? '' : 's'} didn’t upload`,
          body: 'They’re kept on the cabinet and marked with a red “Retry” badge. Tap Retry, or they’ll be re-tried automatically when you submit.',
        });
      }
      const allEntries = uploaded.concat(failedEntries);
      if (allEntries.length === 0) return;
      if (onSetMany) {
        onSetMany(allEntries);
      } else {
        for (const u of allEntries) onSet(u);
      }
      // CAMERA BURST MODE (2026-06-18): on iOS the native camera
      // returns one photo per launch — `multiple` is ignored when
      // `capture` is set. To get a batch-feel, immediately re-open
      // the camera after each successful shot. iOS preserves the
      // user gesture through the file input's change event, so the
      // .click() inside this handler is honored. Vendor taps Cancel
      // on the camera UI to end the chain (which produces zero
      // files, returns out of this handler without re-firing).
      if (kind === 'camera' && resized.length > 0) {
        // Reset value FIRST so re-selecting the same file path works.
        if (ref.current) ref.current.value = '';
        // setTimeout 0 gives React time to render the new photo before
        // we re-open the camera, so the vendor sees the addition.
        setTimeout(() => {
          try { ref.current && ref.current.click(); } catch {}
        }, 200);
      }
    } finally {
      setBusy(false);
      // Allow re-selecting the same file(s). (Already done above for
      // the camera burst path; this is the safe default for uploads.)
      if (ref.current) ref.current.value = '';
    }
  };
  // Compact mode — square 64×64 add-tile that fits inside the PhotosBlock
  // gallery thumb-strip next to existing photos. Default mode is the
  // full-width primary CTA for the empty-state.
  if (compact) {
    return (
      <>
        <button
          type="button"
          className="btn"
          onClick={() => ref.current?.click()}
          disabled={busy}
          title={kind === 'camera' ? 'Take another photo' : 'Upload photos'}
          aria-label={kind === 'camera' ? 'Take another photo' : 'Upload photos'}
          style={{
            width: 64, height: 64, padding: 0, borderRadius: 6,
            border: '2px dashed var(--rule)', background: 'var(--bg)',
            color: 'var(--ink-soft)', cursor: 'pointer',
            display: 'grid', placeItems: 'center',
          }}
        >
          {busy ? '…' : (kind === 'camera' ? <Icon.Camera/> : <Icon.Upload/>)}
        </button>
        <input ref={ref} type="file" accept="image/*"
          {...(allowMulti ? { multiple: true } : {})}
          {...(kind === 'camera' ? { capture: 'environment' } : {})}
          onChange={onFile} style={{ display: 'none' }}/>
      </>
    );
  }
  return (
    <>
      <button className="btn primary"
        style={{ flex: '1 1 140px', minHeight: 44 }}
        onClick={() => ref.current?.click()} disabled={busy}>
        {kind === 'camera' ? <><Icon.Camera/> {busy ? busyLabel : 'Take photo'}</> : <><Icon.Upload/> {busy ? busyLabel : 'Upload photos'}</>}
      </button>
      <input ref={ref} type="file" accept="image/*"
        {...(allowMulti ? { multiple: true } : {})}
        capture={kind === 'camera' ? 'environment' : undefined}
        onChange={onFile} style={{ display: 'none' }}/>
    </>
  );
}

function makeCabinet(n) {
  return {
    id: 'cab_' + Date.now() + '_' + n,
    name: '',
    // Multi-photo array of { id, src, annotations: [], createdAt }.
    // Legacy `photo` / `annotations` mirror the first entry for
    // back-compat with readers that haven't been migrated.
    photos: [],
    photo: null,
    annotations: [],
    typeCode: 'B',         // matches cabinetTypes Firestore code (B/W/V/etc.)
    presetCode: '',         // e.g. 'V36-3D'; empty when custom
    w: '', wu: 'in', h: '', hu: 'in', d: '', du: 'in',
    doors: 0, drawers: 0, shelves: 0,
    doorsRepair: false,    // per-component repair toggle; unchecked = no charge
    drawersRepair: false,
    shelvesRepair: false,
    doorRepairPositions: [],    // ['L','R'] for 2-door; ['L','C','R'] for 3; ['1'..'N'] for 4+
    drawerRepairPositions: [],  // 1-indexed top → bottom
    shelfRepairPositions: [],   // 1-indexed top → bottom (matches pricing.jsx per-position read)
    newShelfNeeded: false,      // separate from shelvesRepair — vendor wants new shelves built
    newShelfCount: 0,
    hingeConfig: 'meeting', // 'left' | 'right' | 'meeting' | 'custom'
    hinges: [],             // ['L','R',...] when hingeConfig === 'custom'
    drawerLayout: '',       // '', '3-equal', '4-deep-bottom', '4-2up-2down', etc.
    drawerHeights: '',      // CSV when drawerLayout === 'custom'
    shelfW: '', shelfD: '', shelfU: 'in',
    finishedSide: 'No', finishedWhich: '',
    boxMaterial: '', boxMaterialOther: '',
    boxThickness: '1/2"',   // default 1/2" per intake redesign
    boxFinish: '',          // 'Natural' | 'Stained' | 'Painted' | 'Unfinished' | 'Other'
    cabType: '',          // vendor picks Base/Wall/Vanity/Island/Peninsula in the wizard
    installUnderExisting: 'No',
    underCounterCutShort: false,
    underCounterAdjustableFeet: false,
    hardware: null,        // { sourcedByVendor: bool, softClose: bool } — captured only; pricing deferred

    // Per-cabinet location — shop needs this when face frames come in as
    // a disassembled pile, and installers need it to put each rebuilt
    // cabinet back where it goes.
    locationRoom: '',      // 'Kitchen' | 'Master bath' | 'Hall bath' | 'Laundry' | 'Other'
    locationDetail: '',    // free-text — "north wall, 2nd from sink"

    // Per-category repair detail — populated by optional textareas when
    // the matching repair checkbox is on. Helps the shop scope the work.
    doorsRepairNotes: '',
    drawersRepairNotes: '',
    shelvesRepairNotes: '',
    rolloutsRepairNotes: '',

    notes: '',
  };
}

// Placeholder photo
const PLACEHOLDER_PHOTO = 'data:image/svg+xml;utf8,' + encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600">
  <defs>
    <linearGradient id="wood" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="#8b5e3c"/>
      <stop offset="0.3" stop-color="#a77349"/>
      <stop offset="0.5" stop-color="#965f38"/>
      <stop offset="0.7" stop-color="#a77349"/>
      <stop offset="1" stop-color="#7a5030"/>
    </linearGradient>
    <pattern id="grain" patternUnits="userSpaceOnUse" width="4" height="80">
      <rect width="4" height="80" fill="url(#wood)" opacity="0.3"/>
      <line x1="2" y1="0" x2="2" y2="80" stroke="#5a3a20" stroke-width="0.5" opacity="0.4"/>
    </pattern>
  </defs>
  <rect width="800" height="600" fill="#d4c9b8"/>
  <rect x="100" y="80" width="600" height="440" fill="url(#wood)" stroke="#5a3a20" stroke-width="3"/>
  <rect x="120" y="100" width="560" height="400" fill="url(#grain)"/>
  <rect x="140" y="120" width="260" height="360" fill="url(#wood)" stroke="#5a3a20" stroke-width="1.5"/>
  <rect x="410" y="120" width="260" height="360" fill="url(#wood)" stroke="#5a3a20" stroke-width="1.5"/>
  <circle cx="380" cy="300" r="6" fill="#3a2510"/>
  <circle cx="430" cy="300" r="6" fill="#3a2510"/>
  <ellipse cx="270" cy="450" rx="50" ry="14" fill="#3a2510" opacity="0.6"/>
</svg>
`);

Object.assign(window, {
  ClientStep, CabinetsStep, PLACEHOLDER_PHOTO, makeCabinet,
  // Reusable widgets surfaced for the intake wizard.
  DimField, NumberStepper, PhotoCaptureButton, BOX_MATERIALS,
  // ChecklistModal — exposed so app.jsx can render <ChecklistModal>
  // across the IIFE boundary. Was missing here, which caused
  // "Can't find variable: ChecklistModal" the instant a vendor
  // tapped Submit Order (caught by the v28 PostSubmitErrorBoundary
  // → bundle.js:305:1904 in the HUD trace). Adding it here is the
  // actual fix for the blank-screen-after-submit bug.
  ChecklistModal,
});

})();

// ===== review.jsx =====
(function(){
// Review & Work Order screens — cabinet-based model

function useMatchMedia(query) {
  const [matches, setMatches] = React.useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    try { return window.matchMedia(query).matches; } catch { return false; }
  });
  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    let mql;
    try { mql = window.matchMedia(query); } catch { return; }
    const handler = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else if (mql.addListener) mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else if (mql.removeListener) mql.removeListener(handler);
    };
  }, [query]);
  return matches;
}

function ReviewStep({ data, estimate, onProceed }) {
  const cabinets = data.cabinets || [];
  const tk = data.toeKick || {};
  estimate = estimate || { lineItems: [], subtotal: 0, tax: 0, total: 0 };
  const isNarrowEstimate = useMatchMedia('(max-width: 479px)');

  return (
    <>
      <div className="page-head">
        <span className="eyebrow">Step 03 · Review</span>
        <h1>Review the order</h1>
        <p>Confirm everything before generating the work order.</p>
      </div>

      <div className="card">
        <div className="card-head"><h3>Vendor, customer & site</h3></div>
        <div className="review-item">
          <span className="k">Vendor</span>
          <span className="v">{data.vendorName || '—'}{data.vendorContact ? ` · ${data.vendorContact}` : ''}</span>
        </div>
        {(data.vendorPhone || data.vendorEmail) && (
          <div className="review-item">
            <span className="k">Vendor contact</span>
            <span className="v mono">{data.vendorPhone}{data.vendorEmail ? ` · ${data.vendorEmail}` : ''}</span>
          </div>
        )}
        {data.vendorPO && (
          <div className="review-item"><span className="k">PO / job ref</span><span className="v mono">{data.vendorPO}</span></div>
        )}
        <div className="review-item">
          <span className="k">Customer</span>
          <span className="v">{data.clientName || '—'}</span>
        </div>
        <div className="review-item">
          <span className="k">Customer contact</span>
          <span className="v mono">{data.clientPhone || '—'}{data.clientEmail ? ` · ${data.clientEmail}` : ''}</span>
        </div>
        <div className="review-item"><span className="k">Address</span><span className="v">{data.address || '—'}</span></div>
        <div className="review-item"><span className="k">Date received</span><span className="v mono">{formatDate(data.dateReceived) || '—'}</span></div>
        <div className="review-item"><span className="k">Completion req.</span><span className="v mono">{formatDate(data.completionRequested) || '—'}</span></div>
        <div className="review-item"><span className="k">Priority</span><span className="v">{labelForTimeframe(data.timeframe)}</span></div>
        <div className="review-item"><span className="k">Install needed</span><span className="v">{data.installNeeded || '—'}</span></div>
        <div className="review-item"><span className="k">Home type</span><span className="v">{data.homeType || '—'}</span></div>
        {data.accessNotes && (<div className="review-item"><span className="k">Access notes</span><span className="v">{data.accessNotes}</span></div>)}
      </div>

      <div className="card">
        <div className="card-head"><h3>Cabinets</h3><span className="eyebrow">{cabinets.length} total</span></div>
        {cabinets.map((c, i) => (
          <div key={c.id} style={{ borderTop: i > 0 ? '1px solid var(--rule)' : 'none', paddingTop: i > 0 ? 18 : 0, paddingBottom: 18 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 10 }}>
              <h3 style={{ fontFamily: 'var(--serif)' }}>Cabinet {String(i + 1).padStart(2, '0')}{c.name ? ` · ${c.name}` : ''}</h3>
              <span className="eyebrow">{c.cabType}</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 16 }}>
              {(() => {
                // Multi-photo render — falls back to legacy single-photo
                // shape for any cabinet that hasn't been re-saved yet.
                const photos = (typeof window !== 'undefined' && window.getCabinetPhotos)
                  ? window.getCabinetPhotos(c)
                  : (c.photos?.length ? c.photos : (c.photo ? [{ src: c.photo, annotations: c.annotations || [] }] : []));
                if (photos.length === 0) return null;
                return (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10, maxWidth: 600 }}>
                    {photos.map((p, pi) => (
                      <div key={p.id || pi} style={{ aspectRatio: '4/3', borderRadius: 6, overflow: 'hidden', background: 'var(--ink)', position: 'relative' }}>
                        <img src={p.src} alt={`Cabinet ${i + 1} photo ${pi + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                        {(p.annotations || []).filter(a => a.type === 'pin').map(a => {
                          const pt = a.points[0];
                          return (
                            <div key={a.id} style={{
                              position: 'absolute', left: `${pt.x * 100}%`, top: `${pt.y * 100}%`,
                              transform: 'translate(-50%, -50%)', width: 18, height: 18, borderRadius: '50%',
                              background: a.color, border: '2px solid white', color: 'white',
                              display: 'grid', placeItems: 'center', fontFamily: 'var(--mono)', fontSize: 9, fontWeight: 600,
                            }}>{a.data.num}</div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                );
              })()}
              <div>
                <div className="review-item"><span className="k">Dimensions</span><span className="v mono">{c.w || '?'}{c.wu} W × {c.h || '?'}{c.hu} H × {c.d || '?'}{c.du} D</span></div>
                <div className="review-item"><span className="k">Components</span><span className="v mono">{c.doors || 0} doors · {c.drawers || 0} drawers · {c.shelves || 0} shelves</span></div>
                {(c.shelfW || c.shelfD) && (<div className="review-item"><span className="k">Shelf size</span><span className="v mono">{c.shelfW || '?'} × {c.shelfD || '?'} {c.shelfU}</span></div>)}
                <div className="review-item"><span className="k">Finished side</span><span className="v">{c.finishedSide === 'Yes' ? `Yes — ${c.finishedWhich || '?'}` : 'No'}</span></div>
                <div className="review-item"><span className="k">Box material</span><span className="v">{c.boxMaterial === 'Other' ? c.boxMaterialOther : (c.boxMaterial || '—')}{c.boxThickness ? ` · ${c.boxThickness}` : ''}</span></div>
                {c.notes && (<div className="review-item"><span className="k">Notes</span><span className="v">{c.notes}</span></div>)}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-head"><h3>Toe kick</h3></div>
        <div className="review-item"><span className="k">Height</span><span className="v mono">{tk.height ? `${tk.height} ${tk.heightU || 'in'}` : '—'}</span></div>
        <div className="review-item"><span className="k">Depth</span><span className="v mono">{tk.depth ? `${tk.depth} ${tk.depthU || 'in'}` : '—'}</span></div>
        <div className="review-item"><span className="k">Setback from face</span><span className="v mono">{tk.setback ? `${tk.setback} ${tk.setbackU || 'in'}` : '—'}</span></div>
        <div className="review-item"><span className="k">Thickness</span><span className="v mono">{tk.thickness || '—'}</span></div>
        <div className="review-item"><span className="k">Total length</span><span className="v mono">{tk.linearFt ? `${tk.linearFt} lin. ft` : '—'}</span></div>
      </div>

      {data.specialInstructions && (
        <div className="card">
          <div className="card-head"><h3>Special instructions</h3></div>
          <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6 }}>{data.specialInstructions}</p>
        </div>
      )}

      {/* Estimate breakdown */}
      <div className="card estimate-card">
        <div className="card-head">
          <h3>Auto-calculated estimate</h3>
          <span className="eyebrow">Based on admin rates</span>
        </div>
        {estimate.lineItems.length === 0 ? (
          <p style={{ color: 'var(--ink-faint)', margin: 0 }}>Add at least one cabinet to see a price.</p>
        ) : isNarrowEstimate ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {estimate.lineItems.map((li, i) => (
              <div key={i} className={'estimate-card-row li-' + li.type}
                style={{ display: 'grid', gridTemplateColumns: '1fr auto', columnGap: 10, rowGap: 4, padding: '12px 14px', background: 'var(--bg)', border: '1px solid var(--rule)', borderRadius: 8 }}>
                <div style={{ fontSize: 14, fontWeight: 500 }}>{li.label}</div>
                <div className="mono" style={{ fontSize: 18, fontWeight: 700, textAlign: 'right', alignSelf: 'center' }}>{fmtMoney(li.amount)}</div>
                {li.detail && (
                  <div style={{ gridColumn: '1 / -1', fontSize: 12, color: 'var(--ink-soft)' }}>{li.detail}</div>
                )}
              </div>
            ))}
            <div style={{ borderTop: '1px solid var(--rule)', marginTop: 4, paddingTop: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
              {estimate.tax > 0 && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                    <span>Subtotal</span>
                    <span className="mono">{fmtMoney(estimate.subtotal)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                    <span>Tax</span>
                    <span className="mono">{fmtMoney(estimate.tax)}</span>
                  </div>
                </>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: 4 }}>
                <strong style={{ fontSize: 15 }}>Order total</strong>
                <strong className="mono" style={{ fontSize: 20 }}>{fmtMoney(estimate.total)}</strong>
              </div>
            </div>
          </div>
        ) : (
          <>
            <table className="estimate-table">
              <thead>
                <tr><th>Item</th><th>Detail</th><th className="num">Amount</th></tr>
              </thead>
              <tbody>
                {estimate.lineItems.map((li, i) => (
                  <tr key={i} className={'li-' + li.type}>
                    <td>{li.label}</td>
                    <td className="detail">{li.detail}</td>
                    <td className="num mono">{fmtMoney(li.amount)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                {estimate.tax > 0 && (
                  <>
                    <tr><td colSpan="2">Subtotal</td><td className="num mono">{fmtMoney(estimate.subtotal)}</td></tr>
                    <tr><td colSpan="2">Tax</td><td className="num mono">{fmtMoney(estimate.tax)}</td></tr>
                  </>
                )}
                <tr className="total-row"><td colSpan="2"><strong>Order total</strong></td><td className="num mono"><strong>{fmtMoney(estimate.total)}</strong></td></tr>
              </tfoot>
            </table>
          </>
        )}
      </div>
    </>
  );
}

function SubmittedStep({ data, estimate, onReset, submitResult, onCreateRetailEstimate, hideEstimates }) {
  estimate = estimate || { lineItems: [], subtotal: 0, tax: 0, total: 0 };
  // RULES-OF-HOOKS FIX (2026-06-17): the previous form was
  //   const jobNum = submitResult?.orderNumber || React.useMemo(() => ..., []);
  // which only invoked useMemo when orderNumber was falsy. React 18
  // StrictMode double-invokes render — the hook count drifts between
  // invocations, React throws "Rendered fewer hooks than expected",
  // the whole subtree unmounts to blank, and the vendor sees a white
  // page after Submit. ALWAYS call the hook; then fall back to the
  // memoized value if the prop was missing.
  const fallbackJobNum = React.useMemo(() => 'WO-' + String(Date.now()).slice(-6), []);
  const jobNum = submitResult?.orderNumber || fallbackJobNum;
  const orderId = submitResult?.orderId || null;
  const isNarrowEstimate = useMatchMedia('(max-width: 479px)');
  const isMobile = useMatchMedia('(max-width: 599px)');
  // Submission timestamp — server doesn't echo it back, so use the
  // current time as a close-enough approximation for the confirmation.
  const submittedAt = submitResult?.createdAt || new Date();
  const date = new Date().toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
  const cabinets = data.cabinets || [];
  const tk = data.toeKick || {};

  // Generate QR code — points to admin portal for scanning
  const [qrDataUrl, setQrDataUrl] = React.useState(null);
  const [qrEnlarged, setQrEnlarged] = React.useState(false);
  React.useEffect(() => {
    if (!orderId || typeof QRCode === 'undefined') return;
    const url = 'https://precision-cabinets-admin.web.app/orders/' + orderId;
    QRCode.toDataURL(url, { width: 400, margin: 2, color: { dark: '#1a1a1a', light: '#ffffff' } })
      .then(setQrDataUrl)
      .catch(console.error);
  }, [orderId]);

  return (
    <>
      {/* Hero — success state with a green check, mono job-num
          eyebrow, big Archivo headline. Matches the design refresh. */}
      <div className="no-print" style={{ textAlign: 'center', padding: '28px 16px 24px' }}>
        <div style={{
          width: 64, height: 64, margin: '0 auto 14px',
          borderRadius: '50%',
          background: 'var(--success)',
          color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: 'var(--sans)', fontWeight: 700, fontSize: 32,
          boxShadow: '0 10px 30px rgba(47,125,82,.30)',
        }}>✓</div>
        <div style={{
          fontFamily: 'var(--mono)', fontWeight: 600,
          fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase',
          color: 'var(--accent)',
        }}>{jobNum}</div>
        <h1 style={{ margin: '6px 0 4px' }}>Order submitted</h1>
        <p style={{ margin: 0, color: 'var(--ink-soft)', fontSize: 14 }}>
          The shop has it. We'll text you with updates.
        </p>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 18, justifyContent: 'center' }}>
          {onCreateRetailEstimate && (
            <button
              className="btn"
              style={{ background: '#C9781B', color: '#fff', border: 0, fontWeight: 700 }}
              onClick={onCreateRetailEstimate}
              title="Generate a Precision-branded retail estimate PDF for the homeowner / insurance"
            >
              📄 Create Retail Estimate
            </button>
          )}
          <button className="btn primary" onClick={onReset}>New Order</button>
        </div>
      </div>

      {/* QR Code section — tappable to enlarge */}
      {qrDataUrl && (
        <div className="order-qr-section no-print" onClick={() => setQrEnlarged(true)} style={{ cursor: 'pointer' }}>
          <h3>Work Order QR Code</h3>
          <p className="hint">Tap to enlarge — show this to Precision Cabinets at drop-off or pickup.</p>
          <img src={qrDataUrl} alt="QR Code" className="order-qr-img" />
          <div style={{ display: 'flex', gap: 8, marginTop: 10, justifyContent: 'center' }}>
            <a href={qrDataUrl} download={`${jobNum}-qr.png`} className="btn secondary"
              onClick={e => e.stopPropagation()} style={{ fontSize: 12 }}>
              Download
            </a>
          </div>
        </div>
      )}

      {/* Enlarged QR overlay */}
      {qrEnlarged && qrDataUrl && (
        <div className="qr-overlay" onClick={() => setQrEnlarged(false)}>
          <div className="qr-overlay-inner" onClick={e => e.stopPropagation()}>
            <div className="qr-overlay-order">{jobNum}</div>
            <img src={qrDataUrl} alt="QR Code" className="qr-overlay-img" />
            <p className="qr-overlay-hint">Show this to Precision Cabinets staff</p>
            <button className="btn ghost" onClick={() => setQrEnlarged(false)} style={{ marginTop: 16 }}>Close</button>
          </div>
        </div>
      )}

      <div className="workorder">
        <div className="wo-head">
          <div>
            <div className="eyebrow">Cabinet Repair Work Order</div>
            <h1 style={{ marginTop: 4 }}>Precision Cabinets LLC</h1>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div className="wo-num">{jobNum}</div>
            <div className="wo-num" style={{ marginTop: 4 }}>{date}</div>
          </div>
        </div>

        <div className="wo-row">
          <div className="wo-block">
            <h4>Vendor</h4>
            <p>
              <strong>{data.vendorName || '—'}</strong><br/>
              {data.vendorContact && <>{data.vendorContact}<br/></>}
              {data.vendorPhone && <span className="mono">{data.vendorPhone}<br/></span>}
              {data.vendorEmail && <>{data.vendorEmail}<br/></>}
              {data.vendorPO && <span className="mono" style={{ fontSize: 12, color: 'var(--ink-soft)' }}>PO: {data.vendorPO}</span>}
            </p>
          </div>
          <div className="wo-block">
            <h4>Customer</h4>
            <p>
              <strong>{data.clientName || '—'}</strong><br/>
              {data.clientPhone && <span className="mono">{data.clientPhone}<br/></span>}
              {data.clientEmail && <>{data.clientEmail}<br/></>}
            </p>
          </div>
        </div>

        <div className="wo-row">
          <div className="wo-block">
            <h4>Project site</h4>
            <p>{data.address || '—'}<br/>{data.homeType && <>{data.homeType}<br/></>}{data.accessNotes && <span style={{ fontSize: 12, color: 'var(--ink-soft)' }}>{data.accessNotes}</span>}</p>
          </div>
          <div className="wo-block">
            <h4>Schedule</h4>
            <p>
              <span style={{ fontSize: 11, color: 'var(--ink-faint)', fontFamily: 'var(--mono)' }}>SUBMITTED</span><br/>
              <span className="mono">{formatSubmittedAt(submittedAt) || '—'}</span><br/>
              <span style={{ fontSize: 11, color: 'var(--ink-faint)', fontFamily: 'var(--mono)' }}>COMPLETION REQUESTED</span><br/>
              <span className="mono">{formatDate(data.completionRequested) || '—'}</span><br/>
              <span style={{
                display: 'inline-block', marginTop: 4, padding: '2px 8px', borderRadius: 4,
                fontFamily: 'var(--mono)', fontSize: 11, fontWeight: 600,
                background: data.rush ? '#b91c1c' : 'var(--bg)',
                color: data.rush ? '#fff' : 'var(--ink-soft)',
                border: data.rush ? 'none' : '1px solid var(--rule)',
              }}>Rush: {data.rush ? 'Yes' : 'No'}</span>
            </p>
          </div>
        </div>

        <div className="tape-rule"/>

        <h3 style={{ fontFamily: 'var(--serif)', marginBottom: 12 }}>Cabinets ({cabinets.length})</h3>
        {cabinets.map((c, i) => (
          <div key={c.id} className="wo-area">
            <h4>Cab {String(i + 1).padStart(2, '0')}{c.name ? ` — ${c.name}` : ''} <span style={{ fontWeight: 'normal', color: 'var(--ink-faint)', fontSize: 13 }}>({c.cabType})</span></h4>
            <table className="wo-table">
              <tbody>
                <tr><td>Dimensions</td><td className="num">{c.w}{c.wu} W × {c.h}{c.hu} H × {c.d}{c.du} D</td></tr>
                <tr><td>Doors / drawers / shelves</td><td className="num">{c.doors || 0} / {c.drawers || 0} / {c.shelves || 0}</td></tr>
                {(c.shelfW || c.shelfD) && (<tr><td>Shelf size</td><td className="num">{c.shelfW} × {c.shelfD} {c.shelfU}</td></tr>)}
                <tr><td>Finished side</td><td className="num">{c.finishedSide === 'Yes' ? `Yes — ${c.finishedWhich}` : 'No'}</td></tr>
                <tr><td>Box material</td><td className="num">{c.boxMaterial === 'Other' ? c.boxMaterialOther : c.boxMaterial}{c.boxThickness ? ` · ${c.boxThickness}` : ''}</td></tr>
              </tbody>
            </table>
            {c.notes && (<div style={{ marginTop: 8, fontSize: 12, color: 'var(--ink-soft)' }}><strong>Notes: </strong>{c.notes}</div>)}
          </div>
        ))}

        <div className="tape-rule"/>

        <h3 style={{ fontFamily: 'var(--serif)', marginBottom: 12 }}>Toe kick</h3>
        <table className="wo-table">
          <tbody>
            <tr><td>Height</td><td className="num">{tk.height ? `${tk.height} ${tk.heightU || 'in'}` : '—'}</td></tr>
            <tr><td>Depth</td><td className="num">{tk.depth ? `${tk.depth} ${tk.depthU || 'in'}` : '—'}</td></tr>
            <tr><td>Setback from face edge</td><td className="num">{tk.setback ? `${tk.setback} ${tk.setbackU || 'in'}` : '—'}</td></tr>
            <tr><td>Thickness</td><td className="num">{tk.thickness || '—'}</td></tr>
            <tr><td>Total linear length</td><td className="num">{tk.linearFt ? `${tk.linearFt} lin. ft` : '—'}</td></tr>
          </tbody>
        </table>

        {data.scribe?.needed === 'Yes' && (
          <>
            <div className="tape-rule"/>
            <h3 style={{ fontFamily: 'var(--serif)', marginBottom: 12 }}>Scribe</h3>
            <table className="wo-table">
              <tbody>
                <tr><td>Quantity</td><td className="num">{
                  data.scribe.sticks
                    ? `${data.scribe.sticks} stick${Number(data.scribe.sticks) === 1 ? '' : 's'} (8 ft)`
                    : (data.scribe.linearFeet ? `${data.scribe.linearFeet} lin. ft` : '—')
                }</td></tr>
                <tr><td>Material</td><td className="num">{data.scribe.matchMaterial === 'No' ? 'Cheapest stock (paint-grade)' : 'Match cabinet material'}</td></tr>
              </tbody>
            </table>
          </>
        )}

        {data.specialInstructions && (<><div className="tape-rule"/><h3 style={{ fontFamily: 'var(--serif)', marginBottom: 8 }}>Special instructions</h3><p style={{ fontSize: 13, lineHeight: 1.6 }}>{data.specialInstructions}</p></>)}

        <div className="tape-rule"/>
        <div style={{ background: 'var(--accent-soft)', border: '1px solid var(--accent)', borderRadius: 6, padding: 14, fontSize: 12 }}>
          <strong>Materials sent with this order:</strong> All face frames, at least one side panel (preferably finished side for color match), all drawers and slides with hardware.
        </div>

        {!hideEstimates && estimate.lineItems.length > 0 && (
          <>
            <div className="tape-rule"/>
            <h3 style={{ fontFamily: 'var(--serif)', marginBottom: 12 }}>Estimate</h3>
            {isNarrowEstimate ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {estimate.lineItems.map((li, i) => (
                  <div key={i}
                    style={{ display: 'grid', gridTemplateColumns: '1fr auto', columnGap: 10, rowGap: 4, padding: '12px 14px', background: 'var(--bg)', border: '1px solid var(--rule)', borderRadius: 8 }}>
                    <div style={{ fontSize: 14, fontWeight: 500 }}>{li.label}</div>
                    <div className="mono" style={{ fontSize: 18, fontWeight: 700, textAlign: 'right', alignSelf: 'center' }}>{fmtMoney(li.amount)}</div>
                    {li.detail && (
                      <div style={{ gridColumn: '1 / -1', fontSize: 12, color: 'var(--ink-soft)' }}>{li.detail}</div>
                    )}
                  </div>
                ))}
                <div style={{ borderTop: '1px solid var(--rule)', marginTop: 4, paddingTop: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {estimate.tax > 0 && (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                        <span>Subtotal</span>
                        <span className="mono">{fmtMoney(estimate.subtotal)}</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                        <span>Tax</span>
                        <span className="mono">{fmtMoney(estimate.tax)}</span>
                      </div>
                    </>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: 4 }}>
                    <strong style={{ fontSize: 15 }}>Order total</strong>
                    <strong className="mono" style={{ fontSize: 20 }}>{fmtMoney(estimate.total)}</strong>
                  </div>
                </div>
              </div>
            ) : (
              <table className="wo-table estimate">
                <thead>
                  <tr><th>Item</th><th>Detail</th><th className="num">Amount</th></tr>
                </thead>
                <tbody>
                  {estimate.lineItems.map((li, i) => (
                    <tr key={i}>
                      <td>{li.label}</td>
                      <td style={{ color: 'var(--ink-soft)', fontSize: 12 }}>{li.detail}</td>
                      <td className="num">{fmtMoney(li.amount)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  {estimate.tax > 0 && (
                    <>
                      <tr><td colSpan="2">Subtotal</td><td className="num">{fmtMoney(estimate.subtotal)}</td></tr>
                      <tr><td colSpan="2">Tax</td><td className="num">{fmtMoney(estimate.tax)}</td></tr>
                    </>
                  )}
                  <tr className="total"><td colSpan="2"><strong>Order total</strong></td><td className="num"><strong>{fmtMoney(estimate.total)}</strong></td></tr>
                </tfoot>
              </table>
            )}
          </>
        )}
      </div>

      {/* Sticky bottom New Order CTA — mobile only */}
      {isMobile && (
        <div className="no-print" style={{
          position: 'sticky', bottom: 0, left: 0, right: 0,
          marginTop: 16,
          padding: 'calc(env(safe-area-inset-bottom, 0px) + 12px) 16px 12px',
          background: 'var(--bg)',
          borderTop: '1px solid var(--rule)',
          zIndex: 50,
        }}>
          <button className="btn primary" style={{ width: '100%', minHeight: 48 }} onClick={onReset}>New Order</button>
        </div>
      )}
    </>
  );
}

function labelForTimeframe(tf) {
  const map = { asap: 'ASAP', '2wk': 'Within 2 weeks', '1mo': 'Within 1 month', '3mo': 'Within 3 months', flex: 'Flexible' };
  return map[tf] || '—';
}

// MM/DD/YYYY — US standard format used across all vendor-facing displays.
// Storage stays ISO YYYY-MM-DD; only display flips to MDY.
function formatDate(d) {
  if (!d) return '';
  try {
    return new Date(d + 'T00:00').toLocaleDateString('en-US', {
      year: 'numeric', month: '2-digit', day: '2-digit',
    });
  } catch { return d; }
}

// Submission timestamp display — "MM/DD/YYYY hh:mm AM/PM" in Arizona local time.
// Accepts a Firestore Timestamp, Date, or ms-number.
function formatSubmittedAt(t) {
  if (!t) return '';
  try {
    const d = t?.toDate ? t.toDate() : new Date(t);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleString('en-US', {
      timeZone: 'America/Phoenix',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: 'numeric', minute: '2-digit', hour12: true,
    });
  } catch { return ''; }
}

Object.assign(window, { ReviewStep, SubmittedStep, labelForTimeframe, formatDate, formatSubmittedAt });

})();

// ===== insurance-estimate-pdf.jsx =====
(function(){
// Marked-up insurance estimate PDF generator.
//
// The vendor enters a markup % (capped 0–40%, step 5) and we open
// a print-friendly window with:
//   - Precision Cabinets branded header (logo, name, address, contact)
//     so the document reads as a real estimate FROM Precision TO the
//     vendor — what the adjuster expects to see from a cabinet shop.
//   - Aggregate totals only: total Materials and total Labor for the
//     entire order, plus derived $/linear-foot. NO per-cabinet line
//     items — the adjuster gets a clean unit-cost narrative.
//   - Photo gallery of cabinets (when photos are present), labeled by
//     cabinet name.
//   - NO Precision contract pricing. Only the marked-up totals.
//
// We deliberately avoid shipping a PDF library — window.print() to
// "Save as PDF" works on every Windows / Mac / iOS device the vendors
// own and adds zero bytes to the bundle.

(function () {
  // Precision Cabinets shop info — pulled from the admin-editable
  // companyInfo/current Firestore doc. ensureCompanyInfo() caches
  // the latest doc on window.PC_COMPANY_INFO; if it hasn't loaded
  // yet (offline / first call), we fall back to these defaults.
  const PRECISION_DEFAULTS = {
    name: 'Precision Cabinets LLC',
    addressLine1: '3319 E Fandango Dr',
    addressLine2: 'Gilbert, AZ 85298',
    phone: 'TBD',
    email: 'estimates@precisioncabinetsllc.com',
    website: 'precisioncabinetsllc.com',
    logoUrl: '',
  };
  function getPrecisionInfo() {
    return Object.assign({}, PRECISION_DEFAULTS, window.PC_COMPANY_INFO || {});
  }

  function fmtUsd(n) {
    if (!isFinite(n) || n == null) return '$0.00';
    return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Sum cabinet widths in inches (cabinet-side widths) and convert
  // to linear feet. We use the cabinet width as the install run
  // contribution — typical shop convention.
  function totalLinearFeet(cabinets) {
    if (!Array.isArray(cabinets)) return 0;
    let inches = 0;
    for (const c of cabinets) {
      const val = parseFloat(String(c.w || 0)) || 0;
      const unit = c.wu || 'in';
      // Wizard emits 'in', 'mm', and 'ft'. mm must be divided by 25.4
      // before the /12 to linear feet — otherwise a 600mm cabinet reads
      // as 50 LF instead of ~1.97.
      const inchesEach = unit === 'ft' ? val * 12
        : unit === 'mm' ? val / 25.4
        : val; // inches (default)
      inches += inchesEach;
    }
    return inches / 12;
  }

  function buildHtml({ vendor, data, pricing, markupPercent }) {
    const PRECISION = getPrecisionInfo();
    const computeEstimate = window.computeEstimate;
    const estimateResult = computeEstimate ? computeEstimate(data, pricing) : { total: 0, lineItems: [] };
    const precisionTotal = estimateResult.total || 0;
    const markup = Math.max(0, Math.min(40, markupPercent || 0));
    const markedUpTotal = precisionTotal * (1 + markup / 100);

    // Materials/Labor split — pull from shopConstants when present,
    // fall back to 60/40 if it hasn't loaded yet.
    const split = (window.PC_SHOP_CONSTANTS && window.PC_SHOP_CONSTANTS.materialsLaborSplit) || 0.6;
    const materialsTotal = markedUpTotal * split;
    const laborTotal = markedUpTotal * (1 - split);

    const linFt = totalLinearFeet(data.cabinets || []);
    const matsPerLf = linFt > 0 ? materialsTotal / linFt : 0;
    const laborPerLf = linFt > 0 ? laborTotal / linFt : 0;

    // The COMPANY NAME used in the notes footer = the vendor company that
    // submitted this order. We prefer the vendor record's name (canonical),
    // fall back to the free-text vendorName captured at intake. Used in
    // the footer to make the disclaimer specific to who provided the info.
    const companyName = vendor?.name || data?.vendorName || 'the vendor';

    // MATERIALS description — list the actual wood / sheet materials
    // collected at intake (one entry per unique box material across
    // cabinets, plus toe-kick if present, plus rebuilt shelves if any).
    // Replaces the prior static "cabinet boxes, face frame, drawer
    // boxes, hardware, finish" copy with material types specific to
    // THIS order, per vendor request 2026-06-18.
    const materialBag = new Set();
    for (const c of (data.cabinets || [])) {
      const m = (c.boxMaterial === 'Other' ? c.boxMaterialOther : c.boxMaterial) || '';
      if (m && m.trim()) {
        const thick = c.boxThickness ? ` ${c.boxThickness}` : '';
        materialBag.add(`${m}${thick} sheet`);
      }
    }
    const tk = data.toeKick || {};
    if (tk.height || tk.depth || tk.linearFt) materialBag.add('Toe-kick stock');
    if ((data.cabinets || []).some(c => (parseInt(c.newShelfCount) || 0) > 0)) materialBag.add('New shelf stock');
    if ((data.cabinets || []).some(c => (parseInt(c.rolloutInstallCount) || parseInt(c.rolloutRebuildCount) || parseInt(c.rolloutRepairCount) || parseInt(c.rolloutCount) || 0) > 0)) {
      materialBag.add('Roll-out shelf stock');
    }
    if ((data.cabinets || []).some(c => c.finishedSide === 'Yes')) materialBag.add('Finished end-panel stock');
    const materialList = Array.from(materialBag);
    const materialsDesc = materialList.length > 0
      ? `Materials — ${materialList.join(', ')}`
      : 'Materials — cabinet stock per scope';

    // LABOR description — list the actual repair / fabrication
    // operations from the computed estimate's line items. Strips
    // dollar amounts; one comma-separated list of operation labels
    // so the adjuster sees what kind of work this estimate covers.
    const labels = new Set();
    for (const li of (estimateResult.lineItems || [])) {
      const label = (li.label || '').trim();
      if (!label) continue;
      // Skip pure surcharge / service-fee lines — they're not "fabrication".
      if (li.type === 'rush' || li.type === 'tax' || li.type === 'service' || li.type === 'minimum') continue;
      labels.add(label);
    }
    const laborList = Array.from(labels);
    const laborDesc = laborList.length > 0
      ? `Fabrication of ${laborList.join(', ')}`
      : 'Fabrication per scope of work';

    // Multi-photo PDF gallery — flattens all cabinets' photos into one
    // grid. Each cell is captioned with the cabinet ref + photo index
    // (e.g. "Cabinet 02 · photo 2 of 3"). Legacy single-photo cabinets
    // appear as a one-cell entry. Cabinets with no photos contribute
    // nothing to the gallery.
    const photoCells = (data.cabinets || []).flatMap((c, ci) => {
      const list = (typeof window !== 'undefined' && window.getCabinetPhotos)
        ? window.getCabinetPhotos(c)
        : (c.photos?.length ? c.photos : (c.photo ? [{ src: c.photo }] : []));
      const cabLabel = c.name || ('Cabinet ' + String(ci + 1).padStart(2, '0'));
      const dims = `${c.w || '?'}"×${c.h || '?'}"×${c.d || '?'}"`;
      return list.map((p, pi) => ({
        src: p.src,
        caption: list.length > 1
          ? `${cabLabel} · photo ${pi + 1} of ${list.length} · ${dims}`
          : `${cabLabel} · ${dims}`,
      }));
    });
    const photoSection = photoCells.length === 0 ? '' : `
      <h2>Scope of Work — Cabinets to be Repaired or Replaced</h2>
      <div class="photo-grid">
        ${photoCells.map((cell) => `
          <div class="photo-cell">
            <img src="${escapeHtml(cell.src)}" alt="${escapeHtml(cell.caption)}" />
            <div class="photo-cap">${escapeHtml(cell.caption)}</div>
          </div>
        `).join('')}
      </div>
    `;

    // Dates intentionally OFF the estimate (per vendor feedback 2026-06-17).
    // The auto-set "Prepared <today>" and the step-5 "Target: <completionRequested>"
    // lines are gone so the PDF stays valid across days and vendors can't
    // accidentally shift the estimate's date by editing the wizard target
    // upstream. "Estimate valid for 30 days" in the footer carries any
    // recency cue the adjuster needs.

    return `<!doctype html>
<html><head><meta charset="utf-8"/>
<title>Estimate — ${escapeHtml(data.clientName || 'Retail')}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: 'Helvetica Neue', Arial, sans-serif; color: #111; margin: 0; padding: 32px; background: #fff; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 3px solid #0a2240; padding-bottom: 16px; margin-bottom: 24px; }
  .brand { display: flex; gap: 14px; align-items: center; }
  .brand-mark { width: 56px; height: 56px; background: #0a2240; color: #f0c14b; display: flex; align-items: center; justify-content: center; font-family: Georgia, serif; font-weight: bold; font-size: 28px; border-radius: 6px; }
  .brand-text { font-family: Georgia, serif; }
  .brand-text .name { font-size: 22px; font-weight: bold; color: #0a2240; }
  .brand-text .tag { font-size: 11px; color: #b08720; letter-spacing: 1px; text-transform: uppercase; }
  .shop-info { font-size: 11px; color: #555; line-height: 1.5; text-align: right; }
  h1 { font-size: 18px; margin: 16px 0 4px; color: #0a2240; }
  h2 { font-size: 14px; margin: 24px 0 8px; color: #b08720; border-bottom: 1px solid #ddd; padding-bottom: 4px; }
  .billto { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 16px; font-size: 12px; }
  .billto .label { font-size: 10px; text-transform: uppercase; color: #888; letter-spacing: 0.5px; }
  table { width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 8px; border: 1px solid #999; }
  th { text-align: left; padding: 8px 10px; background: #0a2240; color: #fff; font-weight: 600; text-transform: uppercase; font-size: 10px; letter-spacing: 0.5px; }
  td { padding: 8px 10px; border-bottom: 1px solid #eee; }
  td.r { text-align: right; font-family: 'SF Mono', 'Consolas', monospace; }
  tfoot td { font-weight: bold; background: #fdf8e9; border-top: 2px solid #0a2240; }
  tfoot td.r { font-size: 14px; color: #0a2240; }
  .totals-row td { padding: 12px 10px; }
  .toolbar { display: flex; gap: 8px; margin-bottom: 24px; }
  .btn { background: #0a2240; color: white; border: 0; padding: 10px 18px; border-radius: 6px; font-size: 13px; cursor: pointer; font-weight: 600; }
  .btn.secondary { background: #f3f4f6; color: #0a2240; }
  .meta-line { font-size: 11px; color: #555; margin: 4px 0; }
  .photo-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 8px; }
  .photo-cell img { width: 100%; aspect-ratio: 4/3; object-fit: cover; border-radius: 6px; border: 1px solid #ddd; }
  .photo-cap { font-size: 10px; color: #555; margin-top: 4px; text-align: center; }
  .footer { margin-top: 32px; font-size: 10px; color: #888; border-top: 1px solid #eee; padding-top: 8px; line-height: 1.5; }
  .footer strong { color: #555; }
  @media print { .no-print { display: none; } body { padding: 16px; } }
</style>
</head><body>

<!-- In the embedded preview the parent app provides its own toolbar.
     If the user opens this HTML in a new tab via "Open in new tab",
     the toolbar shows so they can print directly. -->
<div class="toolbar no-print" id="pcToolbar">
  <button class="btn" onclick="window.print()">Print / Save as PDF</button>
  <button class="btn secondary" onclick="window.close()">Close</button>
</div>
<script>
  // Hide the inline toolbar when this document is loaded inside an
  // iframe (the preview modal already provides Print/Close).
  if (window.parent !== window) {
    var t = document.getElementById('pcToolbar');
    if (t) t.style.display = 'none';
  }
</script>

<div class="header">
  <div class="brand">
    ${PRECISION.logoUrl
      ? `<img src="${escapeHtml(PRECISION.logoUrl)}" alt="${escapeHtml(PRECISION.name)} logo" style="width:64px;height:64px;object-fit:contain;border-radius:6px;background:#0a2240;padding:6px;" />`
      : `<div class="brand-mark">PC</div>`}
    <div class="brand-text">
      <div class="name">${escapeHtml(PRECISION.name)}</div>
      <div class="tag">Cabinetry · Repair · Refacing</div>
    </div>
  </div>
  <div class="shop-info">
    ${escapeHtml(PRECISION.addressLine1)}<br/>
    ${escapeHtml(PRECISION.addressLine2)}<br/>
    ${escapeHtml(PRECISION.phone)}<br/>
    ${escapeHtml(PRECISION.email)}<br/>
    ${escapeHtml(PRECISION.website)}
  </div>
</div>

<h1>Estimate</h1>

<div class="billto" style="margin-top: 16px;">
  <div>
    <div class="label">Prepared for</div>
    <div><strong>${escapeHtml(vendor.name || data.vendorName || '')}</strong></div>
    ${data.vendorContact ? `<div>${escapeHtml(data.vendorContact)}</div>` : ''}
    ${data.vendorPhone ? `<div>${escapeHtml(data.vendorPhone)}</div>` : ''}
    ${data.vendorEmail ? `<div>${escapeHtml(data.vendorEmail)}</div>` : ''}
  </div>
  <div>
    <div class="label">Project</div>
    <div><strong>${escapeHtml(data.clientName || '')}</strong></div>
    ${data.address ? `<div>${escapeHtml(data.address)}</div>` : ''}
  </div>
</div>

${photoSection}

<h2>Estimate Summary</h2>
<div class="meta-line">
  ${(data.cabinets || []).length} cabinet${(data.cabinets || []).length === 1 ? '' : 's'}
  · ${linFt.toFixed(1)} linear ft of cabinetry
</div>
<table>
  <thead>
    <tr>
      <th style="width: 42%;">Description</th>
      <th class="r" style="width: 13%;">Qty</th>
      <th class="r" style="width: 22%;">$ / unit</th>
      <th class="r" style="width: 23%;">Total</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>${escapeHtml(materialsDesc)}</td>
      <td class="r">${linFt > 0 ? linFt.toFixed(1) + ' LF' : '—'}</td>
      <td class="r">${linFt > 0 ? fmtUsd(matsPerLf) + ' / LF' : '—'}</td>
      <td class="r">${fmtUsd(materialsTotal)}</td>
    </tr>
    <tr>
      <td>${escapeHtml(laborDesc)}</td>
      <td class="r">${linFt > 0 ? linFt.toFixed(1) + ' LF' : '—'}</td>
      <td class="r">${linFt > 0 ? fmtUsd(laborPerLf) + ' / LF' : '—'}</td>
      <td class="r">${fmtUsd(laborTotal)}</td>
    </tr>
  </tbody>
  <tfoot>
    <tr class="totals-row">
      <td colspan="3">Estimate total</td>
      <td class="r">${fmtUsd(markedUpTotal)}</td>
    </tr>
  </tfoot>
</table>

<div class="footer">
  <strong>Notes.</strong> This estimate was created using the information provided by ${escapeHtml(companyName)}.
  Any missing or incorrect information is the responsibility of ${escapeHtml(companyName)}.
  Final pricing may vary if additional damage, modifications, or change orders are identified during fabrication
  or installation. Estimate valid for 30 days from date prepared.
  <br/><br/>
  <strong>${escapeHtml(PRECISION.name)}</strong> · ${escapeHtml(PRECISION.phone)} · ${escapeHtml(PRECISION.email)}
</div>

</body></html>`;
  }

  // Cache shop constants for the materials/labor split. Lazy-loaded
  // on first PDF open so we don't hit Firestore on every page load.
  function ensureShopConstants() {
    if (window.PC_SHOP_CONSTANTS) return Promise.resolve(window.PC_SHOP_CONSTANTS);
    if (!window.db) return Promise.resolve(null);
    return window.db.collection('shopConstants').doc('current').get()
      .then(snap => { if (snap.exists) window.PC_SHOP_CONSTANTS = snap.data(); return window.PC_SHOP_CONSTANTS; })
      .catch(() => null);
  }

  // Render the HTML synchronously. Async wrappers tear up the
  // user-gesture context that browsers require to open a new tab,
  // which is why the original window.open() approach got blocked.
  function buildInsuranceEstimateHtml({ vendor, data, pricing, markupPercent }) {
    return buildHtml({ vendor, data, pricing, markupPercent });
  }

  // Best-effort window.open — caller must already be inside a click
  // handler (no awaits before this call) for the popup to be allowed.
  function openInsuranceEstimatePdf({ vendor, data, pricing, markupPercent }) {
    const html = buildHtml({ vendor, data, pricing, markupPercent });
    const win = window.open('', '_blank');
    if (!win) {
      // Fall back to a Blob URL. Some browsers block window.open even
      // inside a click; redirecting the same tab works because it's
      // navigation, not a popup. We open in the same tab as a last
      // resort — the user can use the back button to return.
      try {
        const blob = new Blob([html], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        window.location.assign(url);
        return true;
      } catch {
        alert('Could not open the PDF preview. Try again from your browser without "Add to Home Screen" mode.');
        return false;
      }
    }
    win.document.open();
    win.document.write(html);
    win.document.close();
    return true;
  }

  function ensureShopConstantsAsync() { return ensureShopConstants(); }

  Object.assign(window, {
    openInsuranceEstimatePdf,
    buildInsuranceEstimateHtml,
    ensureShopConstantsAsync,
  });
})();

})();

// ===== intake-wizard.jsx =====
(function(){
// IntakeWizard — guided Q&A flow that replaces the long-scroll new-
// order form. Each top-level step is a focused screen; cabinets are
// added in a tight inner loop with three actions (Back / Add another
// / Done adding). Uses the same data shape as the legacy form so
// save-draft / submit / insurance PDF all keep working unchanged.
//
// Steps:
//   1. Vendor contact            (phone required)
//   2. Service type              Yes/No/Potential — gates step 3
//   3. Customer                  (Yes branch only; name + address required)
//   4. Property type
//   5. Timing + RUSH (auto-prompts when within rushThresholdDays)
//   6. Cabinets loop             (per-cabinet sub-wizard a→h)
//   7. Toe kick
//   8. Scribe
//   9. Special instructions
//  10. Review + Submit / Save Draft / Insurance Estimate
//
// Key fixes from the first iteration:
//   - First cabinet is created in a useEffect, NEVER during render
//     (the previous setData-during-render caused 2-4 ghost cabinets).
//   - Cabinet flow ends with three buttons instead of window.confirm.
//   - Rush upcharge reads from pricing.rush_upcharge_flat (the source
//     of truth for prices) so wizard and submitted-order agree.
//   - Running total displayed in the footer on every step.
//   - Review screen has Edit buttons per section + per-cabinet edit
//     and remove, plus the "estimate" disclaimer.
//   - Date picker enforces today+3 minimum; 3-10 days is the rush
//     window.

const { useState: uS, useEffect: uE, useMemo: uM, useRef: uR, useLayoutEffect: uLE } = React;

// ---- Mobile / BottomSheet helpers ----
//
// Mobile-first wizard helpers — keep these small so the rest of the
// file stays focused on data + flow.

// matchMedia hook — returns true when the viewport matches the query.
// SSR-safe (defaults to false). The wizard uses this to flip between the
// paginated desktop sub-wizard and the accordion mobile layout.
function useMediaQuery(query) {
  const get = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function')
    ? window.matchMedia(query).matches
    : false;
  const [matches, setMatches] = uS(get);
  uE(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange);
    setMatches(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else if (mql.removeListener) mql.removeListener(onChange);
    };
  }, [query]);
  return matches;
}

// Promise-based confirm dialog. Falls back to native window.confirm when
// bottom-sheet.jsx hasn't loaded yet (defensive — the wizard ships in the
// same bundle, but bsConfirm is provided by a sibling file).
function bsConfirmCompat(opts) {
  if (typeof window !== 'undefined' && typeof window.bsConfirm === 'function') {
    return window.bsConfirm(opts);
  }
  const text = [opts?.title, opts?.body].filter(Boolean).join('\n\n');
  return Promise.resolve(window.confirm(text || 'Confirm?'));
}

function bsAlertCompat(opts) {
  if (typeof window !== 'undefined' && typeof window.bsAlert === 'function') {
    return window.bsAlert(opts);
  }
  const text = [opts?.title, opts?.body].filter(Boolean).join('\n\n');
  window.alert(text || '');
  return Promise.resolve();
}

// Resolve a BottomSheet React component if bottom-sheet.jsx has loaded.
// Falls back to a plain inline overlay (same visual as the old modal) so
// the wizard renders identically when the sheet bundle is missing.
function getBottomSheet() {
  return (typeof window !== 'undefined' && window.BottomSheet) || null;
}

// ---- Wizard label catalog ----
// Every user-facing string in the intake wizard is keyed here so admin
// can override it from the Wizard Config → Labels tab. The catalog also
// drives the admin UI: the order + group names below become the
// collapsible sections in the Labels tab.
//
// To add a new editable string: add an entry here AND in the admin
// catalog (`admin-portal/src/lib/wizardLabelCatalog.ts`). The two must
// stay in sync — the admin catalog is what the Labels tab renders;
// this catalog is the vendor PWA's fallback when admin hasn't overridden
// the value.
const LABEL_DEFAULTS = {
  // Step 1 — Vendor contact
  'vendor.title': 'Your contact info',
  'vendor.subtitle': 'So we can reach you about this order.',
  'vendor.field.name': 'Vendor name',
  'vendor.field.contact': 'Contact person',
  'vendor.placeholder.contact': 'Point of contact',
  'vendor.field.phone': 'Phone',
  'vendor.placeholder.phone': '(480) 555-0100',
  'vendor.field.email': 'Email',
  'vendor.placeholder.email': 'pm@company.com',
  'vendor.field.po': 'PO / job ref',
  'vendor.placeholder.po': 'Your PO or job number',
  'vendor.hint': 'Phone is required so we can text or call about the order. Email and PO are optional.',

  // Step 2 — Service type
  'service.title': 'Will this order require pickup, drop-off, or install?',
  'service.subtitle': 'Pick one. Yes lets you choose any combination of pickup, drop-off, and installation.',
  'service.option.yes.label': 'Yes',
  'service.option.yes.detail': 'Pickup, drop-off, install — any combination.',
  'service.option.no.label': 'No pickup, drop-off, or install needed',
  'service.option.no.detail': 'Vendor handles the cabinets — no Precision visit needed.',
  'service.option.potential.label': 'Potential',
  'service.option.potential.detail': "Decide later — we'll ask again before you submit.",
  'service.eyebrow.subToggles': 'Which services? (pick any)',
  'service.validation.needPick': 'Pick at least one service to continue.',
  'service.dropoffFreeSublabel': 'We deliver to the jobsite — included with installation (admin setting).',

  // Step 3 — Customer
  'customer.title': 'Customer info',
  'customer.subtitle': 'Required: name and address. Contact info optional.',
  'customer.field.name': 'Customer name',
  'customer.field.address': 'Address',
  'customer.placeholder.address': 'Street, city, state, ZIP',
  'customer.field.phone': 'Phone',
  'customer.field.email': 'Email',
  'customer.field.preferred': 'Preferred contact',
  'customer.option.preferred.phone': 'Phone',
  'customer.option.preferred.text': 'Text',
  'customer.option.preferred.email': 'Email',
  'customer.field.access': 'Access notes',
  'customer.placeholder.access': 'Gate code, pets, parking…',

  // Step 4 — Property
  'property.title': 'What type of property?',
  'property.subtitle': 'Helps us size the trip and prep the right materials.',

  // Step 5 — Timing + Rush
  'timing.title': 'When do you need this order by?',
  'timing.subtitle': 'Earliest is 3 business days out. Anything {threshold} days or sooner is considered a rush job.',
  'timing.field.date': 'Completion requested',
  'timing.field.rush': 'RUSH order?',

  // Step 6 — Cabinets (shell + sub-step titles)
  'cabinets.title': 'Cabinets',
  'cabinets.subtitle': 'For each cabinet, walk all numbered sections top-to-bottom until each has a green ✓. Only then "+ Add Cabinet" or "Done Adding".',
  'cabinets.help.title': 'How to fill out a cabinet',
  'cabinets.help.body': 'Each cabinet has numbered sections. Tap one to open it. A green ✓ appears once the section has the info we need. Complete every section before adding another cabinet — that way nothing gets missed and your estimate is accurate.\n\nQuick tips:\n• Sections in order: type & size → photos → doors / drawers / shelves → finished sides → box material → under-counter? → notes\n• "Skip photos — continue" if you don\'t have any (photos are optional but very helpful)\n• If any doors / drawers / shelves need repair, tell us how many and what specifically needs fixed\n• Pick "Hardrock Maple" for box material if you\'re not sure — it\'s the most common',
  'cabinets.button.backToTiming': '← Back to timing',
  'cabinets.button.skipToToeKick': 'Skip to toe kick →',
  'cabinets.sub.size': 'Cabinet type & size',
  'cabinets.sub.photos': 'Photos',
  'cabinets.sub.parts': 'Doors / Drawers / Shelves + Hardware',
  'cabinets.sub.finished': 'Finished sides',
  'cabinets.sub.material': 'Box material + thickness',
  'cabinets.sub.hardware': 'Hardware',
  'cabinets.sub.underCounter': 'Under-counter install?',
  'cabinets.sub.notes': 'Anything to note?',
  'cabinets.button.addAnother': '+ Add Cabinet',
  'cabinets.button.doneAdding': '✓ Done Adding Cabinets',
  'cabinets.confirm.allAdded': 'Have you added all the cabinets for this order?',
  'cabinets.button.delete': 'Delete this cabinet',
  'cabinets.confirm.delete': 'Delete Cabinet {n}? This cannot be undone.',

  // Cabinet sub-wizard fields
  'cabinet.field.type': 'Cabinet type',
  'cabinet.field.width': 'Width',
  'cabinet.field.height': 'Height',
  'cabinet.field.depth': 'Depth',
  'cabinet.hint.photos': 'Optional but encouraged. Use Pin to call out specific issues, Draw to circle areas.',
  'cabinet.doors.title': 'Doors',
  'cabinet.doors.sub': 'How many, and is Precision repairing them?',
  'cabinet.doors.checkbox.repair': 'Doors need repair (charged)',
  'cabinet.doors.whichRepair': 'Which door(s) need repair?',
  'cabinet.doors.hingeConfig': 'Hinge configuration',
  'cabinet.drawers.title': 'Drawers',
  'cabinet.drawers.sub': 'How many, and is Precision repairing them?',
  'cabinet.drawers.checkbox.repair': 'Drawers need repair (charged)',
  'cabinet.drawers.whichRepair': 'Which drawer(s) need repair?',
  'cabinet.drawers.whichRepairHint': 'Drawers are counted top-down — top drawer is #1, the next is #2, and so on.',
  'cabinet.shelves.title': 'Shelves',
  'cabinet.shelves.sub': 'Existing shelf count + repair / new-build options.',
  'cabinet.shelves.checkbox.repair': 'Shelves need repair (charged)',
  'cabinet.shelves.whichRepair': 'Which shelf/shelves need repair?',
  'cabinet.shelves.whichRepairHint': 'Shelves are counted top-down — top shelf is #1.',
  'cabinet.shelves.checkbox.new': 'New shelf made (charged — replaces or adds)',
  'cabinet.shelves.howManyNew': 'How many new shelves?',
  'cabinet.shelves.zeroHint': 'Leave count at 0 if this cabinet has no shelves.',
  'cabinet.shelves.rollouts.title': 'Roll-out shelves',
  'cabinet.shelves.rollouts.sub': '(pull-out trays — Base + Full-height cabinets only)',
  'cabinet.shelves.rollouts.howMany': 'How many?',
  'cabinet.field.finishedSide': 'Finished sides?',
  'cabinet.field.whichSide': 'Which side?',
  'cabinet.field.backFinished': 'Is the back side finished?',
  'cabinet.hint.backFinished': 'Islands and peninsulas often have an exposed back. If yes, a skin panel is added.',
  'cabinet.field.boxMaterial': 'Box material',
  'cabinet.field.thickness': 'Thickness',
  'cabinet.hint.thicknessDefault': 'Default 1/2".',
  'cabinet.hint.thicknessUnknown': 'Unknown — shop will measure the dado off the face frame to confirm.',
  'cabinet.field.hardware': 'Hardware',
  'cabinet.hardware.skipNote': 'This cabinet has no doors or drawers — hardware question skipped.',
  'cabinet.field.hardwareSource': 'Is hardware coming with the cabinet?',
  'cabinet.hint.hardwareSource': 'No = Precision supplies the slides / hinges — additional hardware charge applies.',
  'cabinet.field.softClose': 'Soft-close or standard?',
  'cabinet.hint.softClose': 'Soft-close costs more — pricing applied when admin enables it.',
  'cabinet.field.underCounter': 'Installs under existing countertop?',
  'cabinet.hint.underCounter': 'If yes, we cut the cabinet 1" short on the back so it slides under the existing counter without a fight. Adjustable feet are optional.',
  'cabinet.field.underCounterAction': 'What should we do?',
  'cabinet.hint.underCounterAction': 'Pick both, either, or neither.',
  'cabinet.checkbox.cutShort': 'Cut the box 1" short (no charge) — easier under-counter install',
  'cabinet.checkbox.adjustableFeet': 'Add adjustable feet (charged per cabinet)',
  'cabinet.underCounter.sidePanelWarning': 'This cabinet also has a finished side panel. The side-panel skin needs to be either detached before the cut OR accounted for so the panel still aligns. Precision will see this flag on the work order.',
  'cabinet.field.notes': 'Notes (optional)',
  'cabinet.placeholder.notes': 'Damage, finish details, anything specific to this cabinet…',

  // Step 7 — Toe kick
  'toeKick.title': 'Toe kick',
  'toeKick.subtitle': 'The recessed strip under the floor-standing cabinets. Supplied in 8-ft sticks; we always round up.',
  'toeKick.field.height': 'Toe Kick Height',
  'toeKick.field.setback': 'Setback',
  'toeKick.field.thickness': 'Thickness',
  'toeKick.field.length': 'Total length (8-ft sticks)',
  'toeKick.hint.height': '¼" increments. Default 4".',
  'toeKick.hint.setback': '¼" increments. Default 3".',
  'toeKick.hint.thickness': 'Default 1/4".',
  'toeKick.eyebrow.spec': 'Toe kick spec #{n}',
  'toeKick.eyebrow.single': 'Toe kick',

  // Step 8 — Scribe
  'scribe.title': 'Scribe',
  'scribe.subtitle': 'Trim that hides gaps where cabinets meet walls or appliances. Supplied in 8-ft sticks, matched to cabinet material.',
  'scribe.field.needed': 'Need scribe?',
  'scribe.field.sticks': 'How many 8-ft sticks?',

  // Step 9 — Add-ons
  'addons.title': 'Add-ons',
  'addons.subtitle': 'Refrigerator panels, dishwasher panels, fillers, trim — pick what you need.',
  'addons.field.needed': 'Do you need any add-ons?',
  'addons.eyebrow.addOne': 'Add one or more:',
  'addons.eyebrow.yours': 'Your add-ons',
  'addons.placeholder.otherDescription': "What's the accessory? e.g. base molding, light rail, etc.",

  // Step 10 — Special instructions
  'special.title': 'Anything else?',
  'special.subtitle': 'Color match notes, hardware preferences, special handling.',
  'special.placeholder': 'Special instructions…',

  // Step 11 — Review
  'review.eyebrow': 'Review',
  'review.title': 'Looks good?',
  'review.subtitle': 'Tap Edit on any section to adjust. Estimate updates live.',
  'review.section.customer': 'Customer',
  'review.section.timing': 'Timing',
  'review.section.cabinets': 'Cabinets',
  'review.section.toeKick': 'Toe kick',
  'review.section.scribe': 'Scribe',
  'review.section.addons': 'Add-ons',
  'review.section.special': 'Special instructions',

  // Shared / footer
  'shared.back': '← Back',
  'shared.next': 'Next →',
  'shared.runningTotal': 'Running total',
};

// Read a label by key, with fallback to the catalog default. Optional
// `vars` object substitutes {placeholder} tokens (e.g. {threshold}, {n}).
// Named L (not t) so it doesn't collide with the `t` arrow-function
// parameter used throughout this file.
function L(key, vars) {
  const cache = (typeof window !== 'undefined' ? window.PC_PRICING_CACHE : null);
  const override = cache?.wizardConfig?.labels?.[key];
  const value = (typeof override === 'string' && override.length > 0) ? override : LABEL_DEFAULTS[key];
  if (value == null) return key;          // Helps surface a missing key during dev.
  if (!vars) return value;
  return String(value).replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : `{${k}}`));
}

Object.assign(window, { WIZARD_LABEL_DEFAULTS: LABEL_DEFAULTS, L });

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const todayPlus = (n) => {
  const d = new Date(Date.now() + n * MS_PER_DAY);
  return d.toISOString().slice(0, 10);
};
const daysBetween = (iso) => {
  if (!iso) return null;
  const target = new Date(iso).getTime();
  return Math.round((target - Date.now()) / MS_PER_DAY);
};

// US federal holidays (fixed-date + observed Monday holidays where applicable).
// Maintained per year; refresh every January. Format: YYYY-MM-DD.
const US_FEDERAL_HOLIDAYS = new Set([
  // 2026
  '2026-01-01', // New Year's Day
  '2026-01-19', // MLK Day (3rd Mon Jan)
  '2026-02-16', // Presidents Day (3rd Mon Feb)
  '2026-05-25', // Memorial Day (last Mon May)
  '2026-06-19', // Juneteenth
  '2026-07-03', // Independence Day (observed; Jul 4 is Sat)
  '2026-09-07', // Labor Day (1st Mon Sep)
  '2026-10-12', // Columbus Day (2nd Mon Oct)
  '2026-11-11', // Veterans Day
  '2026-11-26', // Thanksgiving (4th Thu Nov)
  '2026-12-25', // Christmas
  // 2027
  '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-18',
  '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25', '2027-12-24',
]);

// Add N business days (Mon–Fri, skipping US federal holidays) to a date.
const addBusinessDays = (fromDate, n) => {
  const d = new Date(fromDate);
  let added = 0;
  while (added < n) {
    d.setDate(d.getDate() + 1);
    const day = d.getDay();
    const iso = d.toISOString().slice(0, 10);
    if (day !== 0 && day !== 6 && !US_FEDERAL_HOLIDAYS.has(iso)) added++;
  }
  return d;
};

// Earliest selectable completion date — today + N business days as ISO YYYY-MM-DD.
const earliestBusinessDate = (n) => addBusinessDays(new Date(), n).toISOString().slice(0, 10);

// Rush charge calc: greater of flat $ or % of subtotal.
// Both pricing keys default to 0 so no rush applies until admin configures.
const computeRushCharge = (pricing, subtotal) => {
  const flat = pricing?.rush_upcharge_flat?.price || 0;
  const pct = pricing?.rush_upcharge_pct?.price || 0;
  const pctAmount = (subtotal || 0) * (pct / 100);
  return Math.max(flat, pctAmount);
};

// ---------- shared layout ----------

function StepShell({ step, total, title, subtitle, onBack, onNext, nextLabel, nextDisabled, runningTotal, children, extraActions }) {
  return (
    <div className="wiz-shell">
      <div className="wiz-progress">
        <div className="wiz-progress-bar" style={{ width: `${(step / total) * 100}%` }} />
      </div>
      <div className="wiz-body">
        <div className="wiz-stepnum">Step {step} of {total}</div>
        <h1 className="wiz-title">{title}</h1>
        {subtitle && <p className="wiz-sub">{subtitle}</p>}
        <div className="wiz-content">{children}</div>
      </div>
      <div className="wiz-footer">
        <button className="btn ghost" onClick={onBack} disabled={!onBack}>{L('shared.back')}</button>
        {runningTotal != null && (
          <div className="wiz-runningtotal">
            <span className="wiz-runningtotal-l">{L('shared.runningTotal')}</span>
            <span className="wiz-runningtotal-v mono">{fmtMoney(runningTotal)}</span>
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {extraActions}
          {onNext && (
            <button className="btn primary lg" onClick={onNext} disabled={nextDisabled}>
              {nextLabel || L('shared.next')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function Field({ label, required, children, hint }) {
  return (
    <div className="wiz-field">
      <label className="wiz-label">{label}{required && <span className="req"> *</span>}</label>
      {children}
      {hint && <div className="hint" style={{ fontSize: 11, marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

function Segmented({ value, options, onChange }) {
  return (
    <div className="segmented">
      {options.map(o => {
        const v = typeof o === 'string' ? o : o.v;
        const l = typeof o === 'string' ? o : o.l;
        const disabled = typeof o === 'object' && o.disabled === true;
        const title = typeof o === 'object' ? o.title : undefined;
        return (
          <button
            key={v}
            className={(value === v ? 'on ' : '') + (disabled ? 'is-disabled' : '')}
            onClick={() => { if (!disabled) onChange(v); }}
            disabled={disabled}
            title={title}
            style={disabled ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}
          >{l}</button>
        );
      })}
    </div>
  );
}

// Lightweight cabinet visual — front view, scaled to fit a fixed box.
// Memoised on the small set of cab fields it actually reads so unrelated
// edits elsewhere in the wizard (cabinet name, notes, photos…) don't
// re-render this SVG on every keystroke.
function CabinetPreviewImpl({ cab }) {
  const wIn = parseFloat(cab.w) || 0;
  const hIn = parseFloat(cab.h) || 0;
  const dIn = parseFloat(cab.d) || 0;
  if (!wIn || !hIn) return null;
  const maxBox = 220;
  const ratio = wIn / hIn;
  const boxW = ratio >= 1 ? maxBox : Math.round(maxBox * ratio);
  const boxH = ratio >= 1 ? Math.round(maxBox / ratio) : maxBox;

  const doors = parseInt(cab.doors) || 0;
  const drawers = parseInt(cab.drawers) || 0;
  // Layout: drawer bank fills top portion when drawers present.
  const drawerBankPct = drawers > 0 && doors > 0 ? 0.4 : (drawers > 0 ? 1.0 : 0);
  const drawerBankH = boxH * drawerBankPct;
  const doorAreaH = boxH - drawerBankH - (drawers > 0 && doors > 0 ? 4 : 0);
  const stileW = 6;

  return (
    <div className="wiz-cabpreview">
      <svg width={boxW} height={boxH} style={{ display: 'block' }}>
        {/* outer box */}
        <rect x="0" y="0" width={boxW} height={boxH} fill="#FBF0E1" stroke="#0a2240" strokeWidth="2" />
        {/* face frame stiles */}
        <rect x="0" y="0" width={stileW} height={boxH} fill="#0a2240" opacity="0.15" />
        <rect x={boxW - stileW} y="0" width={stileW} height={boxH} fill="#0a2240" opacity="0.15" />

        {/* drawer bank */}
        {drawers > 0 && Array.from({ length: drawers }).map((_, i) => {
          const dh = drawerBankH / drawers;
          return (
            <g key={'dr' + i}>
              <rect x={stileW + 2} y={i * dh + 2} width={boxW - 2 * (stileW + 2)} height={dh - 4}
                    fill="#fff" stroke="#0a2240" strokeWidth="1" rx="2" />
            </g>
          );
        })}

        {/* doors */}
        {doors > 0 && (
          <g>
            {Array.from({ length: doors }).map((_, i) => {
              const dw = (boxW - 2 * stileW - (doors - 1) * 4) / doors;
              const dx = stileW + i * (dw + 4);
              const dy = drawerBankH + (drawers > 0 ? 4 : 0);
              const hingeOnLeft = (() => {
                if (cab.hingeConfig === 'left') return true;
                if (cab.hingeConfig === 'right') return false;
                if (cab.hingeConfig === 'meeting') return i < doors / 2 ? true : false;
                if (cab.hingeConfig === 'custom' && cab.hinges?.[i]) return cab.hinges[i] === 'L';
                return i < doors / 2;
              })();
              return (
                <g key={'dr' + i}>
                  <rect x={dx} y={dy} width={dw} height={doorAreaH}
                        fill="#fff" stroke="#0a2240" strokeWidth="1" rx="2" />
                  <circle cx={hingeOnLeft ? dx + 5 : dx + dw - 5} cy={dy + doorAreaH / 2} r="2" fill="#C9781B" />
                </g>
              );
            })}
          </g>
        )}

        {/* labels */}
        <text x={boxW / 2} y={boxH + 14} textAnchor="middle" fontSize="11" fill="#555" fontFamily="Geist Mono, JetBrains Mono, monospace">
          {wIn}" × {hIn}" × {dIn}"
        </text>
      </svg>
      <div style={{
        marginTop: 24,
        fontSize: 11,
        fontStyle: 'italic',
        color: 'var(--ink-faint)',
        textAlign: 'center',
        maxWidth: 320,
      }}>
        Representation only — actual cabinet configuration may differ (drawer position, door swing, hinges, etc.).
      </div>
    </div>
  );
}

function sameHinges(a, b) {
  if (a === b) return true;
  if (!a || !b) return a == b;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
  return true;
}
const CabinetPreview = React.memo(CabinetPreviewImpl, (prev, next) => {
  const a = prev.cab || {}, b = next.cab || {};
  return a.w === b.w && a.h === b.h && a.d === b.d
      && a.doors === b.doors && a.drawers === b.drawers
      && a.hingeConfig === b.hingeConfig
      && sameHinges(a.hinges, b.hinges);
});

// ---------- Step 1 — Vendor contact ----------

function VendorContactStep({ data, setData, vendor, ...nav }) {
  return (
    <StepShell {...nav} title={L('vendor.title')} subtitle={L('vendor.subtitle')}>
      <Field label={L('vendor.field.name')} required>
        <input className="input" value={data.vendorName || vendor.name || ''}
               autoCapitalize="words"
               onChange={e => setData(d => ({ ...d, vendorName: e.target.value }))} />
      </Field>
      <Field label={L('vendor.field.contact')}>
        <input className="input" value={data.vendorContact || ''}
               placeholder={L('vendor.placeholder.contact')}
               autoCapitalize="words"
               onChange={e => setData(d => ({ ...d, vendorContact: e.target.value }))} />
      </Field>
      <Field label={L('vendor.field.phone')} required>
        <input className="input mono" value={data.vendorPhone || ''}
               placeholder={L('vendor.placeholder.phone')}
               type="tel" inputMode="tel" autoComplete="tel" maxLength={14}
               onChange={e => setData(d => ({ ...d, vendorPhone: window.formatPhoneInput(e.target.value) }))} />
      </Field>
      <Field label={L('vendor.field.email')}>
        <input className="input" value={data.vendorEmail || ''}
               placeholder={L('vendor.placeholder.email')}
               type="email" inputMode="email"
               autoCapitalize="none" autoCorrect="off" autoComplete="email"
               onChange={e => setData(d => ({ ...d, vendorEmail: e.target.value }))} />
      </Field>
      {/* PO / job ref moved to Step 3 (customer / job-site info) — was
          asked twice in the prior flow (here and on the drop-only path
          of Step 3). Consolidated into Step 3 for both yes/no service
          paths so vendors only see it once. */}
      <div className="hint" style={{ fontSize: 12, marginTop: 8 }}>
        Phone is required so we can text or call about the order. Email is optional.
      </div>
    </StepShell>
  );
}

// ---------- Step 2 — Service type ----------
//
// Top-level: Yes / No / Potential.
// "Yes" reveals THREE independent toggles: Pickup / Drop-off / Installation.
// Any combination is valid (pickup + install, drop-off only, install only,
// etc.). At least one toggle must be on before Next is enabled.
//
// Data shape:
//   serviceMode = 'multi' | 'none' | 'potential'        (top-level)
//   serviceToggles = { pickup, dropoff, install }       (when 'multi' or 'potential')
//   installNeeded = 'Yes' | 'No' | 'Potential'          (legacy mirror, kept for back-compat)

function ServiceTypeStep({ data, setData, pricing, ...nav }) {
  // Derive the top-level chip from whichever field we have. Legacy
  // single-value modes ('pickup'/'dropoff'/'install') count as "Yes".
  const mode = data.serviceMode ||
    (data.installNeeded === 'Yes' ? 'multi' :
     data.installNeeded === 'No' ? 'none' :
     data.installNeeded === 'Potential' ? 'potential' : null);

  const topLevel =
    mode === 'none' ? 'No' :
    mode === 'potential' ? 'Potential' :
    (mode === 'multi' || mode === 'pickup' || mode === 'dropoff' || mode === 'install') ? 'Yes' :
    null;

  // Migrate legacy single-mode into the new toggles shape on first render.
  const toggles = (() => {
    const t = data.serviceToggles;
    if (t) return { pickup: !!t.pickup, dropoff: !!t.dropoff, install: !!t.install };
    if (mode === 'pickup')  return { pickup: true,  dropoff: false, install: false };
    if (mode === 'dropoff') return { pickup: false, dropoff: true,  install: false };
    if (mode === 'install') return { pickup: false, dropoff: false, install: true  };
    return { pickup: false, dropoff: false, install: false };
  })();

  const setTop = (v) => {
    if (v === 'No') {
      setData(d => ({ ...d, serviceMode: 'none', installNeeded: 'No', serviceToggles: null }));
    } else if (v === 'Potential') {
      setData(d => ({ ...d, serviceMode: 'potential', installNeeded: 'Potential', serviceToggles: null }));
    } else {
      // Yes — promote to multi-mode, seed toggles from prior selection.
      setData(d => ({
        ...d,
        serviceMode: 'multi',
        installNeeded: 'Yes',
        serviceToggles: toggles,
      }));
    }
  };

  const setToggle = (key, val) => {
    const next = { ...toggles, [key]: val };
    setData(d => ({
      ...d,
      serviceMode: 'multi',
      installNeeded: 'Yes',
      serviceToggles: next,
    }));
  };

  const installIncludesDropoff = !!(pricing?.install_includes_dropoff?.price);
  const serviceOptions = React.useMemo(() => deriveServiceOptions(pricing), [pricing]);

  // Look up the live rate for a service option, given its pricingKey + mode.
  const rateFor = (opt) => {
    const key = opt?.pricingKey;
    const entry = key ? pricing?.[key] : null;
    return entry?.price ?? 0;
  };
  const priceTextFor = (opt) => {
    const r = rateFor(opt);
    if (opt.pricingMode === 'per-cabinet') return `+ $${r} ea.`;
    return `+ $${r}`;
  };

  const Toggle = ({ opt, sublabel, priceText }) => (
    <button
      type="button"
      onClick={() => setToggle(opt.id, !toggles[opt.id])}
      className={'wiz-bigchip' + (toggles[opt.id] ? ' on' : '')}
      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
    >
      <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
        <div className="wiz-bigchip-l">{opt.label}{toggles[opt.id] ? ' ✓' : ''}</div>
        <div className="wiz-bigchip-d">{sublabel ?? opt.sublabel}</div>
      </div>
      <div className="mono" style={{ fontSize: 14, fontWeight: 600, color: 'var(--accent-deep)', marginLeft: 12, whiteSpace: 'nowrap' }}>
        {priceText ?? priceTextFor(opt)}
      </div>
    </button>
  );

  const dropoffIsFree = toggles.install && installIncludesDropoff;
  const anyToggle = serviceOptions.some(o => toggles[o.id]);

  return (
    <StepShell {...nav} title={L('service.title')}
      subtitle={L('service.subtitle')}>
      <div className="wiz-bigchips">
        {[
          { v: 'Yes',       l: L('service.option.yes.label'),       d: L('service.option.yes.detail') },
          { v: 'No',        l: L('service.option.no.label'),        d: L('service.option.no.detail') },
          { v: 'Potential', l: L('service.option.potential.label'), d: L('service.option.potential.detail') },
        ].map(o => (
          <button key={o.v}
                  className={'wiz-bigchip' + (topLevel === o.v ? ' on' : '')}
                  onClick={() => setTop(o.v)}>
            <div className="wiz-bigchip-l">{o.l}</div>
            <div className="wiz-bigchip-d">{o.d}</div>
          </button>
        ))}
      </div>

      {topLevel === 'Yes' && (
        <div style={{ marginTop: 24 }}>
          <div className="eyebrow" style={{ marginBottom: 12 }}>{L('service.eyebrow.subToggles')}</div>
          <div className="wiz-bigchips" style={{ gridTemplateColumns: '1fr' }}>
            {serviceOptions.map(opt => {
              // Special-case dropoff free with install — preserve the
              // existing UX that swaps the sublabel + price to $0.
              if (opt.id === 'dropoff' && dropoffIsFree) {
                return (
                  <Toggle key={opt.id} opt={opt}
                    sublabel={L('service.dropoffFreeSublabel')}
                    priceText="+ $0" />
                );
              }
              return <Toggle key={opt.id} opt={opt} />;
            })}
          </div>
          {toggles.install && (
            <div className="hint" style={{ fontSize: 12, marginTop: 8, color: '#C9781B' }}>
              ⓘ Installation is <strong>subject to availability and our installer's schedule</strong>. We'll confirm an install date after the cabinets are built.
            </div>
          )}
          {!anyToggle && (
            <div className="hint" style={{ fontSize: 12, marginTop: 8, color: '#b91c1c' }}>
              {L('service.validation.needPick')}
            </div>
          )}
        </div>
      )}
    </StepShell>
  );
}

// ---------- Step 3 — Customer ----------
//
// Two render modes:
//   "needs-service": full customer info (name + address required, phone /
//   email / preferred / access notes optional). Used when serviceMode is
//   'multi' (vendor picked Yes for pickup / drop-off / install).
//
//   "drop-only": simplified jobsite form. Used when serviceMode is 'none'
//   or 'potential' — Precision isn't touching the cabinets yet so all
//   we need is a job-site reference. Job # was already captured on step
//   1 as `vendorPO`. Jobsite address is optional.

function CustomerStep({ data, setData, ...nav }) {
  // Treat 'multi' as service-needed. 'none', 'potential', and any legacy
  // unset value land on the simplified form.
  const needsService = data.serviceMode === 'multi'
    || (data.serviceMode == null && data.installNeeded === 'Yes');

  if (!needsService) {
    return (
      <StepShell {...nav} title="Job-site info" subtitle="Quick reference for the order. Precision won't visit the home — we just need a way to identify this job.">
        <Field label="Job # / PO" hint="Your PO or job number — required to identify this order." required>
          <input className="input mono" value={data.vendorPO || ''}
                 placeholder="Your PO or job number"
                 autoCapitalize="characters" autoCorrect="off"
                 onChange={e => setData(d => ({ ...d, vendorPO: e.target.value }))} />
        </Field>
        <Field label="Job-site address" hint="Optional — paste the address if you want it on the work order.">
          <input className="input" value={data.address || ''}
                 placeholder={L('customer.placeholder.address')}
                 autoCapitalize="words" autoComplete="street-address"
                 onChange={e => setData(d => ({ ...d, address: e.target.value }))} />
        </Field>
        {data.serviceMode === 'potential' && (
          <div className="hint" style={{ fontSize: 12, color: '#C9781B', marginTop: 8 }}>
            ⓘ You marked this order as <strong>Potential</strong>. We'll ask again on the Review screen — if you decide on pickup, drop-off, or install we'll collect customer name / phone / email there.
          </div>
        )}
      </StepShell>
    );
  }

  return (
    <StepShell {...nav} title={L('customer.title')} subtitle={L('customer.subtitle')}>
      <Field label="Job # / PO" hint="Your PO or job number — optional.">
        <input className="input mono" value={data.vendorPO || ''}
               placeholder="Your PO or job number"
               autoCapitalize="characters" autoCorrect="off"
               onChange={e => setData(d => ({ ...d, vendorPO: e.target.value }))} />
      </Field>
      <Field label={L('customer.field.name')} required>
        <input className="input" value={data.clientName || ''}
               autoCapitalize="words"
               onChange={e => setData(d => ({ ...d, clientName: e.target.value }))} />
      </Field>
      <Field label={L('customer.field.address')} required>
        <input className="input" value={data.address || ''}
               placeholder={L('customer.placeholder.address')}
               autoCapitalize="words" autoComplete="street-address"
               onChange={e => setData(d => ({ ...d, address: e.target.value }))} />
      </Field>
      <Field label={L('customer.field.phone')}>
        <input className="input mono" value={data.clientPhone || ''}
               type="tel" inputMode="tel" autoComplete="tel" maxLength={14}
               placeholder="(480) 555-0142"
               onChange={e => setData(d => ({ ...d, clientPhone: window.formatPhoneInput(e.target.value) }))} />
      </Field>
      <Field label={L('customer.field.email')}>
        <input className="input" value={data.clientEmail || ''}
               type="email" inputMode="email"
               autoCapitalize="none" autoCorrect="off" autoComplete="email"
               onChange={e => setData(d => ({ ...d, clientEmail: e.target.value }))} />
      </Field>
      <Field label={L('customer.field.preferred')}>
        <Segmented value={data.preferredContact || 'Phone'}
                   options={[
                     { v: 'Phone', l: L('customer.option.preferred.phone') },
                     { v: 'Text',  l: L('customer.option.preferred.text') },
                     { v: 'Email', l: L('customer.option.preferred.email') },
                   ]}
                   onChange={v => setData(d => ({ ...d, preferredContact: v }))} />
      </Field>
      <Field label={L('customer.field.access')}>
        <textarea className="textarea" value={data.accessNotes || ''}
                  placeholder={L('customer.placeholder.access')}
                  onChange={e => setData(d => ({ ...d, accessNotes: e.target.value }))} />
      </Field>
    </StepShell>
  );
}

// ---------- Step 4 — Property ----------

function PropertyStep({ data, setData, pricing, ...nav }) {
  const propertyTypes = React.useMemo(() => derivePropertyTypes(pricing), [pricing]);
  const options = propertyTypes.map(p => p.label);
  const defaultLabel = options[0] || 'Residential';
  return (
    <StepShell {...nav} title={L('property.title')} subtitle={L('property.subtitle')}>
      <Segmented value={data.homeType || defaultLabel}
                 options={options}
                 onChange={v => setData(d => ({ ...d, homeType: v }))} />
    </StepShell>
  );
}

// ---------- Step 5 — Timing + RUSH ----------

function TimingStep({ data, setData, pricing, sc, estimate, onConfirmRush, ...nav }) {
  const dateChosen = data.completionRequested || '';
  const minDate = earliestBusinessDate(3);   // today + 3 business days, skipping holidays
  const threshold = (sc && sc.rushThresholdDays) || 10;       // default 10
  const subtotalNow = estimate?.subtotal || 0;
  const upcharge = computeRushCharge(pricing, subtotalNow);
  const days = daysBetween(dateChosen);
  const tooSoon = !!dateChosen && dateChosen < minDate;
  const insideRush = days != null && !tooSoon && days <= threshold;

  // Rush auto-flips ON when the date is inside the window AND auto-flips
  // OFF when the date moves back outside the window. The `rushAck` flag
  // tracks whether the vendor has confirmed the rush upcharge for THIS
  // date; clearing the rush state also clears the ack so a re-entry
  // forces a fresh double-confirm.
  uE(() => {
    if (insideRush && data.rush !== true) {
      setData(d => ({ ...d, rush: true }));
    } else if (!insideRush && data.rush && data.rushAck !== true) {
      // Vendor pushed the date back past the threshold — drop rush, clear ack.
      setData(d => ({ ...d, rush: false, rushAck: false }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insideRush]);

  const onNext = () => {
    if (!dateChosen) return;
    if (tooSoon) {
      bsAlertCompat({
        title: 'Pick a later date',
        body: 'Earliest completion date is 3 business days from today (weekends and federal holidays skipped). Please pick a later date.',
      });
      return;
    }
    // Inside the rush window AND vendor hasn't ack'd the upcharge yet ⇒
    // show the double-confirm. Once acked, future Next presses pass
    // straight through unless the date moves out of the window and back.
    if (insideRush && data.rushAck !== true) {
      onConfirmRush({ days, threshold, upcharge });
      return;
    }
    nav.onNext();
  };

  return (
    <StepShell {...nav} onNext={onNext} title={L('timing.title')} subtitle={L('timing.subtitle', { threshold })}>
      <Field label={L('timing.field.date')} required>
        {/* iOS native date pickers add a chevron + clear button on
            the right that pushed the rounded-border past the wiz-body
            padding. Cap to 240px + box-sizing border-box; date input
            content easily fits in that and stays well inside the
            safe-area on every iPhone size. */}
        <input className="input mono" type="date" value={dateChosen}
               min={minDate}
               style={{ maxWidth: 240, width: '100%', display: 'block', boxSizing: 'border-box' }}
               onChange={e => setData(d => ({ ...d, completionRequested: e.target.value }))} />
        {dateChosen && (
          <div className="hint" style={{ fontSize: 11, marginTop: 4, color: tooSoon ? '#b91c1c' : (insideRush ? '#C9781B' : 'var(--ink-faint)') }}>
            {tooSoon ? `Too soon — earliest is 3 business days out.`
              : `${days} day${days === 1 ? '' : 's'} from today.`
            }
            {insideRush && ` Inside our ${threshold}-day rush window — RUSH is required.`}
          </div>
        )}
      </Field>
      <Field
        label={L('timing.field.rush')}
        hint={(() => {
          const flat = pricing?.rush_upcharge_flat?.price || 0;
          const pct = pricing?.rush_upcharge_pct?.price || 0;
          // Build a "15% of subtotal, $500 minimum" breakdown so the
          // vendor sees both the dollar amount AND the formula.
          const formulaParts = [];
          if (pct > 0) formulaParts.push(`${pct}% of subtotal`);
          if (flat > 0) formulaParts.push(`$${flat} minimum`);
          const formula = formulaParts.join(', ');
          const liveAmount = Math.round(upcharge);
          const hasSubtotal = subtotalNow > 0;
          const amountCopy = liveAmount > 0
            ? (hasSubtotal
                ? `Adds $${liveAmount} to this order`
                : `Will add at least $${liveAmount}; final amount updates as you add cabinets`)
            : null;

          if (insideRush) {
            // Date inside the window — rush is forced. Always show context.
            if (!formula && !amountCopy) {
              return `Locked to Yes — date is inside the ${threshold}-day rush window. Rush pricing isn't configured yet, so no upcharge applies. Push the date past ${threshold} days out to remove rush.`;
            }
            return [
              `Locked to Yes — date is inside the ${threshold}-day rush window.`,
              amountCopy ? `${amountCopy}${formula ? ` (${formula})` : ''}.` : (formula ? `Rush charge: ${formula}.` : null),
              `Push the date past ${threshold} days out to remove rush.`,
            ].filter(Boolean).join(' ');
          }

          // Outside the window — only show info when vendor opted INTO rush.
          // If they said No (the default), leave the hint blank so we're not
          // nagging them about a non-issue.
          if (data.rush !== true) return '';

          // Yes selected outside the window — preview the cost.
          if (amountCopy) return `${amountCopy}${formula ? ` (${formula})` : ''}.`;
          if (formula) return `Rush charge: ${formula}.`;
          return `Rush is flagged on this order — no upcharge configured yet.`;
        })()}
      >
        <Segmented
          value={data.rush ? 'Yes' : 'No'}
          options={[
            { v: 'No',  l: 'No',  disabled: insideRush, title: insideRush ? `Locked — push the date past ${threshold} days out to unlock.` : undefined },
            { v: 'Yes', l: 'Yes' },
          ]}
          onChange={v => setData(d => ({ ...d, rush: v === 'Yes' }))}
        />
      </Field>
    </StepShell>
  );
}

// ---------- Step 6 — Cabinets loop ----------

// Vanity presets — 21" is the typical depth, 24" available for the
// larger units. Each preset bakes in width × height × depth + the
// door/drawer config that goes with the layout. Picking any of these
// auto-sets cabType='Vanity' so the cabinet-type step is skipped.
const VANITY_PRESETS = [
  { code: 'V18',       w: '18', h: '32', d: '21', doors: 1, drawers: 0, drawerLayout: '', desc: '18×32×21 — single door' },
  { code: 'V24',       w: '24', h: '32', d: '21', doors: 1, drawers: 0, drawerLayout: '', desc: '24×32×21 — single door' },
  { code: 'V30',       w: '30', h: '32', d: '21', doors: 2, drawers: 0, drawerLayout: '', desc: '30×32×21 — 2 doors' },
  { code: 'V36',       w: '36', h: '32', d: '21', doors: 2, drawers: 0, drawerLayout: '', desc: '36×32×21 — 2 doors' },
  { code: 'V36-24D',   w: '36', h: '32', d: '24', doors: 2, drawers: 0, drawerLayout: '', desc: '36×32×24 — 2 doors (deep)' },
  { code: 'V36-3D',    w: '36', h: '32', d: '21', doors: 2, drawers: 3, drawerLayout: '3-equal', desc: '36×32×21 — 3 drw ctr, 2 outer doors' },
  { code: 'V36-3DL',   w: '36', h: '32', d: '21', doors: 1, drawers: 3, drawerLayout: '3-equal', desc: '36×32×21 — 3 drw L, 1 door R' },
  { code: 'V36-3DR',   w: '36', h: '32', d: '21', doors: 1, drawers: 3, drawerLayout: '3-equal', desc: '36×32×21 — 3 drw R, 1 door L' },
  { code: 'V42',       w: '42', h: '32', d: '21', doors: 2, drawers: 0, drawerLayout: '', desc: '42×32×21 — 2 doors' },
  { code: 'V48',       w: '48', h: '32', d: '21', doors: 2, drawers: 0, drawerLayout: '', desc: '48×32×21 — 2 doors' },
  { code: 'V48-3D',    w: '48', h: '32', d: '21', doors: 2, drawers: 3, drawerLayout: '3-equal', desc: '48×32×21 — 3 drw ctr, 2 outer doors' },
  { code: 'V48-24D',   w: '48', h: '32', d: '24', doors: 2, drawers: 3, drawerLayout: '3-equal', desc: '48×32×24 — 3 drw ctr, 2 doors (deep)' },
  { code: 'V60',       w: '60', h: '32', d: '21', doors: 2, drawers: 0, drawerLayout: '', desc: '60×32×21 — 2 doors' },
  { code: 'V60-3D',    w: '60', h: '32', d: '21', doors: 2, drawers: 3, drawerLayout: '3-equal', desc: '60×32×21 — 3 drw ctr, 2 outer doors' },
  { code: 'V60-24D',   w: '60', h: '32', d: '24', doors: 2, drawers: 3, drawerLayout: '3-equal', desc: '60×32×24 — 3 drw ctr, 2 doors (deep)' },
  { code: 'V72-3D',    w: '72', h: '32', d: '21', doors: 2, drawers: 3, drawerLayout: '3-equal', desc: '72×32×21 — 3 drw ctr, 2 outer doors' },
  { code: 'V72-24D',   w: '72', h: '32', d: '24', doors: 2, drawers: 3, drawerLayout: '3-equal', desc: '72×32×24 — 3 drw ctr, 2 doors (deep)' },
];

function PhotosBlock({ cab, onChange, onAdvanceTo }) {
  const photos = (typeof window !== 'undefined' && window.getCabinetPhotos)
    ? window.getCabinetPhotos(cab)
    : (cab.photos && cab.photos.length ? cab.photos : (cab.photo ? [{ id: 'legacy', src: cab.photo, annotations: cab.annotations || [] }] : []));
  const max = (typeof window !== 'undefined' && window.MAX_PHOTOS_PER_CABINET) || 6;
  const [activeIdx, setActiveIdx] = uS(photos.length > 0 ? 0 : -1);
  // HI-6: index of a failed-upload photo currently being retried.
  const [retryingIdx, setRetryingIdx] = uS(-1);

  // HI-6: re-upload a photo that failed at capture time. The failed
  // placeholder still holds the local data: URL, so we can push it to
  // Storage again and swap in the resulting download URL (dropping the
  // uploadFailed flag) without the vendor re-taking the shot.
  const retryUpload = async (idx) => {
    const p = photos[idx];
    if (!p || !p.uploadFailed) return;
    if (!(typeof p.src === 'string' && p.src.startsWith('data:'))) return;
    if (!window.uploadCabinetPhotoToStorage) return;
    setRetryingIdx(idx);
    try {
      const photoId = (p.id && String(p.id)) || ('p_retry_' + Date.now());
      const result = await window.uploadCabinetPhotoToStorage(p.src, cab.id, photoId);
      const nextPhotos = photos.map((ph, i) => i === idx
        ? { ...ph, src: result.src, storagePath: result.storagePath, uploadFailed: false }
        : ph);
      onChange({
        ...cab,
        photos: nextPhotos,
        photo: nextPhotos[0]?.src || null,
        annotations: nextPhotos[0]?.annotations || [],
      });
    } catch (err) {
      if (window.bsAlert) window.bsAlert({ title: 'Still couldn’t upload', body: 'Check your connection and try again — the photo is kept on the cabinet.' });
    } finally {
      setRetryingIdx(-1);
    }
  };

  // Keep activeIdx in valid range when photos change (add/remove).
  uE(() => {
    if (photos.length === 0) { setActiveIdx(-1); return; }
    if (activeIdx >= photos.length) setActiveIdx(photos.length - 1);
    if (activeIdx < 0) setActiveIdx(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photos.length]);

  const append = (src) => {
    if (photos.length >= max) {
      if (window.bsAlert) window.bsAlert({ title: 'Photo cap reached', body: `Up to ${max} photos per cabinet. Remove one before adding another.` });
      return;
    }
    const next = window.appendCabinetPhoto ? window.appendCabinetPhoto(cab, src) : { ...cab, photos: [...photos, { id: 'p_' + Date.now(), src, annotations: [] }], photo: photos[0]?.src || src };
    onChange(next);
    // Select the newly added photo so the user lands on the markup canvas
    // for it — making "add another" feel natural.
    setTimeout(() => setActiveIdx(photos.length), 0);
  };

  // Multi-file upload from the gallery picker. Receives an array of
  // data URLs and threads them through appendCabinetPhotos in one
  // onChange call so cab state isn't stale between appends. Trims
  // anything past the per-cabinet cap (with a friendly alert).
  const appendMany = (srcs) => {
    const remaining = Math.max(0, max - photos.length);
    if (remaining === 0) {
      if (window.bsAlert) window.bsAlert({ title: 'Photo cap reached', body: `Up to ${max} photos per cabinet. Remove one before adding another.` });
      return;
    }
    const accepted = srcs.slice(0, remaining);
    const dropped = srcs.length - accepted.length;
    const next = window.appendCabinetPhotos
      ? window.appendCabinetPhotos(cab, accepted)
      : accepted.reduce((c, src) => window.appendCabinetPhoto ? window.appendCabinetPhoto(c, src) : { ...c, photos: [...(c.photos || []), { id: 'p_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6), src, annotations: [] }] }, cab);
    onChange(next);
    // Land on the first newly-added photo.
    setTimeout(() => setActiveIdx(photos.length), 0);
    if (dropped > 0 && window.bsAlert) {
      window.bsAlert({
        title: `Added ${accepted.length} photo${accepted.length === 1 ? '' : 's'}`,
        body: `Skipped ${dropped} — cap is ${max} photos per cabinet. Remove one to add more.`,
      });
    }
  };

  const removeAt = async (idx) => {
    const ok = await bsConfirmCompat({
      title: 'Remove this photo?',
      body: 'The photo and any annotations on it will be removed from this cabinet.',
      confirmLabel: 'Remove',
      cancelLabel: 'Keep',
      danger: true,
    });
    if (!ok) return;
    const next = window.removeCabinetPhotoAt ? window.removeCabinetPhotoAt(cab, idx) : { ...cab, photos: photos.filter((_, i) => i !== idx) };
    onChange(next);
  };

  const setAnnotationsAt = (idx, ann) => {
    const next = window.updateCabinetPhotoAnnotations ? window.updateCabinetPhotoAnnotations(cab, idx, ann) : { ...cab, photos: photos.map((p, i) => i === idx ? { ...p, annotations: ann } : p) };
    onChange(next);
  };

  // Empty state — capture buttons + "No photos" skip.
  if (photos.length === 0) {
    return (
      <div>
        <div style={{
          padding: '10px 12px', marginBottom: 10,
          background: '#FBF0E1', border: '1px solid var(--accent-soft)',
          borderRadius: 8, fontSize: 12.5, lineHeight: 1.5, color: 'var(--ink-soft)',
        }}>
          <strong style={{ color: 'var(--ink)' }}>Best photos to take:</strong>
          <ol style={{ margin: '4px 0 0 18px', padding: 0 }}>
            <li>Face-on shot of the closed cabinet</li>
            <li>Inside with the door(s) / drawer(s) open</li>
            <li>Close-up of any damage / wear</li>
            <li>Where the cabinet meets adjacent ones (helpful for installers)</li>
          </ol>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <div style={{ flex: '1 1 140px' }}>
            <PhotoCaptureButton kind="camera" onSet={append} cabId={cab.id} />
          </div>
          <div style={{ flex: '1 1 140px' }}>
            <PhotoCaptureButton kind="upload" onSet={append} onSetMany={appendMany} cabId={cab.id} />
          </div>
        </div>
        <div style={{ marginTop: 14, padding: '12px 14px', background: '#FBF0E1', border: '1px dashed var(--accent)', borderRadius: 8, textAlign: 'center' }}>
          <div style={{ fontSize: 12, color: 'var(--ink-soft)', marginBottom: 8 }}>
            No photos to add for this cabinet?
          </div>
          <button
            type="button"
            className="btn"
            style={{
              background: '#fff', color: '#0a2240', border: '2px solid #0a2240',
              fontWeight: 600, padding: '12px 18px', minHeight: 44, width: '100%',
            }}
            onClick={() => {
              // Mark photos as explicitly skipped AND advance to the
              // next sub-step (Doors/Drawers/Shelves). Previously this
              // only flipped the noPhotoChosen flag — the section
              // checked green but the vendor stayed on the same panel,
              // feeling like the button did nothing.
              onChange({ ...cab, photo: null, photos: [], noPhotoChosen: true });
              if (typeof onAdvanceTo === 'function') {
                // Defer one tick so the noPhotoChosen state lands
                // before we open the next section (otherwise the
                // accordion can race and re-open photos).
                setTimeout(() => onAdvanceTo(2), 0);
              }
            }}
            title="Skip photos and continue to doors / drawers / shelves"
          >Skip photos — continue →</button>
        </div>
      </div>
    );
  }

  // Non-empty — gallery thumb strip + active photo's MarkupCanvas + add-more.
  const active = photos[activeIdx] || photos[0];
  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10, alignItems: 'center' }}>
        {photos.map((p, i) => (
          <div key={p.id || i} style={{ position: 'relative' }}>
            <button
              type="button"
              onClick={() => setActiveIdx(i)}
              title={p.uploadFailed ? `Photo ${i + 1} — upload failed` : `Photo ${i + 1} of ${photos.length}`}
              style={{
                width: 64, height: 64, padding: 0, borderRadius: 6,
                border: p.uploadFailed ? '2px solid #b91c1c' : (i === activeIdx ? '2px solid #0a2240' : '2px solid var(--rule)'),
                background: '#fff', cursor: 'pointer', overflow: 'hidden',
              }}
            >
              <img src={p.src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            </button>
            {p.uploadFailed && (
              <>
                {/* HI-6: failed-upload overlay + inline Retry affordance. */}
                <div style={{
                  position: 'absolute', top: 0, left: 0, right: 0, height: 40,
                  borderTopLeftRadius: 6, borderTopRightRadius: 6,
                  background: 'rgba(185,28,28,0.62)', pointerEvents: 'none',
                  display: 'grid', placeItems: 'center',
                }}>
                  <span style={{ color: '#fff', fontSize: 9, fontWeight: 700, letterSpacing: '0.02em', lineHeight: 1.1, textAlign: 'center', padding: '0 2px' }}>
                    Upload failed
                  </span>
                </div>
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); retryUpload(i); }}
                  disabled={retryingIdx === i}
                  title="Retry upload"
                  aria-label={`Retry uploading photo ${i + 1}`}
                  style={{
                    position: 'absolute', bottom: 2, left: 2, right: 2, height: 20,
                    borderRadius: 4, background: '#fff', color: '#b91c1c',
                    border: '1px solid #b91c1c', fontSize: 10, fontWeight: 700,
                    cursor: retryingIdx === i ? 'default' : 'pointer', padding: 0,
                  }}
                >{retryingIdx === i ? '…' : 'Retry'}</button>
              </>
            )}
            <button
              type="button"
              onClick={() => removeAt(i)}
              title="Remove this photo"
              aria-label={`Remove photo ${i + 1}`}
              style={{
                position: 'absolute', top: -6, right: -6,
                width: 22, height: 22, borderRadius: 11,
                background: '#b91c1c', color: '#fff', border: '2px solid #fff',
                fontSize: 12, lineHeight: 1, cursor: 'pointer',
                display: 'grid', placeItems: 'center', padding: 0, zIndex: 1,
              }}
            >×</button>
          </div>
        ))}
        {photos.length < max && (
          <div style={{ display: 'flex', gap: 4 }}>
            <div style={{ width: 64 }}>
              <PhotoCaptureButton kind="camera" onSet={append} compact cabId={cab.id} />
            </div>
            <div style={{ width: 64 }}>
              <PhotoCaptureButton kind="upload" onSet={append} onSetMany={appendMany} compact cabId={cab.id} />
            </div>
          </div>
        )}
      </div>
      <div className="hint" style={{ fontSize: 11, color: 'var(--ink-faint)', marginBottom: 8 }}>
        Photo {activeIdx + 1} of {photos.length} · {photos.length}/{max} added · tap a thumbnail to switch
      </div>
      {active && (
        <MarkupCanvas
          key={active.id || activeIdx}
          photo={active.src}
          annotations={active.annotations || []}
          setAnnotations={(ann) => setAnnotationsAt(activeIdx, ann)}
        />
      )}
    </div>
  );
}

// Multi-select chip row — used for door/drawer repair-position pickers.
function MultiChips({ value = [], options, onChange }) {
  const toggle = (v) => {
    const has = value.includes(v);
    const next = has ? value.filter(x => x !== v) : [...value, v];
    onChange(next);
  };
  return (
    <div className="chips">
      {options.map(o => {
        const v = typeof o === 'string' ? o : o.v;
        const l = typeof o === 'string' ? o : o.l;
        return (
          <button key={v}
                  className={'chip' + (value.includes(v) ? ' on' : '')}
                  onClick={() => toggle(v)}>
            <span className="dot"></span>{l}
          </button>
        );
      })}
    </div>
  );
}

// Build door-position option list: 1-door → none; 2-door → L/R; 3+ doors
// → L / 2 / … / R with center positions numbered.
function doorPositionOptions(count) {
  if (count <= 1) return [];
  if (count === 2) return [{ v: 'L', l: 'Left' }, { v: 'R', l: 'Right' }];
  if (count === 3) return [{ v: 'L', l: 'Left' }, { v: 'C', l: 'Center' }, { v: 'R', l: 'Right' }];
  // 4+ doors — number them 1..N, left to right.
  return Array.from({ length: count }, (_, i) => ({
    v: String(i + 1),
    l: i === 0 ? '1 (L)' : i === count - 1 ? `${count} (R)` : String(i + 1),
  }));
}

// Build drawer-position option list: 1-drawer → none; 2 → Top/Bottom; 3+ → numbered top→bottom.
function drawerPositionOptions(count) {
  if (count <= 1) return [];
  if (count === 2) return [{ v: 1, l: 'Top' }, { v: 2, l: 'Bottom' }];
  return Array.from({ length: count }, (_, i) => ({
    v: i + 1,
    l: i === 0 ? '1 (top)' : i === count - 1 ? `${count} (bottom)` : String(i + 1),
  }));
}

// Build shelf-position option list: 1-shelf → none; 2 → Top/Bottom; 3+ → numbered top→bottom.
function shelfPositionOptions(count) {
  if (count <= 1) return [];
  if (count === 2) return [{ v: 1, l: 'Top' }, { v: 2, l: 'Bottom' }];
  return Array.from({ length: count }, (_, i) => ({
    v: i + 1,
    l: i === 0 ? '1 (top)' : i === count - 1 ? `${count} (bottom)` : String(i + 1),
  }));
}

function DoorsBlock({ cab, onChange }) {
  const doors = parseInt(cab.doors) || 0;
  const positionOpts = doorPositionOptions(doors);
  return (
    <div className="wiz-block">
      <div className="wiz-block-head">
        <div>
          <div className="wiz-block-title">{L('cabinet.doors.title')}</div>
          <div className="wiz-block-sub">{L('cabinet.doors.sub')}</div>
        </div>
        <NumberStepper value={cab.doors || 0} onChange={(v) => onChange({ doors: v })} />
      </div>
      <label className="wiz-checkbox">
        <input type="checkbox" checked={cab.doorsRepair === true}
               onChange={e => onChange({ doorsRepair: e.target.checked, ...(e.target.checked ? {} : { doorRepairPositions: [] }) })} />
        <span>{L('cabinet.doors.checkbox.repair')}</span>
      </label>
      {cab.doorsRepair && positionOpts.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <div className="wiz-block-sub" style={{ marginBottom: 4 }}>{L('cabinet.doors.whichRepair')}</div>
          <MultiChips value={cab.doorRepairPositions || []}
                      options={positionOpts}
                      onChange={(arr) => onChange({ doorRepairPositions: arr })} />
          <div style={{ marginTop: 10 }}>
            <div className="wiz-block-sub" style={{ marginBottom: 4 }}>What's wrong? <span style={{ color: 'var(--ink-faint)', fontWeight: 'normal' }}>(optional)</span></div>
            <textarea className="textarea" rows={2}
                      placeholder="e.g. front cracked, hinge mortise blown out, finish chipped along bottom edge"
                      value={cab.doorsRepairNotes || ''}
                      onChange={e => onChange({ doorsRepairNotes: e.target.value })} />
          </div>
        </div>
      )}
      {doors > 0 && (
        <div style={{ marginTop: 8 }}>
          <div className="wiz-block-sub" style={{ marginBottom: 4 }}>{L('cabinet.doors.hingeConfig')}</div>
          {doors === 1 ? (
            <Segmented value={cab.hingeConfig || 'left'}
                       options={[{ v: 'left', l: 'Hinged Left' }, { v: 'right', l: 'Hinged Right' }]}
                       onChange={v => onChange({ hingeConfig: v })} />
          ) : (
            <>
              <Segmented
                value={cab.hingeConfig || 'meeting'}
                options={doors === 2
                  ? [
                      { v: 'meeting', l: 'Double / outer hinges' },
                      { v: 'sameway', l: 'Both same direction' },
                      { v: 'custom',  l: 'Custom per door' },
                    ]
                  : [
                      { v: 'meeting', l: 'Double / outer hinges' },
                      { v: 'custom',  l: 'Custom per door' },
                    ]
                }
                onChange={v => onChange({
                  hingeConfig: v,
                  hinges: v === 'custom' ? Array.from({ length: doors }, (_, i) => (cab.hinges?.[i] || 'L')) : [],
                })}
              />
              {cab.hingeConfig === 'custom' && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                  {Array.from({ length: doors }).map((_, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12 }}>
                      <span>Door {i + 1}</span>
                      <Segmented value={cab.hinges?.[i] || 'L'}
                                 options={[{ v: 'L', l: 'L' }, { v: 'R', l: 'R' }]}
                                 onChange={v => {
                                   const next = [...(cab.hinges || [])];
                                   next[i] = v;
                                   onChange({ hinges: next });
                                 }} />
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

function DrawersBlock({ cab, onChange }) {
  const drawers = parseInt(cab.drawers) || 0;
  const positionOpts = drawerPositionOptions(drawers);
  return (
    <div className="wiz-block">
      <div className="wiz-block-head">
        <div>
          <div className="wiz-block-title">{L('cabinet.drawers.title')}</div>
          <div className="wiz-block-sub">{L('cabinet.drawers.sub')}</div>
        </div>
        <NumberStepper value={cab.drawers || 0} onChange={(v) => onChange({ drawers: v })} />
      </div>
      <label className="wiz-checkbox">
        <input type="checkbox" checked={cab.drawersRepair === true}
               onChange={e => onChange({ drawersRepair: e.target.checked, ...(e.target.checked ? {} : { drawerRepairPositions: [] }) })} />
        <span>{L('cabinet.drawers.checkbox.repair')}</span>
      </label>
      {cab.drawersRepair && positionOpts.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <div className="wiz-block-sub" style={{ marginBottom: 4 }}>{L('cabinet.drawers.whichRepair')}</div>
          <div className="hint" style={{ fontSize: 11, color: 'var(--ink-faint)', marginBottom: 6 }}>
            {L('cabinet.drawers.whichRepairHint')}
          </div>
          <MultiChips value={cab.drawerRepairPositions || []}
                      options={positionOpts}
                      onChange={(arr) => onChange({ drawerRepairPositions: arr })} />
          <div style={{ marginTop: 10 }}>
            <div className="wiz-block-sub" style={{ marginBottom: 4 }}>What's wrong? <span style={{ color: 'var(--ink-faint)', fontWeight: 'normal' }}>(optional)</span></div>
            <textarea className="textarea" rows={2}
                      placeholder="e.g. drawer front gouged, box bottom delaminated, slide broken on #2"
                      value={cab.drawersRepairNotes || ''}
                      onChange={e => onChange({ drawersRepairNotes: e.target.value })} />
          </div>
        </div>
      )}
      {/* 6-2: drawer layout picker dropped entirely. Cabinet builder
          figures out layout from the face frame on receipt — vendor PM
          shouldn't have to know cabinet conventions. */}
    </div>
  );
}

function ShelvesBlock({ cab, onChange, cabinetTypeCfg }) {
  const shelves = parseInt(cab.shelves) || 0;
  const shelfPosOpts = shelfPositionOptions(shelves);
  const newCount = parseInt(cab.newShelfCount) || 0;
  // 6-2: roll-out shelves controlled per cabinet-type via the
  // wizardConfig.cabinetTypes[].showRollouts flag.
  const showRollouts = cabinetTypeCfg
    ? cabinetTypeCfg.showRollouts === true
    : (cab.cabType === 'Base' || cab.cabType === 'Sink base' || cab.cabType === 'Full height');
  // Roll-out shelves now split into THREE quantities so the cost
  // builder can price each independently:
  //   rolloutInstallCount  — install existing roll-outs (hardware supplied)
  //   rolloutRebuildCount  — build new roll-outs from scratch
  //   rolloutRepairCount   — repair an existing roll-out
  const rolloutInstall = parseInt(cab.rolloutInstallCount) || 0;
  const rolloutRebuild = parseInt(cab.rolloutRebuildCount) || 0;
  const rolloutRepair = parseInt(cab.rolloutRepairCount) || 0;
  // Legacy `rolloutCount` from older drafts is migrated lazily — treat
  // any positive legacy count as Rebuild so existing pricing doesn't
  // regress. The Cost Builder reorg adds first-class line items for
  // install / repair so new drafts populate the new fields.
  const legacyRollout = parseInt(cab.rolloutCount) || 0;
  return (
    <div className="wiz-block">
      <div className="wiz-block-head">
        <div>
          <div className="wiz-block-title">{L('cabinet.shelves.title')}</div>
          <div className="wiz-block-sub">{L('cabinet.shelves.sub')}</div>
        </div>
        <NumberStepper value={cab.shelves || 0} onChange={(v) => onChange({ shelves: v, ...(parseInt(v) < shelves ? { shelfRepairPositions: [] } : {}) })} />
      </div>
      <label className="wiz-checkbox">
        <input type="checkbox" checked={cab.shelvesRepair === true}
               onChange={e => onChange({ shelvesRepair: e.target.checked, ...(e.target.checked ? {} : { shelfRepairPositions: [] }) })} />
        <span>{L('cabinet.shelves.checkbox.repair')}</span>
      </label>
      {cab.shelvesRepair && shelfPosOpts.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <div className="wiz-block-sub" style={{ marginBottom: 4 }}>{L('cabinet.shelves.whichRepair')}</div>
          <div className="hint" style={{ fontSize: 11, color: 'var(--ink-faint)', marginBottom: 6 }}>
            {L('cabinet.shelves.whichRepairHint')}
          </div>
          <MultiChips value={cab.shelfRepairPositions || []}
                      options={shelfPosOpts}
                      onChange={(arr) => onChange({ shelfRepairPositions: arr })} />
          <div style={{ marginTop: 10 }}>
            <div className="wiz-block-sub" style={{ marginBottom: 4 }}>What's wrong? <span style={{ color: 'var(--ink-faint)', fontWeight: 'normal' }}>(optional)</span></div>
            <textarea className="textarea" rows={2}
                      placeholder="e.g. sagging, edge chipped, finish ruined by water"
                      value={cab.shelvesRepairNotes || ''}
                      onChange={e => onChange({ shelvesRepairNotes: e.target.value })} />
          </div>
        </div>
      )}
      <label className="wiz-checkbox" style={{ marginTop: 4 }}>
        <input type="checkbox" checked={cab.newShelfNeeded === true}
               onChange={e => onChange({
                 newShelfNeeded: e.target.checked,
                 newShelfCount: e.target.checked ? (newCount || 1) : 0,
               })} />
        <span>{L('cabinet.shelves.checkbox.new')}</span>
      </label>
      {cab.newShelfNeeded && (
        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 12 }}>{L('cabinet.shelves.howManyNew')}</span>
          <NumberStepper value={newCount} onChange={(v) => onChange({ newShelfCount: Math.max(1, v) })} />
        </div>
      )}
      {shelves === 0 && !cab.newShelfNeeded && (
        <div className="hint" style={{ fontSize: 11, marginTop: 6, color: 'var(--ink-faint)' }}>
          {L('cabinet.shelves.zeroHint')}
        </div>
      )}
      {showRollouts && (
        <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid var(--rule)' }}>
          <div className="wiz-block-sub" style={{ marginBottom: 6 }}>
            {L('cabinet.shelves.rollouts.title')}
            <span style={{ fontWeight: 'normal', color: 'var(--ink-faint)', marginLeft: 6, fontSize: 11 }}>
              {L('cabinet.shelves.rollouts.sub')}
            </span>
          </div>
          {legacyRollout > 0 && rolloutInstall === 0 && rolloutRebuild === 0 && rolloutRepair === 0 && (
            <div className="hint" style={{ fontSize: 11, marginBottom: 8, color: '#C9781B' }}>
              Legacy "Roll-outs: {legacyRollout}" from an older draft. Move the count into Install / Rebuild / Repair below so the new pricing applies.
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 6 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'space-between' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 500 }}>Install only</div>
                <div style={{ fontSize: 11, color: 'var(--ink-faint)' }}>Existing roll-outs, hardware supplied — we mount them.</div>
              </div>
              <NumberStepper value={rolloutInstall} onChange={(v) => onChange({ rolloutInstallCount: Math.max(0, v) })} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'space-between' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 500 }}>Rebuild / new</div>
                <div style={{ fontSize: 11, color: 'var(--ink-faint)' }}>Brand-new roll-outs we fabricate and install.</div>
              </div>
              <NumberStepper value={rolloutRebuild} onChange={(v) => onChange({ rolloutRebuildCount: Math.max(0, v) })} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'space-between' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 500 }}>Repair</div>
                <div style={{ fontSize: 11, color: 'var(--ink-faint)' }}>Existing roll-out that needs repair (glides, sides, bottom).</div>
              </div>
              <NumberStepper value={rolloutRepair} onChange={(v) => onChange({ rolloutRepairCount: Math.max(0, v) })} />
            </div>
            {rolloutRepair > 0 && (
              <div style={{ marginTop: 4 }}>
                <div className="wiz-block-sub" style={{ marginBottom: 4 }}>What's wrong with the roll-out(s)? <span style={{ color: 'var(--ink-faint)', fontWeight: 'normal' }}>(optional)</span></div>
                <textarea className="textarea" rows={2}
                          placeholder="e.g. glides bent, bottom split, side panel cracked"
                          value={cab.rolloutsRepairNotes || ''}
                          onChange={e => onChange({ rolloutsRepairNotes: e.target.value })} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// Cabinet types drive the dimension defaults. Per 6-2: added Full height
// + Appliance garage. Vanity now uses the plain W/H/D pickers (preset grid
// dropped) with depth=21" default but NO height default — restoration sees
// both 30" old-style and 34.5" new kitchen-height vanities.
const CABINET_TYPES = ['Base', 'Sink base', 'Wall', 'Vanity', 'Island', 'Peninsula', 'Full height', 'Appliance garage'];

// Defaults applied when a cabinet type is picked. Empty string = vendor
// must pick.
const TYPE_DEFAULTS = {
  Base:               { h: '34.5', d: '24', typeCode: 'B'   },
  'Sink base':        { h: '34.5', d: '24', typeCode: 'SB'  },
  Wall:               { h: '30',   d: '12', typeCode: 'W'   },
  Vanity:             { h: '',     d: '21', typeCode: 'V'   },
  Island:             { h: '34.5', d: '',   typeCode: 'I'   },
  Peninsula:          { h: '34.5', d: '',   typeCode: 'P'   },
  'Full height':      { h: '',     d: '24', typeCode: 'FH'  },
  'Appliance garage': { h: '',     d: '',   typeCode: 'AG'  },
};

function SubSize({ cab, onChange, cabinetTypes }) {
  const types = cabinetTypes && cabinetTypes.length > 0
    ? cabinetTypes
    : deriveCabinetTypes(null);   // fallback if not passed

  const pickType = (typeCfg) => {
    // Switching cabinet type now OVERWRITES height + depth with the
    // new type's defaults (Wall: 30×12, Base: 34.5×24, Vanity: depth
    // 21, etc.). Previously the code did `cab.h || typeCfg.defaultHeight`
    // which preserved the prior type's defaults — a vendor who picked
    // Base by mistake and switched to Wall got 34.5"H instead of 30"H.
    // Trade-off: a vendor who typed a custom dim then switched type
    // loses the custom value. That's a much rarer flow than "I picked
    // the wrong type, let me switch."
    onChange({
      cabType: typeCfg.label,
      typeCode: typeCfg.typeCode || cab.typeCode || '',
      h: typeCfg.defaultHeight || '',
      d: typeCfg.defaultDepth || '',
      hu: cab.hu || 'in',
      du: cab.du || 'in',
    });
  };

  // 6-2: Vanity preset grid dropped — vanity uses the same W/H/D pickers
  // as everything else. Default depth 21" only.
  const showSizePickers = !!cab.cabType;

  const roomOptions = ['Kitchen', 'Master bath', 'Hall bath', 'Powder room', 'Laundry', 'Office', 'Other'];

  return (
    <>
      <Field
        label="Where is this cabinet?"
        hint="Helps the shop track where each piece came from + tells installers where it goes back. Especially important when face frames arrive as a disassembled pile."
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
          {roomOptions.map(r => (
            <button
              key={r}
              type="button"
              className={'wiz-bigchip' + (cab.locationRoom === r ? ' on' : '')}
              style={{ padding: '8px 12px', fontSize: 13, minHeight: 'auto', flex: '0 0 auto', lineHeight: 1.2 }}
              onClick={() => onChange({ locationRoom: r })}
            >{r}</button>
          ))}
        </div>
        <input
          className="input"
          value={cab.locationDetail || ''}
          placeholder='Where in the room? e.g. "north wall, 2nd from sink"'
          onChange={e => onChange({ locationDetail: e.target.value })}
        />
      </Field>

      <Field label={L('cabinet.field.type')} required>
        <div className="wiz-bigchips" style={{
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
          gap: 8,
        }}>
          {types.map(t => (
            <button key={t.id || t.label}
                    className={'wiz-bigchip' + (cab.cabType === t.label ? ' on' : '')}
                    onClick={() => pickType(t)}>
              <div className="wiz-bigchip-l">{t.label}</div>
              {t.chipHint && (
                <div className="wiz-bigchip-d" style={{ fontSize: 11 }}>{t.chipHint}</div>
              )}
            </button>
          ))}
        </div>
      </Field>

      {showSizePickers && (
        <div className="v-fields">
          <DimField label={L('cabinet.field.width')}  value={cab.w} unit={cab.wu} onValue={v => onChange({ w: v })} onUnit={u => onChange({ wu: u })} />
          <DimField label={L('cabinet.field.height')} value={cab.h} unit={cab.hu} onValue={v => onChange({ h: v })} onUnit={u => onChange({ hu: u })} />
          <DimField label={L('cabinet.field.depth')}  value={cab.d} unit={cab.du} onValue={v => onChange({ d: v })} onUnit={u => onChange({ du: u })} />
        </div>
      )}

      {/* Cabinet preview SVG removed 2026-06-22 — vendors didn't find it
          useful and it took up screen real estate; the real shape comes
          across via photos + dimensions. */}
    </>
  );
}

// Keys for cabinet sub-wizard step titles — resolved at render time
// via L() so admin edits take effect immediately.
const SUB_TITLE_KEYS = [
  'cabinets.sub.size',
  'cabinets.sub.photos',
  'cabinets.sub.parts',         // now includes Hardware (folded in 2026-06-22)
  'cabinets.sub.finished',
  'cabinets.sub.material',
  'cabinets.sub.underCounter',
  'cabinets.sub.notes',
];

// Derive the available box-material + thickness lists from live pricing.
// Falls back to the hardcoded BOX_MATERIALS + standard thicknesses when
// pricing hasn't pushed any variant rows yet. Keeps the wizard usable
// during initial setup and respects whatever admin has added in the
// cost builder afterwards.
function deriveSpeciesList(pricing) {
  const rt = Array.isArray(pricing?.repairTypes) ? pricing.repairTypes : [];
  const set = new Set();
  for (const r of rt) {
    if (r.variantSpecies) set.add(r.variantSpecies);
  }
  if (set.size === 0) return [...BOX_MATERIALS];
  // Preserve the original BOX_MATERIALS ordering where possible, then append
  // any extras admin has added at the end.
  const ordered = BOX_MATERIALS.filter(s => set.has(s));
  for (const s of set) if (!ordered.includes(s)) ordered.push(s);
  return ordered;
}

function deriveThicknessList(pricing) {
  const rt = Array.isArray(pricing?.repairTypes) ? pricing.repairTypes : [];
  const set = new Set();
  for (const r of rt) {
    if (r.variantThickness) set.add(r.variantThickness);
  }
  if (set.size === 0) return ['1/2"', '5/8"', '3/4"', 'Unknown'];
  const seed = ['1/2"', '5/8"', '3/4"', 'Unknown'];
  const ordered = seed.filter(t => set.has(t));
  for (const t of set) if (!ordered.includes(t)) ordered.push(t);
  return ordered;
}

// ---- Wizard config derivers ----
// Pull admin-managed wizard schema (cabinet types, property types, service
// options, addons) out of the pricing doc. Falls back to the hardcoded
// constants when admin hasn't pushed a config yet so a brand-new install
// still works.

function deriveCabinetTypes(pricing) {
  const cts = pricing?.wizardConfig?.cabinetTypes;
  if (!Array.isArray(cts) || cts.length === 0) {
    // Fallback: synthesize from hardcoded constants.
    return CABINET_TYPES.map(label => ({
      id: label, label,
      defaultHeight: TYPE_DEFAULTS[label]?.h || '',
      defaultDepth: TYPE_DEFAULTS[label]?.d || '',
      typeCode: TYPE_DEFAULTS[label]?.typeCode || '',
      chipHint: '',
      showRollouts: label === 'Base' || label === 'Sink base' || label === 'Full height',
      showBackFinished: label === 'Island' || label === 'Peninsula',
      contributesToToeKick: label === 'Base' || label === 'Sink base' || label === 'Island' || label === 'Peninsula' || label === 'Full height',
      isFullHeightForScribe: label === 'Full height',
      active: true,
    }));
  }
  return cts.filter(c => c && c.active !== false);
}

function derivePropertyTypes(pricing) {
  const pts = pricing?.wizardConfig?.propertyTypes;
  if (!Array.isArray(pts) || pts.length === 0) {
    return [
      { id: 'single-fam',  label: 'Residential' },
      { id: 'condo',       label: 'Condo' },
      { id: 'rental',      label: 'Rental' },
      { id: 'commercial',  label: 'Commercial' },
    ];
  }
  return pts.filter(p => p && p.active !== false);
}

function deriveServiceOptions(pricing) {
  const sos = pricing?.wizardConfig?.serviceOptions;
  if (!Array.isArray(sos) || sos.length === 0) {
    return [
      { id: 'pickup',  label: 'Pickup',       sublabel: 'We pick up the cabinets — flat fee, within 25 mi.',     pricingKey: 'pickup_flat',         pricingMode: 'flat' },
      { id: 'dropoff', label: 'Drop-off',     sublabel: 'We deliver to the jobsite — flat fee, within 25 mi.',   pricingKey: 'dropoff_flat',        pricingMode: 'flat' },
      { id: 'install', label: 'Installation', sublabel: 'We install at the jobsite — per-cabinet rate.',         pricingKey: 'install_per_cabinet', pricingMode: 'per-cabinet' },
    ];
  }
  return sos.filter(s => s && s.active !== false);
}

function deriveAddonTypes(pricing) {
  const adds = pricing?.wizardConfig?.addons;
  if (!Array.isArray(adds) || adds.length === 0) {
    // Bootstrap fallback — mirrors buildStarterWizardConfig() so the
    // wizard works before admin has saved a wizard config draft.
    return [
      { id: 'fridge-panel', label: 'Refrigerator end panel', emoji: '🧊', pricingOperation: 'fridge-end-panel', inputs: [
        { key: 'count',  label: 'Count',        kind: 'count',     defaultValue: 1 },
        { key: 'height', label: 'Height (in)',  kind: 'segmented', options: ['84', '90', '96', 'custom'], defaultValue: '96' },
        { key: 'depth',  label: 'Depth (in)',   kind: 'segmented', options: ['24', '30', '32', '36', 'custom'], defaultValue: '24' },
        { key: 'side',   label: 'Side',         kind: 'segmented', options: ['L', 'R', 'Both'], defaultValue: 'L' },
      ]},
      { id: 'dishwasher-panel', label: 'Dishwasher end panel', emoji: '🍽️', pricingOperation: 'dishwasher-end-panel', inputs: [
        { key: 'count',  label: 'Count',       kind: 'count',     defaultValue: 1 },
        { key: 'height', label: 'Height (in)', kind: 'segmented', options: ['30', '30.5', '31', 'custom'], defaultValue: '30' },
        { key: 'side',   label: 'Side',        kind: 'segmented', options: ['L', 'R', 'Both'], defaultValue: 'L' },
      ]},
      { id: 'filler', label: 'Filler', emoji: '🧱', pricingOperation: 'filler-base-3', inputs: [
        { key: 'profile', label: 'Profile',    kind: 'segmented', options: ['base', 'fullheight'], defaultValue: 'base' },
        { key: 'width',   label: 'Width (in)', kind: 'segmented', options: ['3', '6'], defaultValue: '3' },
        { key: 'count',   label: 'Count',      kind: 'count',     defaultValue: 1 },
      ]},
      { id: 'corner-mold', label: 'Outside corner mold', emoji: '📐', pricingOperation: 'corner-mold-3434', inputs: [
        { key: 'size',   label: 'Size',         kind: 'segmented', options: ['3/4x3/4', '3/4x1', '3/4x1.25'], defaultValue: '3/4x3/4' },
        { key: 'sticks', label: '8-ft sticks',  kind: 'count',     defaultValue: 1 },
      ]},
      { id: 'quarter-round', label: 'Quarter round', emoji: '⌒', pricingOperation: 'quarter-round', inputs: [
        { key: 'sticks', label: '8-ft sticks', kind: 'count', defaultValue: 1 },
      ]},
      { id: 'other', label: 'Other (free-text)', emoji: '➕', pricingOperation: 'addon-other', inputs: [
        { key: 'description', label: 'Description', kind: 'text',  defaultValue: '' },
        { key: 'qty',         label: 'Quantity',    kind: 'count', defaultValue: 1 },
      ]},
    ];
  }
  return adds.filter(a => a && a.active !== false);
}

// Per-sub-step "is this section complete?" predicate. Used both by the
// paginated desktop wizard (gates Next) and the mobile accordion
// (auto-opens the next section + drives the green check).
function subStepComplete(subIdx, cab) {
  switch (subIdx) {
    case 0: {
      // size — require not just truthy values but reasonable dimensions
      // (≥ 2 chars OR has a decimal point) so a single mid-type digit
      // doesn't trip the auto-advance and scroll the user off the field.
      // Minimum sensible cabinet width is 6", which is 1 char — but
      // virtually no real cabinet is < 10" wide for kitchens, and the
      // first digit of any 2-digit number alone shouldn't count.
      if (!cab.cabType) return false;
      const ok = (v) => {
        if (v == null || v === '') return false;
        const s = String(v).trim();
        return s.length >= 2 || s.includes('.');
      };
      return ok(cab.w) && ok(cab.h) && ok(cab.d);
    }
    case 1: {
      // photos — multi-photo array OR legacy single photo OR explicit skip.
      if (cab.noPhotoChosen === true) return true;
      if (Array.isArray(cab.photos) && cab.photos.length > 0) return true;
      return !!cab.photo;
    }
    case 2: {                                                   // parts + hardware
      // Parts itself has no strictly required input — counts as touched
      // once any field has a non-default value. BUT hardware was folded
      // in (2026-06-22), so if the cabinet has any doors or drawers we
      // also require the hardware questions to be answered. Soft-close
      // is only asked when Precision is supplying the hardware
      // (sourcedByVendor === false), so it's only required in that case.
      const partsTouched = cab.doors != null || cab.drawers != null || cab.shelves != null;
      if (!partsTouched) return false;
      const d = parseInt(cab.doors) || 0;
      const r = parseInt(cab.drawers) || 0;
      if (d === 0 && r === 0) return true;                      // no doors/drawers → hardware n/a
      const hw = cab.hardware || {};
      if (hw.sourcedByVendor == null) return false;             // hardware-source not answered
      if (hw.sourcedByVendor === true) return true;             // vendor supplies → softClose moot
      return hw.softClose != null;                              // Precision supplies → require softClose pick
    }
    case 3: return cab.finishedSide != null;                    // finished sides
    case 4: return !!cab.boxMaterial;                           // material (required)
    case 5: return cab.installUnderExisting != null;            // under-counter (was 6)
    case 6: return true;                                        // notes — always (was 7)
    default: return false;
  }
}

// Render a single sub-step's body. Shared between desktop pagination and
// the mobile accordion so we have one place to evolve sub-step content.
function CabinetSubBody({ subIdx, cab, update, currentTypeCfg, cabinetTypes, availableSpecies, availableThicknesses, onAdvanceTo }) {
  if (subIdx === 0) return <SubSize cab={cab} onChange={update} cabinetTypes={cabinetTypes} />;
  if (subIdx === 1) return (
    <Field label={L('cabinets.sub.photos')} hint={L('cabinet.hint.photos')}>
      <PhotosBlock cab={cab} onChange={update} onAdvanceTo={onAdvanceTo} />
    </Field>
  );
  if (subIdx === 2) return <DDSSubStep cab={cab} update={update} currentTypeCfg={currentTypeCfg} />;
  if (subIdx === 3) return <FinishedSidesSub cab={cab} update={update} currentTypeCfg={currentTypeCfg} />;
  if (subIdx === 4) return (
    <>
      <Field label={L('cabinet.field.boxMaterial')} required>
        {/* pulse-attn lives on a WRAPPER, not the <select> itself —
            iOS PWA standalone mode otherwise blocks the native picker's
            tap-commit when the focused select has an animated outset
            box-shadow. The shadow on the wrapper renders behind the
            select with no input interference. */}
        <div className={!cab.boxMaterial ? 'pulse-attn' : ''} style={{ borderRadius: 'var(--r-md)' }}>
          <select
            className="select"
            value={cab.boxMaterial || ''}
            onChange={e => update({ boxMaterial: e.target.value })}
          >
            <option value="">Select…</option>
            {availableSpecies.map(m => (
              <option key={m} value={m}>
                {m === 'Hardrock Maple' ? `${m} — Most common` : m}
              </option>
            ))}
          </select>
        </div>
      </Field>
      <Field label={L('cabinet.field.thickness')}
             hint={cab.boxThickness === 'Unknown'
               ? L('cabinet.hint.thicknessUnknown')
               : L('cabinet.hint.thicknessDefault')}>
        <Segmented value={cab.boxThickness || '1/2"'}
                   options={availableThicknesses}
                   onChange={v => update({ boxThickness: v })} />
      </Field>
      <Field label="Finish"
             hint="Repair pricing can differ by finish (e.g. Stained Oak ≠ Painted Maple). Pick the closest match — Unknown is fine if you can't tell.">
        <Segmented value={cab.boxFinish || ''}
                   options={['Natural', 'Stained', 'Painted', 'Unfinished', 'Unknown']}
                   onChange={v => update({ boxFinish: v })} />
      </Field>
    </>
  );
  // Hardware was its own sub-step (5) until 2026-06-22. It's now part
  // of the parts sub-step (2) above. The old index 6/7 cases shift up.
  if (subIdx === 5) return <UnderCounterSub cab={cab} update={update} />;
  if (subIdx === 6) return (
    <Field label={L('cabinet.field.notes')}>
      <textarea className="textarea" value={cab.notes || ''}
                placeholder={L('cabinet.placeholder.notes')}
                onChange={e => update({ notes: e.target.value })} />
    </Field>
  );
  return null;
}

// ============================================================
// DDS sub-step (2026-06-22 design refresh) — Doors / Drawers /
// Shelves + Hardware. TWO input layouts the vendor can toggle:
//   • Compact (Mode A) — every sub-section visible at once;
//     stepper + repair checkbox + reveals on each card.
//     Power-user feel, fast scan-and-input.
//   • Guided (Mode B) — collapsible tiles, summary chip on the
//     right; one tile expands at a time. Methodical, mobile-
//     friendly.
// Preference persists per device in localStorage.
// ============================================================
function DDSSubStep({ cab, update, currentTypeCfg }) {
  const [layout, setLayout] = uS(() => {
    try {
      const v = localStorage.getItem('pc.ddsLayout.v1');
      return v === 'compact' || v === 'guided' ? v : 'compact';
    } catch { return 'compact'; }
  });
  const setLayoutPersist = (mode) => {
    setLayout(mode);
    try { localStorage.setItem('pc.ddsLayout.v1', mode); } catch {}
  };
  return (
    <>
      <div className="dds-help">
        <span className="dds-help-icon">›</span>
        <span className="dds-help-text">
          Count what this cabinet has. Tick <strong>"needs repair"</strong> only for parts Precision will fix — those are charged{' '}
          <strong>per door / per drawer / per shelf</strong>. Leave a count at 0 if it doesn't apply.
        </span>
      </div>

      <div className="dds-mode-toggle" role="tablist" aria-label="Layout style">
        <button
          type="button"
          role="tab"
          aria-selected={layout === 'compact'}
          className={layout === 'compact' ? 'on' : ''}
          onClick={() => setLayoutPersist('compact')}
        >Compact view</button>
        <button
          type="button"
          role="tab"
          aria-selected={layout === 'guided'}
          className={layout === 'guided' ? 'on' : ''}
          onClick={() => setLayoutPersist('guided')}
        >Guided</button>
      </div>

      {layout === 'compact'
        ? <DDSCompact cab={cab} update={update} currentTypeCfg={currentTypeCfg} />
        : <DDSGuided cab={cab} update={update} currentTypeCfg={currentTypeCfg} />}
    </>
  );
}

// ---------- Shared atoms ----------

function DDSStepper({ value, onChange, min = 0, max = 99, sm }) {
  const v = parseInt(value) || 0;
  const dec = () => onChange(Math.max(min, v - 1));
  const inc = () => onChange(Math.min(max, v + 1));
  return (
    <div className={'dds-stepper' + (sm ? ' dds-stepper-sm' : '')}>
      <button type="button" onClick={dec} disabled={v <= min} aria-label="Decrease">−</button>
      <div className="dds-stepper-count">{v}</div>
      <button type="button" onClick={inc} disabled={v >= max} aria-label="Increase">+</button>
    </div>
  );
}

function DDSRepairCheck({ checked, onToggle, label, rate, boxed }) {
  return (
    <button
      type="button"
      className={'dds-repair-row' + (boxed ? ' boxed' : '')}
      onClick={() => onToggle(!checked)}
    >
      <span className={'dds-repair-box' + (checked ? ' on' : '')} aria-hidden="true" />
      <span className="dds-repair-label">
        {label}
        {rate ? <> <span className="dds-repair-rate">· {rate}</span></> : null}
      </span>
    </button>
  );
}

function DDSNotesField({ value, placeholder, onChange }) {
  return (
    <div style={{ marginTop: 10 }}>
      <div className="dds-mono-label">What's wrong? <span style={{ color: 'var(--ink-faint)', textTransform: 'none', letterSpacing: 0, fontWeight: 500 }}>(optional)</span></div>
      <textarea
        className="textarea"
        rows={2}
        placeholder={placeholder}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
}

// ---------- Doors / Drawers / Shelves sub-cards ----------
//
// These render the same data as the legacy DoorsBlock/DrawersBlock/
// ShelvesBlock + HardwareBlock — but with the design refresh styling.
// Used by both DDSCompact (visible at once) and DDSGuided (inside a
// tile body). They are layout-agnostic.

function DoorsContent({ cab, update }) {
  const doors = parseInt(cab.doors) || 0;
  const positionOpts = doorPositionOptions(doors);
  return (
    <>
      <div className="dds-row">
        <div className="dds-row-text">
          <div className="dds-card-title">How many doors?</div>
          <div className="dds-card-sub">Count what this cabinet has, not what's broken.</div>
        </div>
        <DDSStepper value={cab.doors || 0} onChange={(v) => update({ doors: v })} />
      </div>
      <DDSRepairCheck
        checked={cab.doorsRepair === true}
        onToggle={(v) => update({ doorsRepair: v, ...(v ? {} : { doorRepairPositions: [] }) })}
        label="Doors need repair"
        rate="charged per door"
      />
      {cab.doorsRepair && positionOpts.length > 0 && (
        <div className="dds-card-divider">
          <div className="dds-mono-label">Which door(s)?</div>
          <div className="dds-chip-row" style={{ marginBottom: 10 }}>
            {positionOpts.map(opt => {
              const on = (cab.doorRepairPositions || []).includes(opt.v);
              return (
                <button
                  key={opt.v}
                  type="button"
                  className={'dds-chip' + (on ? ' on' : '')}
                  onClick={() => {
                    const cur = cab.doorRepairPositions || [];
                    const next = on ? cur.filter(p => p !== opt.v) : [...cur, opt.v];
                    update({ doorRepairPositions: next });
                  }}
                >{opt.l}</button>
              );
            })}
          </div>
          {doors > 1 && (
            <>
              <div className="dds-mono-label">Hinge configuration</div>
              <div className="dds-chip-row" style={{ marginBottom: 10 }}>
                {(doors === 2
                  ? [{ v: 'meeting', l: 'Double / outer' }, { v: 'sameway', l: 'Both same' }, { v: 'custom', l: 'Custom per door' }]
                  : [{ v: 'meeting', l: 'Double / outer' }, { v: 'custom', l: 'Custom per door' }]
                ).map(o => (
                  <button
                    key={o.v}
                    type="button"
                    className={'dds-chip' + ((cab.hingeConfig || 'meeting') === o.v ? ' on' : '')}
                    onClick={() => update({
                      hingeConfig: o.v,
                      hinges: o.v === 'custom' ? Array.from({ length: doors }, (_, i) => (cab.hinges?.[i] || 'L')) : [],
                    })}
                  >{o.l}</button>
                ))}
              </div>
            </>
          )}
          {doors === 1 && (
            <>
              <div className="dds-mono-label">Hinge side</div>
              <div className="dds-chip-row" style={{ marginBottom: 10 }}>
                {[{ v: 'left', l: 'Hinged Left' }, { v: 'right', l: 'Hinged Right' }].map(o => (
                  <button
                    key={o.v}
                    type="button"
                    className={'dds-chip' + ((cab.hingeConfig || 'left') === o.v ? ' on' : '')}
                    onClick={() => update({ hingeConfig: o.v })}
                  >{o.l}</button>
                ))}
              </div>
            </>
          )}
          <DDSNotesField
            value={cab.doorsRepairNotes}
            placeholder="e.g. front cracked, hinge mortise blown out, finish chipped"
            onChange={v => update({ doorsRepairNotes: v })}
          />
        </div>
      )}
    </>
  );
}

function DrawersContent({ cab, update }) {
  const drawers = parseInt(cab.drawers) || 0;
  const positionOpts = drawerPositionOptions(drawers);
  return (
    <>
      <div className="dds-row">
        <div className="dds-row-text">
          <div className="dds-card-title">How many drawers?</div>
          <div className="dds-card-sub">Count what this cabinet has, not what's broken.</div>
        </div>
        <DDSStepper value={cab.drawers || 0} onChange={(v) => update({ drawers: v })} />
      </div>
      <DDSRepairCheck
        checked={cab.drawersRepair === true}
        onToggle={(v) => update({ drawersRepair: v, ...(v ? {} : { drawerRepairPositions: [] }) })}
        label="Drawers need repair"
        rate="charged per drawer"
      />
      {cab.drawersRepair && positionOpts.length > 0 && (
        <div className="dds-card-divider">
          <div className="dds-mono-label">Which drawer(s)?</div>
          <div style={{ fontSize: 11, color: 'var(--ink-faint)', marginBottom: 8 }}>
            Drawers are counted top-down — #1 is the top drawer.
          </div>
          <div className="dds-chip-row" style={{ marginBottom: 10 }}>
            {positionOpts.map(opt => {
              const on = (cab.drawerRepairPositions || []).includes(opt.v);
              return (
                <button
                  key={opt.v}
                  type="button"
                  className={'dds-chip' + (on ? ' on' : '')}
                  onClick={() => {
                    const cur = cab.drawerRepairPositions || [];
                    const next = on ? cur.filter(p => p !== opt.v) : [...cur, opt.v];
                    update({ drawerRepairPositions: next });
                  }}
                >{opt.l}</button>
              );
            })}
          </div>
          <DDSNotesField
            value={cab.drawersRepairNotes}
            placeholder="e.g. drawer front gouged, box bottom delaminated"
            onChange={v => update({ drawersRepairNotes: v })}
          />
        </div>
      )}
    </>
  );
}

function ShelvesContent({ cab, update }) {
  const shelves = parseInt(cab.shelves) || 0;
  const shelfPosOpts = shelfPositionOptions(shelves);
  const newCount = parseInt(cab.newShelfCount) || 0;
  return (
    <>
      <div className="dds-row">
        <div className="dds-row-text">
          <div className="dds-card-title">Existing shelves</div>
          <div className="dds-card-sub">Leave at 0 if this cabinet has no shelves.</div>
        </div>
        <DDSStepper
          value={cab.shelves || 0}
          onChange={(v) => update({ shelves: v, ...(parseInt(v) < shelves ? { shelfRepairPositions: [] } : {}) })}
        />
      </div>
      <DDSRepairCheck
        checked={cab.shelvesRepair === true}
        onToggle={(v) => update({ shelvesRepair: v, ...(v ? {} : { shelfRepairPositions: [] }) })}
        label="Existing shelves need repair"
        rate="per shelf"
      />
      {cab.shelvesRepair && shelfPosOpts.length > 0 && (
        <div className="dds-card-divider">
          <div className="dds-mono-label">Which shelf?</div>
          <div className="dds-chip-row" style={{ marginBottom: 10 }}>
            {shelfPosOpts.map(opt => {
              const on = (cab.shelfRepairPositions || []).includes(opt.v);
              return (
                <button
                  key={opt.v}
                  type="button"
                  className={'dds-chip' + (on ? ' on' : '')}
                  onClick={() => {
                    const cur = cab.shelfRepairPositions || [];
                    const next = on ? cur.filter(p => p !== opt.v) : [...cur, opt.v];
                    update({ shelfRepairPositions: next });
                  }}
                >{opt.l}</button>
              );
            })}
          </div>
          <DDSNotesField
            value={cab.shelvesRepairNotes}
            placeholder="e.g. sagging, edge chipped, finish ruined"
            onChange={v => update({ shelvesRepairNotes: v })}
          />
        </div>
      )}
      <div className="dds-card-divider">
        <div className="dds-row">
          <div className="dds-row-text">
            <div className="dds-card-title">New shelves to build</div>
            <div className="dds-card-sub">Made fresh — replaces or adds. <span style={{ color: 'var(--success)' }}>Charged each.</span></div>
          </div>
          <DDSStepper
            value={newCount}
            onChange={(v) => update({
              newShelfCount: v,
              newShelfNeeded: v > 0,
            })}
          />
        </div>
      </div>
    </>
  );
}

function RolloutsContent({ cab, update, cabinetTypeCfg }) {
  const showRollouts = cabinetTypeCfg
    ? cabinetTypeCfg.showRollouts === true
    : (cab.cabType === 'Base' || cab.cabType === 'Sink base' || cab.cabType === 'Full height');
  if (!showRollouts) {
    return (
      <div style={{ padding: '10px 0', fontSize: 12.5, color: 'var(--ink-faint)' }}>
        Roll-outs are only available on Base, Sink base, and Full-height cabinets. Skip this for {cab.cabType || 'this cabinet'}.
      </div>
    );
  }
  const rolloutInstall = parseInt(cab.rolloutInstallCount) || 0;
  const rolloutRebuild = parseInt(cab.rolloutRebuildCount) || 0;
  const rolloutRepair = parseInt(cab.rolloutRepairCount) || 0;
  return (
    <>
      <div className="dds-row">
        <div className="dds-row-text">
          <div className="dds-card-title">Install only</div>
          <div className="dds-card-sub">Hardware supplied — we mount.</div>
        </div>
        <DDSStepper sm value={rolloutInstall} onChange={(v) => update({ rolloutInstallCount: v })} />
      </div>
      <div className="dds-row">
        <div className="dds-row-text">
          <div className="dds-card-title">Rebuild / new</div>
          <div className="dds-card-sub">We fabricate and install.</div>
        </div>
        <DDSStepper sm value={rolloutRebuild} onChange={(v) => update({ rolloutRebuildCount: v })} />
      </div>
      <div className="dds-row">
        <div className="dds-row-text">
          <div className="dds-card-title">Repair</div>
          <div className="dds-card-sub">Glides, sides, bottom.</div>
        </div>
        <DDSStepper sm value={rolloutRepair} onChange={(v) => update({ rolloutRepairCount: v })} />
      </div>
      {rolloutRepair > 0 && (
        <div className="dds-card-divider">
          <DDSNotesField
            value={cab.rolloutsRepairNotes}
            placeholder="e.g. glides bent, bottom split"
            onChange={v => update({ rolloutsRepairNotes: v })}
          />
        </div>
      )}
    </>
  );
}

function HardwareContent({ cab, update }) {
  const d = parseInt(cab.doors) || 0;
  const r = parseInt(cab.drawers) || 0;
  const hw = cab.hardware || {};
  if (d === 0 && r === 0) {
    return (
      <div style={{ padding: '10px 0', fontSize: 12.5, color: 'var(--ink-faint)' }}>
        This cabinet has no doors or drawers — hardware question skipped.
      </div>
    );
  }
  return (
    <>
      <div className="dds-mono-label">Is hardware coming with the cabinet?</div>
      <div className="dds-chip-row" style={{ marginBottom: 8 }}>
        {['Yes', 'No'].map(o => {
          const sel = hw.sourcedByVendor === true ? 'Yes' : hw.sourcedByVendor === false ? 'No' : '';
          return (
            <button
              key={o}
              type="button"
              className={'dds-chip' + (sel === o ? ' on' : '')}
              onClick={() => {
                const yes = o === 'Yes';
                const next = { ...hw, sourcedByVendor: yes };
                if (yes) delete next.softClose;
                update({ hardware: next });
              }}
            >{o}</button>
          );
        })}
      </div>
      {hw.sourcedByVendor === false && (
        <>
          <div style={{ fontSize: 11.5, color: 'var(--ink-faint)', marginBottom: 8 }}>
            No = Precision supplies the slides / hinges — additional hardware charge applies.
          </div>
          <div className="dds-mono-label">Soft-close or standard?</div>
          <div className="dds-chip-row">
            {[{ v: false, l: 'Standard' }, { v: true, l: 'Soft-close' }].map(o => {
              const sel = hw.softClose === o.v;
              return (
                <button
                  key={String(o.v)}
                  type="button"
                  className={'dds-chip' + (sel ? ' on' : '')}
                  onClick={() => update({ hardware: { ...hw, softClose: o.v } })}
                >{o.l}</button>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

// ---------- Layout A — Compact ----------
//
// All five sections (Doors, Drawers, Shelves, Roll-outs, Hardware)
// render at once as stacked cards. Each card shows the count stepper
// inline. Repair checkboxes are flush; conditional sub-options
// reveal below the divider.
function DDSCompact({ cab, update, currentTypeCfg }) {
  return (
    <div>
      <div className="dds-card">
        <DoorsContent cab={cab} update={update} />
      </div>
      <div className="dds-card">
        <DrawersContent cab={cab} update={update} />
      </div>
      <div className="dds-card">
        <ShelvesContent cab={cab} update={update} />
      </div>
      <div className="dds-card">
        <div className="dds-card-title">Roll-out shelves</div>
        <div className="dds-card-sub" style={{ marginBottom: 11 }}>Pull-out trays — Base / Sink base / Full-height only.</div>
        <RolloutsContent cab={cab} update={update} cabinetTypeCfg={currentTypeCfg} />
      </div>
      <div className="dds-card">
        <div className="dds-card-title">Hardware</div>
        <div className="dds-card-sub" style={{ marginBottom: 11 }}>Slides + hinges for the doors and drawers above.</div>
        <HardwareContent cab={cab} update={update} />
      </div>
    </div>
  );
}

// ---------- Layout B — Guided (accordion tiles) ----------
//
// One tile expands at a time. Summary chip on the right shows the
// current value when collapsed, so the vendor can scan the whole
// cabinet at a glance before submitting.
function DDSGuided({ cab, update, currentTypeCfg }) {
  const [open, setOpen] = uS(null); // 'doors' | 'drawers' | 'shelves' | 'rollouts' | 'hardware' | null
  const toggle = (k) => setOpen(prev => prev === k ? null : k);

  const sumDoors = (() => {
    const d = parseInt(cab.doors) || 0;
    if (d === 0) return 'none';
    const r = (cab.doorsRepair && (cab.doorRepairPositions || []).length) || (cab.doorsRepair ? d : 0);
    return d + ' · ' + (cab.doorsRepair ? (r + ' need repair') : 'no repairs');
  })();
  const sumDrawers = (() => {
    const d = parseInt(cab.drawers) || 0;
    if (d === 0) return 'none';
    const r = (cab.drawersRepair && (cab.drawerRepairPositions || []).length) || (cab.drawersRepair ? d : 0);
    return d + ' · ' + (cab.drawersRepair ? (r + ' need repair') : 'no repairs');
  })();
  const sumShelves = (() => {
    const s = parseInt(cab.shelves) || 0;
    const newS = parseInt(cab.newShelfCount) || 0;
    if (s === 0 && newS === 0) return 'none';
    const parts = [];
    if (s > 0) parts.push(s + ' existing');
    if (newS > 0) parts.push(newS + ' new');
    return parts.join(' · ');
  })();
  const sumRollouts = (() => {
    const i = parseInt(cab.rolloutInstallCount) || 0;
    const b = parseInt(cab.rolloutRebuildCount) || 0;
    const r = parseInt(cab.rolloutRepairCount) || 0;
    const t = i + b + r;
    return t === 0 ? 'none' : (t + ' tray' + (t === 1 ? '' : 's'));
  })();
  const sumHardware = (() => {
    const hw = cab.hardware || {};
    if (hw.sourcedByVendor === true) return 'Vendor supplies';
    if (hw.sourcedByVendor === false) {
      return 'Precision · ' + (hw.softClose === true ? 'Soft-close' : hw.softClose === false ? 'Standard' : 'choose');
    }
    return 'not set';
  })();

  const Tile = ({ k, title, summary, children }) => {
    const isOpen = open === k;
    return (
      <div className="dds-tile">
        <button type="button" className="dds-tile-head" onClick={() => toggle(k)} aria-expanded={isOpen}>
          <span className="dds-tile-title">{title}</span>
          <span className="dds-tile-summary">{summary}</span>
          <span className="dds-tile-chev">{isOpen ? '▾' : '›'}</span>
        </button>
        {isOpen && <div className="dds-tile-body">{children}</div>}
      </div>
    );
  };

  return (
    <div>
      <div className="dds-mono-label" style={{ marginBottom: 10 }}>Tap each part this cabinet has</div>
      <Tile k="doors" title="Doors" summary={sumDoors}>
        <DoorsContent cab={cab} update={update} />
      </Tile>
      <Tile k="drawers" title="Drawers" summary={sumDrawers}>
        <DrawersContent cab={cab} update={update} />
      </Tile>
      <Tile k="shelves" title="Shelves" summary={sumShelves}>
        <ShelvesContent cab={cab} update={update} />
      </Tile>
      <Tile k="rollouts" title="Roll-out shelves" summary={sumRollouts}>
        <RolloutsContent cab={cab} update={update} cabinetTypeCfg={currentTypeCfg} />
      </Tile>
      <Tile k="hardware" title="Hardware" summary={sumHardware}>
        <HardwareContent cab={cab} update={update} />
      </Tile>
    </div>
  );
}

// HardwareBlock — folded into the Doors/Drawers/Shelves sub-step
// (2026-06-22). When the cabinet has no doors AND no drawers, hardware
// is N/A and we just show a short skip-note. Otherwise the same two
// segmented controls as the prior standalone sub-step.
function HardwareBlock({ cab, onChange }) {
  const d = parseInt(cab.doors) || 0;
  const r = parseInt(cab.drawers) || 0;
  const hw = cab.hardware || {};
  return (
    <div className="wiz-block" style={{ marginTop: 12 }}>
      <div className="wiz-block-head">
        <div>
          <div className="wiz-block-title">{L('cabinet.field.hardware')}</div>
          <div className="wiz-block-sub">Slides + hinges for the doors and drawers above.</div>
        </div>
      </div>
      {d === 0 && r === 0 ? (
        <div style={{ padding: '10px 12px', background: '#FBF0E1', borderRadius: 8, fontSize: 13, color: 'var(--ink-soft)' }}>
          {L('cabinet.hardware.skipNote')}
        </div>
      ) : (
        <>
          <Field label={L('cabinet.field.hardwareSource')}
                 hint={hw.sourcedByVendor === true ? null : L('cabinet.hint.hardwareSource')}>
            <Segmented value={hw.sourcedByVendor === true ? 'Yes' : hw.sourcedByVendor === false ? 'No' : ''}
                       options={['Yes', 'No']}
                       onChange={v => {
                         // When the vendor flips to Yes (they're
                         // shipping the hardware), the soft-close
                         // question is moot — whatever they bring is
                         // what gets installed. Clear softClose so the
                         // completion check doesn't gate on a stale
                         // answer from when they had No selected.
                         const yes = v === 'Yes';
                         const next = { ...hw, sourcedByVendor: yes };
                         if (yes) delete next.softClose;
                         onChange({ hardware: next });
                       }} />
          </Field>
          {/* Soft-close vs standard only matters when Precision is
              supplying the hardware (No on the question above). If the
              vendor's bringing their own, we install whatever they
              ship — no Precision pricing impact either way. */}
          {hw.sourcedByVendor === false && (
            <Field label={L('cabinet.field.softClose')}
                   hint={L('cabinet.hint.softClose')}>
              <Segmented value={hw.softClose === true ? 'Soft-close' : hw.softClose === false ? 'Standard' : ''}
                         options={['Standard', 'Soft-close']}
                         onChange={v => onChange({ hardware: { ...hw, softClose: v === 'Soft-close' } })} />
            </Field>
          )}
        </>
      )}
    </div>
  );
}

// Finished sides sub-step — extracted so the conditional "which side"
// reveal can carry its own scroll-into-view ref without polluting the
// switch render.
function FinishedSidesSub({ cab, update, currentTypeCfg }) {
  const whichRef = uR(null);
  const backRef = uR(null);
  const showWhich = cab.finishedSide === 'Yes';
  const showBack = currentTypeCfg?.showBackFinished === true;
  uLE(() => {
    if (showWhich && whichRef.current) {
      whichRef.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, [showWhich]);
  uLE(() => {
    if (showBack && backRef.current) {
      backRef.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, [showBack]);
  return (
    <>
      <Field label={L('cabinet.field.finishedSide')}>
        <Segmented value={cab.finishedSide || 'No'}
                   options={['No', 'Yes']}
                   onChange={v => update({ finishedSide: v })} />
      </Field>
      {showWhich && (
        <div ref={whichRef}>
          <Field label={L('cabinet.field.whichSide')}>
            <Segmented value={cab.finishedWhich || ''}
                       options={['Left', 'Right', 'Both']}
                       onChange={v => update({ finishedWhich: v })} />
          </Field>
        </div>
      )}
      {/* 6-2: Island + Peninsula get a second question about the
          back side (exposed when not against a wall). Vendors can
          say no if the back is against a pony wall. Controlled by
          cabinetTypes config flag `showBackFinished`. */}
      {showBack && (
        <div ref={backRef}>
          <Field label={L('cabinet.field.backFinished')}
                 hint={L('cabinet.hint.backFinished')}>
            <Segmented value={cab.backFinished === true ? 'Yes' : (cab.backFinished === false ? 'No' : '')}
                       options={['No', 'Yes']}
                       onChange={v => update({ backFinished: v === 'Yes' })} />
          </Field>
        </div>
      )}
    </>
  );
}

// Under-counter sub-step — extracted to carry a scroll ref on the
// conditional checkbox reveal.
function UnderCounterSub({ cab, update }) {
  const actionRef = uR(null);
  const showAction = cab.installUnderExisting === 'Yes';
  // Finished side panel + under-counter install is a collision condition
  // — the side-panel skin needs to be detached before the cut or its
  // alignment will fight the shorter box. We persist a flag the work
  // order surfaces to Precision so the shop sees it on the floor.
  const sidePanelCollision = showAction && cab.finishedSide === 'Yes';
  uLE(() => {
    if (showAction && actionRef.current) {
      actionRef.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, [showAction]);
  // Keep `precisionSidePanelFlag` in sync with the live collision.
  uE(() => {
    if (sidePanelCollision && cab.precisionSidePanelFlag !== true) {
      update({ precisionSidePanelFlag: true });
    } else if (!sidePanelCollision && cab.precisionSidePanelFlag === true) {
      update({ precisionSidePanelFlag: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidePanelCollision]);
  return (
    <>
      <Field label={L('cabinet.field.underCounter')}
             hint={L('cabinet.hint.underCounter')}>
        <Segmented value={cab.installUnderExisting || 'No'}
                   options={['No', 'Yes']}
                   onChange={v => update({
                     installUnderExisting: v,
                     ...(v === 'No' ? { underCounterCutShort: false, underCounterAdjustableFeet: false, precisionSidePanelFlag: false } : {}),
                   })} />
      </Field>
      {showAction && (
        <div ref={actionRef}>
          <Field label={L('cabinet.field.underCounterAction')} hint={L('cabinet.hint.underCounterAction')}>
            <label className="wiz-checkbox">
              <input type="checkbox" checked={cab.underCounterCutShort === true}
                     onChange={e => update({ underCounterCutShort: e.target.checked })} />
              <span>{L('cabinet.checkbox.cutShort')}</span>
            </label>
            <label className="wiz-checkbox" style={{ marginTop: 4 }}>
              <input type="checkbox" checked={cab.underCounterAdjustableFeet === true}
                     onChange={e => update({ underCounterAdjustableFeet: e.target.checked })} />
              <span>{L('cabinet.checkbox.adjustableFeet')}</span>
            </label>
          </Field>
          {sidePanelCollision && (
            <div
              role="alert"
              style={{
                marginTop: 12,
                padding: '10px 12px',
                background: '#fff5e6',
                border: '2px solid #C9781B',
                borderRadius: 8,
                fontSize: 13,
                lineHeight: 1.4,
                color: '#7a5b14',
              }}
            >
              <strong>⚠ Finished side + under-counter:</strong> {L('cabinet.underCounter.sidePanelWarning')}
            </div>
          )}
        </div>
      )}
    </>
  );
}

function CabinetSubWizard({ cab, idx, total, pricing, onChange, onBackToPrev, onAddAnother, onDuplicate, onDoneAdding, onDelete }) {
  const availableSpecies = React.useMemo(() => deriveSpeciesList(pricing), [pricing]);
  const availableThicknesses = React.useMemo(() => deriveThicknessList(pricing), [pricing]);
  const cabinetTypes = React.useMemo(() => deriveCabinetTypes(pricing), [pricing]);
  const currentTypeCfg = React.useMemo(
    () => cabinetTypes.find(t => t.label === cab.cabType),
    [cabinetTypes, cab.cabType],
  );

  // Mobile uses an accordion (single scroll, all 8 sections stacked).
  // Desktop keeps the paginated wizard with inner Back/Next. The
  // 768px breakpoint matches the rest of the PWA's responsive layout.
  const isMobile = useMediaQuery('(max-width: 768px)');

  // ---------- Mobile accordion ----------
  // `update` passes the PATCH up unmerged. The IntakeWizard's updateCab
  // merges against the latest state functionally so back-to-back updates
  // (e.g. visited-set useEffect + Box Material onChange in the same
  // microtask) don't race on a stale cab snapshot.
  if (isMobile) {
    return (
      <CabinetAccordion
        cab={cab} idx={idx} total={total}
        update={(patch) => onChange(patch)}
        currentTypeCfg={currentTypeCfg}
        cabinetTypes={cabinetTypes}
        availableSpecies={availableSpecies}
        availableThicknesses={availableThicknesses}
        onAddAnother={onAddAnother}
        onDuplicate={onDuplicate}
        onDoneAdding={onDoneAdding}
        onDelete={onDelete}
        onBackToPrev={onBackToPrev}
      />
    );
  }

  // ---------- Desktop paginated wizard (preserved) ----------
  return (
    <CabinetPaginatedDesktop
      cab={cab} idx={idx} total={total}
      onChange={onChange}
      currentTypeCfg={currentTypeCfg}
      cabinetTypes={cabinetTypes}
      availableSpecies={availableSpecies}
      availableThicknesses={availableThicknesses}
      onAddAnother={onAddAnother}
      onDuplicate={onDuplicate}
      onDoneAdding={onDoneAdding}
      onDelete={onDelete}
      onBackToPrev={onBackToPrev}
    />
  );
}

// ---------- Desktop sub-wizard (the original 8-step paginated UX) ----------
//
// Lifted out of CabinetSubWizard so the mobile accordion has its own
// component tree. Data flow + completion semantics are unchanged.
function CabinetPaginatedDesktop({
  cab, idx, total, onChange, currentTypeCfg, cabinetTypes,
  availableSpecies, availableThicknesses,
  onAddAnother, onDuplicate, onDoneAdding, onDelete, onBackToPrev,
}) {
  const [sub, setSub] = uS(0);
  const isLast = sub === SUB_TITLE_KEYS.length - 1;

  const handleDelete = async () => {
    const ok = await bsConfirmCompat({
      title: 'Delete cabinet?',
      body: 'This removes it from the order. Cannot be undone.',
      confirmLabel: 'Delete',
      cancelLabel: 'Keep cabinet',
      danger: true,
    });
    if (ok) onDelete();
  };

  const subValid = (() => {
    if (sub === 0) return !!(cab.cabType && cab.w && cab.h && cab.d);
    if (sub === 4) return !!cab.boxMaterial;             // material required
    return true;
  })();

  // Mirror the mobile accordion's allDone gate so desktop "+ Add Cabinet"
  // and "Done Adding" both refuse to advance until every required section
  // is complete. Visited tracking isn't surfaced on desktop (the user
  // walks through linearly via Next so all sub-steps get touched anyway).
  const desktopAllDone = SUB_TITLE_KEYS.every((_, i) => subStepComplete(i, cab));

  const next = () => {
    if (!subValid) return;
    setSub(s => Math.min(SUB_TITLE_KEYS.length - 1, s + 1));
  };
  const back = () => sub === 0 ? onBackToPrev() : setSub(s => Math.max(0, s - 1));
  // Pass the patch up unmerged so IntakeWizard's updateCab can merge
  // against the latest state — avoids the stale-closure race described
  // on the mobile accordion path.
  const update = (patch) => onChange(patch);

  return (
    <div className="wiz-subshell">
      <div className="wiz-subhead">
        <strong>Cabinet {idx + 1}{total > 1 ? ' of ' + total : ''}</strong>
        <span className="wiz-substep">{L(SUB_TITLE_KEYS[sub])}</span>
      </div>
      <div className="wiz-subbody">
        <CabinetSubBody
          subIdx={sub}
          cab={cab}
          update={update}
          currentTypeCfg={currentTypeCfg}
          cabinetTypes={cabinetTypes}
          availableSpecies={availableSpecies}
          availableThicknesses={availableThicknesses}
          onAdvanceTo={(nextSub) => setSub(nextSub)}
        />
      </div>
      <div className="wiz-subfooter">
        <button className="btn ghost" onClick={back}>{L('shared.back')}</button>
        {isLast ? (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button className="btn"
                    style={{
                      background: '#fff', color: '#0a2240', border: '2px solid #0a2240', fontWeight: 600,
                      opacity: desktopAllDone ? 1 : 0.45,
                    }}
                    disabled={!desktopAllDone}
                    title={desktopAllDone ? undefined : 'Finish every section above before adding another cabinet.'}
                    onClick={onAddAnother}>{L('cabinets.button.addAnother')}</button>
            <button className="btn"
                    style={{
                      background: '#fff', color: '#0a2240', border: '2px solid #0a2240', fontWeight: 600,
                      opacity: (desktopAllDone && cab.cabType) ? 1 : 0.45,
                    }}
                    disabled={!desktopAllDone || !cab.cabType}
                    title={
                      !cab.cabType
                        ? 'Pick a cabinet type first.'
                        : !desktopAllDone
                          ? 'Finish every section above before duplicating.'
                          : "Create a new cabinet pre-filled with this cabinet's data. Photos start empty."
                    }
                    onClick={onDuplicate}>📋 Duplicate</button>
            <button className="btn primary lg"
                    onClick={onDoneAdding}
                    disabled={!desktopAllDone}
                    style={{ opacity: desktopAllDone ? 1 : 0.45 }}
                    title={desktopAllDone ? undefined : 'Finish every section above to continue.'}>
              {L('cabinets.button.doneAdding')}
            </button>
          </div>
        ) : (
          <button className="btn primary lg" onClick={next} disabled={!subValid}>
            {subValid ? L('shared.next') : (sub === 0 ? 'Pick a type & size first' : 'Pick box material')}
          </button>
        )}
      </div>
      <div className="wiz-subdelete">
        <button
          type="button"
          className="btn"
          onClick={handleDelete}
          style={{
            background: '#fff', color: '#b91c1c', border: '2px solid #b91c1c',
            fontWeight: 600, width: '100%', marginTop: 12,
          }}
        >
          <Icon.Trash/> {L('cabinets.button.delete')}
        </button>
      </div>
    </div>
  );
}

// ---------- Mobile sub-wizard accordion ----------
//
// All 8 sub-steps render as a single scrollable list. The first
// incomplete section is open on mount; completing a section auto-opens
// the next one and scrolls it into view. Inner Back/Next are gone —
// the outer wizard footer drives navigation between cabinets and
// between top-level wizard steps.
function CabinetAccordion({
  cab, idx, total, update, currentTypeCfg, cabinetTypes,
  availableSpecies, availableThicknesses,
  onAddAnother, onDuplicate, onDoneAdding, onDelete, onBackToPrev,
}) {
  // Track which sections the user has explicitly toggled — we don't
  // want auto-advance to slam shut a section the vendor reopened to
  // revise.
  const initialOpenIdx = (() => {
    for (let i = 0; i < SUB_TITLE_KEYS.length; i++) {
      if (!subStepComplete(i, cab)) return i;
    }
    return 0;
  })();
  const [openIdx, _setOpenIdx] = uS(initialOpenIdx);
  // VISITED TRACKING (2026-06-18): green checkmarks only render after
  // a section has been visited AND is complete. Without this, sections
  // like Parts (defaults to doors=0/drawers=0/shelves=0) showed checked
  // before the vendor even saw them, which made the "all green = Done
  // Adding unlocks" UX lie.
  //
  // PERSISTENCE (2026-06-18 fix #2): visited state is stored on the
  // cabinet object as `cab.visitedSubSteps` (sorted array of indices)
  // so a vendor who saves a draft and returns later doesn't lose
  // their per-section progress. A LEGACY cabinet (cabType set, no
  // visitedSubSteps array) is treated as fully visited — these
  // pre-date the feature so we can't have made them re-walk every
  // sub-step.
  const initialVisited = (() => {
    if (Array.isArray(cab.visitedSubSteps)) {
      return new Set(cab.visitedSubSteps);
    }
    if (cab.cabType) {
      // Legacy / pre-feature draft — trust the vendor was here before.
      return new Set(SUB_TITLE_KEYS.map((_, i) => i));
    }
    return new Set([initialOpenIdx]);
  })();
  const [visited, setVisited] = uS(initialVisited);
  // Persist visited to the cabinet so draft autosave catches it.
  // Compare against the existing array to avoid loop renders on equal
  // sets.
  uE(() => {
    const arr = Array.from(visited).sort((a, b) => a - b);
    const existing = Array.isArray(cab.visitedSubSteps) ? cab.visitedSubSteps : [];
    const changed = arr.length !== existing.length || arr.some((v, i) => v !== existing[i]);
    if (changed) update({ visitedSubSteps: arr });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visited]);
  const setOpenIdx = (next) => {
    _setOpenIdx(next);
    if (typeof next === 'number' && next >= 0) {
      setVisited((prev) => {
        if (prev.has(next)) return prev;
        const out = new Set(prev);
        out.add(next);
        return out;
      });
    }
  };
  const sectionRefs = uR([]);
  const lastOpenedRef = uR(openIdx);

  // After the open index changes, scroll the freshly opened section
  // into view. useLayoutEffect runs before paint so the user doesn't
  // see a flash of the wrong scroll position.
  uLE(() => {
    if (lastOpenedRef.current === openIdx) return;
    lastOpenedRef.current = openIdx;
    const el = sectionRefs.current[openIdx];
    if (el && typeof el.scrollIntoView === 'function') {
      // Defer a tick so the <details> open animation has the right
      // height before we scroll — otherwise iOS Safari jumps to the
      // pre-open offset.
      requestAnimationFrame(() => {
        el.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    }
  }, [openIdx]);

  // AUTO-ADVANCE DISABLED (2026-06-18): the previous version tried
  // to be helpful by opening the next sub-step as soon as the current
  // one looked "complete," with a 700ms debounce + meaningful-dim
  // check. Both heuristics still bounced vendors off mid-typing:
  // typing "30" for width fired the advance the moment they paused
  // after the second digit, scrolling them away from the field they
  // were still editing. Vendor feedback was unambiguous — "Full
  // entry of numbers in any cabinet type, custom number, changing a
  // number should not bounce you to the next section."
  //
  // Section navigation is now 100% manual: tap a section header to
  // expand/collapse, and the green check on the accordion head tells
  // the vendor when each section is complete. Done Adding cabinets
  // still requires every section visited + complete.
  const completionFlags = SUB_TITLE_KEYS.map((_, i) => subStepComplete(i, cab));

  // Per-section visual "done" — both visited AND complete (see
  // VISITED TRACKING note above). doneFlags drives the green check
  // badges + the section count in the head.
  const doneFlags = completionFlags.map((c, i) => c && visited.has(i));
  // allDone gates the "Done Adding cabinets" button — vendor must
  // visit every section AND every section must be complete.
  const allDone = doneFlags.every(Boolean);

  const handleDelete = async () => {
    const ok = await bsConfirmCompat({
      title: 'Delete cabinet?',
      body: 'This removes it from the order. Cannot be undone.',
      confirmLabel: 'Delete',
      cancelLabel: 'Keep cabinet',
      danger: true,
    });
    if (ok) onDelete();
  };

  return (
    <div className="wiz-subshell wiz-subshell-accordion">
      <div className="wiz-subhead">
        <strong>Cabinet {idx + 1}{total > 1 ? ' of ' + total : ''}</strong>
        <span className="wiz-substep">
          {doneFlags.filter(Boolean).length} / {SUB_TITLE_KEYS.length} sections
        </span>
      </div>
      <div className="wiz-acc-list">
        {SUB_TITLE_KEYS.map((key, i) => {
          const isOpen = openIdx === i;
          const done = doneFlags[i];
          return (
            <section
              key={key}
              ref={(el) => { sectionRefs.current[i] = el; }}
              className={'wiz-acc-card' + (isOpen ? ' is-open' : '') + (done ? ' is-done' : '')}
            >
              <button
                type="button"
                className="wiz-acc-head"
                aria-expanded={isOpen}
                onClick={() => setOpenIdx(isOpen ? -1 : i)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 8,
                  padding: '12px 14px',
                  background: isOpen ? 'var(--accent-soft, #FBF0E1)' : '#fff',
                  border: '1px solid var(--rule, #e5e7eb)',
                  borderRadius: 10,
                  marginTop: i === 0 ? 0 : 8,
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: 14,
                  color: '#0a2240',
                }}
              >
                <span style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span
                    aria-hidden="true"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 22, height: 22, borderRadius: 11,
                      background: done ? '#16a34a' : '#fff',
                      color: done ? '#fff' : '#0a2240',
                      border: '1.5px solid ' + (done ? '#16a34a' : '#0a2240'),
                      fontSize: 12, fontWeight: 700, flexShrink: 0,
                    }}
                  >{done ? '✓' : (i + 1)}</span>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {L(key)}
                  </span>
                  {/* "Saved" chip — appears only on closed sections that
                      are fully complete. Earlier draft had an "In
                      progress" variant when visited-but-incomplete, but
                      that fired the moment a vendor merely opened a
                      section to look, falsely suggesting they'd entered
                      data. Now the chip only celebrates completed work. */}
                  {!isOpen && done && (
                    <span style={{
                      fontSize: 10, fontWeight: 600, padding: '2px 6px',
                      borderRadius: 999, background: 'rgba(22,163,74,0.12)',
                      color: '#15803d', flexShrink: 0,
                      letterSpacing: 0.3, textTransform: 'uppercase',
                    }}>
                      ✓ Saved
                    </span>
                  )}
                </span>
                <span style={{ fontSize: 18, color: 'var(--ink-faint, #6b7280)', flexShrink: 0 }}>
                  {isOpen ? '▾' : '▸'}
                </span>
              </button>
              {isOpen && (
                <div className="wiz-acc-body" style={{ padding: '12px 14px 16px' }}>
                  <CabinetSubBody
                    subIdx={i}
                    cab={cab}
                    update={update}
                    currentTypeCfg={currentTypeCfg}
                    cabinetTypes={cabinetTypes}
                    availableSpecies={availableSpecies}
                    availableThicknesses={availableThicknesses}
                    onAdvanceTo={(next) => setOpenIdx(next)}
                  />
                </div>
              )}
            </section>
          );
        })}
      </div>

      {/* Add another / Done adding pair — ALWAYS visible at the bottom
          of the accordion so the vendor knows the cabinet-adding flow
          ends here. Done Adding is disabled until every required
          section reports complete (the section count above shows
          progress). The outer wizard footer no longer offers a
          "Skip to Toe Kick" shortcut — Done Adding is the only forward
          path off step 6. */}
      <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
        <button
          className="btn"
          style={{
            background: '#fff', color: '#0a2240', border: '2px solid #0a2240',
            fontWeight: 600, flex: '1 1 140px',
            opacity: allDone ? 1 : 0.45,
          }}
          onClick={onAddAnother}
          disabled={!allDone}
          title={allDone ? undefined : 'Finish every section above before adding another cabinet.'}
        >{L('cabinets.button.addAnother')}</button>
        {/* Duplicate — shortcut for the common case where Cabinets 2–N
            share most of Cabinet 1's spec (kitchens with rows of
            identical bases, etc.). Same allDone gate as Add Cabinet so
            we never duplicate an incomplete cabinet. Also a quick-path
            from the bottom of the section in case the vendor missed
            the Duplicate button in the header banner. */}
        <button
          className="btn"
          style={{
            background: '#fff', color: '#0a2240', border: '2px solid #0a2240',
            fontWeight: 600, flex: '1 1 140px',
            opacity: (allDone && cab.cabType) ? 1 : 0.45,
          }}
          onClick={onDuplicate}
          disabled={!allDone || !cab.cabType}
          title={
            !cab.cabType
              ? 'Pick a cabinet type first.'
              : !allDone
                ? 'Finish every section above before duplicating.'
                : "Create a new cabinet pre-filled with this cabinet's data. Photos start empty."
          }
        >📋 Duplicate</button>
        <button
          className="btn primary lg"
          style={{ flex: '1 1 140px', opacity: allDone ? 1 : 0.45 }}
          onClick={onDoneAdding}
          disabled={!allDone}
          title={allDone ? undefined : 'Finish every section above to continue.'}
        >{L('cabinets.button.doneAdding')}</button>
      </div>
      {!allDone && (
        <div className="hint" style={{ fontSize: 11, marginTop: 6, color: 'var(--ink-faint)', textAlign: 'center' }}>
          Finish every section above ({doneFlags.filter(Boolean).length} / {SUB_TITLE_KEYS.length}) to unlock <strong>+ Add Cabinet</strong>, <strong>📋 Duplicate</strong>, or <strong>{L('cabinets.button.doneAdding')}</strong>.
        </div>
      )}

      <div className="wiz-subdelete">
        {/* Per task spec — delete only renders inside the first
            (cabinet-identity) section on mobile, AND the section must
            be open. We render it adjacent to the accordion list when
            section 0 is open so it stays out of the way during the
            rest of the flow. */}
        {openIdx === 0 && (
          <button
            type="button"
            className="btn"
            onClick={handleDelete}
            style={{
              background: '#fff', color: '#b91c1c', border: '2px solid #b91c1c',
              fontWeight: 600, width: '100%', marginTop: 16,
            }}
          >
            <Icon.Trash/> {L('cabinets.button.delete')}
          </button>
        )}
      </div>
    </div>
  );
}

// ---------- Step 7 — Toe kick ----------

// 6-2: toe kick supplied in 8-ft sticks. Quickpicks are stick multiples
// (8, 16, 24, …) since vendors don't get to cut to non-multiples — we
// always supply the next whole stick.
const TOEKICK_LF_QUICKPICKS = [8, 16, 24, 32, 40, 48];

function FractionStepper({ value, onChange, step = 0.25, min = 0, max = 12, suffix = '"' }) {
  const v = parseFloat(value) || 0;
  const set = (next) => {
    const clamped = Math.max(min, Math.min(max, next));
    onChange(String(Math.round(clamped * 100) / 100));
  };
  return (
    <div className="wiz-fracstep">
      <button type="button" className="wiz-fracstep-btn" onClick={() => set(v - step)}>−</button>
      <input
        type="number"
        inputMode="decimal"
        pattern="[0-9.]*"
        className="input mono"
        value={value || ''}
        step={step}
        min={min}
        max={max}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: 80, textAlign: 'center' }}
      />
      <button type="button" className="wiz-fracstep-btn" onClick={() => set(v + step)}>+</button>
      <span style={{ fontSize: 13, color: 'var(--ink-soft)' }}>{suffix}</span>
    </div>
  );
}

// 6-2: toe kick always supplied in 8-ft sticks. Recommendation rounds up
// to the next whole stick because the shop pays for the offcut otherwise.
// Contributor cabinet types come from wizardConfig.cabinetTypes
// (`contributesToToeKick` flag), with a hardcoded fallback when the
// admin schema isn't loaded yet.
function recommendedToeKickFt(cabinets, pricing) {
  const cabinetTypes = deriveCabinetTypes(pricing);
  const floorTypes = new Set(
    cabinetTypes.filter(t => t.contributesToToeKick === true).map(t => t.label),
  );
  // Legacy 'Standard wall' treated as Base for old drafts.
  floorTypes.add('Standard wall');
  let totalIn = 0;
  for (const c of cabinets || []) {
    if (!floorTypes.has(c.cabType)) continue;
    const w = parseFloat(c.w) || 0;
    if (!w) continue;
    const inches = c.wu === 'mm' ? w / 25.4 : w;
    totalIn += inches;
  }
  if (totalIn <= 0) return 0;
  const ft = totalIn / 12 + 2;          // 2 ft buffer
  return Math.ceil(ft / 8) * 8;          // round up to nearest 8 ft stick
}

// Default shape for a fresh toe kick row.
function defaultToeKick(linearFt = 0) {
  return { height: '4', setback: '3', thickness: '1/4"', linearFt: linearFt ? String(linearFt) : '' };
}

function ToeKickStep({ data, setData, pricing, ...nav }) {
  // 6-2: vendor can add multiple toe-kick specs (e.g. kitchen 4×3 +
  // island 3.5×3). Data shape is `data.toeKicks` (array). Legacy
  // single-object `data.toeKick` is migrated on first interaction.
  const initialKicks = Array.isArray(data.toeKicks) && data.toeKicks.length > 0
    ? data.toeKicks
    : (data.toeKick && (data.toeKick.linearFt || data.toeKick.height)
        ? [data.toeKick]
        : [defaultToeKick()]);
  const kicks = initialKicks;

  const writeKicks = (next) => {
    setData(d => ({
      ...d,
      toeKicks: next,
      // keep singular field in sync with first entry for back-compat
      toeKick: next[0] || {},
    }));
  };
  const updateKick = (idx, patch) => {
    writeKicks(kicks.map((k, i) => (i === idx ? { ...k, ...patch } : k)));
  };
  const addKick = () => writeKicks([...kicks, defaultToeKick()]);
  const removeKick = (idx) => {
    if (kicks.length <= 1) return;
    writeKicks(kicks.filter((_, i) => i !== idx));
  };

  const recommended = recommendedToeKickFt(data.cabinets, pricing);

  // Auto-fill the first toe-kick's linear feet from the sum of
  // contributing-cabinet widths on first visit (2026-06-22). Only fills
  // when the vendor hasn't entered anything yet — never overwrites a
  // manual value. The autoFilledRef latch prevents re-fill if the
  // vendor manually CLEARS the field after we filled it (otherwise
  // adding another cabinet upstream would silently re-populate it).
  const autoFilledRef = uR(false);
  uE(() => {
    if (autoFilledRef.current) return;
    if (recommended <= 0) return;
    const first = kicks[0] || {};
    if (first.linearFt && String(first.linearFt).trim() !== '') return;
    autoFilledRef.current = true;
    writeKicks(kicks.map((k, i) => (i === 0 ? { ...k, linearFt: String(recommended) } : k)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recommended]);

  return (
    <StepShell {...nav} title={L('toeKick.title')} subtitle={L('toeKick.subtitle')}>
      {kicks.map((tk, idx) => {
        const currentLf = parseFloat(tk.linearFt) || 0;
        const recMatches = idx === 0 && recommended > 0 && currentLf === recommended;
        return (
          <div key={idx} style={{
            border: '1px solid var(--rule)', borderRadius: 8, padding: 14, marginBottom: 12,
            background: '#fff',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
              <div className="eyebrow">{kicks.length > 1 ? L('toeKick.eyebrow.spec', { n: idx + 1 }) : L('toeKick.eyebrow.single')}</div>
              {kicks.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeKick(idx)}
                  className="btn"
                  style={{ background: '#fff', color: '#b91c1c', border: '1px solid #b91c1c', padding: '4px 10px', fontSize: 12 }}
                >Remove</button>
              )}
            </div>
            <Field label={L('toeKick.field.height')} hint={L('toeKick.hint.height')}>
              <FractionStepper value={tk.height || ''} onChange={v => updateKick(idx, { height: v })} />
            </Field>
            <Field label={L('toeKick.field.setback')} hint={L('toeKick.hint.setback')}>
              <FractionStepper value={tk.setback || ''} onChange={v => updateKick(idx, { setback: v })} />
            </Field>
            <Field label={L('toeKick.field.thickness')} hint={L('toeKick.hint.thickness')}>
              <Segmented value={tk.thickness || '1/4"'}
                         options={['1/4"', '1/2"', '5/8"', '3/4"']}
                         onChange={v => updateKick(idx, { thickness: v })} />
            </Field>
            <Field label={L('toeKick.field.length')}
                   hint={idx === 0 && recommended > 0
                     ? `Recommended ${recommended} ft (${recommended / 8} stick${recommended / 8 === 1 ? '' : 's'}) — sum of base / island / peninsula / full-height widths + 2 ft buffer, rounded up to the next 8-ft stick.`
                     : 'Always rounded up to the nearest 8-ft stick. Override below if you need a different total.'}>
              <div className="chips" style={{ marginBottom: 8 }}>
                {idx === 0 && recommended > 0 && (
                  <button
                    className={'chip' + (recMatches ? ' on' : '')}
                    onClick={() => updateKick(idx, { linearFt: String(recommended) })}
                    style={{
                      borderColor: '#C9781B',
                      background: recMatches ? '#FBF0E1' : '#fff8e1',
                      // Inline-override .chip.on which would otherwise paint cream
                      // text on this amber background, hiding the label until hover.
                      color: 'var(--ink)',
                    }}
                  >
                    <span className="dot" style={{ background: '#C9781B' }}></span>
                    Recommended {recommended} ft
                  </button>
                )}
                {TOEKICK_LF_QUICKPICKS.map(n => (
                  <button key={n}
                          className={'chip' + (currentLf === n ? ' on' : '')}
                          onClick={() => updateKick(idx, { linearFt: String(n) })}>
                    <span className="dot"></span>{n} ft
                  </button>
                ))}
              </div>
              <DimField label="Custom length" value={tk.linearFt} onValue={v => updateKick(idx, { linearFt: v })} />
            </Field>
          </div>
        );
      })}
      <button
        type="button"
        onClick={addKick}
        className="btn"
        style={{ background: '#fff', color: '#0a2240', border: '2px dashed #0a2240', fontWeight: 600, width: '100%' }}
      >
        + Add another toe-kick spec
      </button>
    </StepShell>
  );
}

// ---------- Step 8 — Scribe ----------

// 6-2: scribe always matches the cabinet material (the "no, cheapest"
// option was almost never used). Auto-calculated as 1 stick per 2
// finished-side cabinets, 2 sticks per full-height cabinet with finished
// sides. Vendor can manually bump up if they want extra.
function recommendedScribeSticks(cabinets) {
  let regularFinished = 0;
  let fullHeightFinished = 0;
  for (const c of cabinets || []) {
    if (c.finishedSide !== 'Yes') continue;
    if (c.cabType === 'Full height') fullHeightFinished++;
    else regularFinished++;
  }
  // 1 stick / 2 regular cabinets (round up); 2 sticks per full-height cabinet
  const regularSticks = Math.ceil(regularFinished / 2);
  const fullHeightSticks = fullHeightFinished * 2;
  return regularSticks + fullHeightSticks;
}

function ScribeStep({ data, setData, ...nav }) {
  const sc = data.scribe || {};
  const update = (patch) => setData(d => ({ ...d, scribe: { ...sc, ...patch } }));
  const recommended = recommendedScribeSticks(data.cabinets);
  const currentSticks = parseInt(sc.sticks);
  const usingRecommended = recommended > 0 && (currentSticks === recommended || (!Number.isFinite(currentSticks) && sc.needed === 'Yes'));

  // Apply the recommendation as the default the first time Yes is picked.
  uE(() => {
    if (sc.needed === 'Yes' && (sc.sticks == null || sc.sticks === '') && recommended > 0) {
      update({ sticks: recommended });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sc.needed, recommended]);

  return (
    <StepShell {...nav} title={L('scribe.title')} subtitle={L('scribe.subtitle')}>
      <Field label={L('scribe.field.needed')}>
        <Segmented value={sc.needed || 'No'} options={['No', 'Yes']} onChange={v => update({ needed: v })} />
      </Field>
      {sc.needed === 'Yes' && (
        <>
          <Field
            label={L('scribe.field.sticks')}
            hint={recommended > 0
              ? `Recommended ${recommended} stick${recommended === 1 ? '' : 's'} (1 per 2 finished-side cabinets, 2 per finished full-height). Bump up if you want extra.`
              : 'No cabinets with finished sides yet — recommendation will appear once you add some.'}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <NumberStepper value={currentSticks || 0} onChange={(v) => update({ sticks: Math.max(0, v) })} />
              <span style={{ fontSize: 13, color: 'var(--ink-soft)' }}>sticks ({((currentSticks || 0) * 8)} lin. ft)</span>
              {recommended > 0 && !usingRecommended && (
                <button
                  className="btn ghost"
                  style={{ padding: '4px 10px', fontSize: 12 }}
                  onClick={() => update({ sticks: recommended })}
                  type="button"
                >
                  Use recommended ({recommended})
                </button>
              )}
            </div>
          </Field>
        </>
      )}
    </StepShell>
  );
}

// ---------- Step 9 — End-of-intake Add-ons (6-2) ----------
//
// Master Yes/No question. On Yes, vendor picks from a column of
// "+ Add X" buttons; each click appends a row of that type's
// inline fields. Each row has its own pricing in the cost builder.

// Legacy hardcoded list — preserved only so deriveAddonTypes' fallback
// path (used before wizardConfig is loaded) has the same key set as the
// admin-managed schema. New code should not read this directly.
const ADDON_TYPES = [
  { key: 'fridge-panel',    label: 'Refrigerator end panel',     emoji: '🧊' },
  { key: 'dishwasher-panel', label: 'Dishwasher end panel',       emoji: '🍽️' },
  { key: 'filler',          label: 'Filler',                     emoji: '🧱' },
  { key: 'corner-mold',     label: 'Outside corner mold',        emoji: '📐' },
  { key: 'quarter-round',   label: 'Quarter round',              emoji: '⌒' },
  { key: 'other',           label: 'Other (free-text)',          emoji: '➕' },
];

// Seed a fresh addon item from an addon config (data-driven over inputs[]).
function defaultAddonItem(addonCfg) {
  const id = 'ad_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
  const item = { id, type: addonCfg.id };
  for (const input of addonCfg.inputs || []) {
    item[input.key] = input.defaultValue ?? '';
  }
  return item;
}

function AddonsStep({ data, setData, pricing, ...nav }) {
  const addonTypes = React.useMemo(() => deriveAddonTypes(pricing), [pricing]);
  const addons = data.addons || { needed: 'No', items: [] };
  const items = Array.isArray(addons.items) ? addons.items : [];
  const update = (patch) => setData(d => ({ ...d, addons: { ...addons, ...patch } }));

  const addItem = (addonCfg) => {
    update({ items: [...items, defaultAddonItem(addonCfg)] });
  };
  const removeItem = (id) => {
    update({ items: items.filter(it => it.id !== id) });
  };
  const updateItem = (id, patch) => {
    update({ items: items.map(it => it.id === id ? { ...it, ...patch } : it) });
  };

  return (
    <StepShell {...nav} title={L('addons.title')} subtitle={L('addons.subtitle')}>
      <Field label={L('addons.field.needed')}>
        <Segmented value={addons.needed || 'No'} options={['No', 'Yes']}
                   onChange={v => update({ needed: v, items: v === 'No' ? [] : items })} />
      </Field>

      {addons.needed === 'Yes' && (
        <>
          <div style={{ marginTop: 16 }}>
            <div className="eyebrow" style={{ marginBottom: 8 }}>{L('addons.eyebrow.addOne')}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 8 }}>
              {addonTypes.map(t => (
                <button
                  key={t.id}
                  type="button"
                  onClick={() => addItem(t)}
                  className="btn"
                  style={{
                    background: '#fff', color: '#0a2240', border: '2px solid #0a2240',
                    fontWeight: 600, padding: '10px 12px', textAlign: 'left',
                    display: 'flex', alignItems: 'center', gap: 8,
                  }}
                >
                  <span style={{ fontSize: 18 }}>{t.emoji}</span>
                  <span style={{ flex: 1 }}>+ {t.label}</span>
                </button>
              ))}
            </div>
          </div>

          {items.length > 0 && (
            <div style={{ marginTop: 24 }}>
              <div className="eyebrow" style={{ marginBottom: 8 }}>{L('addons.eyebrow.yours')} ({items.length})</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {items.map((it, idx) => {
                  const cfg = addonTypes.find(t => t.id === it.type);
                  return (
                    <AddonRow key={it.id} item={it} idx={idx} cfg={cfg}
                              onUpdate={(patch) => updateItem(it.id, patch)}
                              onRemove={() => removeItem(it.id)} />
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}
    </StepShell>
  );
}

function AddonRow({ item, idx, cfg, onUpdate, onRemove }) {
  // Falls back to a minimal placeholder when cfg is missing (e.g. legacy
  // item whose addon type was removed from wizardConfig).
  const meta = cfg || { label: item.type, emoji: '•', inputs: [] };
  const inputs = Array.isArray(meta.inputs) ? meta.inputs : [];

  const renderInput = (input) => {
    const raw = item[input.key];
    const val = raw == null ? '' : raw;
    switch (input.kind) {
      case 'count':
        return (
          <Field key={input.key} label={input.label}>
            <NumberStepper value={Number(val) || 0}
                           onChange={v => onUpdate({ [input.key]: Math.max(1, v) })} />
          </Field>
        );
      case 'number':
        return (
          <Field key={input.key} label={input.label}>
            <input className="input mono" type="number"
                   inputMode="decimal" pattern="[0-9.]*"
                   value={val}
                   onChange={e => onUpdate({ [input.key]: e.target.value === '' ? '' : Number(e.target.value) })} />
          </Field>
        );
      case 'segmented':
        return (
          <Field key={input.key} label={input.label}>
            <Segmented value={String(val)}
                       options={input.options || []}
                       onChange={v => {
                         const isNumeric = !isNaN(Number(v)) && v !== '' && v !== 'custom';
                         onUpdate({ [input.key]: v === 'custom' ? '' : (isNumeric ? Number(v) : v) });
                       }} />
          </Field>
        );
      case 'text':
      default:
        return (
          <Field key={input.key} label={input.label} required={input.key === 'description'}>
            {input.key === 'description' ? (
              <textarea className="textarea" value={val}
                        placeholder={L('addons.placeholder.otherDescription')}
                        style={{ minHeight: 50 }}
                        onChange={e => onUpdate({ [input.key]: e.target.value })} />
            ) : (
              <input className="input" value={val}
                     onChange={e => onUpdate({ [input.key]: e.target.value })} />
            )}
          </Field>
        );
    }
  };

  return (
    <div style={{
      border: '1px solid var(--rule)', borderRadius: 8, padding: 12, background: '#fff',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <strong style={{ fontSize: 13 }}>
          <span style={{ marginRight: 6 }}>{meta.emoji}</span>
          {meta.label} #{idx + 1}
        </strong>
        <button type="button" onClick={onRemove} className="btn"
                style={{ background: '#fff', color: '#b91c1c', border: '1px solid #b91c1c', padding: '4px 10px', fontSize: 12 }}>
          Remove
        </button>
      </div>
      <div className="v-fields">
        {inputs.map(renderInput)}
      </div>
    </div>
  );
}

// ---------- Step 10 — Special instructions ----------

function SpecialStep({ data, setData, ...nav }) {
  return (
    <StepShell {...nav} title={L('special.title')} subtitle={L('special.subtitle')}>
      <textarea className="textarea" value={data.specialInstructions || ''}
                placeholder={L('special.placeholder')}
                style={{ minHeight: 120 }}
                onChange={e => setData(d => ({ ...d, specialInstructions: e.target.value }))} />
    </StepShell>
  );
}

// ---------- Step 10 — Review ----------

function ReviewStep({ data, setData, pricing, estimate, runningTotal, hideEstimates, ...actions }) {
  const cabs = data.cabinets || [];
  // Edit-mode labels (Feature 1): the primary action becomes "Save Changes"
  // and the Save Draft button is hidden so a submitted order can't be
  // reverted to a draft.
  const submitLabel = actions.submitLabel || 'Submit Order →';
  const submittingLabel = actions.submitLabel ? 'Saving…' : 'Submitting…';
  const hideSaveDraft = !!actions.hideSaveDraft;
  const isPotential = data.serviceMode === 'potential';
  const toggles = data.serviceToggles || { pickup: false, dropoff: false, install: false };
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [overflowOpen, setOverflowOpen] = uS(false);
  const Sheet = getBottomSheet();
  const setToggle = (key, val) => {
    // Picking any service-mode toggle clears the "unresolved" flag —
    // the vendor just made a decision, so admin no longer needs to chase.
    setData(d => ({
      ...d,
      serviceToggles: { ...toggles, [key]: val },
      serviceUnresolved: false,
    }));
  };
  // Decided = vendor chose something explicit (toggle on, or marked
  // unresolved-but-let-Precision-handle-it). Per D10, the "unresolved"
  // path keeps serviceMode='potential' and flags the order for follow-up.
  const anyToggle = toggles.pickup || toggles.dropoff || toggles.install;
  const decided = !isPotential
    || anyToggle
    || data.serviceUnresolved === true;
  // When Potential ⇒ vendor turns on a service ⇒ we need full customer
  // info (the step 3 simplified form did not collect it). Gate submit
  // on customer name + address when that happens.
  const needCustomerForPotential = isPotential && anyToggle;
  const customerComplete = !needCustomerForPotential
    || !!(data.clientName && data.address);
  const canSubmit = decided && customerComplete;
  return (
    <div className="wiz-shell">
      <div className="wiz-progress"><div className="wiz-progress-bar" style={{ width: '100%' }} /></div>
      <div className="wiz-body">
        <div className="wiz-stepnum" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{L('review.eyebrow')}</span>
          {isMobile && (!hideSaveDraft || !hideEstimates) && (
            <button
              type="button"
              onClick={() => setOverflowOpen(true)}
              aria-label="More actions"
              title="More actions"
              className="btn ghost"
              style={{ padding: 4, fontSize: 20, lineHeight: 1, color: '#0a2240' }}
            >⋮</button>
          )}
        </div>
        <h1 className="wiz-title">{L('review.title')}</h1>
        <p className="wiz-sub">{L('review.subtitle')}</p>

        {isPotential && (
          <DecisionTimeBlock
            data={data}
            pricing={pricing}
            toggles={toggles}
            setToggle={setToggle}
            cabCount={cabs.length}
            onMarkUnresolved={() => setData(d => ({
              ...d,
              // Keep serviceMode='potential' so admin sees an unresolved
              // chip; clear toggles + flag the order for Precision follow-up.
              serviceToggles: null,
              serviceUnresolved: true,
            }))}
            unresolved={data.serviceUnresolved === true}
          />
        )}

        {needCustomerForPotential && (
          <PotentialCustomerForm data={data} setData={setData} />
        )}

        <ReviewSection title={L('review.section.customer')} onEdit={() => actions.onJump(data.serviceMode === 'none' ? 2 : 3)}>
          <div>{data.clientName || <em style={{ color: 'var(--ink-faint)' }}>(none)</em>}</div>
          <div style={{ fontSize: 12, color: 'var(--ink-soft)' }}>{data.address || ''}</div>
        </ReviewSection>

        <ReviewSection title={L('review.section.timing')} onEdit={() => actions.onJump(5)}>
          <div>{data.completionRequested ? formatDate(data.completionRequested) : 'no date'}</div>
          {data.rush && <span className="status-badge" style={{ '--badge-color': '#b91c1c', fontSize: 10 }}>RUSH</span>}
        </ReviewSection>

        <ReviewSection title={`${L('review.section.cabinets')} (${cabs.length})`} onEdit={() => actions.onJump(6)}>
          {cabs.length === 0 ? (
            <div style={{ color: 'var(--ink-faint)', fontSize: 13 }}>No cabinets added.</div>
          ) : (
            cabs.map((c, i) => (
              <div key={c.id || i} className="wiz-review-cabrow">
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600 }}>
                    Cab {String(i + 1).padStart(2, '0')} · {c.presetCode || `${c.w || '?'}×${c.h || '?'}×${c.d || '?'}`}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--ink-faint)' }}>
                    {c.cabType || 'Standard wall'}{c.boxMaterial ? ' · ' + c.boxMaterial : ''}
                    {c.doors > 0 ? ` · ${c.doors} door${c.doors === 1 ? '' : 's'}${c.doorsRepair ? ' (repair)' : ''}` : ''}
                    {c.drawers > 0 ? ` · ${c.drawers} drawer${c.drawers === 1 ? '' : 's'}${c.drawersRepair ? ' (repair)' : ''}` : ''}
                  </div>
                </div>
                <button className="btn ghost" style={{ padding: 4 }} onClick={() => actions.onEditCab(i)} title="Edit">
                  <Icon.Pencil/>
                </button>
                <button className="btn ghost danger-hover" style={{ padding: 4 }} onClick={() => actions.onRemoveCab(i)} title="Remove">
                  <Icon.Trash/>
                </button>
              </div>
            ))
          )}
        </ReviewSection>

        <ReviewSection title={L('review.section.toeKick')} onEdit={() => actions.onJump(7)}>
          <div style={{ fontSize: 13 }}>
            {data.toeKick?.height ? `${data.toeKick.height}" tall` : '4" tall'}
            {data.toeKick?.setback ? ` · ${data.toeKick.setback}" setback` : ' · 3" setback'}
            {data.toeKick?.linearFt ? ` · ${data.toeKick.linearFt} lf` : ''}
          </div>
        </ReviewSection>

        <ReviewSection title={L('review.section.scribe')} onEdit={() => actions.onJump(8)}>
          <div style={{ fontSize: 13 }}>
            {data.scribe?.needed === 'Yes'
              ? (data.scribe.sticks
                  ? `${data.scribe.sticks} stick${data.scribe.sticks === 1 ? '' : 's'} (8') · matched material`
                  : `${data.scribe.linearFeet || 0} lf · matched material`)
              : 'Not needed'}
          </div>
        </ReviewSection>

        <ReviewSection title={`${L('review.section.addons')} (${(data.addons?.items || []).length})`} onEdit={() => actions.onJump(9)}>
          <div style={{ fontSize: 13, color: 'var(--ink-soft)' }}>
            {data.addons?.needed === 'Yes' && (data.addons.items || []).length > 0
              ? (data.addons.items || []).map((it, i) => (
                  <div key={it.id || i}>
                    • {it.type.replace(/-/g, ' ')}
                    {it.count ? ` × ${it.count}` : ''}
                    {it.sticks ? ` × ${it.sticks} stick${it.sticks === 1 ? '' : 's'}` : ''}
                    {it.description ? ` — ${it.description}` : ''}
                  </div>
                ))
              : 'No add-ons.'}
          </div>
        </ReviewSection>

        <ReviewSection title={L('review.section.special')} onEdit={() => actions.onJump(10)}>
          <div style={{ fontSize: 13, color: 'var(--ink-soft)' }}>{data.specialInstructions || <em>(none)</em>}</div>
        </ReviewSection>

        {!hideEstimates && (
          <div className="wiz-review-block" style={{ background: '#FBF0E1', borderColor: '#0a2240' }}>
            <div className="wiz-review-h">Estimate</div>
            <div className="mono" style={{ fontSize: 28, fontWeight: 700, color: '#0a2240' }}>{fmtMoney(estimate.total)}</div>
            {estimate.rushApplied && <div className="hint" style={{ fontSize: 11, color: '#b91c1c' }}>RUSH upcharge applied.</div>}
            <div className="hint" style={{ fontSize: 11, marginTop: 8, fontStyle: 'italic' }}>
              This is an <strong>estimate</strong>. Actual cost will be calculated after items are built and verified against the order.
            </div>
          </div>
        )}
      </div>
      {isMobile ? (
        <div className="wiz-footer wiz-footer-mobile" style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'stretch' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
            <button className="btn ghost" onClick={actions.onBack}>← Back</button>
            {!hideEstimates && (
              <div className="wiz-runningtotal" style={{ display: 'inline-flex', gap: 6, alignItems: 'baseline' }}>
                <span className="wiz-runningtotal-l">Total</span>
                <span className="wiz-runningtotal-v mono">{fmtMoney(runningTotal)}</span>
              </div>
            )}
          </div>
          {/* Save Draft + Create Retail Estimate next to Submit on
              mobile. When the vendor is configured to hide estimates,
              the Estimate PDF button is dropped and Save Draft fills
              the row. */}
          {(!hideSaveDraft || !hideEstimates) && (
            <div style={{ display: 'grid', gridTemplateColumns: (!hideSaveDraft && !hideEstimates) ? '1fr 1fr' : '1fr', gap: 8 }}>
              {!hideSaveDraft && (
                <button
                  className="btn"
                  style={{ background: '#fff', color: '#0a2240', border: '2px solid #0a2240', fontWeight: 600 }}
                  onClick={actions.onSaveDraft}
                  disabled={actions.savingDraft}
                >{actions.savingDraft ? 'Saving…' : '💾 Save Draft'}</button>
              )}
              {!hideEstimates && (
                <button
                  className="btn"
                  style={{ background: '#C9781B', color: '#fff', border: 0, fontWeight: 600 }}
                  onClick={actions.onInsurance}
                  disabled={!cabs.length}
                >📄 Estimate PDF</button>
              )}
            </div>
          )}
          <button className="btn primary lg"
                  style={{ width: '100%' }}
                  onClick={actions.onSubmit}
                  disabled={actions.submitting || !cabs.length || !canSubmit}
                  title={!decided ? 'Decide on pickup / drop-off / install above before submitting' : (!customerComplete ? 'Add customer name + address above (required when you turn on a service)' : undefined)}>
            {actions.submitting ? submittingLabel : submitLabel}
          </button>
        </div>
      ) : (
        <div className="wiz-footer wiz-footer-multi">
          <button className="btn ghost" onClick={actions.onBack}>← Back</button>
          {!hideEstimates && (
            <div className="wiz-runningtotal">
              <span className="wiz-runningtotal-l">Total</span>
              <span className="wiz-runningtotal-v mono">{fmtMoney(runningTotal)}</span>
            </div>
          )}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {!hideSaveDraft && (
              <button className="btn"
                      style={{ background: '#fff', color: '#0a2240', border: '2px solid #0a2240', fontWeight: 600 }}
                      onClick={actions.onSaveDraft} disabled={actions.savingDraft}>
                {actions.savingDraft ? 'Saving…' : '💾 Save Draft'}
              </button>
            )}
            {!hideEstimates && (
              <button className="btn"
                      style={{ background: '#C9781B', color: '#fff', border: 0, fontWeight: 600 }}
                      onClick={actions.onInsurance} disabled={!cabs.length}>
                📄 Create Retail Estimate
              </button>
            )}
            <button className="btn primary lg"
                    onClick={actions.onSubmit}
                    disabled={actions.submitting || !cabs.length || !canSubmit}
                    title={!decided ? 'Decide on pickup / drop-off / install above before submitting' : (!customerComplete ? 'Add customer name + address above' : undefined)}>
              {actions.submitting ? submittingLabel : submitLabel}
            </button>
          </div>
        </div>
      )}

      {/* Mobile overflow menu — Save Draft + Retail Estimate live here
          so the primary sticky Submit button stays uncluttered. */}
      {isMobile && overflowOpen && (
        Sheet ? (
          <Sheet open onClose={() => setOverflowOpen(false)} title="More actions">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {!hideSaveDraft && (
                <button className="btn"
                        style={{ background: '#fff', color: '#0a2240', border: '2px solid #0a2240', fontWeight: 600 }}
                        onClick={() => { setOverflowOpen(false); actions.onSaveDraft(); }}
                        disabled={actions.savingDraft}>
                  {actions.savingDraft ? 'Saving…' : '💾 Save Draft'}
                </button>
              )}
              {!hideEstimates && (
                <button className="btn"
                        style={{ background: '#C9781B', color: '#fff', border: 0, fontWeight: 600 }}
                        onClick={() => { setOverflowOpen(false); actions.onInsurance(); }}
                        disabled={!cabs.length}>
                  📄 Create Retail Estimate
                </button>
              )}
            </div>
          </Sheet>
        ) : (
          <div className="modal-backdrop" onClick={() => setOverflowOpen(false)}>
            <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 360 }}>
              <h3 style={{ margin: '0 0 12px' }}>More actions</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {!hideSaveDraft && (
                  <button className="btn"
                          style={{ background: '#fff', color: '#0a2240', border: '2px solid #0a2240', fontWeight: 600 }}
                          onClick={() => { setOverflowOpen(false); actions.onSaveDraft(); }}
                          disabled={actions.savingDraft}>
                    {actions.savingDraft ? 'Saving…' : '💾 Save Draft'}
                  </button>
                )}
                {!hideEstimates && (
                  <button className="btn"
                          style={{ background: '#C9781B', color: '#fff', border: 0, fontWeight: 600 }}
                          onClick={() => { setOverflowOpen(false); actions.onInsurance(); }}
                          disabled={!cabs.length}>
                    📄 Create Retail Estimate
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
}

// Decision-time block — only shown on the Review screen when the
// vendor picked "Potential" at step 2. Forces the vendor to choose
// pickup/drop-off/install (or explicitly skip) before submit.
function DecisionTimeBlock({ data, pricing, toggles, setToggle, cabCount, onMarkUnresolved, unresolved }) {
  const pickupRate = pricing?.pickup_flat?.price ?? 0;
  const dropoffRate = pricing?.dropoff_flat?.price ?? 0;
  const installRate = pricing?.install_per_cabinet?.price ?? 0;
  const installIncludesDropoff = !!(pricing?.install_includes_dropoff?.price);
  const Toggle = ({ k, label, sublabel, priceText }) => (
    <button
      type="button"
      onClick={() => setToggle(k, !toggles[k])}
      className={'wiz-bigchip' + (toggles[k] ? ' on' : '')}
      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
    >
      <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
        <div className="wiz-bigchip-l">{label}{toggles[k] ? ' ✓' : ''}</div>
        <div className="wiz-bigchip-d">{sublabel}</div>
      </div>
      <div className="mono" style={{ fontSize: 14, fontWeight: 600, color: 'var(--accent-deep)', marginLeft: 12, whiteSpace: 'nowrap' }}>
        {priceText}
      </div>
    </button>
  );
  const installImplicitDropoff = toggles.install && !installIncludesDropoff;
  return (
    <div className="wiz-review-block" style={{ borderColor: 'var(--accent)', borderWidth: 2, background: 'var(--accent-soft)' }}>
      <div className="wiz-review-h" style={{ color: 'var(--accent-deep)' }}>Decision time</div>
      <p style={{ fontSize: 13, color: 'var(--ink-soft)', margin: '4px 0 14px' }}>
        You marked this order as <strong>Potential</strong> at the start. Before submitting, decide which services to include — toggle each one on or off. Costs are added to the total live.
      </p>
      <div className="wiz-bigchips" style={{ gridTemplateColumns: '1fr' }}>
        <Toggle k="pickup" label="Pickup" sublabel="We pick up the cabinets — flat fee, within 25 mi." priceText={`+ $${pickupRate}`} />
        <Toggle
          k="dropoff"
          label="Drop-off"
          sublabel={installImplicitDropoff
            ? 'We deliver to the jobsite — included with installation when both are on (admin setting).'
            : 'We deliver to the jobsite — flat fee, within 25 mi.'}
          priceText={installImplicitDropoff ? '+ $0' : `+ $${dropoffRate}`}
        />
        <Toggle
          k="install"
          label="Installation"
          sublabel={cabCount > 0 ? `We install at the jobsite — ${cabCount} cabinet${cabCount === 1 ? '' : 's'} × $${installRate}.` : 'We install at the jobsite — per-cabinet rate.'}
          priceText={`+ $${installRate * cabCount}`}
        />
      </div>
      {toggles.install && (
        <div className="hint" style={{ fontSize: 12, marginTop: 8, color: '#C9781B' }}>
          ⓘ Installation is <strong>subject to availability and our installer's schedule</strong>. We'll confirm an install date after the cabinets are built.
        </div>
      )}
      <div style={{ marginTop: 10, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8 }}>
        {unresolved && (
          <span className="status-badge" style={{ '--badge-color': '#C9781B', fontSize: 10 }}>
            UNRESOLVED — Precision will follow up
          </span>
        )}
        <button
          className="btn ghost"
          onClick={onMarkUnresolved}
          type="button"
          title="Keep the order flagged as 'service mode unresolved' — Precision admins will contact you to confirm pickup / drop-off / install."
        >
          {unresolved ? 'Marked — Precision will contact you' : 'None — Precision will contact me'}
        </button>
      </div>
    </div>
  );
}

// Inline customer form rendered on the Review screen when the vendor
// originally picked "Potential" at step 2 AND has now flipped on
// pickup / drop-off / install in the Decision block. The simplified
// step-3 form did not collect customer contact info, so we need it
// here before the order can be submitted.
function PotentialCustomerForm({ data, setData }) {
  return (
    <div className="wiz-review-block" style={{ borderColor: '#b91c1c', borderWidth: 2, background: '#fff' }}>
      <div className="wiz-review-h" style={{ color: '#b91c1c' }}>Customer info required</div>
      <p style={{ fontSize: 13, color: 'var(--ink-soft)', margin: '4px 0 14px' }}>
        Since you're now adding a Precision service to this order, we need the homeowner's contact and address.
      </p>
      <div className="v-fields">
        <div className="v-field full">
          <label>Customer name <span style={{ color: '#b91c1c' }}>*</span></label>
          <input className="input" value={data.clientName || ''}
                 autoCapitalize="words"
                 onChange={e => setData(d => ({ ...d, clientName: e.target.value }))} />
        </div>
        <div className="v-field full">
          <label>Job-site address <span style={{ color: '#b91c1c' }}>*</span></label>
          <input className="input" value={data.address || ''}
                 placeholder="123 Main St, City"
                 autoCapitalize="words" autoComplete="street-address"
                 onChange={e => setData(d => ({ ...d, address: e.target.value }))} />
        </div>
        <div className="v-field">
          <label>Customer phone</label>
          <input className="input mono" value={data.clientPhone || ''}
                 type="tel" inputMode="tel" autoComplete="tel" maxLength={14}
                 placeholder="(480) 555-0142"
                 onChange={e => setData(d => ({ ...d, clientPhone: window.formatPhoneInput(e.target.value) }))} />
        </div>
        <div className="v-field">
          <label>Customer email</label>
          <input className="input" value={data.clientEmail || ''}
                 type="email" inputMode="email"
                 autoCapitalize="none" autoCorrect="off" autoComplete="email"
                 onChange={e => setData(d => ({ ...d, clientEmail: e.target.value }))} />
        </div>
      </div>
    </div>
  );
}

function ReviewSection({ title, onEdit, children }) {
  return (
    <div className="wiz-review-block">
      <div className="wiz-review-row">
        <div className="wiz-review-h">{title}</div>
        <button className="btn ghost" style={{ padding: '2px 8px', fontSize: 11 }} onClick={onEdit}>
          <Icon.Pencil/> Edit
        </button>
      </div>
      <div>{children}</div>
    </div>
  );
}

// ---------- Confirm modal ----------

function RushConfirmModal({ days, threshold, upcharge, onAccept, onDecline }) {
  const display = Math.round(upcharge || 0);
  const Sheet = getBottomSheet();
  const body = (
    <>
      <h3 style={{ margin: '0 0 4px' }}>Rush date — please confirm</h3>
      <p>The completion date you picked is <strong>{days} day{days === 1 ? '' : 's'}</strong> from today, inside our <strong>{threshold}-day</strong> rush window.</p>
      {display > 0 ? (
        <>
          <p>This order will include a <strong>${display}</strong> rush upcharge. By continuing you acknowledge the rush cost so it doesn't surprise you at the end.</p>
          <div className="hint" style={{ fontSize: 11, color: 'var(--ink-faint)' }}>
            Calculated as the greater of the flat rush fee or the % of subtotal — whichever is higher.
          </div>
        </>
      ) : (
        <p>Order will be flagged <strong>RUSH</strong>. Rush pricing isn't configured yet, so no upcharge applies — but production will be moved to the front of the queue.</p>
      )}
      <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <button className="btn ghost" onClick={onDecline}>Pick a later date</button>
        <button className="btn primary" onClick={onAccept}>
          {display > 0 ? `Acknowledge — add $${display} rush` : 'Acknowledge — flag as RUSH'}
        </button>
      </div>
    </>
  );
  if (Sheet) {
    return (
      <Sheet open onClose={onDecline} title="Rush confirmation">
        {body}
      </Sheet>
    );
  }
  // Fallback to the inline modal when bottom-sheet.jsx hasn't loaded.
  return (
    <div className="modal-backdrop" onClick={onDecline}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420 }}>
        {body}
      </div>
    </div>
  );
}

// ---------- Wizard root ----------

// Tiny "Saved · 4:32 PM" chip that the wizard surfaces in its header.
// Reads window.PC_AUTO_SAVED_AT every second so vendors get continuous
// feedback that the draft is persisting — important on phones where
// people half-fill a form, lock the screen, and come back unsure.
function WizardSavedChip() {
  const [savedAt, setSavedAt] = uS(() => {
    const v = (typeof window !== 'undefined') ? window.PC_AUTO_SAVED_AT : null;
    return v instanceof Date ? v : (v ? new Date(v) : null);
  });
  uE(() => {
    if (typeof window === 'undefined') return;
    const tick = () => {
      const v = window.PC_AUTO_SAVED_AT;
      if (!v) { setSavedAt(null); return; }
      const next = v instanceof Date ? v : new Date(v);
      setSavedAt(prev => {
        if (prev && next && prev.getTime() === next.getTime()) return prev;
        return next;
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  if (!savedAt) return null;
  return (
    <span className="wiz-saved-chip" style={{
      fontSize: 11,
      color: 'var(--ink-soft)',
      padding: '2px 8px',
      borderRadius: 999,
      background: 'rgba(22,163,74,0.08)',
      whiteSpace: 'nowrap',
    }}>
      Saved · {savedAt.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}
    </span>
  );
}

// Sticky banner used to host the autosave chip above each step. Position
// is fixed so it sits above the wizard's own scrolling body — the chip
// height is small enough that it doesn't crowd content.
function WizardHeaderBanner() {
  return (
    <div className="wiz-header-banner" style={{
      position: 'sticky',
      top: 0,
      zIndex: 5,
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '6px 12px 0',
      pointerEvents: 'none',
    }}>
      <div style={{ pointerEvents: 'auto' }}>
        <WizardSavedChip />
      </div>
    </div>
  );
}

function IntakeWizard({ vendor, data, setData, pricing, onSubmit, onSaveDraft, onInsurancePreview, submitting, savingDraft, sc, hideEstimates, submitLabel, hideSaveDraft }) {
  const [step, setStep] = uS(1);
  const [rushPrompt, setRushPrompt] = uS(null);
  const [editingCabIdx, setEditingCabIdx] = uS(0);
  const [showCabinetHelp, setShowCabinetHelp] = uS(false);
  // First-time auto-show: show the cabinet-walkthrough sheet once when the
  // vendor first lands on step 6 (per browser, per device — localStorage).
  // Dismiss persists so it doesn't reappear later.
  uE(() => {
    if (step !== 6) return;
    try {
      const k = 'pc.cabinetHelpSeen.v1';
      if (typeof localStorage !== 'undefined' && !localStorage.getItem(k)) {
        setShowCabinetHelp(true);
      }
    } catch {}
  }, [step]);
  const dismissCabinetHelp = () => {
    setShowCabinetHelp(false);
    try { localStorage.setItem('pc.cabinetHelpSeen.v1', '1'); } catch {}
  };
  const cabs = data.cabinets || [];

  // Scroll-to-top on every step transition (forward OR back OR revisit).
  // Previously the page kept the prior step's scroll position, so
  // advancing from a long step landed the user halfway down the next
  // step — they thought the new step started somewhere off-screen.
  uE(() => {
    try {
      window.scrollTo({ top: 0, behavior: 'auto' });
      // Also reset the wizard body's own scroll if it scrolls internally.
      const body = document.querySelector('.wiz-body');
      if (body && typeof body.scrollTo === 'function') body.scrollTo({ top: 0, behavior: 'auto' });
    } catch {}
  }, [step]);

  // Helper to wrap each step's render with the sticky header banner.
  // Returning a Fragment keeps the existing wiz-shell layout intact.
  const withHeader = (children) => (
    <>
      <WizardHeaderBanner />
      {children}
    </>
  );

  const TOTAL_STEPS = 11;
  // Step 3 is now ALWAYS shown — but the form it renders depends on the
  // serviceMode picked at step 2:
  //   - 'multi' (Yes): full customer info (name + address required).
  //   - 'none' / 'potential': simplified job-site form (Job # + optional
  //     jobsite address). No skip — vendor still needs a reference for
  //     the work order.
  // (skipsCustomer kept as `false` so the old skip-to-step-4 path no
  // longer fires.)
  const skipsCustomer = false;
  // For 'multi' (Yes branch), we need at least one toggle on before we
  // know the vendor actually decided.
  const multiNoToggle = data.serviceMode === 'multi' &&
    !(data.serviceToggles?.pickup || data.serviceToggles?.dropoff || data.serviceToggles?.install);
  // Mirror the same predicate the CustomerStep uses to decide its mode —
  // the canAdvance() rules below need to match.
  const needsFullCustomer = data.serviceMode === 'multi'
    || (data.serviceMode == null && data.installNeeded === 'Yes');

  // Live estimate for the running total + review screen.
  const estimate = uM(() => {
    try { return computeEstimate(data, pricing || {}); } catch { return { total: 0, lineItems: [] }; }
  }, [data, pricing]);

  // Create the first cabinet ONCE when entering step 6. Doing this in
  // a useEffect (not during render) prevents the previous bug where
  // multiple ghost cabinets were added.
  uE(() => {
    if (step === 6 && cabs.length === 0) {
      const next = makeCabinet(1);
      setData(d => ({ ...d, cabinets: [next] }));
      setEditingCabIdx(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const canAdvance = () => {
    if (step === 1) return !!(data.vendorPhone && data.vendorPhone.trim());
    if (step === 2) {
      // Top-level pick required. For 'multi' (Yes), require ≥1 toggle on.
      const m = data.serviceMode;
      if (m === 'none' || m === 'potential') return true;
      if (m === 'multi') return !multiNoToggle;
      // Legacy single-value modes from older drafts also count as decided.
      if (m === 'pickup' || m === 'dropoff' || m === 'install') return true;
      // Legacy installNeeded with no serviceMode: 'No' / 'Potential' OK.
      if (data.installNeeded === 'No' || data.installNeeded === 'Potential') return true;
      return false;
    }
    if (step === 3) {
      // Full customer mode: name + address required (as before).
      // Simplified mode (no/potential): Precision won't visit the home, so a
      // PO / Job # is the required identifier instead of customer info.
      if (needsFullCustomer) return !!(data.clientName && data.address);
      return !!(data.vendorPO && String(data.vendorPO).trim());
    }
    if (step === 5) return !!data.completionRequested;
    return true;
  };

  const goNext = () => {
    if (step === 1 && !canAdvance()) return;
    if (step === 2) {
      setStep(skipsCustomer ? 4 : 3);
      return;
    }
    if (step === 3 && !canAdvance()) return;
    setStep(s => Math.min(TOTAL_STEPS, s + 1));
  };
  const goBack = () => {
    if (step === 4 && skipsCustomer) { setStep(2); return; }
    setStep(s => Math.max(1, s - 1));
  };

  // Cabinet edits accept a PATCH (partial cab fields) and merge
  // functionally against the LATEST state — never against the closure-
  // captured cabs/cab. Two rapid updates that used to spread the same
  // stale snapshot (e.g. the visited-set useEffect firing right when
  // the vendor picks a Box Material) would otherwise have the second
  // overwrite the first, losing the field change.
  const updateCab = (idx, patch) => {
    setData(d => {
      const list = [...(d.cabinets || [])];
      if (!list[idx]) return d;
      list[idx] = { ...list[idx], ...patch };
      return { ...d, cabinets: list };
    });
  };
  const addCab = () => {
    const newCab = makeCabinet(cabs.length + 1);
    const next = [...cabs, newCab];
    setData(d => ({ ...d, cabinets: next }));
    setEditingCabIdx(next.length - 1);
  };
  // Duplicate the currently-edited cabinet — copy every field except
  // id + photos (Storage refs are shared by URL; we don't want one
  // cab's delete to nuke the other's image). Visited-set pre-filled
  // so the duplicate's section indicators reflect the pre-populated
  // data. Called from both the header banner and the footer button
  // pair so vendors discover it from either spot.
  const duplicateCab = () => {
    const src = cabs[editingCabIdx];
    if (!src || !src.cabType) return;
    const dup = {
      ...src,
      id: 'cab_' + Date.now() + '_dup',
      photos: [],
      photo: null,
      annotations: [],
      noPhotoChosen: false,
      visitedSubSteps: Array.from({ length: SUB_TITLE_KEYS.length }, (_, i) => i),
    };
    setData(d => ({ ...d, cabinets: [...(d.cabinets || []), dup] }));
    setEditingCabIdx(cabs.length);
  };
  const removeCab = (idx) => {
    const next = cabs.filter((_, i) => i !== idx);
    setData(d => ({ ...d, cabinets: next }));
    if (editingCabIdx >= next.length) setEditingCabIdx(Math.max(0, next.length - 1));
  };
  const goEditCab = (i) => {
    setEditingCabIdx(i);
    setStep(6);
  };

  const stepProps = {
    step, total: TOTAL_STEPS,
    runningTotal: estimate.total,
  };

  // ---- Render the right step ----
  if (step === 1) return withHeader(
    <VendorContactStep data={data} setData={setData} vendor={vendor}
      {...stepProps} onBack={null} onNext={goNext} nextDisabled={!canAdvance()} />
  );
  if (step === 2) return withHeader(
    <ServiceTypeStep data={data} setData={setData} pricing={pricing}
      {...stepProps} onBack={goBack} onNext={goNext} nextDisabled={!canAdvance()} />
  );
  if (step === 3) return withHeader(
    <CustomerStep data={data} setData={setData}
      {...stepProps} onBack={goBack} onNext={goNext} nextDisabled={!canAdvance()} />
  );
  if (step === 4) return withHeader(
    <PropertyStep data={data} setData={setData} pricing={pricing}
      {...stepProps} onBack={goBack} onNext={goNext} />
  );
  if (step === 5) return withHeader(
    <>
      <TimingStep data={data} setData={setData} pricing={pricing} sc={sc} estimate={estimate}
        {...stepProps} onBack={goBack} onNext={goNext}
        onConfirmRush={(info) => setRushPrompt(info)} />
      {rushPrompt && (
        <RushConfirmModal {...rushPrompt}
          onAccept={() => {
            // Vendor acknowledged the rush upcharge. Stamp rushAck so a
            // future Next press passes through without re-prompting, then
            // advance to step 6.
            setData(d => ({ ...d, rush: true, rushAck: true }));
            setRushPrompt(null);
            setStep(6);
          }}
          onDecline={() => {
            // Decline → STAY on step 5 so the vendor can push the date
            // out of the rush window. Don't change rush state; the date
            // gate will re-prompt if they try Next again.
            setRushPrompt(null);
          }} />
      )}
    </>
  );
  if (step === 6) {
    if (cabs.length === 0) {
      // useEffect will create the first cabinet on the next tick.
      return withHeader(<div className="wiz-shell"><div className="wiz-body"><p>Loading…</p></div></div>);
    }
    const cab = cabs[editingCabIdx] || cabs[0];
    // Build the human-readable chip label: "Cab 02 · Vanity 36\"" so a
    // vendor with five cabinets can tell them apart at a glance without
    // tapping each one. Falls back gracefully when type/width are blank.
    const cabChipLabel = (c, i) => {
      const num = `Cab ${String(i + 1).padStart(2, '0')}`;
      const type = c?.cabType || '—';
      const w = c?.w ? `${c.w}"` : '';
      return `${num} · ${type}${w ? ' ' + w : ''}`;
    };
    // Per-cabinet completion ratio — visible on the chip so a vendor
    // with five cabinets sees at a glance which ones are still in
    // progress. A green check replaces the ratio once all sections are
    // done. Mirrors the subStepComplete logic; visited-set isn't
    // available here so we approximate by treating "complete" alone as
    // "done" — close enough for an at-a-glance signal.
    const cabCompletion = (c) => {
      let done = 0;
      for (let i = 0; i < SUB_TITLE_KEYS.length; i++) {
        if (subStepComplete(i, c || {})) done++;
      }
      return { done, total: SUB_TITLE_KEYS.length };
    };
    return withHeader(
      <div className="wiz-shell">
        <div className="wiz-progress"><div className="wiz-progress-bar" style={{ width: `${(6 / TOTAL_STEPS) * 100}%` }} /></div>
        <div className="wiz-body">
          <div className="wiz-stepnum">Step 6 of {TOTAL_STEPS}</div>
          <h1 className="wiz-title">{L('cabinets.title')}</h1>
          <p className="wiz-sub">{L('cabinets.subtitle')}</p>
          <div style={{ marginTop: -4, marginBottom: 12 }}>
            <button
              type="button"
              className="btn ghost"
              style={{ fontSize: 13, padding: '6px 10px', display: 'inline-flex', alignItems: 'center', gap: 6 }}
              onClick={() => setShowCabinetHelp(true)}
            >
              ⓘ How to fill out a cabinet
            </button>
          </div>
          {showCabinetHelp && (() => {
            const Sheet = (typeof window !== 'undefined' && window.BottomSheet) ? window.BottomSheet : null;
            const body = (
              <div style={{ fontSize: 14, lineHeight: 1.55, whiteSpace: 'pre-line', color: 'var(--ink)' }}>
                {L('cabinets.help.body')}
                <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                  <button className="btn primary" onClick={dismissCabinetHelp}>Got it</button>
                </div>
              </div>
            );
            return Sheet ? (
              <Sheet open onClose={dismissCabinetHelp} title={L('cabinets.help.title')}>{body}</Sheet>
            ) : (
              <div className="modal-backdrop" onClick={dismissCabinetHelp}>
                <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }}>
                  <h3 style={{ margin: '0 0 12px' }}>{L('cabinets.help.title')}</h3>
                  {body}
                </div>
              </div>
            );
          })()}
          {(() => {
            const cur = cabs[editingCabIdx] || {};
            const { done, total } = cabCompletion(cur);
            const allDone = done === total;
            return (
              <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                flexWrap: 'wrap', gap: 8, marginBottom: 10,
                padding: '8px 12px', background: '#FBF0E1',
                border: '1px solid var(--accent-soft)', borderRadius: 8,
              }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink)' }}>
                  Cabinet {editingCabIdx + 1} of {cabs.length}
                  <span style={{
                    marginLeft: 8, fontWeight: 'normal',
                    color: allDone ? '#16a34a' : 'var(--ink-soft)',
                  }}>
                    {allDone ? '✓ All sections complete' : `${done} / ${total} sections complete`}
                  </span>
                </div>
                <button
                  type="button"
                  className="btn ghost"
                  style={{ fontSize: 12, padding: '4px 10px' }}
                  onClick={duplicateCab}
                  title="Create a new cabinet pre-filled with this cabinet's data (location, type, dimensions, doors / drawers, material). Photos start empty."
                  disabled={!cur.cabType}
                >
                  📋 Duplicate
                </button>
              </div>
            );
          })()}
          {cabs.length > 1 && (
            <div className="wiz-cabnav">
              {cabs.map((c, i) => {
                const { done, total } = cabCompletion(c);
                const isDone = done === total;
                return (
                  <button key={c.id || i}
                          className={'wiz-cabnav-chip' + (i === editingCabIdx ? ' on' : '') + (isDone ? ' wiz-cabnav-chip-done' : '')}
                          onClick={() => setEditingCabIdx(i)}
                          title={cabChipLabel(c, i) + ` · ${done}/${total}`}>
                    <span style={{ color: isDone ? '#16a34a' : 'inherit', marginRight: 4 }}>
                      {isDone ? '✓' : `${done}/${total}`}
                    </span>
                    {cabChipLabel(c, i)}
                  </button>
                );
              })}
            </div>
          )}
          <CabinetSubWizard
            key={cab.id}
            cab={cab}
            idx={editingCabIdx}
            total={cabs.length}
            pricing={pricing}
            onChange={(patch) => updateCab(editingCabIdx, patch)}
            onBackToPrev={() => {
              if (editingCabIdx === 0) goBack();
              else setEditingCabIdx(i => Math.max(0, i - 1));
            }}
            onAddAnother={addCab}
            onDuplicate={duplicateCab}
            onDoneAdding={async () => {
              const ok = await bsConfirmCompat({
                title: 'Done adding cabinets?',
                body: L('cabinets.confirm.allAdded'),
                confirmLabel: 'Yes, continue',
                cancelLabel: 'Keep adding',
              });
              if (ok) setStep(7);
            }}
            onDelete={() => {
              removeCab(editingCabIdx);
              // If that was the last cabinet, drop back to step 5 so the
              // useEffect at step 6 can seed a fresh first cabinet.
              if (cabs.length <= 1) {
                setStep(5);
              }
            }}
          />
        </div>
        <div className="wiz-footer">
          <button className="btn ghost" onClick={goBack}>{L('cabinets.button.backToTiming')}</button>
          <div className="wiz-runningtotal">
            <span className="wiz-runningtotal-l">{L('shared.runningTotal')}</span>
            <span className="wiz-runningtotal-v mono">{fmtMoney(estimate.total)}</span>
          </div>
          {/* Skip-to-toe-kick removed — vendors must hit Done Adding inside
              the cabinet accordion to proceed. A spacer keeps the
              running-total chip centered between Back and the edge. */}
          <span style={{ width: 64 }} aria-hidden="true" />
        </div>
      </div>
    );
  }
  if (step === 7) return withHeader(
    <ToeKickStep data={data} setData={setData} pricing={pricing}
      {...stepProps} onBack={() => setStep(6)} onNext={goNext} />
  );
  if (step === 8) return withHeader(
    <ScribeStep data={data} setData={setData}
      {...stepProps} onBack={goBack} onNext={goNext} />
  );
  if (step === 9) return withHeader(
    <AddonsStep data={data} setData={setData} pricing={pricing}
      {...stepProps} onBack={goBack} onNext={goNext} />
  );
  if (step === 10) return withHeader(
    <SpecialStep data={data} setData={setData}
      {...stepProps} onBack={goBack} onNext={goNext} />
  );
  // Step 11 — Review
  return withHeader(
    <ReviewStep data={data} setData={setData} pricing={pricing}
      estimate={estimate} runningTotal={estimate.total}
      hideEstimates={hideEstimates}
      onBack={() => setStep(10)}
      onJump={(s) => setStep(s)}
      onEditCab={goEditCab}
      onRemoveCab={removeCab}
      onSubmit={onSubmit} onSaveDraft={onSaveDraft} onInsurance={onInsurancePreview}
      submitting={submitting} savingDraft={savingDraft}
      submitLabel={submitLabel} hideSaveDraft={hideSaveDraft} />
  );
}

Object.assign(window, { IntakeWizard });

})();

// ===== dashboard.jsx =====
(function(){
// Vendor Dashboard — shows orders, balance, history
const { useState: useSt, useEffect: useEf, useMemo: useMe } = React;

// Service-mode-aware statuses share the first three slots (New / Received /
// In Production); the last two depend on whether Precision is delivering,
// installing, or holding for vendor pickup. Legacy values are kept so
// orders submitted before Phase 3 still render with sensible labels.
const STATUS_LABELS = {
  new: 'New',
  received: 'Received',
  in_production: 'In Production',
  ready_for_pickup: 'Ready for Pickup',
  picked_up: 'Picked Up',
  ready_for_delivery: 'Ready for Delivery',
  ready_for_install: 'Ready for Install',
  installed: 'Installed',
  // Legacy
  complete: 'Complete',
  delivered: 'Delivered',
};

const STATUS_COLORS = {
  new: '#3b82f6',
  received: '#f59e0b',
  in_production: '#f97316',
  ready_for_pickup: '#8b5cf6',
  picked_up: '#94a3b8',
  ready_for_delivery: '#8b5cf6',
  ready_for_install: '#8b5cf6',
  installed: '#22c55e',
  complete: '#22c55e',
  delivered: '#94a3b8',
};

function StatusBadge({ status }) {
  const color = STATUS_COLORS[status] || '#94a3b8';
  return (
    <span className="status-badge" style={{ '--badge-color': color }}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

function VendorDashboard({ vendorId, vendorName, contactName, onNewOrder, onViewOrder, hideEstimates }) {
  const [orders, setOrders] = useSt([]);
  const [loading, setLoading] = useSt(true);
  const [filter, setFilter] = useSt('active'); // 'all' | 'active' | 'complete' | 'delivered' | 'drafts'

  useEf(() => {
    if (!vendorId) return;
    // Cap the listener: dashboard only needs the recent set. Vendors who hit
    // 50 orders can drill into Order Detail or use the History filter for
    // older ones. Without this we stream every order's full doc (including
    // base64 cabinet photos) on first paint — easily 30+ MB on heavy vendors.
    const DASH_LIMIT = 50;
    const unsub = db.collection('orders')
      .where('vendorId', '==', vendorId)
      .orderBy('createdAt', 'desc')
      .limit(DASH_LIMIT)
      .onSnapshot((snap) => {
        const list = snap.docs.map(d => {
          const data = d.data();
          // Strip heavy per-cabinet base64 photo + annotation payloads —
          // dashboard only reads `cabinets.length`. Anything that needs
          // the full photo (order detail, retail markup) re-reads the doc.
          const slimCabinets = Array.isArray(data.cabinets)
            ? data.cabinets.map(() => ({}))
            : data.cabinets;
          return { id: d.id, ...data, cabinets: slimCabinets };
        });
        setOrders(list);
        setLoading(false);
      }, (err) => {
        console.error('Error loading orders:', err);
        setLoading(false);
      });
    return () => unsub();
  }, [vendorId]);

  const filtered = useMe(() => {
    // Drafts are scoped to their own filter — they should NOT appear
    // in 'all' / 'active' since they aren't real orders yet.
    const realOrders = orders.filter(o => o.status !== 'draft');
    if (filter === 'all') return realOrders;
    if (filter === 'active') return realOrders.filter(o => ['new', 'received', 'in_production'].includes(o.status));
    if (filter === 'complete') return realOrders.filter(o => ['complete', 'ready_for_pickup', 'ready_for_delivery', 'ready_for_install'].includes(o.status));
    if (filter === 'delivered') return realOrders.filter(o => ['delivered', 'picked_up', 'installed'].includes(o.status));
    if (filter === 'drafts') return orders.filter(o => o.status === 'draft');
    return realOrders;
  }, [orders, filter]);

  const draftCount = useMe(() => orders.filter(o => o.status === 'draft').length, [orders]);
  // Most recently touched draft — surfaced via a "Continue last draft"
  // banner so vendors don't lose track of in-progress work. Sorts by
  // updatedAt desc (falls back to createdAt) and grabs the first draft.
  // Filters out any draft missing an id (defensive — would otherwise
  // navigate to /drafts/undefined and 404).
  const lastDraft = useMe(() => {
    const drafts = orders.filter(o => o.status === 'draft' && !!o.id);
    if (drafts.length === 0) return null;
    const ts = (o) => {
      const t = o.updatedAt || o.createdAt || 0;
      if (typeof t === 'number') return t;
      if (t && typeof t.toMillis === 'function') return t.toMillis();
      if (typeof t === 'string') { const d = Date.parse(t); return isNaN(d) ? 0 : d; }
      return 0;
    };
    return [...drafts].sort((a, b) => ts(b) - ts(a))[0];
  }, [orders]);

  // Outstanding excludes drafts AND new orders. An order only counts as
  // outstanding once Precision has taken possession (received or beyond)
  // per the 5-29 enhancements: "outstanding is for all projects that
  // are in the status of received or beyond".
  const OUTSTANDING_STATUSES = new Set([
    'received', 'in_production',
    'complete', 'delivered',                      // legacy
    'ready_for_pickup', 'picked_up',
    'ready_for_delivery',
    'ready_for_install', 'installed',
  ]);
  const outstanding = useMe(() => {
    return orders
      .filter(o => OUTSTANDING_STATUSES.has(o.status) && !o.paid)
      .reduce((sum, o) => sum + (o.estimate?.total || 0), 0);
  }, [orders]);

  const paidTotal = useMe(() => {
    return orders.filter(o => o.paid).reduce((sum, o) => sum + (o.estimate?.total || 0), 0);
  }, [orders]);

  const FINAL_STATUSES = new Set(['picked_up', 'delivered', 'installed']);
  const activeCount = orders.filter(o => !FINAL_STATUSES.has(o.status) && o.status !== 'draft').length;

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner"></div>
        <p>Loading your orders...</p>
      </div>
    );
  }

  return (
    <div className="dashboard" style={{ paddingBottom: 120 }}>
      <style>{`
        @media (max-width: 520px) {
          .dash-order-meta { flex-direction: column !important; align-items: flex-start !important; gap: 4px !important; }
        }
      `}</style>
      <header className="dash-header">
        <div className="dash-tagline">Precision Cabinets LLC</div>
        <div className="dash-row">
          <div className="dash-row-left">
            <h1 className="dash-title">{vendorName || 'Vendor portal'}</h1>
            <p className="dash-sub">{contactName ? `${contactName} · ` : ''}Vendor portal</p>
          </div>
          <div className="dash-avatar" aria-hidden="true">
            {(contactName || vendorName || 'V').split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase()}
          </div>
        </div>
      </header>
      {/* Bottom-bar New Order CTA — replaces the floating circle FAB.
          Full-width amber bar at the bottom of the viewport so vendors
          can never miss the "start a new order" action. Cream-to-
          transparent gradient above it blends into the orders list. */}
      <div
        className="dash-new-order-bar"
        style={{
          position: 'fixed',
          left: 0, right: 0,
          bottom: 0,
          padding: '14px 18px calc(18px + var(--safe-bottom))',
          background: 'linear-gradient(to top, var(--bg) 70%, rgba(247,245,240,0))',
          zIndex: 50,
          pointerEvents: 'none',
        }}
      >
        <button
          type="button"
          onClick={onNewOrder}
          style={{
            pointerEvents: 'auto',
            width: '100%',
            height: 58,
            border: 'none',
            borderRadius: 16,
            background: 'var(--accent)',
            color: '#fff',
            fontFamily: 'var(--sans)',
            fontWeight: 700,
            fontSize: 17,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            boxShadow: '0 10px 24px rgba(201,120,27,.34)',
          }}
        >
          <span style={{ fontSize: 22, lineHeight: 0, fontWeight: 700 }}>+</span>
          Start new work order
        </button>
      </div>

      <div className="dash-cards">
        {!hideEstimates && (
          <div className="dash-card dash-card-hero">
            <div className="dash-card-label">Outstanding</div>
            <div className="dash-card-value" style={{ color: 'var(--accent)' }}>{fmtMoney(outstanding)}</div>
            <div className="dash-card-sub">{activeCount} active order{activeCount !== 1 ? 's' : ''} in production</div>
          </div>
        )}
        {!hideEstimates && (
          <div className="dash-card">
            <div className="dash-card-label">Paid</div>
            <div className="dash-card-value" style={{ color: 'var(--success)' }}>{fmtMoney(paidTotal)}</div>
            <div className="dash-card-sub">{orders.filter(o => o.paid).length} paid</div>
          </div>
        )}
        <div className="dash-card">
          <div className="dash-card-label">Total Orders</div>
          <div className="dash-card-value">{orders.length}</div>
          <div className="dash-card-sub">all time</div>
        </div>
        {hideEstimates && (
          <div className="dash-card">
            <div className="dash-card-label">Active</div>
            <div className="dash-card-value">{activeCount}</div>
            <div className="dash-card-sub">in progress</div>
          </div>
        )}
      </div>

      {lastDraft && lastDraft.id && (
        <button
          type="button"
          onClick={() => navigate('/drafts/' + lastDraft.id)}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            gap: 12, width: '100%', textAlign: 'left',
            padding: '12px 16px', marginBottom: 12,
            background: 'var(--accent-soft, #FBF0E1)',
            border: '1px solid var(--accent, #C9781B)',
            borderRadius: 10, cursor: 'pointer',
            color: 'var(--ink)',
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: 'var(--accent-deep, #92400e)', fontWeight: 600, letterSpacing: 0.4, textTransform: 'uppercase' }}>
              {draftCount > 1 ? `${draftCount} drafts in progress` : 'Draft in progress'}
            </div>
            <div style={{ fontSize: 15, fontWeight: 600, marginTop: 2 }}>
              Continue last draft
              {lastDraft.clientName ? ` — ${lastDraft.clientName}` : ''}
            </div>
            <div style={{ fontSize: 12, color: 'var(--ink-soft)' }}>
              {Array.isArray(lastDraft.cabinets) && lastDraft.cabinets.length > 0
                ? `${lastDraft.cabinets.length} cabinet${lastDraft.cabinets.length === 1 ? '' : 's'} so far`
                : 'No cabinets added yet'}
            </div>
          </div>
          <div style={{ fontSize: 18, color: 'var(--accent-deep, #92400e)', flexShrink: 0 }}>→</div>
        </button>
      )}

      <div className="dash-filter-row">
        {['active', 'complete', 'delivered', 'drafts', 'all'].map(f => (
          <button key={f} type="button" className={'dash-filter-chip' + (filter === f ? ' active' : '')} onClick={() => setFilter(f)}>
            {f === 'all' ? 'All'
              : f === 'active' ? 'Active'
              : f === 'complete' ? 'Ready'
              : f === 'delivered' ? 'History'
              : `Drafts${draftCount > 0 ? ` (${draftCount})` : ''}`}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="dash-empty">
          <p>
            {filter === 'active' ? 'No active orders.'
              : filter === 'complete' ? 'No orders ready for pickup.'
              : filter === 'delivered' ? 'No past orders yet.'
              : filter === 'drafts' ? 'No saved drafts. Start a new order and click "Save as Draft" to keep your work.'
              : 'No orders yet.'}
          </p>
          {filter !== 'all' && <button className="btn ghost" onClick={() => setFilter('all')}>Show all orders</button>}
        </div>
      ) : (
        <div className="dash-orders-list">
          {filtered.map(order => {
            const isDraft = order.status === 'draft';
            const open = () => isDraft ? navigate('/drafts/' + order.id) : onViewOrder(order.id);
            const openRetail = (e) => {
              e.stopPropagation();
              navigate('/drafts/' + order.id + '/retail');
            };
            const lastMarkup = (order.markupHistory && order.markupHistory.length > 0)
              ? order.markupHistory[order.markupHistory.length - 1] : null;
            // Show the quick retail-estimate button only on drafts that
            // have at least one cabinet AND have been opened in the
            // retail wizard before (markupHistory non-empty). For drafts
            // that haven't generated one yet, the user opens the draft
            // and clicks the button there.
            const showRetailQuick = !hideEstimates && isDraft && lastMarkup && (order.cabinets || []).length > 0;
            return (
              <div
                key={order.id}
                className="dash-order-row"
                role="button"
                tabIndex={0}
                onClick={open}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
                style={{ minHeight: 56, cursor: 'pointer' }}
              >
                <div className="dash-order-num mono">{isDraft ? 'DRAFT' : (order.orderNumber || '—')}</div>
                <div className="dash-order-info">
                  <div className="dash-order-client">{order.clientName || 'No customer'}</div>
                  <div className="dash-order-addr">{order.address || ''}</div>
                </div>
                <div className="dash-order-meta">
                  <div style={{ display: 'flex', gap: 4, alignItems: 'center', flexWrap: 'wrap' }}>
                    <StatusBadge status={order.status} />
                    {order.paid && <span className="status-badge" style={{ '--badge-color': '#22c55e', fontSize: 11 }}>PAID</span>}
                    {showRetailQuick && (
                      <button
                        type="button"
                        className="dash-retail-quick"
                        onClick={openRetail}
                        title="Open the Retail Estimate for this draft"
                      >
                        📄 Retail Estimate
                      </button>
                    )}
                  </div>
                  {!hideEstimates && (
                    <div className="dash-order-total mono">
                      {fmtMoney(order.estimate?.total || 0)}
                    </div>
                  )}
                  <div className="dash-order-date">{order.dateReceived || ''}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

Object.assign(window, { VendorDashboard, StatusBadge, STATUS_LABELS, STATUS_COLORS });

})();

// ===== order-detail.jsx =====
(function(){
// Order detail view with inline editing for vendors
// Vendor can edit orders in 'new' or 'received' status
// Edits are tracked with old/new values in a changes array
// Price-affecting changes prompt for confirmation

// Fields that affect pricing
const PRICE_FIELDS = ['w', 'wu', 'h', 'hu', 'd', 'du', 'doors', 'drawers', 'shelves',
  'finishedSide', 'finishedWhich', 'boxMaterial', 'cabType'];
const TOE_PRICE_FIELDS = ['linearFt'];

// Format a price for the change-confirmation modal. `fmtMoney` rounds to whole
// dollars, so a sub-$1 change ($1,200.40 → $1,200.90) renders as an identical
// "$1,200 → $1,200". When old and new round to the same dollar but actually
// differ, show 2-dp so the vendor can see the real delta.
function fmtConfirmMoney(v, oldT, newT) {
  if (Math.round(oldT) === Math.round(newT) && oldT !== newT) {
    return '$' + Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return fmtMoney(v);
}

function OrderDetailPage({ orderId, onBack, isVendor }) {
  const [order, setOrder] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [qrDataUrl, setQrDataUrl] = React.useState(null);
  const [qrEnlarged, setQrEnlarged] = React.useState(false);
  const [actionLoading, setActionLoading] = React.useState(false);

  // Edit state
  const [editing, setEditing] = React.useState(false);
  const [editData, setEditData] = React.useState(null); // working copy
  const [saving, setSaving] = React.useState(false);
  const savingRef = React.useRef(false); // sync latch — blocks double-tap before `saving` re-renders
  const [priceConfirm, setPriceConfirm] = React.useState(null); // { oldTotal, newTotal, onConfirm }

  // Mobile breakpoints
  const [isNarrowTimeline, setIsNarrowTimeline] = React.useState(
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(max-width: 480px)').matches : false
  );
  const [isMobileCabinet, setIsMobileCabinet] = React.useState(
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(max-width: 768px)').matches : false
  );
  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const m1 = window.matchMedia('(max-width: 480px)');
    const m2 = window.matchMedia('(max-width: 768px)');
    const h1 = () => setIsNarrowTimeline(m1.matches);
    const h2 = () => setIsMobileCabinet(m2.matches);
    if (m1.addEventListener) { m1.addEventListener('change', h1); m2.addEventListener('change', h2); }
    else { m1.addListener(h1); m2.addListener(h2); }
    return () => {
      if (m1.removeEventListener) { m1.removeEventListener('change', h1); m2.removeEventListener('change', h2); }
      else { m1.removeListener(h1); m2.removeListener(h2); }
    };
  }, []);

  React.useEffect(() => {
    if (!orderId) return;
    const unsub = db.collection('orders').doc(orderId).onSnapshot((doc) => {
      if (doc.exists) setOrder({ id: doc.id, ...doc.data() });
      setLoading(false);
    });
    return () => unsub();
  }, [orderId]);

  // QR code
  React.useEffect(() => {
    if (!order) return;
    const url = 'https://precision-cabinets-admin.web.app/orders/' + order.id;
    try {
      if (window.QRCode && window.QRCode.toDataURL) {
        window.QRCode.toDataURL(url, { width: 400, margin: 2, color: { dark: '#1a1a1a', light: '#ffffff' } })
          .then(setQrDataUrl).catch(console.error);
      }
    } catch (err) { console.error('QR error:', err); }
  }, [order?.id]);

  // Start editing
  const startEdit = () => {
    setEditData(JSON.parse(JSON.stringify(order))); // deep clone
    setEditing(true);
  };

  const cancelEdit = () => {
    setEditing(false);
    setEditData(null);
  };

  // Update a top-level field in editData
  const updateField = (key, value) => {
    setEditData(prev => ({ ...prev, [key]: value }));
  };

  // Update a cabinet field
  const updateCabinet = (idx, key, value) => {
    setEditData(prev => {
      const cabs = [...prev.cabinets];
      cabs[idx] = { ...cabs[idx], [key]: value };
      return { ...prev, cabinets: cabs };
    });
  };

  // Update toe kick
  const updateToeKick = (key, value) => {
    setEditData(prev => ({
      ...prev,
      toeKick: { ...(prev.toeKick || {}), [key]: value }
    }));
  };

  // Compute changes between original and edited
  const computeChanges = () => {
    if (!order || !editData) return [];
    const changes = [];
    const fields = ['vendorContact', 'vendorPhone', 'vendorEmail', 'vendorPO',
      'clientName', 'clientPhone', 'clientEmail', 'address', 'accessNotes',
      'completionRequested', 'timeframe', 'specialInstructions'];

    for (const f of fields) {
      if ((order[f] || '') !== (editData[f] || '')) {
        changes.push({ section: 'order', field: f, old: order[f] || '', new: editData[f] || '' });
      }
    }

    // Cabinets
    const origCabs = order.cabinets || [];
    const editCabs = editData.cabinets || [];
    const maxLen = Math.max(origCabs.length, editCabs.length);
    for (let i = 0; i < maxLen; i++) {
      const oc = origCabs[i] || {};
      const ec = editCabs[i] || {};
      const cabFields = ['name', 'w', 'wu', 'h', 'hu', 'd', 'du', 'doors', 'drawers', 'shelves',
        'finishedSide', 'finishedWhich', 'boxMaterial', 'boxThickness', 'cabType', 'notes'];
      for (const f of cabFields) {
        if (String(oc[f] || '') !== String(ec[f] || '')) {
          changes.push({
            section: `cabinet_${i}`, field: f,
            old: String(oc[f] || ''), new: String(ec[f] || ''),
            cabIdx: i, cabName: ec.name || oc.name || `Cab ${i + 1}`,
          });
        }
      }
    }

    // Toe kick
    const otk = order.toeKick || {};
    const etk = editData.toeKick || {};
    for (const f of ['height', 'setback', 'thickness', 'linearFt']) {
      if (String(otk[f] || '') !== String(etk[f] || '')) {
        changes.push({ section: 'toeKick', field: f, old: String(otk[f] || ''), new: String(etk[f] || '') });
      }
    }

    return changes;
  };

  // Check if changes affect pricing
  const changeAffectsPrice = (changes) => {
    return changes.some(c => {
      if (c.section.startsWith('cabinet_') && PRICE_FIELDS.includes(c.field)) return true;
      if (c.section === 'toeKick' && TOE_PRICE_FIELDS.includes(c.field)) return true;
      // NOTE: `timeframe` (Priority / rush) is NOT price-affecting — rush is a
      // separate flag. Editing only Priority must not pop the price modal.
      return false;
    });
  };

  // Rehydrate the order's frozen pricing snapshot the SAME way the server
  // will (incl. repairTypes) so the preview total matches pc_editOrder.
  const frozenPricing = () => {
    const snap = editData?.pricingSnapshot || order?.pricingSnapshot;
    return (snap && window.pricingFromSnapshot)
      ? window.pricingFromSnapshot(snap)
      : DEFAULT_PRICING;
  };

  // Save edits — routed through pc_editOrder. The SERVER recomputes the
  // estimate authoritatively from the order's frozen snapshot and writes
  // editHistory + audit; the client never writes `estimate` (that path used
  // to silently collapse totals when the snapshot lacked repairTypes).
  const saveEdits = async (confirmed) => {
    const changes = computeChanges();
    if (changes.length === 0) { cancelEdit(); return; }

    // Price-impact preview (transparency only — server is authoritative).
    if (!confirmed && changeAffectsPrice(changes)) {
      const oldEstimate = order.estimate?.total || 0;
      const newEstimate = computeEstimate(editData, frozenPricing()).total;
      setPriceConfirm({ oldTotal: oldEstimate, newTotal: newEstimate, changes });
      return;
    }

    // Double-submit latch: a fast double-tap can fire a second saveEdits before
    // `saving` re-renders the disabled button. The ref flips synchronously.
    if (savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    try {
      // Strip photo blobs from cabinets — photos are mutated only via the
      // intake wizard / gallery, never this metadata edit path.
      const cleanCabs = (editData.cabinets || []).map(({ photo, photos, annotations, ...rest }) => rest);
      const patch = {
        vendorPO: editData.vendorPO || '',
        clientName: editData.clientName || '',
        clientPhone: editData.clientPhone || '',
        clientEmail: editData.clientEmail || '',
        address: editData.address || '',
        accessNotes: editData.accessNotes || '',
        completionRequested: editData.completionRequested || '',
        timeframe: editData.timeframe || '',
        specialInstructions: editData.specialInstructions || '',
        cabinets: cleanCabs,
        toeKick: editData.toeKick || {},
      };
      if (Array.isArray(editData.toeKicks)) patch.toeKicks = editData.toeKicks;
      await callFunction('pc_editOrder', { orderId, patch });
      setEditing(false);
      setEditData(null);
      setPriceConfirm(null);
      if (window.bsAlert) await window.bsAlert({ title: 'Changes saved', body: 'Your changes to this order have been saved.' });
    } catch (err) {
      if (window.bsAlert) await window.bsAlert({ title: 'Failed to save', body: err.message || 'Unknown error' });
      else alert('Failed to save: ' + (err.message || 'Unknown error'));
    } finally {
      setSaving(false);
      savingRef.current = false;
    }
  };

  // ---- Change requests (in-production orders) ----
  // Once an order is in production a vendor can no longer edit it directly;
  // they file a change request that staff apply. Subscribe to the order's
  // change requests and expose a compose action.
  const [changeRequests, setChangeRequests] = React.useState([]);
  const [showChangeReq, setShowChangeReq] = React.useState(false);
  const [changeReqText, setChangeReqText] = React.useState('');
  const [changeReqBusy, setChangeReqBusy] = React.useState(false);

  React.useEffect(() => {
    if (!orderId) return;
    const unsub = db.collection('orders').doc(orderId).collection('changeRequests')
      .onSnapshot((snap) => {
        const list = [];
        snap.forEach((d) => list.push({ id: d.id, ...d.data() }));
        list.sort((a, b) => {
          const ta = a.createdAt?.toMillis ? a.createdAt.toMillis() : 0;
          const tb = b.createdAt?.toMillis ? b.createdAt.toMillis() : 0;
          return tb - ta;
        });
        setChangeRequests(list);
      }, () => { /* rules deny for non-owning contexts — ignore */ });
    return () => unsub();
  }, [orderId]);

  // Escape closes the change-request modal (a11y). Bound only while open.
  React.useEffect(() => {
    if (!showChangeReq) return;
    const onKey = (e) => { if (e.key === 'Escape' && !changeReqBusy) setShowChangeReq(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [showChangeReq, changeReqBusy]);

  const submitChangeRequest = async () => {
    const msg = (changeReqText || '').trim();
    if (!msg) return;
    setChangeReqBusy(true);
    try {
      await callFunction('pc_createChangeRequest', { orderId, message: msg });
      setChangeReqText('');
      setShowChangeReq(false);
      if (window.bsAlert) await window.bsAlert({ title: 'Change request sent', body: 'Precision has been notified and will follow up.' });
    } catch (err) {
      if (window.bsAlert) await window.bsAlert({ title: 'Could not send', body: err.message || 'Unknown error' });
      else alert('Could not send: ' + (err.message || 'Unknown error'));
    } finally {
      setChangeReqBusy(false);
    }
  };

  // Employee/Admin status changes
  const handleStatusAction = async (action) => {
    const labels = { receive: 'Mark as Received?', advance: 'Advance status?', deliver: 'Mark as Delivered?' };
    const title = labels[action] || 'Change status?';
    const ok = window.bsConfirm
      ? await window.bsConfirm({ title, confirmLabel: 'Confirm' })
      : confirm(title);
    if (!ok) return;
    setActionLoading(true);
    try {
      await callFunction('pc_updateOrderStatus', { orderId: order.id, action });
    } catch (err) {
      if (window.bsAlert) await window.bsAlert({ title: 'Error', body: err.message });
      else alert('Error: ' + err.message);
    }
    finally { setActionLoading(false); }
  };

  if (loading) return <div className="dashboard-loading"><div className="spinner"></div><p>Loading order...</p></div>;
  if (!order) return <div className="dashboard-loading"><p>Order not found.</p><button className="btn ghost" onClick={onBack}>Go back</button></div>;

  // Service-mode-aware status timeline (MD-7). The first three stages are
  // shared; the final two depend on how Precision is fulfilling the order —
  // install, drop-off delivery, or vendor pickup — mirroring dashboard.jsx's
  // full status set (STATUS_LABELS is a shared global). Legacy orders
  // (status 'complete'/'delivered' with no serviceMode) keep the old lane so
  // they still render. Building the list dynamically guarantees currentIdx is
  // never -1 for a real order (which previously blanked the ready_for_* /
  // picked_up / installed statuses off the timeline).
  const buildStatusList = (o) => {
    const base = ['new', 'received', 'in_production'];
    const st = o.status;
    // An explicit final-stage status pins its own lane.
    const laneByStatus = {
      ready_for_pickup:   ['ready_for_pickup', 'picked_up'],
      picked_up:          ['ready_for_pickup', 'picked_up'],
      ready_for_install:  ['ready_for_install', 'installed'],
      installed:          ['ready_for_install', 'installed'],
      ready_for_delivery: ['ready_for_delivery', 'delivered'],
    };
    if (laneByStatus[st]) return [...base, ...laneByStatus[st]];
    const t = o.serviceToggles || {};
    const wantsInstall = t.install === true || o.serviceMode === 'install' || o.installNeeded === 'Yes';
    const wantsDropoff = t.dropoff === true || o.serviceMode === 'dropoff';
    if (st === 'delivered') {
      // 'delivered' is an ambiguous terminal: a drop-off order ends there,
      // and so does a legacy order. Prefer the intended service lane.
      return wantsInstall ? [...base, 'ready_for_install', 'installed']
        : wantsDropoff ? [...base, 'ready_for_delivery', 'delivered']
          : [...base, 'complete', 'delivered'];
    }
    if (st === 'complete') return [...base, 'complete', 'delivered']; // legacy terminal
    // Not yet at a final stage — preview the lane from the chosen service mode.
    if (wantsInstall) return [...base, 'ready_for_install', 'installed'];
    if (wantsDropoff) return [...base, 'ready_for_delivery', 'delivered'];
    return [...base, 'ready_for_pickup', 'picked_up'];
  };
  const STATUS_ORDER_LIST = buildStatusList(order);
  const currentIdx = STATUS_ORDER_LIST.indexOf(order.status);
  const isEmployee = !isVendor;
  const canEdit = isVendor && (order.status === 'new' || order.status === 'received');
  // Past 'received' the order is in production — vendors can no longer edit
  // directly and instead file a change request that staff apply. Terminal
  // statuses (delivered/installed/picked_up) are done — no changes possible.
  const canRequestChange = isVendor
    && !['draft', 'new', 'received', 'delivered', 'installed', 'picked_up'].includes(order.status);
  const openChangeRequests = (changeRequests || []).filter(r => r.status === 'open');
  const hasOpenChangeRequest = openChangeRequests.length > 0;
  // Block a new request while one is still pending review (anti-spam / stale).
  const canFileNewRequest = canRequestChange && !hasOpenChangeRequest;

  // Use editData when editing, order when viewing
  const d = editing ? editData : order;
  const cabs = d?.cabinets || [];
  const tk = d?.toeKick || {};

  return (
    <div className="order-detail">
      {/* Header */}
      <header className="order-detail-header">
        <button className="btn ghost" onClick={editing ? cancelEdit : onBack}>
          <Icon.ArrowL /> {editing ? 'Cancel' : 'Back'}
        </button>
        <div style={{ flex: 1 }}>
          <h2 className="mono">{order.orderNumber || 'Order'}</h2>
          <StatusBadge status={order.status} />
        </div>
        {!editing && canEdit && (
          <button className="btn primary edit-order-btn" onClick={startEdit}>
            <Icon.Pencil /> Edit Order
          </button>
        )}
        {!editing && canEdit && (
          <button
            className="btn ghost edit-order-btn"
            onClick={() => navigate('/orders/' + order.id + '/edit')}
            title="Open the full cabinet wizard for this order"
          >
            <Icon.Plus /> Add / edit cabinets
          </button>
        )}
        {!editing && canRequestChange && (
          <button
            className="btn ghost edit-order-btn"
            onClick={() => setShowChangeReq(true)}
            disabled={hasOpenChangeRequest}
            title={hasOpenChangeRequest ? 'You already have a change request pending Precision’s review.' : undefined}
          >
            <Icon.Pencil /> Request a change
          </button>
        )}
      </header>

      {/* Change requests — in-production edit workflow */}
      {isVendor && (canRequestChange || (changeRequests && changeRequests.length > 0)) && (
        <div className="detail-section" style={{ marginTop: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 8 }}>
            <h3 style={{ margin: 0 }}>Change requests</h3>
            {canRequestChange && (
              <button
                className="btn ghost"
                style={{ padding: '6px 12px' }}
                onClick={() => setShowChangeReq(true)}
                disabled={hasOpenChangeRequest}
                title={hasOpenChangeRequest ? 'You already have a change request pending Precision’s review.' : undefined}
              >+ New request</button>
            )}
          </div>
          {canRequestChange && hasOpenChangeRequest && (
            <p style={{ fontSize: 12, color: 'var(--ink-soft, #6B6459)', margin: '0 0 8px' }}>
              You have a change request awaiting Precision’s review. You can send another once it’s resolved.
            </p>
          )}
          {(!changeRequests || changeRequests.length === 0) ? (
            <p style={{ fontSize: 13, color: 'var(--ink-soft, #6B6459)' }}>
              This order is in production, so it can’t be edited directly. Send a change request and Precision will follow up.
            </p>
          ) : (
            <div>
              {changeRequests.map((r) => (
                <ChangeRequestCard key={r.id} orderId={orderId} req={r} />
              ))}
            </div>
          )}
        </div>
      )}

      {showChangeReq && (
        <div
          onClick={() => !changeReqBusy && setShowChangeReq(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '24px 16px', overflowY: 'auto' }}
        >
          <div
            className="card"
            role="dialog"
            aria-modal="true"
            aria-labelledby="change-req-title"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: 440, width: '100%', padding: 20, maxHeight: 'calc(100dvh - 48px)', overflowY: 'auto' }}
          >
            <h3 id="change-req-title" style={{ marginTop: 0 }}>Request a change</h3>
            <p style={{ fontSize: 13, marginTop: 0, color: 'var(--ink-soft, #6B6459)' }}>
              Describe what needs to change on {order.orderNumber || 'this order'}. Precision’s team will review and update the order.
            </p>
            <textarea
              className="textarea"
              rows={5}
              value={changeReqText}
              onChange={(e) => setChangeReqText(e.target.value)}
              placeholder="e.g. Cabinet 03 should be Hardrock Maple, not Birch. Add a roll-out to Cabinet 05."
              maxLength={2000}
              autoFocus
              style={{ width: '100%', fontSize: 16 }}
            />
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
              <button className="btn ghost" onClick={() => setShowChangeReq(false)} disabled={changeReqBusy}>Cancel</button>
              <button className="btn primary" onClick={submitChangeRequest} disabled={changeReqBusy || !changeReqText.trim()}>
                {changeReqBusy ? 'Sending…' : 'Send request'}
              </button>
            </div>
          </div>
        </div>
      )}

      {editing && (
        <div className="edit-banner">
          <Icon.Pencil /> Editing — changes will be tracked. Tap Save when done.
        </div>
      )}

      {/* Info request banners — Precision admin can ask the vendor for
          more photos / details after submit. Each pending request opens
          a form to respond inline. */}
      <VendorInfoRequests order={order} orderId={orderId} />

      {/* Status timeline (collapsed eyebrow on narrow screens) */}
      {isNarrowTimeline ? (
        <div className="status-timeline-eyebrow" style={{
          fontSize: 12, fontFamily: 'var(--mono)', color: 'var(--ink-soft)',
          padding: '8px 0', letterSpacing: '0.05em',
        }}>
          {currentIdx + 1} / {STATUS_ORDER_LIST.length} · {STATUS_LABELS[order.status] || order.status}
        </div>
      ) : (
        <div className="status-timeline">
          {STATUS_ORDER_LIST.map((s, i) => (
            <div key={s} className={'timeline-step' + (i <= currentIdx ? ' done' : '') + (i === currentIdx ? ' current' : '')}>
              <div className="timeline-dot"></div>
              <div className="timeline-label">{STATUS_LABELS[s]}</div>
            </div>
          ))}
        </div>
      )}

      {/* Fixed bottom Save bar while editing */}
      {editing && (
        <div style={{
          position: 'fixed',
          bottom: 0, left: 0, right: 0,
          padding: 'calc(12px + 0px) 16px calc(12px + var(--safe-bottom))',
          background: 'var(--bg)',
          borderTop: '1px solid var(--ink-faint)',
          display: 'flex',
          gap: 8,
          zIndex: 50,
        }}>
          <button type="button" className="btn ghost" style={{ flex: 1 }} onClick={cancelEdit} disabled={saving}>
            Cancel
          </button>
          <button type="button" className="btn primary" style={{ flex: 1 }} onClick={() => saveEdits(false)} disabled={saving}>
            {saving ? 'Saving...' : 'Save changes'}
          </button>
        </div>
      )}

      {/* QR Code */}
      {!editing && (
        <div className="order-qr-section" onClick={() => qrDataUrl && setQrEnlarged(true)} style={{ cursor: qrDataUrl ? 'pointer' : 'default' }}>
          <h3>Work Order QR Code</h3>
          {isVendor && <p className="hint">Show this to Precision Cabinets at drop-off or pickup.{qrDataUrl ? ' Tap to enlarge.' : ''}</p>}
          {qrDataUrl ? (
            <img src={qrDataUrl} alt="QR Code" className="order-qr-img" />
          ) : (
            <div style={{ padding: 20, background: 'var(--bg)', borderRadius: 8, marginTop: 8 }}>
              <div className="spinner" style={{ margin: '0 auto 8px' }}></div>
              <p className="hint" style={{ textAlign: 'center' }}>Generating QR code...</p>
            </div>
          )}
          {qrDataUrl && (
            <div style={{ display: 'flex', gap: 8, marginTop: 10, justifyContent: 'center' }}>
              <a href={qrDataUrl} download={`${order.orderNumber}-qr.png`} className="btn secondary"
                onClick={e => e.stopPropagation()} style={{ fontSize: 12 }}>Download</a>
            </div>
          )}
        </div>
      )}

      {/* QR enlarged overlay */}
      {qrEnlarged && qrDataUrl && window.BottomSheet && (
        <window.BottomSheet open={qrEnlarged} onClose={() => setQrEnlarged(false)} title={order.orderNumber || 'QR Code'}>
          <div style={{ textAlign: 'center' }}>
            <img src={qrDataUrl} alt="QR Code" className="qr-overlay-img" style={{ maxWidth: '100%' }} />
            <div className="qr-overlay-status" style={{ marginTop: 12 }}><StatusBadge status={order.status} /></div>
            {isVendor && <p className="qr-overlay-hint">Show this to Precision Cabinets staff</p>}
          </div>
        </window.BottomSheet>
      )}
      {qrEnlarged && qrDataUrl && !window.BottomSheet && (
        <div className="qr-overlay" onClick={() => setQrEnlarged(false)}>
          <div className="qr-overlay-inner" onClick={e => e.stopPropagation()}>
            <div className="qr-overlay-order">{order.orderNumber}</div>
            <img src={qrDataUrl} alt="QR Code" className="qr-overlay-img" />
            <div className="qr-overlay-status"><StatusBadge status={order.status} /></div>
            {isVendor && <p className="qr-overlay-hint">Show this to Precision Cabinets staff</p>}
            <button className="btn ghost" onClick={() => setQrEnlarged(false)} style={{ marginTop: 16 }}>Close</button>
          </div>
        </div>
      )}

      {/* Employee status actions */}
      {isEmployee && order.status === 'new' && (
        <div className="order-action-box">
          <p><strong>New order from {order.vendorName}</strong></p>
          <button className="btn primary lg" onClick={() => handleStatusAction('receive')} disabled={actionLoading}>
            {actionLoading ? 'Processing...' : 'Mark as Received (Dropped Off)'}
          </button>
        </div>
      )}
      {isEmployee && order.status === 'received' && (
        <div className="order-action-box" style={{ background: 'var(--bg-raised)', borderColor: 'var(--rule)' }}>
          <button className="btn primary" onClick={() => handleStatusAction('advance')} disabled={actionLoading}>
            {actionLoading ? 'Processing...' : 'Move to In Production'}
          </button>
        </div>
      )}
      {isEmployee && order.status === 'in_production' && (
        <div className="order-action-box" style={{ background: 'var(--bg-raised)', borderColor: 'var(--rule)' }}>
          <button className="btn primary" onClick={() => handleStatusAction('advance')} disabled={actionLoading}>
            {actionLoading ? 'Processing...' : 'Mark as Complete'}
          </button>
        </div>
      )}
      {isEmployee && order.status === 'complete' && (
        <div className="order-action-box">
          <button className="btn primary lg" onClick={() => handleStatusAction('deliver')} disabled={actionLoading}>
            {actionLoading ? 'Processing...' : 'Mark as Delivered (Picked Up)'}
          </button>
        </div>
      )}
      {order.status === 'delivered' && (
        <div className="order-action-box" style={{ background: 'oklch(95% 0.04 140)', borderColor: 'oklch(70% 0.12 140)' }}>
          <p style={{ color: 'oklch(40% 0.12 140)', margin: 0 }}><strong>Order delivered.</strong></p>
        </div>
      )}

      {/* Price change confirmation modal */}
      {priceConfirm && window.BottomSheet && (
        <window.BottomSheet open={!!priceConfirm} onClose={() => setPriceConfirm(null)} title="Price Change">
          <p style={{ fontSize: 14, color: 'var(--ink-soft)', margin: '0 0 16px' }}>
            Your changes affect the estimated price:
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <span className="mono" style={{ fontSize: 18, textDecoration: 'line-through', color: 'var(--ink-faint)' }}>
              {fmtConfirmMoney(priceConfirm.oldTotal, priceConfirm.oldTotal, priceConfirm.newTotal)}
            </span>
            <span style={{ color: 'var(--ink-faint)' }}>→</span>
            <span className="mono" style={{ fontSize: 22, fontWeight: 700, color: priceConfirm.newTotal > priceConfirm.oldTotal ? 'var(--danger)' : 'oklch(50% 0.15 150)' }}>
              {fmtConfirmMoney(priceConfirm.newTotal, priceConfirm.oldTotal, priceConfirm.newTotal)}
            </span>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn ghost" style={{ flex: 1 }} onClick={() => setPriceConfirm(null)}>Cancel</button>
            <button className="btn primary" style={{ flex: 1 }} onClick={() => saveEdits(true)} disabled={saving}>
              {saving ? 'Saving...' : 'Confirm Change'}
            </button>
          </div>
        </window.BottomSheet>
      )}
      {priceConfirm && !window.BottomSheet && (
        <div className="qr-overlay" onClick={() => setPriceConfirm(null)}>
          <div className="qr-overlay-inner" onClick={e => e.stopPropagation()} style={{ maxWidth: 340 }}>
            <h3 style={{ margin: '0 0 12px' }}>Price Change</h3>
            <p style={{ fontSize: 14, color: 'var(--ink-soft)', margin: '0 0 16px' }}>
              Your changes affect the estimated price:
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <span className="mono" style={{ fontSize: 18, textDecoration: 'line-through', color: 'var(--ink-faint)' }}>
                {fmtConfirmMoney(priceConfirm.oldTotal, priceConfirm.oldTotal, priceConfirm.newTotal)}
              </span>
              <span style={{ color: 'var(--ink-faint)' }}>→</span>
              <span className="mono" style={{ fontSize: 22, fontWeight: 700, color: priceConfirm.newTotal > priceConfirm.oldTotal ? 'var(--danger)' : 'oklch(50% 0.15 150)' }}>
                {fmtConfirmMoney(priceConfirm.newTotal, priceConfirm.oldTotal, priceConfirm.newTotal)}
              </span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn ghost" style={{ flex: 1 }} onClick={() => setPriceConfirm(null)}>Cancel</button>
              <button className="btn primary" style={{ flex: 1 }} onClick={() => saveEdits(true)} disabled={saving}>
                {saving ? 'Saving...' : 'Confirm Change'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Order detail sections */}
      <div className="order-detail-sections">
        {/* Vendor info */}
        <div className="order-detail-section">
          <h3>Vendor</h3>
          <div className="detail-grid">
            <div><span className="label">Name</span><span>{d.vendorName}</span></div>
            {editing ? (
              <>
                <EditField label="Contact" value={d.vendorContact} orig={order.vendorContact} onChange={v => updateField('vendorContact', v)} />
                <EditField label="Phone" value={d.vendorPhone} orig={order.vendorPhone} onChange={v => updateField('vendorPhone', v)} mono type="tel" inputMode="tel" />
                <EditField label="Email" value={d.vendorEmail} orig={order.vendorEmail} onChange={v => updateField('vendorEmail', v)} type="email" inputMode="email" autoCapitalize="none" />
                <EditField label="PO #" value={d.vendorPO} orig={order.vendorPO} onChange={v => updateField('vendorPO', v)} mono />
              </>
            ) : (
              <>
                <DetailVal label="Contact" value={d.vendorContact} orig={order.vendorContact} edits={order.editHistory} field="vendorContact" />
                <DetailVal label="Phone" value={d.vendorPhone} orig={order.vendorPhone} edits={order.editHistory} field="vendorPhone" mono />
                <DetailVal label="Email" value={d.vendorEmail} orig={order.vendorEmail} edits={order.editHistory} field="vendorEmail" />
                {d.vendorPO && <DetailVal label="PO #" value={d.vendorPO} edits={order.editHistory} field="vendorPO" mono />}
              </>
            )}
          </div>
        </div>

        {/* Customer */}
        <div className="order-detail-section">
          <h3>Customer</h3>
          <div className="detail-grid">
            {editing ? (
              <>
                <EditField label="Name" value={d.clientName} orig={order.clientName} onChange={v => updateField('clientName', v)} />
                <EditField label="Phone" value={d.clientPhone} orig={order.clientPhone} onChange={v => updateField('clientPhone', v)} mono type="tel" inputMode="tel" />
                <EditField label="Email" value={d.clientEmail} orig={order.clientEmail} onChange={v => updateField('clientEmail', v)} type="email" inputMode="email" autoCapitalize="none" />
                <EditField label="Address" value={d.address} orig={order.address} onChange={v => updateField('address', v)} full />
              </>
            ) : (
              <>
                <DetailVal label="Name" value={d.clientName} edits={order.editHistory} field="clientName" />
                <DetailVal label="Phone" value={d.clientPhone} edits={order.editHistory} field="clientPhone" mono />
                {d.clientEmail && <DetailVal label="Email" value={d.clientEmail} edits={order.editHistory} field="clientEmail" />}
                <DetailVal label="Address" value={d.address} edits={order.editHistory} field="address" />
              </>
            )}
          </div>
        </div>

        {/* Cabinets */}
        {cabs.length > 0 && (
          <div className="order-detail-section">
            <h3>Cabinets ({cabs.length})</h3>
            {cabs.map((cab, i) => {
              const inner = editing ? (
                <CabinetEditCard cab={cab} idx={i} origCab={(order.cabinets || [])[i]}
                  onChange={(k, v) => updateCabinet(i, k, v)} />
              ) : (
                <>
                  <CabinetViewCard cab={cab} idx={i} editHistory={order.editHistory} />
                  {window.CabinetSchematicVendor && (
                    <CabinetSchematicVendor cab={cab} idx={i} showCutList={!isVendor || !!order.showCutListToVendor} />
                  )}
                </>
              );
              if (isMobileCabinet) {
                return (
                  <details key={cab.id || i} className="order-cabinet-card" open={i === 0 || editing}>
                    <summary style={{ cursor: 'pointer', padding: '6px 0', fontWeight: 600 }}>
                      Cab {String(i + 1).padStart(2, '0')}{cab.name ? ` — ${cab.name}` : ''}
                    </summary>
                    {inner}
                  </details>
                );
              }
              return (
                <div key={cab.id || i} className="order-cabinet-card">
                  {inner}
                </div>
              );
            })}
          </div>
        )}

        {/* Toe Kick */}
        {(tk.linearFt || tk.height || editing) && (
          <div className="order-detail-section">
            <h3>Toe Kick</h3>
            <div className="detail-grid">
              {editing ? (
                <>
                  <EditField label="Height" value={tk.height} orig={(order.toeKick||{}).height} onChange={v => updateToeKick('height', v)} mono type="number" inputMode="decimal" pattern="[0-9.]*" />
                  <EditField label="Setback" value={tk.setback} orig={(order.toeKick||{}).setback} onChange={v => updateToeKick('setback', v)} mono type="number" inputMode="decimal" pattern="[0-9.]*" />
                  <EditField label="Thickness" value={tk.thickness} orig={(order.toeKick||{}).thickness} onChange={v => updateToeKick('thickness', v)} mono type="number" inputMode="decimal" pattern="[0-9.]*" />
                  <EditField label="Linear ft" value={tk.linearFt} orig={(order.toeKick||{}).linearFt} onChange={v => updateToeKick('linearFt', v)} mono type="number" inputMode="decimal" pattern="[0-9.]*" />
                </>
              ) : (
                <>
                  {tk.height && <DetailVal label="Height" value={`${tk.height} ${tk.heightU || 'in'}`} />}
                  {tk.setback && <DetailVal label="Setback" value={`${tk.setback} ${tk.setbackU || 'in'}`} />}
                  {tk.thickness && <DetailVal label="Thickness" value={tk.thickness} />}
                  {tk.linearFt && <DetailVal label="Linear ft" value={tk.linearFt} mono />}
                </>
              )}
            </div>
          </div>
        )}

        {/* Scribe */}
        {d.scribe?.needed === 'Yes' && (
          <div className="order-detail-section">
            <h3>Scribe</h3>
            <div className="detail-grid">
              <DetailVal label="Quantity" value={
                d.scribe.sticks
                  ? `${d.scribe.sticks} stick${Number(d.scribe.sticks) === 1 ? '' : 's'} (8 ft)`
                  : (d.scribe.linearFeet ? `${d.scribe.linearFeet} lf` : '—')
              } mono />
              <DetailVal label="Material" value={d.scribe.matchMaterial === 'No' ? 'Cheapest stock (paint-grade)' : 'Match cabinet material'} />
            </div>
          </div>
        )}

        {/* Special Instructions */}
        <div className="order-detail-section">
          <h3>Special Instructions</h3>
          {editing ? (
            <textarea className="textarea" value={d.specialInstructions || ''}
              onChange={e => updateField('specialInstructions', e.target.value)}
              placeholder="Color match, hardware, notes…" style={{ minHeight: 60 }} />
          ) : (
            <p style={{ margin: 0, fontSize: 14 }}>{d.specialInstructions || '—'}</p>
          )}
        </div>

        {/* Estimate */}
        {order.estimate && (
          <div className="order-detail-section">
            <h3>Estimate</h3>
            <div className="estimate-table">
              {(order.estimate.lineItems || []).map((item, i) => (
                <div key={i} className="est-row">
                  <span className="est-label">
                    {item.label}
                    {item.type === 'change_order' && (
                      <span className="status-badge" style={{ '--badge-color': '#C9781B', fontSize: 10, marginLeft: 6, verticalAlign: 'middle' }}>Change</span>
                    )}
                  </span>
                  <span className="est-detail">{item.detail}</span>
                  <span className="est-amount mono">{fmtMoney(item.amount)}</span>
                </div>
              ))}
              <div className="est-row est-total">
                <span>Total</span><span></span>
                <span className="mono">{fmtMoney(order.estimate.total)}</span>
              </div>
            </div>
          </div>
        )}

        {/* Retail / Insurance estimate — persistent access to the marked-up figure */}
        {isVendor && (
          <div className="order-detail-section">
            <h3>Retail / Insurance Estimate</h3>
            <p style={{ margin: '0 0 10px', fontSize: 13, color: 'var(--ink-soft, #6B6459)' }}>
              Regenerates the branded, marked-up retail figure for insurance. This
              is the retail price — distinct from the base Precision price shown above.
            </p>
            <button
              type="button"
              className="btn ghost"
              onClick={async () => {
                try {
                  if (window.ensureShopConstantsAsync) await window.ensureShopConstantsAsync();
                  if (window.openInsuranceEstimatePdf) {
                    window.openInsuranceEstimatePdf({
                      vendor: { name: order.vendorName },
                      data: order,
                      pricing: window.PC_PRICING_CACHE || {},
                      markupPercent: order.insuranceMarkupPercent || 30,
                    });
                  }
                } catch (err) {
                  if (window.bsAlert) await window.bsAlert({ title: 'Could not open estimate', body: err.message || 'Unknown error' });
                }
              }}
            >
              View / print insurance estimate
            </button>
          </div>
        )}

        {/* Edit history */}
        {order.editHistory && order.editHistory.length > 0 && (
          <div className="order-detail-section">
            <style>{`
              @media (max-width: 520px) {
                .edit-change-row { flex-direction: column !important; align-items: flex-start !important; gap: 2px !important; }
                .edit-change-row .edit-change-arrow { display: none !important; }
              }
            `}</style>
            <h3>Edit History</h3>
            {order.editHistory.map((entry, i) => (
              <div key={i} className="edit-history-entry">
                <div className="edit-history-header">
                  <span className="edit-history-by">{entry.changedByName}</span>
                  <span className="edit-history-time mono">
                    {entry.timestamp?.toDate ? entry.timestamp.toDate().toLocaleString() : new Date(entry.timestamp).toLocaleString()}
                  </span>
                </div>
                <div className="edit-history-changes">
                  {(entry.changes || []).map((c, j) => (
                    <div key={j} className="edit-change-row" style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                      <span className="edit-change-field">{c.cabName ? `${c.cabName} · ` : ''}{c.field}</span>
                      <span className="edit-change-old">{c.old || '—'}</span>
                      <span className="edit-change-arrow">→</span>
                      <span className="edit-change-new">{c.new || '—'}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Status history */}
        {order.statusHistory && order.statusHistory.length > 0 && (
          <div className="order-detail-section">
            <h3>Status History</h3>
            <div className="status-history">
              {order.statusHistory.map((entry, i) => (
                <div key={i} className="history-entry">
                  <StatusBadge status={entry.status} />
                  <span className="history-by">{entry.changedByName || 'System'}</span>
                  <span className="history-method">{entry.method === 'qr_scan' ? 'QR Scan' : ''}</span>
                  <span className="history-time mono">
                    {entry.timestamp?.toDate ? entry.timestamp.toDate().toLocaleString() : ''}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// A single change-request thread: status, an optional proposed-charge decision,
// the comment thread, a reply composer, and (while still open) a withdraw
// action. Each card owns its own comments subscription so the onSnapshot
// listener cleans up when the card unmounts.
function ChangeRequestCard({ orderId, req }) {
  const [comments, setComments] = React.useState([]);
  const [replyText, setReplyText] = React.useState('');
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    if (!orderId || !req?.id) return;
    const unsub = db.collection('orders').doc(orderId)
      .collection('changeRequests').doc(req.id)
      .collection('comments').orderBy('createdAt', 'asc')
      .onSnapshot((snap) => {
        const list = [];
        snap.forEach((d) => list.push({ id: d.id, ...d.data() }));
        setComments(list);
      }, () => { /* rules deny for non-owning contexts — ignore */ });
    return () => unsub();
  }, [orderId, req?.id]);

  const STATUS_WORD = { open: 'Pending', applied: 'Applied', rejected: 'Declined', rescinded: 'Withdrawn' };
  const STATUS_COLOR = { open: '#A6620E', applied: '#2F7D52', rejected: '#9A9286', rescinded: '#9A9286' };
  const statusWord = STATUS_WORD[req.status] || 'Pending';
  const statusColor = STATUS_COLOR[req.status] || '#A6620E';

  const pc = req.proposedCharge;
  // Negative amounts are credits — render them plainly, e.g. "-$50 credit".
  const fmtCharge = (amt) => (amt < 0 ? '-' + fmtMoney(Math.abs(amt)) + ' credit' : fmtMoney(amt || 0));

  const sendReply = async () => {
    const text = (replyText || '').trim();
    if (!text) return;
    setBusy(true);
    try {
      await callFunction('pc_postChangeRequestComment', { orderId, requestId: req.id, text });
      setReplyText('');
    } catch (err) {
      if (window.bsAlert) await window.bsAlert({ title: 'Could not send', body: err.message || 'Unknown error' });
      else alert('Could not send: ' + (err.message || 'Unknown error'));
    } finally {
      setBusy(false);
    }
  };

  const withdraw = async () => {
    const ok = window.bsConfirm
      ? await window.bsConfirm({ title: 'Withdraw this change request?', confirmLabel: 'Withdraw' })
      : confirm('Withdraw this change request?');
    if (!ok) return;
    setBusy(true);
    try {
      await callFunction('pc_rescindChangeRequest', { orderId, requestId: req.id });
    } catch (err) {
      if (window.bsAlert) await window.bsAlert({ title: 'Could not withdraw', body: err.message || 'Unknown error' });
      else alert('Could not withdraw: ' + (err.message || 'Unknown error'));
    } finally {
      setBusy(false);
    }
  };

  const respondCharge = async (decision) => {
    setBusy(true);
    try {
      await callFunction('pc_respondToProposedCharge', { orderId, requestId: req.id, decision });
    } catch (err) {
      if (window.bsAlert) await window.bsAlert({ title: 'Could not respond', body: err.message || 'Unknown error' });
      else alert('Could not respond: ' + (err.message || 'Unknown error'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ padding: '12px 0', borderBottom: '1px solid var(--rule, #E6E1D7)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
        <span className="mono" style={{ fontSize: 12, textTransform: 'uppercase', color: statusColor }}>
          {statusWord}
        </span>
        <span style={{ fontSize: 12, color: 'var(--ink-soft, #6B6459)' }}>{req.requestedByName || 'You'}</span>
      </div>
      <p style={{ margin: '4px 0 0', fontSize: 14 }}>{req.message}</p>
      {req.resolutionNote && (
        <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--ink-soft, #6B6459)' }}>Precision: {req.resolutionNote}</p>
      )}

      {/* Proposed charge from Precision — approve / decline */}
      {pc && (
        <div style={{ marginTop: 10, padding: 10, background: 'var(--paper-2, #F4F1EA)', borderRadius: 8, border: '1px solid var(--rule, #E6E1D7)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'baseline' }}>
            <span style={{ fontSize: 13, fontWeight: 600 }}>{pc.label || 'Proposed charge'}</span>
            <span className="mono" style={{ fontSize: 15, fontWeight: 700, color: (pc.amount < 0 ? '#2F7D52' : '#A6620E') }}>{fmtCharge(pc.amount)}</span>
          </div>
          {pc.note && (
            <p style={{ margin: '6px 0 0', fontSize: 13, color: 'var(--ink-soft, #6B6459)' }}>{pc.note}</p>
          )}
          {pc.status === 'proposed' && (
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              <button className="btn primary" style={{ padding: '6px 14px' }} disabled={busy} onClick={() => respondCharge('approved')}>Approve</button>
              <button className="btn ghost" style={{ padding: '6px 14px' }} disabled={busy} onClick={() => respondCharge('declined')}>Decline</button>
            </div>
          )}
          {pc.status === 'approved' && (
            <p style={{ margin: '8px 0 0', fontSize: 13, color: '#2F7D52', fontWeight: 600 }}>Approved — awaiting Precision to apply.</p>
          )}
          {pc.status === 'declined' && (
            <p style={{ margin: '8px 0 0', fontSize: 13, color: '#9A9286', fontWeight: 600 }}>Declined.</p>
          )}
          {pc.status === 'applied' && (
            <p style={{ margin: '8px 0 0', fontSize: 13, color: '#2F7D52', fontWeight: 600 }}>Applied to order.</p>
          )}
        </div>
      )}

      {/* Comment thread */}
      {comments.length > 0 && (
        <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>
          {comments.map((c) => {
            const mine = c.authorRole === 'vendor';
            return (
              <div key={c.id} style={{ padding: '8px 10px', background: 'var(--paper-2, #F4F1EA)', borderRadius: 8 }}>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 12, fontWeight: 600 }}>{c.authorName || (mine ? 'You' : 'Precision')}</span>
                  <span className="status-badge" style={{ '--badge-color': mine ? '#6B6459' : '#C9781B', fontSize: 10 }}>{mine ? 'You' : 'Precision'}</span>
                  <span style={{ fontSize: 11, color: 'var(--ink-soft, #6B6459)', marginLeft: 'auto' }}>
                    {c.createdAt?.toDate ? c.createdAt.toDate().toLocaleString() : ''}
                  </span>
                </div>
                <p style={{ margin: '4px 0 0', fontSize: 14 }}>{c.text}</p>
              </div>
            );
          })}
        </div>
      )}

      {/* Reply composer — hidden once a request is withdrawn */}
      {req.status !== 'rescinded' && (
        <div style={{ display: 'flex', gap: 8, marginTop: 10, alignItems: 'flex-end' }}>
          <textarea
            className="textarea"
            rows={2}
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
            placeholder="Reply to Precision…"
            maxLength={2000}
            style={{ flex: 1, fontSize: 16, minHeight: 44 }}
          />
          <button className="btn primary" style={{ padding: '8px 16px' }} disabled={busy || !replyText.trim()} onClick={sendReply}>
            {busy ? '…' : 'Send'}
          </button>
        </div>
      )}

      {/* Withdraw — only while the request is still open */}
      {req.status === 'open' && (
        <div style={{ marginTop: 8 }}>
          <button className="btn ghost" style={{ padding: '6px 12px', fontSize: 13 }} disabled={busy} onClick={withdraw}>
            Withdraw request
          </button>
        </div>
      )}
    </div>
  );
}

// Inline edit field
function EditField({ label, value, orig, onChange, mono, full, type = 'text', inputMode, autoCapitalize, autoComplete, pattern }) {
  const changed = orig !== undefined && (value || '') !== (orig || '');
  // Auto-format phone numbers as the user types so order-detail edits
  // get the same (xxx) xxx-xxxx shape as the intake wizard.
  const isPhone = type === 'tel' || inputMode === 'tel';
  return (
    <div className={full ? 'edit-field full' : 'edit-field'}>
      <span className="label">{label}</span>
      {changed && orig && <span className="edit-old-value">{orig}</span>}
      <input className={'input' + (mono ? ' mono' : '') + (changed ? ' edited' : '')}
        type={type}
        inputMode={inputMode}
        autoCapitalize={autoCapitalize}
        autoComplete={autoComplete}
        pattern={pattern}
        maxLength={isPhone ? 14 : undefined}
        value={value || ''} onChange={e => onChange(isPhone && window.formatPhoneInput ? window.formatPhoneInput(e.target.value) : e.target.value)} />
    </div>
  );
}

// Read-only detail value — shows edit history strikethrough if changed
function DetailVal({ label, value, edits, field, mono }) {
  // Find the most recent old value for this field from edit history
  let oldValue = null;
  if (edits && field) {
    for (let i = edits.length - 1; i >= 0; i--) {
      const change = (edits[i].changes || []).find(c => c.field === field && c.section === 'order');
      if (change) { oldValue = change.old; break; }
    }
  }
  return (
    <div>
      <span className="label">{label}</span>
      {oldValue && oldValue !== value && (
        <span className="detail-old-value">{oldValue}</span>
      )}
      <span className={mono ? 'mono' : ''}>{value || '—'}</span>
    </div>
  );
}

// Cabinet view card — shows edit history
function CabinetViewCard({ cab, idx, editHistory }) {
  const material = cab.boxMaterial
    ? (cab.boxMaterial + (cab.boxThickness ? ` · ${cab.boxThickness}` : ''))
    : null;
  return (
    <>
      <div className="order-cab-head">
        <strong>Cab {String(idx + 1).padStart(2, '0')}{cab.name ? ' — ' + cab.name : ''}</strong>
        <span className="mono">{cab.w}{cab.wu} × {cab.h}{cab.hu} × {cab.d}{cab.du}</span>
      </div>
      <div className="order-cab-specs">
        <span>{cab.doors || 0} doors{cab.doorsRepair ? ' (repair)' : ''}</span>
        <span>{cab.drawers || 0} drawers{cab.drawersRepair ? ' (repair)' : ''}</span>
        <span>{cab.shelves || 0} shelves{cab.shelvesRepair ? ' (repair)' : ''}{cab.newShelfNeeded ? ` +${cab.newShelfCount || 1} new` : ''}</span>
        {material && <span>{material}</span>}
        {cab.finishedSide === 'Yes' && <span>Finished: {cab.finishedWhich}</span>}
        {cab.cabType && cab.cabType !== 'Standard wall' && <span>{cab.cabType}</span>}
        {cab.hardware && (
          <span>
            HW: {cab.hardware.sourcedByVendor ? 'vendor' : 'Precision'}
            {cab.hardware.softClose != null ? ` · ${cab.hardware.softClose ? 'soft-close' : 'std'}` : ''}
          </span>
        )}
        {cab.installUnderExisting === 'Yes' && (
          <span>
            Under-counter
            {cab.underCounterCutShort ? ' · cut short' : ''}
            {cab.underCounterAdjustableFeet ? ' · feet' : ''}
          </span>
        )}
      </div>
      {cab.notes && <div className="order-cab-notes">{cab.notes}</div>}
    </>
  );
}

// Cabinet edit card — inline editing
function CabinetEditCard({ cab, idx, origCab, onChange }) {
  const oc = origCab || {};
  const changed = (field) => String(cab[field] || '') !== String(oc[field] || '');

  return (
    <div className="cab-edit-card">
      <div className="edit-field full">
        <span className="label">Name</span>
        <input className={'input' + (changed('name') ? ' edited' : '')} value={cab.name || ''} onChange={e => onChange('name', e.target.value)} />
      </div>
      <div className="v-fields" style={{ marginTop: 8 }}>
        <div className="edit-field">
          <span className="label">Width</span>
          {changed('w') && <span className="edit-old-value">{oc.w}</span>}
          <input className={'input mono' + (changed('w') ? ' edited' : '')} value={cab.w || ''} onChange={e => onChange('w', e.target.value)} />
        </div>
        <div className="edit-field">
          <span className="label">Height</span>
          {changed('h') && <span className="edit-old-value">{oc.h}</span>}
          <input className={'input mono' + (changed('h') ? ' edited' : '')} value={cab.h || ''} onChange={e => onChange('h', e.target.value)} />
        </div>
        <div className="edit-field">
          <span className="label">Depth</span>
          {changed('d') && <span className="edit-old-value">{oc.d}</span>}
          <input className={'input mono' + (changed('d') ? ' edited' : '')} value={cab.d || ''} onChange={e => onChange('d', e.target.value)} />
        </div>
      </div>
      <div className="v-fields" style={{ marginTop: 8 }}>
        <div className="edit-field">
          <span className="label">Doors</span>
          <input className={'input mono' + (changed('doors') ? ' edited' : '')} type="number" min="0" value={cab.doors || 0} onChange={e => onChange('doors', parseInt(e.target.value) || 0)} />
        </div>
        <div className="edit-field">
          <span className="label">Drawers</span>
          <input className={'input mono' + (changed('drawers') ? ' edited' : '')} type="number" min="0" value={cab.drawers || 0} onChange={e => onChange('drawers', parseInt(e.target.value) || 0)} />
        </div>
        <div className="edit-field">
          <span className="label">Shelves</span>
          <input className={'input mono' + (changed('shelves') ? ' edited' : '')} type="number" min="0" value={cab.shelves || 0} onChange={e => onChange('shelves', parseInt(e.target.value) || 0)} />
        </div>
      </div>
      <div className="v-fields" style={{ marginTop: 8 }}>
        <div className="edit-field">
          <span className="label">Material</span>
          {changed('boxMaterial') && <span className="edit-old-value">{oc.boxMaterial}</span>}
          <select className={'select' + (changed('boxMaterial') ? ' edited' : '')} value={cab.boxMaterial || ''} onChange={e => onChange('boxMaterial', e.target.value)}>
            <option value="">Select…</option>
            {BOX_MATERIALS.map(m => <option key={m}>{m}</option>)}
          </select>
        </div>
        <div className="edit-field">
          <span className="label">Finished side</span>
          <div className="segmented">{['Yes', 'No'].map(opt => (
            <button key={opt} className={(cab.finishedSide === opt ? 'on' : '') + (changed('finishedSide') ? ' edited' : '')} onClick={() => onChange('finishedSide', opt)}>{opt}</button>
          ))}</div>
        </div>
      </div>
      <div className="edit-field full" style={{ marginTop: 8 }}>
        <span className="label">Notes</span>
        <textarea className={'textarea' + (changed('notes') ? ' edited' : '')} value={cab.notes || ''} onChange={e => onChange('notes', e.target.value)} />
      </div>
    </div>
  );
}

// ============================================================
// VendorInfoRequests — banner + inline response form for
// Precision-admin info requests. Shows every infoRequest entry on the
// order (pending and responded), pending ones expand with a text +
// photo form. Submitting routes through the pc_respondToInfoRequest
// callable, which writes the response into the infoRequests array
// server-side and bumps the admin's "new response" badge. (The vendor
// no longer writes the order doc directly — the hardened rules deny it.)
// ============================================================
function VendorInfoRequests({ order, orderId }) {
  const requests = Array.isArray(order?.infoRequests) ? order.infoRequests : [];
  if (requests.length === 0) return null;
  // Reverse so newest first.
  const ordered = [...requests].reverse();
  return (
    <div style={{ margin: '12px 0', display: 'flex', flexDirection: 'column', gap: 10 }}>
      {ordered.map((r) => (
        <VendorInfoRequestRow key={r.id} req={r} order={order} orderId={orderId} />
      ))}
    </div>
  );
}

function VendorInfoRequestRow({ req, order, orderId }) {
  const [open, setOpen] = React.useState(req.status !== 'responded');
  const [text, setText] = React.useState('');
  const [photos, setPhotos] = React.useState([]); // [{ id, url, storagePath }]
  const [submitting, setSubmitting] = React.useState(false);
  const isResponded = req.status === 'responded';
  const isPending = !isResponded;

  const requestedAt = (() => {
    const s = req.requestedAt;
    if (!s) return '';
    if (s.toDate) return s.toDate().toLocaleString();
    if (s instanceof Date) return s.toLocaleString();
    if (typeof s === 'string') return s;
    return '';
  })();

  const addPhoto = (u) => {
    if (photos.length >= 6) {
      if (window.bsAlert) window.bsAlert({ title: 'Photo cap reached', body: 'Up to 6 photos per response.' });
      return;
    }
    // PhotoCaptureButton's onSet passes a { src, storagePath } object (or a
    // failed-upload placeholder). Normalize to { url, storagePath } so the
    // tile renders and the callable receives a clean [{ url, storagePath }].
    const url = typeof u === 'string' ? u : ((u && u.src) || '');
    const storagePath = (u && typeof u === 'object' && u.storagePath) || null;
    if (!url) return;
    setPhotos((prev) => [...prev, { id: 'rp_' + Date.now() + '_' + prev.length, url, storagePath }]);
  };
  const removePhotoAt = (i) => setPhotos((prev) => prev.filter((_, k) => k !== i));

  const submit = async () => {
    if (text.trim().length === 0 && photos.length === 0) {
      if (window.bsAlert) window.bsAlert({ title: 'Nothing to send', body: 'Add a reply or attach at least one photo before sending.' });
      return;
    }
    setSubmitting(true);
    try {
      // Rescue any photo still on a data: URL (an upload that failed all its
      // retries) by re-uploading to Storage — mirror the order-submit rescue so
      // a base64 blob never lands inside the order doc's infoRequests array
      // (which the callable rewrites on every reply, risking the 1MB doc cap).
      const responsePhotos = [];
      for (const p of photos) {
        const isData = typeof p.url === 'string' && p.url.startsWith('data:');
        if (isData && window.uploadCabinetPhotoToStorage) {
          try {
            const r = await window.uploadCabinetPhotoToStorage(p.url, 'inforeply_' + req.id, p.id || ('rp_' + Math.random().toString(36).slice(2, 8)));
            responsePhotos.push({ url: r.src, storagePath: r.storagePath || null });
          } catch (e) {
            console.warn('Info-reply photo rescue failed:', e);
            // Skip a still-failed photo rather than embed base64 in Firestore.
          }
        } else if (typeof p.url === 'string' && !isData) {
          responsePhotos.push({ url: p.url, storagePath: p.storagePath || null });
        }
      }
      // If every attached photo failed to upload and there's no text, stop with
      // a clear message instead of hitting the server's "reply required" error.
      if (responsePhotos.length < photos.length && responsePhotos.length === 0 && text.trim().length === 0) {
        const lost = photos.length;
        if (window.bsAlert) window.bsAlert({ title: 'Photo upload failed', body: lost + ' photo(s) couldn’t upload. Check your connection and try again.' });
        setSubmitting(false);
        return;
      }
      // Route through the vendor-scoped callable. The server writes the
      // response into the order's infoRequests array and bumps the admin's
      // "new response" badge — the hardened rules DENY a direct vendor write
      // to the order doc, so we must not touch it here.
      await callFunction('pc_respondToInfoRequest', {
        orderId,
        requestId: req.id,
        responseText: text.trim(),
        responsePhotos,
      });
      setText('');
      setPhotos([]);
      setOpen(false);
      if (window.bsAlert) window.bsAlert({ title: 'Response sent', body: 'Precision has your reply and will follow up if needed.' });
    } catch (err) {
      const body = 'Failed to send response: ' + (err.message || 'Unknown error');
      if (window.bsAlert) window.bsAlert({ title: 'Send failed', body });
      else alert(body);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      border: isPending ? '2px solid #b08720' : '1px solid #16a34a',
      background: isPending ? '#fff5e6' : '#f0fdf4',
      borderRadius: 8,
      padding: '12px 14px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 11, fontFamily: 'var(--mono)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {isPending ? (
          <span style={{ background: '#b08720', color: '#fff', padding: '2px 8px', borderRadius: 999, fontWeight: 600 }}>
            ⓘ More info needed
          </span>
        ) : (
          <span style={{ background: '#16a34a', color: '#fff', padding: '2px 8px', borderRadius: 999, fontWeight: 600 }}>
            ✓ Sent
          </span>
        )}
        <span style={{ color: 'var(--ink-faint)' }}>
          From {req.requestedByName || 'Precision'}{requestedAt ? ` · ${requestedAt}` : ''}
        </span>
      </div>

      <div style={{ marginTop: 8, fontSize: 14, whiteSpace: 'pre-wrap', color: 'var(--ink)' }}>
        {req.message}
      </div>

      {(req.needsPhotos || req.needsText) && (
        <div style={{ marginTop: 4, fontSize: 11, color: 'var(--ink-soft)' }}>
          Asked for: {[req.needsPhotos && 'photos', req.needsText && 'written details'].filter(Boolean).join(' + ')}
        </div>
      )}

      {isResponded && (
        <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid #bbf7d0' }}>
          <div style={{ fontSize: 11, color: '#15803d', fontFamily: 'var(--mono)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
            Your response
          </div>
          {req.responseText && (
            <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', marginBottom: 8 }}>{req.responseText}</div>
          )}
          {Array.isArray(req.responsePhotos) && req.responsePhotos.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {req.responsePhotos.map((p, i) => (
                <img key={p.id || i} src={typeof p === 'string' ? p : (p.url || p.src)} alt={`Response photo ${i + 1}`}
                  style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 6, border: '1px solid var(--rule)' }} />
              ))}
            </div>
          )}
        </div>
      )}

      {isPending && (
        <div style={{ marginTop: 12 }}>
          {!open && (
            <button
              className="btn primary"
              style={{ width: '100%' }}
              onClick={() => setOpen(true)}
            >Reply now →</button>
          )}
          {open && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <textarea
                className="textarea"
                value={text}
                onChange={(e) => setText(e.target.value)}
                rows={4}
                placeholder="Type your reply…"
                maxLength={2000}
                style={{ fontSize: 16 }}
              />
              <div>
                <div style={{ fontSize: 12, color: 'var(--ink-soft)', marginBottom: 6 }}>
                  Attach photos ({photos.length} / 6)
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {photos.map((p, i) => (
                    <div key={p.id || i} style={{ position: 'relative' }}>
                      <img src={p.url} alt="" style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 6, border: '1px solid var(--rule)' }} />
                      <button
                        type="button"
                        onClick={() => removePhotoAt(i)}
                        style={{
                          position: 'absolute', top: -6, right: -6, width: 22, height: 22, borderRadius: 11,
                          background: '#b91c1c', color: '#fff', border: '2px solid #fff', fontSize: 12,
                          cursor: 'pointer', display: 'grid', placeItems: 'center', padding: 0,
                        }}
                      >×</button>
                    </div>
                  ))}
                  {photos.length < 6 && (
                    <div style={{ display: 'flex', gap: 4 }}>
                      <div style={{ width: 72 }}>
                        <PhotoCaptureButton kind="camera" onSet={addPhoto} compact />
                      </div>
                      <div style={{ width: 72 }}>
                        <PhotoCaptureButton kind="upload" onSet={addPhoto} compact />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                <button className="btn ghost" onClick={() => { setOpen(false); setText(''); setPhotos([]); }} disabled={submitting}>
                  Cancel
                </button>
                <button className="btn primary" onClick={submit} disabled={submitting}>
                  {submitting ? 'Sending…' : 'Send to Precision →'}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

Object.assign(window, { OrderDetailPage });

})();

// ===== router.jsx =====
(function(){
// Simple hash-based router for the vendor PWA
// Routes: #/login, #/dashboard, #/orders/:id, #/new

function useHashRouter() {
  const [route, setRoute] = React.useState(parseHash());

  React.useEffect(() => {
    const handler = () => setRoute(parseHash());
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);

  return route;
}

function parseHash() {
  const hash = window.location.hash.replace(/^#\/?/, '');
  if (!hash || hash === '/') {
    // SMS deep link (?order=<id>). The backend sends a QUERY param, not a
    // #fragment, because fragments get dropped by some URL shorteners /
    // in-app webviews. Honor it ONLY when the hash hasn't already picked a
    // route (a fresh open) — once we navigate to #/orders/:id the hash is
    // authoritative and app.jsx strips ?order= so this stops re-firing.
    try {
      const qOrder = new URLSearchParams(window.location.search).get('order');
      if (qOrder) return { page: 'order-detail', params: { orderId: qOrder } };
    } catch {}
    return { page: 'home', params: {} };
  }
  const parts = hash.split('/');

  if (parts[0] === 'login') return { page: 'login', params: {} };
  if (parts[0] === 'dashboard') return { page: 'dashboard', params: {} };
  if (parts[0] === 'new') return { page: 'new', params: {} };
  if (parts[0] === 'drafts' && parts[1]) {
    return { page: 'draft', params: { draftId: parts[1], openRetail: parts[2] === 'retail' } };
  }
  // Edit an existing (pre-production) order in the full wizard. Must come
  // BEFORE the generic orders/:id branch so /orders/:id/edit isn't swallowed.
  if (parts[0] === 'orders' && parts[1] && parts[2] === 'edit') {
    return { page: 'edit-order', params: { orderId: parts[1] } };
  }
  if (parts[0] === 'orders' && parts[1]) return { page: 'order-detail', params: { orderId: parts[1] } };
  // Warranty route disabled — see admin /coming-soon for status.
  // if (parts[0] === 'w' && parts[1]) return { page: 'warranty', params: { warrantyId: parts[1] } };

  return { page: 'home', params: {} };
}

function navigate(path) {
  window.location.hash = path;
}

Object.assign(window, { useHashRouter, navigate });

})();

// ===== app.jsx =====
(function(){
// Main app — vendor PWA (email/password auth, multi-contact per vendor).
//
// Boot path (v14, slug retired):
//   1. onAuthStateChanged fires.
//   2. No user                            → <SignInScreen />.
//   3. Wrong role                         → signOut + toast.
//   4. claims.mustChangePassword === true → <ChangePasswordScreen />.
//   5. Otherwise: load vendors/{claims.vendorId} + vendorContacts/{uid}
//      in parallel, then render the existing hash router.
//
// One-shot localStorage cleanup wipes the retired slug keys on first
// boot of v14 so old PWA installs don't carry stale state forward.
const { useState: useS, useMemo: useM, useEffect: useE } = React;

const todayISO = () => new Date().toISOString().slice(0, 10);

// Aggressive Firestore payload scrub. The user kept hitting "array
// contains an invalid nested entity" — the safest pre-treatment is a
// JSON round-trip (drops undefined, functions, NaN, Infinity, DOM
// nodes, React fibers, anything non-serializable) followed by a
// recursive walk that wraps any direct array-of-array values in an
// object so Firestore accepts them.
function sanitizeForFirestore(value) {
  // Round-trip first to strip non-serializable junk. Replacer also
  // converts NaN/Infinity → null and drops `undefined` properties.
  let plain;
  try {
    plain = JSON.parse(JSON.stringify(value, (key, v) => {
      if (v === undefined) return null;
      if (typeof v === 'number' && !Number.isFinite(v)) return null;
      if (typeof v === 'function') return null;
      // Firestore Timestamps survive — toJSON returns ISO string,
      // which Firestore re-accepts as a Timestamp on write.
      return v;
    }));
  } catch {
    return null;
  }
  return scrubArrays(plain);
}

function scrubArrays(value) {
  if (value === null || typeof value !== 'object') return value;
  if (Array.isArray(value)) {
    return value.map((item) => {
      if (Array.isArray(item)) {
        // Firestore disallows direct array nesting — wrap inner array.
        return { items: scrubArrays(item) };
      }
      return scrubArrays(item);
    });
  }
  const out = {};
  for (const k of Object.keys(value)) {
    out[k] = scrubArrays(value[k]);
  }
  return out;
}

const blankData = () => ({
  vendorName: '', vendorContact: '', vendorPhone: '', vendorEmail: '', vendorPO: '',
  clientName: '', clientPhone: '', clientEmail: '',
  preferredContact: 'Phone',
  address: '', installNeeded: null, serviceMode: null, serviceToggles: null, homeType: 'Residential',
  accessNotes: '',
  dateReceived: todayISO(), completionRequested: '',
  timeframe: '1mo',
  // Cabinets created on demand by the wizard (Step 6); no need to
  // seed an empty one — it caused phantom cabinets in the review.
  cabinets: [],
  toeKick: { height: '4', setback: '3', thickness: '1/4"', heightU: 'in', depthU: 'in', setbackU: 'in' },
  scribe: { needed: 'No', linearFeet: '', matchMaterial: 'Yes' },
  rush: false,
  specialInstructions: '',
  draftId: generateDraftId(),
});

// ============================================================
// HI-5 — local wizard safety net. A new order lives only in React state
// until the vendor taps "Save as Draft" (which creates a Firestore doc).
// A refresh, PWA kill, or accidental back-nav before that first save
// used to wipe everything. We mirror the working `data` into localStorage
// (debounced) so it survives, then rehydrate on mount when the form is
// still blank. This is a PURELY LOCAL net — it never creates Firestore
// docs. The key is cleared the moment a real draft/submit exists so stale
// data can't resurrect. The schema version stamp guards against reading a
// snapshot written by an older/newer wizard shape.
// ============================================================
const WIZARD_DRAFT_LS_KEY = 'pc.wizardDraft.v1';
const WIZARD_DRAFT_SCHEMA_VERSION = 1;

// Drop heavy base64 / data: URL photo payloads before persisting to
// localStorage. Uploaded photos already carry small https download URLs
// (kept); only legacy or upload-failed entries hold a data: URL, which we
// omit so we never blow the ~5MB localStorage quota. Dimensions, cabinet
// config, and customer fields — the stuff worth protecting — are kept.
function slimWizardDataForLocal(data) {
  try {
    const clone = JSON.parse(JSON.stringify(data || {}));
    const isDataUrl = (s) => typeof s === 'string' && s.startsWith('data:');
    if (Array.isArray(clone.cabinets)) {
      clone.cabinets.forEach((c) => {
        if (!c || typeof c !== 'object') return;
        if (isDataUrl(c.photo)) c.photo = null;
        if (Array.isArray(c.photos)) c.photos = c.photos.filter((p) => !isDataUrl(p && p.src));
      });
    }
    return clone;
  } catch { return data; }
}

function saveWizardLocalDraft(data) {
  try {
    localStorage.setItem(WIZARD_DRAFT_LS_KEY, JSON.stringify({
      v: WIZARD_DRAFT_SCHEMA_VERSION,
      savedAt: new Date().toISOString(),
      data: slimWizardDataForLocal(data),
    }));
  } catch (err) {
    // Quota / serialization failure — this net is strictly best-effort.
    try { console.warn('wizard local-draft save failed:', err); } catch {}
  }
}

function loadWizardLocalDraft() {
  try {
    const raw = localStorage.getItem(WIZARD_DRAFT_LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Version mismatch → discard rather than rehydrate an incompatible shape.
    if (!parsed || parsed.v !== WIZARD_DRAFT_SCHEMA_VERSION || !parsed.data) return null;
    return parsed.data;
  } catch { return null; }
}

function clearWizardLocalDraft() {
  try { localStorage.removeItem(WIZARD_DRAFT_LS_KEY); } catch {}
}

// A wizard is "blank" (safe to overwrite with a rehydrated snapshot) when
// the vendor hasn't entered a customer, address, or any cabinet yet.
function isWizardDataBlank(d) {
  if (!d) return true;
  const hasClient = d.clientName && String(d.clientName).trim();
  const hasAddress = d.address && String(d.address).trim();
  const hasCabs = Array.isArray(d.cabinets) && d.cabinets.length > 0;
  return !hasClient && !hasAddress && !hasCabs;
}


// ============================================================
// SignInScreen — email + password, with "forgot password" reset.
// Prefills email from localStorage; persists on successful sign-in
// so PWA relaunches land on the password field.
// ============================================================
const LAST_EMAIL_KEY = 'pc.lastSignedInEmail';

function SignInScreen() {
  const [email, setEmail] = useS(() => {
    try { return localStorage.getItem(LAST_EMAIL_KEY) || ''; } catch { return ''; }
  });
  const [password, setPassword] = useS('');
  const [showPw, setShowPw] = useS(false);
  const [submitting, setSubmitting] = useS(false);
  const [error, setError] = useS('');
  const [resetSending, setResetSending] = useS(false);
  const [resetMsg, setResetMsg] = useS('');

  const mapAuthError = (code) => {
    switch (code) {
      case 'auth/invalid-credential':
      case 'auth/wrong-password':
      case 'auth/user-not-found':
        return 'Email or password is incorrect.';
      case 'auth/too-many-requests':
        return 'Too many failed attempts. Wait a few minutes and try again.';
      case 'auth/user-disabled':
        return 'This account has been deactivated. Contact Precision Cabinets.';
      case 'auth/invalid-email':
        return 'That doesn’t look like a valid email address.';
      default:
        return 'Sign-in failed. Check your connection and try again.';
    }
  };

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setError('');
    setResetMsg('');
    if (!email || !password) {
      setError('Enter your email and password.');
      return;
    }
    setSubmitting(true);
    try {
      await auth.signInWithEmailAndPassword(email.trim(), password);
      try { localStorage.setItem(LAST_EMAIL_KEY, email.trim()); } catch {}
      // onAuthStateChanged in AppRoot will pick it up from here.
    } catch (err) {
      setError(mapAuthError(err && err.code));
    } finally {
      setSubmitting(false);
    }
  };

  const sendReset = async () => {
    setError('');
    setResetMsg('');
    if (!email.trim()) {
      setError('Enter your email above first, then tap "Forgot password".');
      return;
    }
    setResetSending(true);
    try {
      await auth.sendPasswordResetEmail(email.trim());
      setResetMsg('Password reset email sent. Check your inbox (and spam).');
    } catch (err) {
      setError(mapAuthError(err && err.code));
    } finally {
      setResetSending(false);
    }
  };

  return (
    <div className="app-loading" style={{ alignItems: 'stretch', padding: '32px 24px', maxWidth: 420, margin: '0 auto' }}>
      <div style={{ textAlign: 'center' }}>
        <div className="brand-mark" style={{ width: 64, height: 64, margin: '0 auto 12px' }}></div>
        <h2 style={{ fontFamily: 'var(--serif)', margin: '8px 0 4px' }}>Precision Cabinets LLC</h2>
        <p style={{ color: 'var(--ink-soft)', fontSize: 14, marginTop: 0 }}>Vendor sign-in</p>
      </div>

      <form onSubmit={submit} style={{ marginTop: 24 }}>
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--ink-soft)', display: 'block', marginBottom: 6 }}>Email</label>
          <input
            className="input"
            type="email"
            inputMode="email"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            autoComplete="username"
            autoFocus={!email}
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="you@company.com"
            required
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--ink-soft)', display: 'block', marginBottom: 6 }}>Password</label>
          <div style={{ position: 'relative' }}>
            <input
              className="input"
              type={showPw ? 'text' : 'password'}
              autoComplete="current-password"
              autoFocus={!!email}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{ paddingRight: 48 }}
            />
            <button
              type="button"
              onClick={() => setShowPw(v => !v)}
              aria-label={showPw ? 'Hide password' : 'Show password'}
              style={{ position: 'absolute', right: 4, top: 4, width: 40, height: 40, background: 'none', border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--ink-soft)' }}
            >
              {showPw ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>
        </div>

        {error && (
          <div style={{ marginTop: 10, fontSize: 13, color: 'var(--danger, #b91c1c)', background: '#fef2f2', padding: 10, borderRadius: 6 }}>
            {error}
          </div>
        )}
        {resetMsg && (
          <div style={{ marginTop: 10, fontSize: 13, color: '#065f46', background: '#ecfdf5', padding: 10, borderRadius: 6 }}>
            {resetMsg}
          </div>
        )}

        <button
          type="submit"
          className="btn primary lg"
          style={{ width: '100%', marginTop: 14 }}
          disabled={submitting}
        >
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>

        <button
          type="button"
          onClick={sendReset}
          disabled={resetSending}
          style={{ display: 'block', margin: '12px auto', padding: '12px 16px', background: 'none', border: 0, color: 'var(--accent-deep,#a06400)', fontSize: 14, cursor: 'pointer' }}
        >
          {resetSending ? 'Sending reset email…' : 'Forgot password?'}
        </button>
      </form>

      <div style={{ marginTop: 24, fontSize: 12, color: 'var(--ink-faint)', textAlign: 'center' }}>
        Need an account? Contact Precision Cabinets at (480) 555-0100.
      </div>
    </div>
  );
}

// ============================================================
// ChangePasswordScreen — mandatory first-login password rotation.
// Renders when mustChangePassword=true on either the ID token claims
// or the vendorContacts/{uid} doc. After a successful change we call
// pc_clearMustChangePassword, then force-refresh the ID token so the
// next render of AppRoot sees the cleared claim.
//
// Firebase requires a "recent" sign-in to call updatePassword. If the
// session is past that window we re-prompt the temp password and
// reauthenticate before retrying.
// ============================================================
function ChangePasswordScreen({ email }) {
  const [next1, setNext1] = useS('');
  const [next2, setNext2] = useS('');
  const [tempPw, setTempPw] = useS('');
  const [needReauth, setNeedReauth] = useS(false);
  const [submitting, setSubmitting] = useS(false);
  const [error, setError] = useS('');
  const [showPw1, setShowPw1] = useS(false);
  const [showPw2, setShowPw2] = useS(false);

  const renderEyeButton = (visible, toggle) => (
    <button
      type="button"
      onClick={toggle}
      aria-label={visible ? 'Hide password' : 'Show password'}
      style={{ position: 'absolute', right: 4, top: 4, width: 40, height: 40, background: 'none', border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--ink-soft)' }}
    >
      {visible ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
          <line x1="1" y1="1" x2="23" y2="23"/>
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
          <circle cx="12" cy="12" r="3"/>
        </svg>
      )}
    </button>
  );

  const strengthHint = (() => {
    const p = next1;
    if (!p) return '';
    if (p.length < 8) return 'Too short — minimum 8 characters.';
    const classes = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^A-Za-z0-9]/].filter(rx => rx.test(p)).length;
    if (classes <= 1) return 'Weak — mix in upper-case, numbers, or symbols.';
    if (classes === 2) return 'OK — a longer or more varied password is safer.';
    if (classes === 3) return 'Strong.';
    return 'Very strong.';
  })();

  const signOut = async () => {
    try { await auth.signOut(); } catch {}
  };

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setError('');
    if (next1.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (next1 !== next2) { setError('The two passwords don’t match.'); return; }
    const user = auth.currentUser;
    if (!user) { setError('Session expired. Sign in again.'); return; }
    setSubmitting(true);
    try {
      if (needReauth) {
        const cred = firebase.auth.EmailAuthProvider.credential(user.email, tempPw);
        await user.reauthenticateWithCredential(cred);
        setNeedReauth(false);
      }
      await user.updatePassword(next1);
      // Clear the claim server-side, then refresh the ID token so the
      // next AppRoot render picks up mustChangePassword=false.
      try {
        await callFunction('pc_clearMustChangePassword', {});
      } catch (err) {
        console.warn('pc_clearMustChangePassword failed:', err);
      }
      await user.getIdToken(true);
      // AppRoot is listening to onIdTokenChanged via onAuthStateChanged
      // refresh; nothing else to do here.
    } catch (err) {
      if (err && err.code === 'auth/requires-recent-login') {
        setNeedReauth(true);
        setError('For security, please re-enter your current (temporary) password to continue.');
      } else if (err && err.code === 'auth/weak-password') {
        setError('Password is too weak. Use at least 8 characters and mix character types.');
      } else if (err && err.code === 'auth/wrong-password') {
        setError('Current password is incorrect.');
      } else {
        setError(err && err.message ? err.message : 'Could not change password.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="app-loading" style={{ alignItems: 'stretch', padding: '32px 24px', maxWidth: 420, margin: '0 auto' }}>
      <div style={{ textAlign: 'center' }}>
        <div className="brand-mark" style={{ width: 64, height: 64, margin: '0 auto 12px' }}></div>
        <h2 style={{ fontFamily: 'var(--serif)', margin: '8px 0 4px' }}>Set your password</h2>
        <p style={{ color: 'var(--ink-soft)', fontSize: 13, marginTop: 0 }}>
          One-time setup for <strong>{email || 'your account'}</strong>.
        </p>
      </div>

      <form onSubmit={submit} style={{ marginTop: 20 }}>
        {needReauth && (
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, color: 'var(--ink-soft)', display: 'block', marginBottom: 6 }}>
              Current (temporary) password
            </label>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              value={tempPw}
              onChange={e => setTempPw(e.target.value)}
              required
            />
          </div>
        )}

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--ink-soft)', display: 'block', marginBottom: 6 }}>
            New password
          </label>
          <div style={{ position: 'relative' }}>
            <input
              className="input"
              type={showPw1 ? 'text' : 'password'}
              autoComplete="new-password"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              value={next1}
              onChange={e => setNext1(e.target.value)}
              required
              minLength={8}
              style={{ paddingRight: 48 }}
            />
            {renderEyeButton(showPw1, () => setShowPw1(v => !v))}
          </div>
          {strengthHint && (
            <div className="hint" style={{ marginTop: 4, fontSize: 11 }}>{strengthHint}</div>
          )}
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--ink-soft)', display: 'block', marginBottom: 6 }}>
            Confirm new password
          </label>
          <div style={{ position: 'relative' }}>
            <input
              className="input"
              type={showPw2 ? 'text' : 'password'}
              autoComplete="new-password"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              value={next2}
              onChange={e => setNext2(e.target.value)}
              required
              minLength={8}
              style={{ paddingRight: 48 }}
            />
            {renderEyeButton(showPw2, () => setShowPw2(v => !v))}
          </div>
        </div>

        {error && (
          <div style={{ marginTop: 10, fontSize: 13, color: 'var(--danger, #b91c1c)', background: '#fef2f2', padding: 10, borderRadius: 6 }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          className="btn primary lg"
          style={{ width: '100%', marginTop: 14 }}
          disabled={submitting}
        >
          {submitting ? 'Saving…' : 'Save password and continue'}
        </button>
      </form>

      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <button className="btn ghost" style={{ fontSize: 12 }} onClick={signOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}

// ============================================================
// VendorHeader — sticky top bar with sign-out menu.
// Shows the company brand line, the vendor company name, and the
// signed-in contact's name. The right-side button opens a tiny
// pop-over with "My Orders" + "Sign out".
// ============================================================
function VendorHeader({ vendor, contact, showDashboard, onDashboard }) {
  const [menuOpen, setMenuOpen] = useS(false);
  const [isNarrow, setIsNarrow] = useS(() => typeof window !== 'undefined' && window.innerWidth < 600);
  const ref = React.useRef(null);

  // Track viewport width so we can render the account menu as either an
  // inline absolute-positioned dropdown (desktop) or a BottomSheet (phone).
  useE(() => {
    const onResize = () => setIsNarrow(window.innerWidth < 600);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useE(() => {
    if (!menuOpen) return;
    if (isNarrow) return; // BottomSheet handles its own outside-click.
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('touchstart', onDoc);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('touchstart', onDoc);
    };
  }, [menuOpen, isNarrow]);

  const signOut = async () => {
    setMenuOpen(false);
    try { await auth.signOut(); } catch (err) { console.warn('signOut failed:', err); }
  };

  // BottomSheet + BottomSheetActions come from bottom-sheet.jsx (loaded
  // before app.jsx in index.html). If for any reason they're missing,
  // fall back to the legacy inline dropdown so the menu still works.
  const BSheet = (typeof window !== 'undefined' && window.BottomSheet) || null;
  const BSheetActions = (typeof window !== 'undefined' && window.BottomSheetActions) || null;
  const useSheet = isNarrow && BSheet && BSheetActions;

  return (
    <header className={'vendor-header' + (isNarrow ? ' vendor-header-narrow' : '')}>
      <div className="vendor-header-brand">Precision Cabinets LLC</div>
      <div className="vendor-header-name" style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{vendor && vendor.name ? vendor.name : ''}</span>
        {contact && contact.name && (
          <span style={{ fontSize: 12, fontWeight: 400, color: 'var(--ink-soft)', fontFamily: 'var(--sans)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            · {contact.name}
          </span>
        )}
      </div>
      <div ref={ref} style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 6 }}>
        {showDashboard && (
          <button className="vendor-header-btn" onClick={onDashboard}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
              <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
            </svg>
            My Orders
          </button>
        )}
        <button
          className="vendor-header-btn"
          aria-label="Account menu"
          onClick={() => setMenuOpen(v => !v)}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4"/>
            <path d="M4 21c1.5-4 5-6 8-6s6.5 2 8 6"/>
          </svg>
        </button>
        {!useSheet && menuOpen && (
          <div
            role="menu"
            style={{
              position: 'absolute', right: 0, top: 'calc(100% + 6px)',
              background: '#fff', border: '1px solid var(--rule)', borderRadius: 8,
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)', minWidth: 180, zIndex: 60,
              padding: 6,
            }}
          >
            <div style={{ padding: '8px 10px', borderBottom: '1px solid var(--rule)', fontSize: 11, color: 'var(--ink-faint)' }}>
              {contact && contact.email ? contact.email : 'Signed in'}
            </div>
            <button
              role="menuitem"
              className="btn ghost"
              style={{ width: '100%', justifyContent: 'flex-start', fontSize: 13 }}
              onClick={signOut}
            >
              Sign out
            </button>
          </div>
        )}
      </div>
      {useSheet && (
        <BSheet open={menuOpen} onClose={() => setMenuOpen(false)} title="Account">
          <div style={{ padding: '4px 4px 12px', fontSize: 13, color: 'var(--ink-soft)' }}>
            You're signed in as <strong>{contact && contact.name ? contact.name : (contact && contact.email) || 'this account'}</strong>.
            {contact && contact.email && (
              <div style={{ fontSize: 11, color: 'var(--ink-faint)', marginTop: 4 }}>{contact.email}</div>
            )}
          </div>
          <BSheetActions>
            <button
              className="btn ghost"
              style={{ width: '100%', justifyContent: 'flex-start' }}
              onClick={() => { setMenuOpen(false); window.bsAlert && window.bsAlert({ title: 'Edit profile', body: 'Profile editing is coming soon. For now, contact Precision Cabinets to update your contact info.' }); }}
            >
              Edit profile
            </button>
            <button
              className="btn primary"
              style={{ width: '100%' }}
              onClick={signOut}
            >
              Sign out
            </button>
          </BSheetActions>
        </BSheet>
      )}
    </header>
  );
}

// ============================================================
// Root — auth-gated. No user → SignInScreen. mustChangePassword →
// ChangePasswordScreen. Otherwise load vendor + contact docs then
// render the hash router.
// ============================================================
function AppRoot() {
  const [user, setUser] = useS(null);
  const [claims, setClaims] = useS(null);
  const [contact, setContact] = useS(null);
  const [vendor, setVendor] = useS(null);
  const [loading, setLoading] = useS(true);
  const [slowLoading, setSlowLoading] = useS(false);
  const [authError, setAuthError] = useS('');
  const route = useHashRouter();

  // Keyboard-aware sticky footer.
  //
  // History:
  //   v18: --kb-offset lifted footer above keyboard → bar shoved over
  //        the input row the vendor was typing into. BAD.
  //   v19: detect kbHeight OR focused editable → hide footer. Solved
  //        the cover-input bug but the focusEditable OR-check made
  //        kb-open STICKY on iOS — after dismissing keyboard, the
  //        input can keep focus (no blur fires until user taps a
  //        non-focusable target), so the footer stayed hidden and
  //        vendors thought Back/Next/Total were broken (verbatim
  //        feedback 2026-06-18).
  //   v20 (this): VIEWPORT-HEIGHT ONLY. If iOS keyboard is up, the
  //        visual viewport shrinks → we hide. The moment the keyboard
  //        animates closed (visualViewport.resize fires with full
  //        height) we restore. No focus-based heuristic that can get
  //        wedged. Threshold raised 60 → 150px so transient bottom-
  //        bar URL collapses on iOS Safari don't false-trigger.
  useE(() => {
    if (typeof window === 'undefined') return;
    const root = document.documentElement;
    const body = document.body;
    let lastKbOpen = false;
    const apply = () => {
      const kbHeight = window.visualViewport
        ? Math.max(0, window.innerHeight - window.visualViewport.height)
        : 0;
      root.style.setProperty('--kb-offset', kbHeight + 'px');
      // Only treat as keyboard-open when the height drop is large
      // (>150px). Real software keyboards take 250-340px on iOS / 220-
      // 380px on Android; nothing else legitimately shrinks visualViewport
      // by that much.
      const open = kbHeight > 150;
      if (open !== lastKbOpen) {
        lastKbOpen = open;
        body.classList.toggle('kb-open', open);
      }
    };
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', apply);
    }
    // Defensive: re-evaluate when the page visibility flips or on
    // pageshow (returning to the PWA from background). visualViewport
    // doesn't always fire `resize` on app resume on iOS.
    document.addEventListener('visibilitychange', apply);
    window.addEventListener('pageshow', apply);
    apply();
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', apply);
      }
      document.removeEventListener('visibilitychange', apply);
      window.removeEventListener('pageshow', apply);
      root.style.removeProperty('--kb-offset');
      body.classList.remove('kb-open');
    };
  }, []);

  // Surface a "stuck loading?" panel after 5s so users on slow networks
  // get a recovery path (sign out / reload) instead of a forever spinner.
  useE(() => {
    if (!loading) { setSlowLoading(false); return; }
    const id = setTimeout(() => setSlowLoading(true), 5000);
    return () => clearTimeout(id);
  }, [loading]);

  // One-shot localStorage cleanup. Wipes the retired slug keys the
  // first time v14 boots on a given device so stale state doesn't
  // leak into the auth-only flow.
  useE(() => {
    try {
      if (!localStorage.getItem('pc.cleanedV14')) {
        localStorage.removeItem('pc.vendorSlug');
        localStorage.removeItem('cabinet_intake_vendors_v1');
        localStorage.setItem('pc.cleanedV14', '1');
      }
    } catch {}
  }, []);

  // Cache shop constants + company info up-front. These are public
  // reads so they're safe to issue before sign-in completes.
  useE(() => {
    db.collection('shopConstants').doc('current').get()
      .then(snap => { if (snap.exists) window.PC_SHOP_CONSTANTS = snap.data(); })
      .catch(() => {});
    db.collection('companyInfo').doc('current').get()
      .then(snap => { if (snap.exists) window.PC_COMPANY_INFO = snap.data(); })
      .catch(() => {});
  }, []);

  // SMS deep link: capture ?order=<id> at app load — BEFORE the sign-in
  // wall can swallow it — so the target survives a sign-in round-trip. The
  // onIdTokenChanged handler consumes it once a vendor resolves (works
  // whether the vendor was already signed in or had to sign in first).
  useE(() => {
    try {
      const q = new URLSearchParams(window.location.search).get('order');
      if (q) sessionStorage.setItem('pc.pendingOrder', q);
    } catch {}
  }, []);

  // The single source of truth for who's signed in. We resolve the
  // token claims AND the contact + vendor docs here so downstream
  // components don't have to await anything.
  //
  // NOTE: onIdTokenChanged (not onAuthStateChanged) so this re-runs
  // after getIdToken(true) following a successful first-login password
  // change — otherwise the cleared mustChangePassword claim never makes
  // it back into React state and the user is stuck on the change
  // password screen forever.
  useE(() => {
    let cancelled = false;
    const unsub = auth.onIdTokenChanged(async (u) => {
      if (cancelled) return;
      setAuthError('');
      if (!u) {
        setUser(null); setClaims(null); setContact(null); setVendor(null);
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const tokenResult = await u.getIdTokenResult();
        const c = tokenResult.claims || {};
        if (c.role && c.role !== 'vendor') {
          setAuthError('This account isn’t a vendor account. Signing out.');
          await auth.signOut();
          return;
        }
        setUser(u);
        setClaims(c);

        if (c.mustChangePassword) {
          // Don't bother loading vendor + contact docs yet — the
          // ChangePasswordScreen doesn't render them, and Firestore
          // rules may also block reads until the rotation is done.
          setContact(null); setVendor(null);
          setLoading(false);
          return;
        }

        const vendorId = c.vendorId;
        if (!vendorId) {
          setAuthError('Your account is missing a vendor assignment. Contact Precision Cabinets.');
          await auth.signOut();
          return;
        }

        const [contactSnap, vendorSnap] = await Promise.all([
          db.collection('vendorContacts').doc(u.uid).get(),
          db.collection('vendors').doc(vendorId).get(),
        ]);

        if (cancelled) return;

        const contactData = contactSnap.exists ? { uid: u.uid, ...contactSnap.data() } : null;
        const vendorData = vendorSnap.exists ? { id: vendorSnap.id, ...vendorSnap.data() } : null;

        // Contact-doc fallback for mustChangePassword — in case the
        // custom claim hasn't been minted yet but the doc says we
        // must rotate. Either signal triggers the change screen.
        if (contactData && contactData.mustChangePassword) {
          setContact(contactData); setVendor(vendorData);
          setClaims({ ...c, mustChangePassword: true });
          setLoading(false);
          return;
        }

        if (!vendorData) {
          setAuthError('Vendor record not found. Contact Precision Cabinets.');
          await auth.signOut();
          return;
        }

        setContact(contactData);
        setVendor(vendorData);
        setLoading(false);

        // SMS deep link: now that we have a fully-resolved vendor, honor any
        // pending ?order target captured at app load. Route to the order and
        // strip ?order= from the URL so a manual refresh doesn't re-trigger it.
        try {
          const pending = sessionStorage.getItem('pc.pendingOrder');
          if (pending) {
            sessionStorage.removeItem('pc.pendingOrder');
            navigate('/orders/' + pending);
            try {
              const url = new URL(window.location.href);
              url.searchParams.delete('order');
              window.history.replaceState({}, '', url.pathname + url.search + url.hash);
            } catch {}
          }
        } catch {}
      } catch (err) {
        console.error('Auth bootstrap failed:', err);
        if (!cancelled) {
          setAuthError(err && err.message ? err.message : 'Sign-in error.');
          setLoading(false);
        }
      }
    });
    return () => { cancelled = true; unsub(); };
  }, []);

  if (loading) {
    return (
      <div className="app-loading">
        <div className="brand-mark" style={{ width: 64, height: 64 }}></div>
        <p>Loading…</p>
        {slowLoading && (
          <div style={{
            marginTop: 16, padding: 12, background: '#fff7ed', border: '1px solid #fed7aa',
            borderRadius: 8, maxWidth: 320, textAlign: 'center', fontSize: 13, color: '#92400e',
          }}>
            <div style={{ marginBottom: 8 }}>Stuck loading?</div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                className="btn ghost"
                style={{ fontSize: 13 }}
                onClick={async () => { try { await auth.signOut(); } catch {} window.location.reload(); }}
              >
                Sign out
              </button>
              <button
                className="btn primary"
                style={{ fontSize: 13 }}
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (!user) {
    return (
      <>
        {authError && (
          <div style={{
            position: 'fixed', top: 'calc(12px + env(safe-area-inset-top))', left: '50%', transform: 'translateX(-50%)',
            background: '#fef2f2', color: '#b91c1c', padding: '8px 14px',
            borderRadius: 8, fontSize: 13, zIndex: 100, maxWidth: 380, textAlign: 'center',
          }}>
            {authError}
          </div>
        )}
        <SignInScreen />
      </>
    );
  }

  if (claims && claims.mustChangePassword) {
    return <ChangePasswordScreen email={user.email} />;
  }

  if (!vendor) {
    // Defensive — shouldn't happen because we sign-out above when the
    // vendor doc is missing, but renders cleanly if it does.
    return (
      <div className="app-loading">
        <p>Loading vendor…</p>
      </div>
    );
  }

  if (route.page === 'order-detail') {
    return (
      <>
        <VendorHeader vendor={vendor} contact={contact} showDashboard={true} onDashboard={() => navigate('/dashboard')} />
        <OrderDetailPage orderId={route.params.orderId} onBack={() => navigate('/dashboard')} isVendor={true} />
      </>
    );
  }

  if (route.page === 'new') {
    return (
      <>
        <VendorHeader vendor={vendor} contact={contact} showDashboard={true} onDashboard={() => navigate('/dashboard')} />
        <PostSubmitErrorBoundary onReset={() => navigate('/dashboard')}>
          <NewOrderPage vendor={vendor} contact={contact} onDone={() => navigate('/dashboard')} />
        </PostSubmitErrorBoundary>
      </>
    );
  }

  if (route.page === 'draft') {
    return (
      <>
        <VendorHeader vendor={vendor} contact={contact} showDashboard={true} onDashboard={() => navigate('/dashboard')} />
        <PostSubmitErrorBoundary onReset={() => navigate('/dashboard')}>
          <NewOrderPage vendor={vendor} contact={contact} draftOrderId={route.params.draftId} openRetailOnLoad={!!route.params.openRetail} onDone={() => navigate('/dashboard')} />
        </PostSubmitErrorBoundary>
      </>
    );
  }

  if (route.page === 'edit-order') {
    // Reopen a pre-production order in the SAME wizard as a new order
    // (add-cabinets step included). NewOrderPage seeds from the order + its
    // frozen pricing snapshot and saves back through pc_editOrder.
    return (
      <>
        <VendorHeader vendor={vendor} contact={contact} showDashboard={true} onDashboard={() => navigate('/dashboard')} />
        <PostSubmitErrorBoundary onReset={() => navigate('/orders/' + route.params.orderId)}>
          <NewOrderPage vendor={vendor} contact={contact} editOrderId={route.params.orderId} onDone={() => navigate('/orders/' + route.params.orderId)} />
        </PostSubmitErrorBoundary>
      </>
    );
  }

  // Default: dashboard
  return (
    <>
      <VendorHeader vendor={vendor} contact={contact} showDashboard={false} />
      <VendorDashboard
        vendorId={vendor.id}
        vendorName={vendor.name}
        contactName={contact && contact.name}
        hideEstimates={vendor?.hideEstimates === true}
        onNewOrder={() => navigate('/new')}
        onViewOrder={(id) => navigate('/orders/' + id)}
      />
    </>
  );
}

// ============================================================
// ErrorBoundary — catches render errors anywhere in its subtree and
// shows a friendly fallback instead of unmounting to a blank screen.
// Critical post-submit because the vendor's order is ALREADY in
// Firestore — we don't want a SubmittedStep render bug to look like
// "submit failed" when really it succeeded.
//
// Also wrapped around the ENTIRE NewOrderPage (2026-06-18) because
// the vendor reported "blank screen after submit" with only a
// submit-click trace event — meaning the ChecklistModal renders
// invisibly or throws silently. ErrorBoundary at the page level
// catches anything anywhere in the wizard tree.
// ============================================================
class PostSubmitErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('[PostSubmitErrorBoundary] render error:', error, info);
    try { window.__pcLastRenderError = { message: error?.message, stack: error?.stack, componentStack: info?.componentStack, at: new Date().toISOString() }; } catch {}
    try { if (window.pcDebugLog) window.pcDebugLog('react-render-error', error?.message || String(error), (error?.stack || '') + '\n--\nReact stack:\n' + (info?.componentStack || '')); } catch {}
  }
  render() {
    if (this.state.hasError) {
      const orderNumber = this.props.orderNumber || '';
      const orderId = this.props.orderId || '';
      return (
        <div style={{
          maxWidth: 520, margin: '40px auto', padding: 20,
          background: '#fff', border: '2px solid #b91c1c', borderRadius: 12,
        }}>
          <h2 style={{ color: '#b91c1c', marginTop: 0 }}>Order saved — display error</h2>
          <p>
            Good news: your order <strong className="mono">{orderNumber || '(saved)'}</strong> was
            submitted successfully to Precision Cabinets. There was a problem rendering the
            confirmation screen — but the order is in our system.
          </p>
          {this.state.error?.message && (
            <pre style={{ background: '#fef2f2', padding: 10, borderRadius: 6, fontSize: 11, overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
              {this.state.error.message}
            </pre>
          )}
          <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
            <button className="btn primary" onClick={() => {
              try { this.props.onReset && this.props.onReset(); } catch {}
              this.setState({ hasError: false, error: null });
            }}>Start New Order</button>
            {orderId && (
              <a className="btn" style={{ background: '#fff', color: '#0a2240', border: '2px solid #0a2240', textDecoration: 'none' }}
                href={'#/orders/' + orderId}>View Order</a>
            )}
            <button className="btn ghost" onClick={() => window.location.reload()}>Reload App</button>
          </div>
          <p style={{ fontSize: 11, color: '#6b7280', marginTop: 14 }}>
            Screenshot this if you can — error is logged in the browser console for diagnosis.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

// ============================================================
// NewOrderPage — single scrollable form, no sidebar/steps
// ============================================================
function NewOrderPage({ vendor, contact, onDone, draftOrderId, openRetailOnLoad, editOrderId }) {
  // Edit mode: reopen a submitted (pre-production) order in this same wizard
  // and save back through pc_editOrder instead of pc_submitOrder.
  const isEdit = !!editOrderId;
  const [data, setData] = useS(() => applyVendorToData(blankData(), vendor, contact));
  const [pricing, setPricing] = useS(loadPricing);
  const [submitting, setSubmitting] = useS(false);
  const [savingDraft, setSavingDraft] = useS(false);
  const [draftId, setDraftId] = useS(draftOrderId || null);
  const [draftLoading, setDraftLoading] = useS(!!draftOrderId || !!editOrderId);
  const [autoSavedAt, setAutoSavedAt] = useS(null);
  const lastSavedRef = React.useRef(null);
  // Reentrancy latch for submit. `submitting` state can still read false in a
  // second tap's closure before React re-renders, so a synchronous ref guards
  // against double-submit (duplicate orders).
  const submittingRef = React.useRef(false);
  // Idempotency key for pc_submitOrder. Minted once per submit attempt and
  // REUSED across manual retries so the server dedupes and converges on ONE
  // order. Cleared only after a confirmed successful submit.
  const submitReqIdRef = React.useRef(null);
  const [submitted, setSubmitted] = useS(null); // { orderId, orderNumber }
  const [showChecklist, setShowChecklist] = useS(false);
  const [showMarkupModal, setShowMarkupModal] = useS(false);

  // Trace showChecklist state changes to the Debug HUD so we know
  // whether ChecklistModal is supposed to be open. If we see
  // submit-click + showChecklist:true but no checklist-mount, the
  // sheet isn't even rendering and we're hitting a render error
  // upstream. (Blank-screen-after-submit diagnostics, 2026-06-18.)
  useE(() => {
    try { if (window.pcDebugLog) window.pcDebugLog('state:showChecklist', String(showChecklist), ''); } catch {}
  }, [showChecklist]);
  useE(() => {
    try { if (window.pcDebugLog) window.pcDebugLog('state:submitted', submitted ? ('orderId=' + submitted.orderId) : 'null', ''); } catch {}
  }, [submitted]);

  // 6-11: force = every quote SESSION starts on fresh pricing (skips the
  // 5-min cache); the session then keeps this pricing until submit — no
  // mid-quote rate changes in front of a customer.
  // Edit mode SKIPS this: it reprices from the order's FROZEN snapshot
  // (seeded below) so the running total matches pc_editOrder's recompute.
  useE(() => {
    if (isEdit) return;
    loadPricingFromFirestore({ force: true }).then(p => { setPricing(p); window.PC_PRICING_CACHE = p; });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load existing draft when entering /drafts/:id route.
  useE(() => {
    if (!draftOrderId) return;
    let cancelled = false;
    db.collection('orders').doc(draftOrderId).get().then(doc => {
      if (cancelled || !doc.exists) { setDraftLoading(false); return; }
      const d = doc.data();
      setData(prev => ({
        ...prev,
        ...d,
        cabinets: d.cabinets || prev.cabinets,
        toeKick: d.toeKick || prev.toeKick,
        // keep our local draftId but use the Firestore doc id as the
        // canonical identifier so subsequent saves UPSERT in place.
        draftId: prev.draftId,
      }));
      setDraftLoading(false);
      // Auto-open the Retail Estimate modal when the dashboard's quick
      // button routed us here via /drafts/:id/retail. Only trigger if
      // the draft has cabinets — otherwise the modal would generate an
      // empty estimate.
      if (openRetailOnLoad && (d.cabinets || []).length > 0) {
        setShowMarkupModal(true);
      }
    }).catch(() => setDraftLoading(false));
    return () => { cancelled = true; };
  }, [draftOrderId, openRetailOnLoad]);

  // Feature 1: seed the wizard from an existing order when entering
  // /orders/:id/edit. Mirrors the draft-load effect but (a) does NOT set
  // draftId — an edit saves through pc_editOrder, never the draft path —
  // and (b) reprices from the order's FROZEN pricing snapshot so the wizard
  // running total matches what pc_editOrder will authoritatively recompute.
  useE(() => {
    if (!editOrderId) return;
    let cancelled = false;
    db.collection('orders').doc(editOrderId).get().then(doc => {
      if (cancelled || !doc.exists) { setDraftLoading(false); return; }
      const d = doc.data();
      setData(prev => ({
        ...prev,
        ...d,
        cabinets: d.cabinets || [],
        toeKick: d.toeKick || prev.toeKick,
      }));
      if (window.pricingFromSnapshot) {
        setPricing(window.pricingFromSnapshot(d.pricingSnapshot) || pricing);
      }
      setDraftLoading(false);
    }).catch(() => setDraftLoading(false));
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editOrderId]);

  // Pre-fill the contact-person fields from the signed-in contact's
  // own profile. The vendor can still override per order — this is a
  // default, not a lock. Drafts are skipped because they already have
  // the values baked in.
  useE(() => {
    if (draftOrderId || editOrderId || !contact) return;
    setData(prev => ({
      ...prev,
      vendorContact: prev.vendorContact || contact.name  || '',
      vendorPhone:   prev.vendorPhone   || contact.phone || '',
      vendorEmail:   prev.vendorEmail   || contact.email || '',
    }));
  }, [contact, draftOrderId]);

  // HI-5: rehydrate an in-progress wizard from localStorage on mount.
  // Only when we're NOT resuming a Firestore draft (/drafts/:id owns its
  // own state) and the form is still blank — so we never clobber a fresh
  // vendor prefill or an edit the vendor is mid-way through.
  useE(() => {
    if (draftOrderId || editOrderId) return;
    const restored = loadWizardLocalDraft();
    if (!restored) return;
    setData(prev => {
      if (!isWizardDataBlank(prev)) return prev;
      // Keep our fresh local draftId so a later Firestore save upserts cleanly.
      return { ...prev, ...restored, draftId: prev.draftId };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // HI-5: debounced (~800ms) local mirror of the working order. Runs ONLY
  // before a Firestore draft/submit exists — once draftId is set, Firestore
  // is the source of truth and the autosave effect below takes over. Skips
  // blank forms (nothing worth protecting, and avoids re-persisting right
  // after a clear).
  useE(() => {
    if (isEdit) return; // never revert a submitted order to a local draft
    if (draftLoading) return;
    if (draftId) return;
    if (submitted) return;
    if (isWizardDataBlank(data)) return;
    const id = setTimeout(() => { saveWizardLocalDraft(data); }, 800);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, draftLoading, draftId, submitted]);

  const update = (k, v) => setData(prev => ({ ...prev, [k]: v }));
  const estimate = useM(() => computeEstimate(data, pricing), [data, pricing]);
  const cabinets = data.cabinets || [];
  const tk = data.toeKick || {};
  const canSubmit = data.clientName && data.address && cabinets.length > 0;

  // Functional updater — reads `cabinets` off the latest state so a stale
  // closure captured by a memoised child (MarkupCanvas, etc.) still patches
  // the current document instead of overwriting concurrent edits.
  const updateCabinet = (idx, patch) => {
    setData(prev => {
      const list = prev.cabinets || [];
      const next = list.map((c, i) => i === idx ? { ...c, ...patch } : c);
      return { ...prev, cabinets: next };
    });
  };

  const addCabinet = () => {
    setData(prev => {
      const list = prev.cabinets || [];
      return { ...prev, cabinets: [...list, makeCabinet(list.length + 1)] };
    });
  };

  const removeCabinet = (idx) => {
    if (cabinets.length <= 1) return;
    setData(prev => ({ ...prev, cabinets: prev.cabinets.filter((_, i) => i !== idx) }));
  };

  const updateToeKick = (patch) => {
    setData(prev => ({ ...prev, toeKick: { ...(prev.toeKick || {}), ...patch } }));
  };

  // Legacy pre-fill helper. In the slug era the vendor PWA wrote back
  // `vendors/{id}.lastContact` so the next order pre-filled from that
  // doc. With per-contact accounts the contact's own profile is the
  // source of truth, so this is now a no-op. (Firestore rules also
  // block vendor PWAs from writing /vendors directly under the new
  // multi-contact model.) Kept as a stub so existing call sites still
  // resolve cleanly.
  const writeBackVendorContact = async () => { /* no-op in v14 */ };

  // Build the order payload — same shape used for both submits and
  // draft saves. Drafts keep photos in-place (base64) so the vendor
  // can come back to a partially-filled form. Submits strip them.
  const buildOrderPayload = ({ status, includePhotos }) => {
    const finalEstimate = computeEstimate(data, pricing);
    const pricingSnapshot = {};
    for (const [k, v] of Object.entries(pricing)) {
      if (v && typeof v === 'object' && typeof v.price === 'number') {
        pricingSnapshot[k] = { price: v.price };
      }
    }
    // Snapshot the wizard config version used to build this order so an
    // admin viewing the order later can tell which schema it was
    // submitted against (even after the schema has been pushed live with
    // new types / addons / labels). The full schema lives in
    // wizardConfigHistory; we only carry the lightweight metadata here.
    const wizMeta = pricing?.wizardConfig?.metadata || null;
    const wizardConfigSnapshot = wizMeta ? {
      versionName: wizMeta.versionName || '',
      updatedAt: wizMeta.updatedAt || null,
      updatedByEmail: wizMeta.updatedByEmail || '',
    } : null;
    // Multi-photo doc-size guard (2026-06-18 fix for blank-screen-on-submit):
    // The legacy strip only removed `photo` singular. With cab.photos[] added
    // for multi-photo, a vendor capturing 3-6 photos per cabinet × N cabinets
    // can blow Firestore's 1MB doc limit during submit — the write throws,
    // submitted state never sets, and the user sees a blank screen with the
    // alert hidden behind safe-area/keyboard. Strip BOTH photo and photos
    // when includePhotos is false (submit path); drafts keep the photos
    // for the in-progress editing experience.
    const cleanCabinets = includePhotos
      ? cabinets
      : cabinets.map(({ photo, photos, annotations, ...rest }) => rest);
    // Multi-contact identity. The Order schema (admin-portal/tech-portal
    // types/order.ts) was extended with vendorContactId / Name / Email /
    // Phone + submittedByUid. We keep writing the legacy
    // vendorContact/vendorPhone/vendorEmail fields verbatim so existing
    // PDF templates (insurance estimate, work-order print) keep rendering.
    const uid = auth.currentUser && auth.currentUser.uid;
    const vendorContactName  = (contact && contact.name)  || data.vendorContact || '';
    const vendorContactEmail = (contact && contact.email) || data.vendorEmail   || '';
    const vendorContactPhone = (contact && contact.phone) || data.vendorPhone   || '';
    const raw = {
      status,
      vendorId: vendor.id, vendorName: data.vendorName || vendor.name,
      // Multi-contact-per-vendor fields (new):
      vendorContactId: uid || null,
      vendorContactName,
      vendorContactEmail,
      vendorContactPhone,
      submittedByUid: uid || null,
      // Legacy fields kept verbatim for back-compat with PDFs + older
      // queries. They mirror the contact-specific fields above but stay
      // editable via the existing intake inputs.
      vendorContact: data.vendorContact || vendorContactName,
      vendorPhone:   data.vendorPhone   || vendorContactPhone,
      vendorEmail:   data.vendorEmail   || vendorContactEmail,
      vendorPO: data.vendorPO,
      clientName: data.clientName, clientPhone: data.clientPhone, clientEmail: data.clientEmail,
      preferredContact: data.preferredContact, address: data.address,
      installNeeded: data.installNeeded, serviceMode: data.serviceMode || null, serviceToggles: data.serviceToggles || null,
      homeType: data.homeType, accessNotes: data.accessNotes,
      dateReceived: data.dateReceived || todayISO(), completionRequested: data.completionRequested, timeframe: data.timeframe,
      specialInstructions: data.specialInstructions,
      cabinets: cleanCabinets, toeKick: data.toeKick || {},
      estimate: finalEstimate, pricingSnapshot, wizardConfigSnapshot,
      // Carry over markup state if it's already on the doc.
      insuranceMarkupPercent: data.insuranceMarkupPercent || 0,
      markupHistory: data.markupHistory || [],
      reminderSent: data.reminderSent || false,
    };
    // Firestore rejects payloads containing `undefined`, raw functions,
    // arrays-of-arrays, or NaN. Run every value through the sanitizer
    // so we never blow up a draft save because some intake field
    // happened to be unset (annotations.data is the usual culprit).
    return sanitizeForFirestore(raw);
  };

  // Save (or upsert) as a draft. Drafts have no order number and do
  // not appear in the tech queue. Auto-save and the explicit "Save
  // as Draft" button both call this.
  const saveDraft = async ({ silent } = {}) => {
    if (!silent) setSavingDraft(true);
    try {
      const payload = buildOrderPayload({ status: 'draft', includePhotos: true });
      const writePayload = {
        ...payload,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      };
      if (draftId) {
        await db.collection('orders').doc(draftId).set(writePayload, { merge: true });
      } else {
        const ref = await db.collection('orders').add({
          ...writePayload,
          orderNumber: 'DRAFT-' + Date.now(),
          statusHistory: [{ status: 'draft', timestamp: new Date(), changedBy: 'vendor', changedByName: (contact && contact.name) || vendor.name, method: 'auto-save' }],
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
        setDraftId(ref.id);
      }
      // Remember what we just persisted so the autosave effect can skip
      // a no-op write on the next debounce tick.
      try { lastSavedRef.current = JSON.stringify(payload); } catch {}
      const now = new Date();
      setAutoSavedAt(now);
      try { window.PC_AUTO_SAVED_AT = now; } catch {}
      // HI-5: a real Firestore draft now owns this order — retire the local
      // safety net so it can't later resurrect stale form data.
      clearWizardLocalDraft();
      writeBackVendorContact();
    } catch (err) {
      console.error('Save draft failed:', err);
      if (!silent) {
        const detail = err?.message ? err.message : 'Unknown error';
        const body = `Failed to save draft.\n\n${detail}\n\nIf this keeps happening, screenshot this and send to Precision.`;
        if (window.bsAlert) window.bsAlert({ title: 'Save failed', body });
        else alert(body);
      }
    } finally {
      if (!silent) setSavingDraft(false);
    }
  };

  // Auto-save: 1.5s debounce after the last edit. Skip if there's no
  // draft yet (the explicit "Save as Draft" button creates the doc; auto-
  // save only keeps existing drafts up to date). Also dedups against the
  // last persisted payload so an unchanged debounce tick is a no-op.
  //
  // SUBMIT-RACE GUARD (2026-06-17): once the user has submitted (data.status
  // === 'new' OR `submitted` state is set), autosave MUST stop writing
  // status='draft' onto the doc — that race was making submitted orders
  // disappear from the admin OrdersPage (which filters out drafts).
  useE(() => {
    if (isEdit) return; // edit mode saves via pc_editOrder, never the draft path
    if (draftLoading) return;
    if (!draftId) return; // no orderId yet → skip per spec
    if (submitted) return; // never autosave-as-draft after submit
    if (data.status && data.status !== 'draft') return; // belt + suspenders
    const id = setTimeout(() => {
      let payload;
      try {
        payload = buildOrderPayload({ status: 'draft', includePhotos: true });
      } catch (err) {
        console.warn('autosave: buildOrderPayload failed', err);
        return;
      }
      let serialized;
      try { serialized = JSON.stringify(payload); } catch { serialized = null; }
      if (serialized && serialized === lastSavedRef.current) return;
      saveDraft({ silent: true });
    }, 1500);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, draftLoading, draftId, submitted]);

  // Submit-time validation (HI-7). The wizard gates completeness on the
  // "Done Adding" button, but review-edit jump-backs and resumed legacy drafts
  // can bypass it, so re-check here — mirrors the server's validateOrder so a
  // submit that passes this gate won't be rejected by pc_submitOrder.
  const validateOrderForSubmit = () => {
    const problems = [];
    // Customer info (name + address) is required ONLY when Precision handles
    // pickup, drop-off, or install (serviceMode 'multi'). For a shop-only order
    // (No service) we don't touch the home, so a PO / Job # is the identifier
    // instead. MUST stay in sync with the wizard's needsFullCustomer
    // (intake-wizard.jsx) AND the server (submitOrder.ts).
    const needsCustomer = data.serviceMode === 'multi'
      || (data.serviceMode == null && data.installNeeded === 'Yes');
    if (needsCustomer) {
      if (!data.clientName || !String(data.clientName).trim()) problems.push('• Customer name is required.');
      if (!data.address || !String(data.address).trim()) problems.push('• Job address is required.');
    } else {
      if (!data.vendorPO || !String(data.vendorPO).trim()) problems.push('• A PO or Job # is required.');
    }
    const cabs = data.cabinets || [];
    if (cabs.length === 0) problems.push('• Add at least one cabinet.');
    cabs.forEach((c, i) => {
      const w = parseFloat(c && c.w);
      const wIn = (c && c.wu === 'mm') ? (w / 25.4) : w;
      if (!(wIn > 0) || wIn > 300) {
        problems.push(`• Cabinet ${String(i + 1).padStart(2, '0')} needs a valid width (over 0, under 300 in).`);
      }
    });
    return problems;
  };

  // Build the intake payload for the server callable. The server is the
  // authority for the estimate, order number, and pricing snapshot — so we
  // send the raw form fields (photos stripped, ALL scope fields incl. addons /
  // scribe / rush / toeKicks) and let pc_submitOrder compute + persist money.
  const buildServerOrderPayload = () => {
    const cleanCabinets = (cabinets || []).map(({ photo, photos, annotations, ...rest }) => rest);
    const raw = {
      vendorName: data.vendorName || vendor.name,
      vendorSlug: data._vendorSlug || vendor.slug || '',
      vendorPO: data.vendorPO,
      vendorContact: data.vendorContact, vendorPhone: data.vendorPhone, vendorEmail: data.vendorEmail,
      clientName: data.clientName, clientPhone: data.clientPhone, clientEmail: data.clientEmail,
      preferredContact: data.preferredContact, address: data.address,
      installNeeded: data.installNeeded, serviceMode: data.serviceMode || null,
      serviceToggles: data.serviceToggles || null, serviceUnresolved: data.serviceUnresolved === true,
      homeType: data.homeType, accessNotes: data.accessNotes,
      dateReceived: data.dateReceived || todayISO(), completionRequested: data.completionRequested,
      timeframe: data.timeframe, specialInstructions: data.specialInstructions,
      cabinets: cleanCabinets, toeKick: data.toeKick || {}, toeKicks: data.toeKicks || [],
      scribe: data.scribe || {}, addons: data.addons || {},
      rush: data.rush === true, rushAck: data.rushAck || null,
      insuranceMarkupPercent: data.insuranceMarkupPercent || 0,
      markupHistory: data.markupHistory || [],
      reminderSent: data.reminderSent || false,
    };
    return sanitizeForFirestore(raw);
  };

  const handleSubmit = async (opts = {}) => {
    // Trace key steps to the Debug HUD so we can see exactly where
    // submit lands or fails on a vendor's phone (no console access).
    const trace = (step, msg) => {
      try { if (window.pcDebugLog) window.pcDebugLog('submit-trace', step, msg || ''); } catch {}
    };
    // Reentrancy guard — synchronous ref + state check blocks a double-tap
    // from creating two orders.
    if (submittingRef.current || submitting) {
      trace('reentry-blocked', 'submit already in progress');
      return;
    }
    submittingRef.current = true;
    trace('start', 'handleSubmit called; draftId=' + (draftId || 'none'));
    // NOTE: setSubmitting(true) — which renders the full-screen submit overlay —
    // is deliberately DEFERRED until after the validation + offline gates below.
    // The overlay sits at a high z-index; showing it now would cover the "fix
    // these problems" / "you're offline" bsAlert, so the vendor could neither
    // see nor dismiss it and the await would hang forever (a spinner that never
    // finishes). Reentrancy is already guarded by submittingRef above.
    try {
      // Validation gate.
      const problems = validateOrderForSubmit();
      if (problems.length > 0) {
        trace('validation-failed', problems.length + ' problem(s)');
        const body = "Please fix these before submitting:\n\n" + problems.join('\n');
        if (window.bsAlert) await window.bsAlert({ title: 'Almost there', body });
        else alert(body);
        return;
      }

      const orderPayload = buildServerOrderPayload();
      try {
        const sz = JSON.stringify(orderPayload).length;
        trace('payload-built', 'size=' + sz + ' bytes; cabinets=' + (orderPayload.cabinets || []).length);
      } catch {}

      // Offline guard (MD-23): the submit callable needs connectivity. Rather
      // than an ambiguous ghost write, save a draft and tell the vendor to
      // resubmit when back online.
      if (typeof navigator !== 'undefined' && navigator.onLine === false) {
        trace('offline', 'navigator.onLine=false; saving draft instead');
        // Fire-and-forget: with Firestore offline persistence the write
        // promise doesn't resolve until reconnect, so AWAITING it would hang
        // the handler — the "you're offline" alert would never show and the
        // finally block would never release submittingRef/setSubmitting(false).
        try { saveDraft({ silent: true }).catch(() => {}); } catch {}
        const body = "You appear to be offline. Your work was saved as a draft — reconnect and submit again from the dashboard.";
        if (window.bsAlert) await window.bsAlert({ title: "You're offline", body });
        else alert(body);
        return;
      }

      // Idempotency: mint a stable clientRequestId ONCE per attempt and reuse
      // it across manual retries so pc_submitOrder dedupes and converges on a
      // single order. Only mint fresh if there's no unconsumed id already.
      if (!submitReqIdRef.current) {
        submitReqIdRef.current = (typeof crypto !== 'undefined' && crypto.randomUUID)
          ? crypto.randomUUID()
          : (Date.now() + '-' + Math.random().toString(36).slice(2));
      }
      const clientRequestId = submitReqIdRef.current;

      // Past every interactive gate — NOW show the blocking overlay for the
      // network round-trip. (Deferred from the top of handleSubmit so it never
      // covers the validation/offline bsAlert; see note above.)
      setSubmitting(true);

      // Server-authoritative submit: computes the estimate, allocates the WO
      // number, writes a complete pricing snapshot, converts the draft in
      // place (if any), and returns the ids + estimate.
      trace('calling-submitOrder', 'draftId=' + (draftId || 'none') + '; reqId=' + clientRequestId);
      const res = await callFunction('pc_submitOrder', {
        order: orderPayload,
        draftId: draftId || null,
        shippingNote: opts.shippingNote || null,
        clientRequestId,
      });
      if (!res || !res.orderId) {
        throw new Error('Submit did not return an order id.');
      }
      // Confirmed successful submit — consume the idempotency id so the NEXT
      // order mints a fresh one. On failure we skip this and keep the id, so a
      // manual retry reuses it and the server dedupes.
      submitReqIdRef.current = null;
      const orderId = res.orderId;
      const orderNumber = res.orderNumber;
      const serverEstimate = res.estimate;
      // Tracks photo-attach failures so we can inform the vendor post-submit.
      let photoFailureCount = 0;
      trace('submitOrder-ok', 'orderId=' + orderId + '; num=' + orderNumber);

      // Reflect the server's shipping-note stamp locally for the confirmation
      // render (server prepends it authoritatively).
      if (opts.shippingNote) {
        const existing = (data.specialInstructions || '').trim();
        const stamped = `[Shipping note] ${String(opts.shippingNote).trim()}`;
        setData(d => ({ ...d, specialInstructions: existing ? `${stamped}\n\n${existing}` : stamped }));
      }

      // Photos as Storage objects (2026-06-18). Photos were uploaded
      // to Firebase Storage at capture time, so the photo objects in
      // state already carry a `src` (download URL) and `storagePath`.
      // We just write a small metadata doc per cabinet — annotations,
      // URLs, ids. No more inline base64, no more 1MB risk.
      //
      // Back-compat: any photo whose `src` is still a data: URL is a
      // legacy / upload-failed entry. We upload it to Storage here so
      // the submit doesn't drop it, then write the resulting URL.
      try {
        const photoFailures = [];
        const writes = [];
        for (const c of (cabinets || [])) {
          if (!c.id) continue;
          const cabPhotos = (typeof window !== 'undefined' && window.getCabinetPhotos)
            ? window.getCabinetPhotos(c)
            : (Array.isArray(c.photos) && c.photos.length
                ? c.photos
                : (c.photo ? [{ id: 'legacy', src: c.photo, annotations: c.annotations || [] }] : []));
          if (cabPhotos.length === 0) continue;
          // Rescue any photo still on a data: URL — upload to Storage.
          const rescued = [];
          for (const p of cabPhotos) {
            if (typeof p.src === 'string' && p.src.startsWith('data:') && window.uploadCabinetPhotoToStorage) {
              try {
                const result = await window.uploadCabinetPhotoToStorage(p.src, c.id, p.id || ('p_legacy_' + Math.random().toString(36).slice(2, 8)));
                rescued.push({ ...p, src: result.src, storagePath: result.storagePath });
              } catch (e) {
                console.warn('Photo rescue upload failed for', c.id, e);
                photoFailures.push(c.id);
                // Skip this photo rather than persisting a data: URL.
              }
            } else {
              rescued.push(p);
            }
          }
          if (rescued.length === 0) continue;
          const ref = db.collection('orders').doc(orderId)
            .collection('media').doc('cab_' + c.id);
          writes.push(
            ref.set({
              cabId: c.id,
              photos: rescued,
              updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            }).catch((e) => {
              console.warn('Photo doc write failed for', c.id, e);
              photoFailures.push(c.id);
              try { if (window.pcDebugLog) window.pcDebugLog('photos-cab-failed', c.id + ': ' + (e?.message || String(e)), e?.stack || ''); } catch {}
            }),
          );
        }
        if (writes.length > 0) {
          await Promise.allSettled(writes);
          await db.collection('orders').doc(orderId)
            .collection('media').doc('cabinetPhotosIndex')
            .set({
              cabIds: (cabinets || []).filter(c => c.id).map(c => c.id),
              updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            });
        }
        if (photoFailures.length > 0) {
          photoFailureCount = photoFailures.length;
          // Flag the order so admin sees that photos may be incomplete.
          try {
            await db.collection('orders').doc(orderId).set({
              photosIncomplete: true,
              photoFailedCabIds: photoFailures,
            }, { merge: true });
          } catch {}
        }
      } catch (photoErr) {
        console.warn('Photo subcollection write failed (non-fatal):', photoErr);
        try {
          if (window.pcDebugLog) {
            window.pcDebugLog('photos-subcollection-failed (non-fatal)', photoErr?.message || String(photoErr), photoErr?.stack || '');
          }
        } catch {}
      }
      // AUTOSAVE RACE FIX (2026-06-17): the autosave debounce runs on
      // any data change after submit and writes status='draft' back to
      // the doc, hiding it from the admin Orders list. Stamping
      // local data.status='new' here teaches the autosave dedup to
      // skip the no-op AND ensures any subsequent write carries the
      // correct status.
      setData(d => ({ ...d, status: 'new', orderNumber, submittedAt: new Date().toISOString() }));
      // Pin the submitted doc id as the draftId so autosave (which
      // writes via merge into draftId) won't overwrite status. Also
      // freeze lastSavedRef so the next autosave debounce tick is a no-op.
      setDraftId(orderId);
      try { lastSavedRef.current = JSON.stringify({ ...orderPayload, status: 'new', orderNumber }); } catch {}
      writeBackVendorContact();
      // HI-5: order is submitted server-side — clear the local safety net.
      clearWizardLocalDraft();
      setSubmitted({ orderId, orderNumber, estimate: serverEstimate });
      // Task 5: the order is safely submitted, but if any photos failed to
      // attach, tell the vendor (non-blocking — the success screen still
      // renders) so they know to retry from the dashboard.
      if (photoFailureCount > 0) {
        try {
          const body = `Your order was submitted, but ${photoFailureCount} photo(s) didn't attach. Open the order from the dashboard to retry.`;
          if (window.bsAlert) window.bsAlert({ title: 'Order submitted — photos incomplete', body });
          else alert(body);
        } catch {}
      }
    } catch (err) {
      // BLANK-SCREEN DIAGNOSTICS (2026-06-18): the alert path was
      // proven invisible on iPhone PWA (Firestore confirms zero
      // status=new orders despite multiple submit attempts). Push
      // the full error into the on-screen Debug HUD so the vendor
      // can READ it without any console / DevTools access. We
      // ALSO still try bsAlert + alert as last-mile fallbacks.
      const code = err?.code || '';
      const msg = err?.message || 'Unknown error';
      const stack = err?.stack || '';
      console.error('[handleSubmit] Submit failed:', err);
      try { window.__pcLastSubmitError = { message: msg, code, stack, at: new Date().toISOString() }; } catch {}
      try {
        if (window.pcDebugLog) {
          window.pcDebugLog('submit-failed', `${code ? code + ': ' : ''}${msg}`, stack);
        }
      } catch {}
      const detail = code ? `\n\nCode: ${code}` : '';
      const body = 'Failed to submit: ' + msg + detail
        + '\n\nYour order was NOT saved. The red banner at the top of the screen has the full error — tap ▾ to expand or ⧉ to copy it.';
      try {
        if (window.bsAlert) window.bsAlert({ title: 'Submit failed', body });
        else alert(body);
      } catch {}
    } finally {
      setSubmitting(false);
      submittingRef.current = false;
    }
  };

  // Feature 1: save an EDIT of an existing pre-production order. Routes the
  // full cabinets/scope patch through pc_editOrder (NOT pc_submitOrder — that
  // replays + no-ops on an existing order id). The server strips photos,
  // re-gates on {draft,new,received}, and reprices from the frozen snapshot.
  // We then port the media-subcollection photo write so photos on NEWLY added
  // cabinets persist, and hand off to onDone() (back to the order screen).
  const handleSaveEdit = async () => {
    const trace = (step, msg) => {
      try { if (window.pcDebugLog) window.pcDebugLog('editsave-trace', step, msg || ''); } catch {}
    };
    if (submittingRef.current || submitting) { trace('reentry-blocked', 'save already in progress'); return; }
    submittingRef.current = true;
    trace('start', 'handleSaveEdit; orderId=' + (editOrderId || 'none'));
    try {
      // Same completeness gate as submit so an edit can't push the order into a
      // state the server would reject. Deferred overlay (see handleSubmit note).
      const problems = validateOrderForSubmit();
      if (problems.length > 0) {
        const body = "Please fix these before saving:\n\n" + problems.join('\n');
        if (window.bsAlert) await window.bsAlert({ title: 'Almost there', body });
        else alert(body);
        return;
      }
      if (typeof navigator !== 'undefined' && navigator.onLine === false) {
        const body = "You appear to be offline. Reconnect and try saving your changes again.";
        if (window.bsAlert) await window.bsAlert({ title: "You're offline", body });
        else alert(body);
        return;
      }

      const patch = buildServerOrderPayload();
      setSubmitting(true);
      trace('calling-editOrder', 'orderId=' + editOrderId);
      await callFunction('pc_editOrder', { orderId: editOrderId, patch });
      trace('editOrder-ok', 'orderId=' + editOrderId);

      // Photo write ported from handleSubmit: only NEWLY added cabinets carry
      // photos in state (existing cabinets loaded from Firestore have their
      // photos stripped from the doc + already stored in the media
      // subcollection), so getCabinetPhotos returns [] for them → skipped.
      try {
        const writes = [];
        for (const c of (cabinets || [])) {
          if (!c.id) continue;
          const cabPhotos = (typeof window !== 'undefined' && window.getCabinetPhotos)
            ? window.getCabinetPhotos(c)
            : (Array.isArray(c.photos) && c.photos.length
                ? c.photos
                : (c.photo ? [{ id: 'legacy', src: c.photo, annotations: c.annotations || [] }] : []));
          if (cabPhotos.length === 0) continue;
          const rescued = [];
          for (const p of cabPhotos) {
            if (typeof p.src === 'string' && p.src.startsWith('data:') && window.uploadCabinetPhotoToStorage) {
              try {
                const result = await window.uploadCabinetPhotoToStorage(p.src, c.id, p.id || ('p_legacy_' + Math.random().toString(36).slice(2, 8)));
                rescued.push({ ...p, src: result.src, storagePath: result.storagePath });
              } catch (e) {
                console.warn('Photo rescue upload failed for', c.id, e);
              }
            } else {
              rescued.push(p);
            }
          }
          if (rescued.length === 0) continue;
          const ref = db.collection('orders').doc(editOrderId)
            .collection('media').doc('cab_' + c.id);
          writes.push(
            ref.set({
              cabId: c.id,
              photos: rescued,
              updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            }, { merge: true }).catch((e) => { console.warn('Photo doc write failed for', c.id, e); }),
          );
        }
        if (writes.length > 0) {
          await Promise.allSettled(writes);
          await db.collection('orders').doc(editOrderId)
            .collection('media').doc('cabinetPhotosIndex')
            .set({
              cabIds: (cabinets || []).filter(c => c.id).map(c => c.id),
              updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            }, { merge: true });
        }
      } catch (photoErr) {
        console.warn('Edit photo subcollection write failed (non-fatal):', photoErr);
      }

      if (onDone) onDone();
    } catch (err) {
      const code = err?.code || '';
      const msg = err?.message || 'Unknown error';
      console.error('[handleSaveEdit] Edit failed:', err);
      try { if (window.pcDebugLog) window.pcDebugLog('editsave-failed', `${code ? code + ': ' : ''}${msg}`, err?.stack || ''); } catch {}
      if (String(code).includes('failed-precondition')) {
        const body = "This order has moved into production, so it can no longer be edited here.\n\nPlease file a change request from the order screen instead.";
        if (window.bsAlert) await window.bsAlert({ title: 'Order in production', body });
        else alert(body);
      } else {
        const body = 'Failed to save changes: ' + msg + (code ? `\n\nCode: ${code}` : '') + '\n\nYour changes were NOT saved.';
        if (window.bsAlert) window.bsAlert({ title: 'Save failed', body });
        else alert(body);
      }
    } finally {
      setSubmitting(false);
      submittingRef.current = false;
    }
  };

  // Called by the InsuranceWizard on Generate. Records the markup
  // history both locally (for the open wizard) and to Firestore so
  // admin can re-render later.
  //   - Pre-submit:  writes to the current draft via saveDraft()
  //   - Post-submit: writes to the submitted order's doc directly
  const commitMarkup = (percent) => {
    const total = computeEstimate(data, pricing).total || 0;
    const markedUpTotal = total * (1 + (percent || 0) / 100);
    const newEntry = {
      percent: percent || 0,
      markedUpTotal,
      preparedAt: new Date().toISOString(),
      preparedBy: data.vendorContact || (contact && contact.name) || vendor.name,
    };
    const nextHistory = [...(data.markupHistory || []), newEntry];
    setData(prev => ({
      ...prev,
      insuranceMarkupPercent: percent || 0,
      markupHistory: nextHistory,
    }));
    // Persist the markup snapshot to the RIGHT doc:
    //  - post-submit confirmation screen → the submitted order
    //  - editing an existing order (edit-as-wizard) → that order (NOT saveDraft,
    //    which with no draftId would spawn a phantom duplicate draft — audit
    //    verify: edit-mode phantom draft)
    //  - a genuinely new draft → the normal saveDraft path
    // (markupHistory + insuranceMarkupPercent are the vendor-writable post-submit
    // fields, so the direct .update is allowed by the rules.)
    const targetOrderId = submitted?.orderId || (isEdit ? editOrderId : null);
    if (targetOrderId) {
      db.collection('orders').doc(targetOrderId).update({
        markupHistory: nextHistory,
        insuranceMarkupPercent: percent || 0,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      }).catch((err) => console.warn('Markup save failed:', err));
    } else {
      saveDraft({ silent: true }).catch(() => {});
    }
  };

  // Submitted — show confirmation. The retail estimate button stays
  // available post-submit too; commitMarkup() routes the snapshot to
  // the submitted order's doc instead of the draft path.
  if (submitted) {
    const resetForNewOrder = () => {
      // HI-5: fresh order → make sure no stale local snapshot lingers.
      clearWizardLocalDraft();
      setData(applyVendorToData(blankData(), vendor, contact));
      setSubmitted(null);
      // A second order in the same session must NOT reuse the previous order's
      // Firestore doc id. Clear draftId + the autosave dedup refs so autosave,
      // Save-Draft, and Submit all target a brand-new doc.
      setDraftId(null);
      lastSavedRef.current = null;
      setAutoSavedAt(null);
      // New quote session without a remount — pull fresh pricing.
      loadPricingFromFirestore({ force: true }).then(p => { setPricing(p); window.PC_PRICING_CACHE = p; });
    };
    return (
      <div className="vendor-form-wrap">
        <PostSubmitErrorBoundary
          orderNumber={submitted.orderNumber}
          orderId={submitted.orderId}
          onReset={resetForNewOrder}
        >
          <SubmittedStep
            data={data}
            estimate={submitted.estimate}
            submitResult={submitted}
            onReset={resetForNewOrder}
            hideEstimates={vendor?.hideEstimates === true}
            onCreateRetailEstimate={vendor?.hideEstimates === true
              ? undefined
              : () => { window.scrollTo(0, 0); setShowMarkupModal(true); }}
          />
          {showMarkupModal && vendor?.hideEstimates !== true && (
            <InsuranceWizard
              historyCount={(data.markupHistory || []).length}
              vendor={vendor}
              data={data}
              pricing={pricing}
              onClose={() => setShowMarkupModal(false)}
              onCommitMarkup={commitMarkup}
            />
          )}
        </PostSubmitErrorBoundary>
      </div>
    );
  }

  // Wizard for new orders; the long-form scroll page is replaced.
  // Drafts re-enter the wizard at step 1 with all fields prefilled —
  // a summary-page UI for drafts can come later.
  if (draftLoading) {
    return <div className="app-loading"><p>Loading draft…</p></div>;
  }

  return (
    <>
      <IntakeWizard
        vendor={vendor}
        data={data}
        setData={setData}
        pricing={pricing}
        sc={window.PC_SHOP_CONSTANTS}
        submitting={submitting}
        savingDraft={savingDraft}
        hideEstimates={vendor?.hideEstimates === true}
        submitLabel={isEdit ? 'Save Changes' : undefined}
        hideSaveDraft={isEdit}
        onSubmit={isEdit
          ? handleSaveEdit
          : () => {
              try { window.pcDebugLog && window.pcDebugLog('submit-click', 'Submit Order button tapped → opening ChecklistModal'); } catch {}
              setShowChecklist(true);
            }}
        onSaveDraft={() => saveDraft()}
        onInsurancePreview={vendor?.hideEstimates === true
          ? undefined
          : () => { window.scrollTo(0, 0); setShowMarkupModal(true); }}
      />

      {showChecklist && (
        <ChecklistModal onClose={() => setShowChecklist(false)} onProceed={(opts) => {
          try { window.pcDebugLog && window.pcDebugLog('checklist-proceed', 'ChecklistModal OK tapped → calling handleSubmit', JSON.stringify(opts || {})); } catch {}
          setShowChecklist(false);
          handleSubmit(opts);
        }}/>
      )}

      {showMarkupModal && vendor?.hideEstimates !== true && (
        <InsuranceWizard
          historyCount={(data.markupHistory || []).length}
          vendor={vendor}
          data={data}
          pricing={pricing}
          onClose={() => setShowMarkupModal(false)}
          onCommitMarkup={commitMarkup}
        />
      )}

      {/* Blocking, non-dismissible submit overlay. Submit + post-submit photo/
          media writes can take many seconds (up to ~70s on cellular); this
          gives the vendor clear feedback that work is in progress so the app
          doesn't read as frozen. Highest z-index so it sits above all modals. */}
      {submitting && (
        <div
          role="alertdialog"
          aria-live="assertive"
          aria-label="Submitting your order"
          style={{
            position: 'fixed', inset: 0, zIndex: 3000,
            background: 'rgba(10,34,64,0.72)',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            gap: 18, padding: 24, textAlign: 'center',
            WebkitBackdropFilter: 'blur(2px)', backdropFilter: 'blur(2px)',
          }}
        >
          <div className="spinner" style={{ width: 44, height: 44, borderWidth: 4 }} />
          <div style={{ color: '#fff', fontSize: 18, fontWeight: 700, maxWidth: 360 }}>
            Submitting your order…
          </div>
          <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, maxWidth: 320, lineHeight: 1.4 }}>
            Keep the app open — this can take up to a minute on a slow connection.
          </div>
        </div>
      )}
    </>
  );
}

// ============================================================
// Legacy long-form NewOrderPage body — preserved as a separate
// component for now in case we need to fall back. Not rendered.
// ============================================================
function _LegacyNewOrderForm({ data, update, cabinets, addCabinet, removeCabinet, updateCabinet, updateToeKick, tk, estimate, canSubmit, submitting, setShowChecklist, savingDraft, saveDraft, setShowMarkupModal, autoSavedAt, draftId }) {
  return (
    <div className="vendor-form-wrap">
      {/* Your Info */}
      <div className="v-section">
        <h2 className="v-section-title">Your Info</h2>
        <div className="v-fields">
          <div className="v-field"><label>Contact person</label><input className="input" value={data.vendorContact || ''} onChange={e => update('vendorContact', e.target.value)} placeholder="Point of contact"/></div>
          <div className="v-field"><label>Phone</label><input className="input mono" type="tel" inputMode="tel" maxLength={14} value={data.vendorPhone || ''} onChange={e => update('vendorPhone', window.formatPhoneInput(e.target.value))} placeholder="(480) 555-0100"/></div>
          <div className="v-field"><label>Email</label><input className="input" value={data.vendorEmail || ''} onChange={e => update('vendorEmail', e.target.value)} placeholder="pm@company.com"/></div>
          <div className="v-field"><label>PO / job ref</label><input className="input mono" value={data.vendorPO || ''} onChange={e => update('vendorPO', e.target.value)} placeholder="Your PO or job number"/></div>
        </div>
      </div>

      {/* Customer */}
      <div className="v-section">
        <h2 className="v-section-title">Customer</h2>
        <div className="v-fields">
          <div className="v-field"><label>Customer name <span className="req">*</span></label><input className="input" value={data.clientName || ''} onChange={e => update('clientName', e.target.value)} placeholder="Homeowner name"/></div>
          <div className="v-field"><label>Phone</label><input className="input mono" type="tel" inputMode="tel" maxLength={14} value={data.clientPhone || ''} onChange={e => update('clientPhone', window.formatPhoneInput(e.target.value))} placeholder="(480) 555-0142"/></div>
          <div className="v-field"><label>Email</label><input className="input" value={data.clientEmail || ''} onChange={e => update('clientEmail', e.target.value)}/></div>
          <div className="v-field">
            <label>Preferred contact</label>
            <div className="segmented">{['Phone', 'Text', 'Email'].map(opt => (
              <button key={opt} className={data.preferredContact === opt ? 'on' : ''} onClick={() => update('preferredContact', opt)}>{opt}</button>
            ))}</div>
          </div>
        </div>
      </div>

      {/* Project Site */}
      <div className="v-section">
        <h2 className="v-section-title">Project Site</h2>
        <div className="v-fields">
          <div className="v-field full">
            <label>Address <span className="req">*</span></label>
            <div style={{ display: 'flex', gap: 6 }}>
              <input className="input" style={{ flex: 1 }} value={data.address || ''} onChange={e => update('address', e.target.value)} placeholder="Street, city, state, ZIP"/>
              <button
                type="button"
                className="btn ghost sm"
                title="Paste from clipboard"
                onClick={async () => {
                  try {
                    const text = await navigator.clipboard?.readText?.();
                    if (text && text.trim()) update('address', text.trim());
                  } catch { /* clipboard blocked; user can paste manually */ }
                }}
              >Paste</button>
            </div>
          </div>
          <div className="v-field">
            <label>Install needed?</label>
            <div className="segmented">{['Yes', 'No', 'Unsure'].map(opt => (
              <button key={opt} className={data.installNeeded === opt ? 'on' : ''} onClick={() => update('installNeeded', opt)}>{opt}</button>
            ))}</div>
          </div>
          <div className="v-field">
            <label>Home type</label>
            <div className="segmented">{['Residential', 'Condo', 'Rental', 'Commercial'].map(opt => (
              <button key={opt} className={data.homeType === opt ? 'on' : ''} onClick={() => update('homeType', opt)}>{opt}</button>
            ))}</div>
          </div>
          <div className="v-field full"><label>Access notes</label><textarea className="textarea" value={data.accessNotes || ''} onChange={e => update('accessNotes', e.target.value)} placeholder="Gate code, pets, parking…"/></div>
          <div className="v-field"><label>Completion requested</label><input className="input mono" type="date" value={data.completionRequested || ''} onChange={e => update('completionRequested', e.target.value)}/></div>
          <div className="v-field">
            <label>Priority</label>
            <div className="chips">{[
              { v: 'asap', l: 'ASAP' }, { v: '2wk', l: '2 weeks' }, { v: '1mo', l: '1 month' }, { v: '3mo', l: '3 months' }, { v: 'flex', l: 'Flexible' },
            ].map(o => (
              <button key={o.v} className={'chip' + (data.timeframe === o.v ? ' on' : '')} onClick={() => update('timeframe', o.v)}><span className="dot"></span>{o.l}</button>
            ))}</div>
          </div>
        </div>
      </div>

      {/* Cabinets */}
      <div className="v-section">
        <div className="v-section-header">
          <h2 className="v-section-title">Cabinets</h2>
          <button className="btn primary sm" onClick={addCabinet}><Icon.Plus /> Add</button>
        </div>
        {cabinets.map((cab, idx) => (
          <CabinetCard key={cab.id} cab={cab} idx={idx} total={cabinets.length}
            onChange={(patch) => updateCabinet(idx, patch)}
            onRemove={() => removeCabinet(idx)} />
        ))}
      </div>

      {/* Toe Kick */}
      <div className="v-section">
        <h2 className="v-section-title">Toe Kick</h2>
        <div className="v-fields">
          <DimField label="Toe Kick Height" value={tk.height} unit={tk.heightU} onValue={v => updateToeKick({ height: v })} onUnit={u => updateToeKick({ heightU: u })}/>
          <DimField label="Setback" value={tk.setback} unit={tk.setbackU} onValue={v => updateToeKick({ setback: v })} onUnit={u => updateToeKick({ setbackU: u })}/>
          <div className="v-field">
            <label>Thickness</label>
            <div className="segmented">{['1/4"', '1/2"', '5/8"', '3/4"'].map(opt => (
              <button key={opt} className={tk.thickness === opt ? 'on' : ''} onClick={() => updateToeKick({ thickness: opt })}>{opt}</button>
            ))}</div>
          </div>
          <DimField label="Total length" value={tk.linearFt} onValue={v => updateToeKick({ linearFt: v })}/>
        </div>
      </div>

      {/* Special Instructions */}
      <div className="v-section">
        <h2 className="v-section-title">Special Instructions</h2>
        <textarea className="textarea" value={data.specialInstructions || ''} onChange={e => update('specialInstructions', e.target.value)}
          placeholder="Color match notes, hardware preferences, anything else…" style={{ minHeight: 80 }}/>
      </div>

      {/* Estimate + Submit */}
      <div className="v-section v-estimate">
        <div className="v-estimate-row">
          <span>Estimate</span>
          <span className="mono" style={{ fontSize: 24, fontWeight: 700 }}>{fmtMoney(estimate.total)}</span>
        </div>
        {estimate.rushApplied && <div className="v-estimate-note">Rush priority applied</div>}
        <button className="btn primary lg" style={{ width: '100%', marginTop: 16 }}
          onClick={() => setShowChecklist(true)} disabled={!canSubmit || submitting}>
          {submitting ? 'Submitting...' : 'Submit Order'}
        </button>
        <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
          <button
            className="btn"
            style={{
              flex: '1 1 160px',
              background: '#fff',
              color: '#0a2240',
              border: '2px solid #0a2240',
              fontWeight: 600,
            }}
            onClick={() => saveDraft()}
            disabled={savingDraft || submitting}
          >
            {savingDraft ? 'Saving…' : draftId ? '💾 Save Draft' : '💾 Save as Draft'}
          </button>
          <button
            className="btn"
            style={{
              flex: '1 1 160px',
              background: '#C9781B',
              color: '#fff',
              border: 0,
              fontWeight: 600,
            }}
            onClick={() => setShowMarkupModal(true)}
            disabled={!cabinets.length || submitting}
          >
            📄 Create Retail Estimate
          </button>
        </div>
        {autoSavedAt && (
          <div className="hint" style={{ textAlign: 'center', marginTop: 6, fontSize: 11 }}>
            Auto-saved {autoSavedAt.toLocaleTimeString()}
          </div>
        )}
        {!canSubmit && <div className="hint" style={{ textAlign: 'center', marginTop: 8 }}>Customer name, address, and at least one cabinet required</div>}
      </div>

      {showChecklist && (
        <ChecklistModal onClose={() => setShowChecklist(false)} onProceed={(opts) => {
          try { window.pcDebugLog && window.pcDebugLog('checklist-proceed', 'ChecklistModal OK tapped → calling handleSubmit', JSON.stringify(opts || {})); } catch {}
          setShowChecklist(false);
          handleSubmit(opts);
        }}/>
      )}

      {showMarkupModal && (
        <MarkupModal
          initialPercent={data.insuranceMarkupPercent || 0}
          historyCount={(data.markupHistory || []).length}
          onClose={() => setShowMarkupModal(false)}
          onConfirm={(p) => { setShowMarkupModal(false); handleInsurancePdf(p); }}
        />
      )}

      {pdfPreview && (
        <InsurancePdfPreview
          html={pdfPreview.html}
          onClose={() => setPdfPreview(null)}
        />
      )}
    </div>
  );
}

// In-page PDF preview. Renders the estimate HTML inside a same-origin
// iframe (srcdoc) so the user can scroll, print, or save without ever
// triggering a popup. Print and Open-in-new-tab buttons live in the
// modal toolbar, not inside the iframe content, because the iframe's
// own print toolbar is hidden when displayed in a modal.
function InsurancePdfPreview({ html, onClose }) {
  const iframeRef = React.useRef(null);

  const printIt = () => {
    const f = iframeRef.current;
    if (!f) return;
    try {
      f.focus();
      f.contentWindow.print();
    } catch (err) {
      const body = 'Print failed: ' + (err.message || 'unknown');
      if (window.bsAlert) window.bsAlert({ title: 'Print failed', body });
      else alert(body);
    }
  };

  const openInNewTab = () => {
    try {
      const blob = new Blob([html], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const w = window.open(url, '_blank');
      if (!w) {
        // Popup blocked — fall back to a download. Browsers don't
        // block direct downloads triggered by a click.
        const a = document.createElement('a');
        a.href = url;
        a.download = 'precision-cabinets-estimate.html';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (err) {
      const body = 'Open failed: ' + (err.message || 'unknown');
      if (window.bsAlert) window.bsAlert({ title: 'Open failed', body });
      else alert(body);
    }
  };

  // Native share sheet — uses the OS share menu so the vendor can
  // send the estimate via Mail, Messages, AirDrop, etc. directly
  // from their phone. Falls back to download if not supported.
  const shareIt = async () => {
    try {
      const blob = new Blob([html], { type: 'text/html' });
      const file = new File([blob], 'precision-cabinets-estimate.html', { type: 'text/html' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: 'Precision Cabinets Estimate',
          text: 'Retail estimate',
          files: [file],
        });
        return;
      }
      // No file-share support — share a URL instead.
      if (navigator.share) {
        const url = URL.createObjectURL(blob);
        await navigator.share({ title: 'Precision Cabinets Estimate', url });
        return;
      }
      openInNewTab();
    } catch (err) {
      if (err && err.name !== 'AbortError') {
        const body = 'Share failed: ' + (err.message || 'unknown');
        if (window.bsAlert) window.bsAlert({ title: 'Share failed', body });
        else alert(body);
      }
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000,
        display: 'flex', flexDirection: 'column',
      }}
    >
      <div
        style={{
          background: '#0a2240', color: '#fff', padding: '10px 14px',
          display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ fontWeight: 600 }}>Retail Estimate Preview</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button
            className="btn"
            style={{ background: '#C9781B', color: '#fff', border: 0, fontWeight: 600 }}
            onClick={printIt}
          >
            🖨️ Print / Save as PDF
          </button>
          <button
            className="btn"
            style={{ background: '#fff', color: '#0a2240', border: 0, fontWeight: 600 }}
            onClick={shareIt}
          >
            📤 Share / Save
          </button>
          <button
            className="btn"
            style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.4)' }}
            onClick={openInNewTab}
          >
            ↗ New tab
          </button>
          <button
            className="btn"
            style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.4)' }}
            onClick={onClose}
          >
            ✕ Close
          </button>
        </div>
      </div>
      <iframe
        ref={iframeRef}
        title="Retail Estimate"
        srcDoc={html}
        style={{ flex: 1, width: '100%', border: 0, background: '#fff' }}
      />
    </div>
  );
}

// Retail Estimate Wizard — short intro modal, one-click generation
// at a fixed 30% retail markup, then PDF preview. The vendor presents
// this to their customer as their contractor estimate; Precision
// remains the wholesale fabricator behind the scenes.
//
// Note: the parent app still uses the prop `onCommitMarkup` and the
// PDF generator still accepts `markupPercent` so the existing draft-
// history schema and admin verification flow are unchanged.
const RETAIL_MARKUP_PERCENT = 30;

function InsuranceWizard({ historyCount, vendor, data, pricing, onClose, onCommitMarkup }) {
  const [step, setStep] = useS('intro');             // 'intro' | 'preview'
  const [html, setHtml] = useS(null);
  const iframeRef = React.useRef(null);

  const generate = () => {
    if (!window.buildInsuranceEstimateHtml) {
      const body = 'Estimate PDF generator not loaded — refresh the page.';
      if (window.bsAlert) window.bsAlert({ title: 'Not ready', body });
      else alert(body);
      return;
    }
    // Persist the markup % to the draft so admins can verify what was sent.
    onCommitMarkup(RETAIL_MARKUP_PERCENT);
    const generated = window.buildInsuranceEstimateHtml({
      vendor, data, pricing, markupPercent: RETAIL_MARKUP_PERCENT,
    });
    setHtml(generated);
    setStep('preview');
  };

  const printIt = () => {
    const f = iframeRef.current;
    if (!f) return;
    try { f.focus(); f.contentWindow.print(); } catch (err) {
      const body = 'Print failed: ' + err.message;
      if (window.bsAlert) window.bsAlert({ title: 'Print failed', body });
      else alert(body);
    }
  };
  const shareIt = async () => {
    if (!html) return;
    try {
      const blob = new Blob([html], { type: 'text/html' });
      const file = new File([blob], 'precision-cabinets-estimate.html', { type: 'text/html' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: 'Precision Cabinets Estimate',
          text: 'Retail estimate',
          files: [file],
        });
        return;
      }
      if (navigator.share) {
        const url = URL.createObjectURL(blob);
        await navigator.share({ title: 'Precision Cabinets Estimate', url });
        return;
      }
      // Fall back to download.
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'precision-cabinets-estimate.html';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
    } catch (err) {
      if (err && err.name !== 'AbortError') {
        const body = 'Share failed: ' + err.message;
        if (window.bsAlert) window.bsAlert({ title: 'Share failed', body });
        else alert(body);
      }
    }
  };

  return (
    <div className="iw-fullscreen" role="dialog" aria-modal="true">
      <div className="iw-header">
        <div style={{ fontWeight: 600 }}>📄 Retail Estimate</div>
        <button className="btn"
                style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.4)' }}
                onClick={onClose}>✕ Close</button>
      </div>

      {step === 'intro' && (
        <div className="iw-body">
          <div className="iw-intro-card">
            <h2 style={{ marginTop: 0, color: '#0a2240' }}>Retail Estimate</h2>
            <p>
              This is the <strong>retail estimate</strong> you present to your customer as their
              contractor's price. Precision Cabinets is your wholesale fabricator — the customer-facing
              total includes a standard 30% margin over the contract price you're paying us.
            </p>
            <p style={{ fontSize: 13, color: 'var(--ink-soft)' }}>
              The PDF is generated on Precision Cabinets letterhead and shows only the retail total.
              Your wholesale contract price is not displayed.
            </p>
            <p style={{ fontSize: 13, color: 'var(--ink-soft)' }}>
              Generating the PDF saves your draft and logs the markup percentage to your draft history.
            </p>
            {historyCount > 0 && (
              <p style={{ fontSize: 12, color: 'var(--ink-faint)' }}>
                You've generated {historyCount} estimate{historyCount === 1 ? '' : 's'} on this draft already.
              </p>
            )}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
              <button className="btn ghost" onClick={onClose}>Not now</button>
              <button className="btn primary lg" onClick={generate}>Create Retail Estimate →</button>
            </div>
          </div>
        </div>
      )}

      {step === 'preview' && (
        <>
          <div className="iw-toolbar">
            <button className="btn"
                    style={{ background: '#C9781B', color: '#fff', border: 0, fontWeight: 600 }}
                    onClick={printIt}>🖨️ Print / Save PDF</button>
            <button className="btn"
                    style={{ background: '#fff', color: '#0a2240', border: 0, fontWeight: 600 }}
                    onClick={shareIt}>📤 Share / Send</button>
          </div>
          <iframe
            ref={iframeRef}
            title="Retail Estimate"
            srcDoc={html || ''}
            style={{ flex: 1, width: '100%', border: 0, background: '#fff' }}
          />
        </>
      )}
    </div>
  );
}

// ============================================================
// Cabinet size presets — exhaustive list, grouped by type
// Format: B36 = Base 36×34.5×24, W3030 = Wall 30×30×12, etc.
// ============================================================
const CABINET_PRESETS = (() => {
  const list = [];
  const baseWidths = [9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 42, 48, 60];
  const wallWidths = [9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 42, 48];
  const wallHeights = [12, 15, 18, 24, 30, 36, 42];
  const wallDepths = [12, 15];
  const tallWidths = [18, 24, 30, 36];
  const tallHeights = [84, 90, 96];

  // Bases: standard 34.5H × 24D
  baseWidths.forEach(w => {
    list.push({ code: `B${w}`, type: 'Base', w: String(w), h: '34.5', d: '24', desc: `${w}×34.5×24` });
  });

  // Walls: various heights × 12D and 15D
  wallWidths.forEach(w => {
    wallHeights.forEach(wh => {
      wallDepths.forEach(wd => {
        const code = `W${w}${wh}${wd !== 12 ? 'x' + wd : ''}`;
        list.push({ code, type: 'Wall', w: String(w), h: String(wh), d: String(wd), desc: `${w}×${wh}×${wd}` });
      });
    });
  });

  // Tall/Pantry
  tallWidths.forEach(w => {
    tallHeights.forEach(th => {
      list.push({ code: `T${w}${th}`, type: 'Tall', w: String(w), h: String(th), d: '24', desc: `${w}×${th}×24` });
    });
  });

  // Drawer bases: standard 34.5H × 24D (common 3-drawer configs)
  [12, 15, 18, 24, 30, 36].forEach(w => {
    list.push({ code: `DB${w}`, type: 'Drawer Base', w: String(w), h: '34.5', d: '24', desc: `${w}×34.5×24` });
  });

  // Sink bases
  [30, 33, 36, 42].forEach(w => {
    list.push({ code: `SB${w}`, type: 'Sink Base', w: String(w), h: '34.5', d: '24', desc: `${w}×34.5×24` });
  });

  // Lazy susan / corner bases
  [33, 36].forEach(w => {
    list.push({ code: `LS${w}`, type: 'Lazy Susan', w: String(w), h: '34.5', d: String(w), desc: `${w}×34.5×${w}` });
  });

  return list;
})();

const PRESET_TYPES = ['Base', 'Wall', 'Drawer Base', 'Sink Base', 'Tall', 'Lazy Susan'];

// Expose for the intake wizard so it can render the same preset
// data in its own (taller) grid layout instead of the small dropdown.
Object.assign(window, { CABINET_PRESETS, PRESET_TYPES });

function CabinetSizePreset({ cab, onSelect }) {
  const [open, setOpen] = React.useState(false);
  const [activeType, setActiveType] = React.useState('Base');

  const currentCode = CABINET_PRESETS.find(p => p.w === cab.w && p.h === cab.h && p.d === cab.d)?.code || null;

  const filtered = CABINET_PRESETS.filter(p => p.type === activeType);

  return (
    <div className="size-preset-wrap">
      <button className="size-preset-trigger" onClick={() => setOpen(!open)}>
        <span className="size-preset-value">
          {currentCode ? (
            <><span className="size-preset-code">{currentCode}</span> <span className="size-preset-dims">{cab.w}×{cab.h}×{cab.d}</span></>
          ) : (
            <span className="size-preset-placeholder">Select a standard size…</span>
          )}
        </span>
        <span className="size-preset-arrow">{open ? '▴' : '▾'}</span>
      </button>

      {/* Backdrop — click anywhere outside to close */}
      {open && <div className="size-preset-backdrop" onClick={() => setOpen(false)} />}

      {open && (
        <div className="size-preset-dropdown">
          <div className="size-preset-types">
            {PRESET_TYPES.map(t => (
              <button key={t} className={'size-preset-type-btn' + (activeType === t ? ' on' : '')}
                onClick={() => setActiveType(t)}>{t}</button>
            ))}
          </div>
          <div className="size-preset-grid">
            {filtered.map(p => (
              <button key={p.code} className={'size-preset-item' + (currentCode === p.code ? ' on' : '')}
                onClick={() => { onSelect(p.w, p.h, p.d); setOpen(false); }}>
                <span className="size-preset-item-code">{p.code}</span>
                <span className="size-preset-item-dims">{p.desc}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ============================================================
// CabinetCard — collapsible cabinet in the single-page flow
// ============================================================
function CabinetCard({ cab, idx, total, onChange, onRemove }) {
  const [open, setOpen] = useS(idx === 0);
  const uf = (k, v) => onChange({ [k]: v });

  return (
    <div className="v-cab-card">
      <button className="v-cab-header" onClick={() => setOpen(!open)}>
        <span className="v-cab-num">Cab {String(idx + 1).padStart(2, '0')}</span>
        <span className="v-cab-label">{cab.name || 'Untitled'}</span>
        <span className="v-cab-dims mono">{cab.w && cab.h ? `${cab.w}×${cab.h}` : '—'}</span>
        <span className="v-cab-chevron">{open ? '▾' : '▸'}</span>
      </button>
      {open && (
        <div className="v-cab-body">
          <div className="v-field full">
            <label>Cabinet name</label>
            <input className="input" value={cab.name || ''} onChange={e => uf('name', e.target.value)} placeholder="e.g. Sink base, Upper L"/>
          </div>

          {/* Photo */}
          <div className="v-field full">
            <label>Photo</label>
            {!cab.photo ? (
              <div style={{ display: 'flex', gap: 8 }}>
                <PhotoCaptureButton kind="camera" onSet={(src) => uf('photo', src)}/>
                <PhotoCaptureButton kind="upload" onSet={(src) => uf('photo', src)}/>
              </div>
            ) : (
              <div>
                <MarkupCanvas photo={cab.photo} annotations={cab.annotations || []} setAnnotations={(ann) => uf('annotations', ann)} />
                <button className="btn ghost" style={{ marginTop: 6 }} onClick={() => { uf('photo', null); uf('annotations', []); }}><Icon.X/> Replace</button>
              </div>
            )}
          </div>

          {/* Quick size preset dropdown */}
          <div className="v-field full">
            <label>Quick size</label>
            <CabinetSizePreset cab={cab} onSelect={(w, h, d) => onChange({ w, wu: 'in', h, hu: 'in', d, du: 'in' })} />
          </div>

          {/* Dimensions — individual with quickpicks */}
          <div className="v-fields">
            <DimField label="Width" value={cab.w} unit={cab.wu} onValue={v => uf('w', v)} onUnit={u => uf('wu', u)}/>
            <DimField label="Height" value={cab.h} unit={cab.hu} onValue={v => uf('h', v)} onUnit={u => uf('hu', u)}/>
            <DimField label="Depth" value={cab.d} unit={cab.du} onValue={v => uf('d', v)} onUnit={u => uf('du', u)}/>
          </div>

          {/* Components */}
          <div className="v-fields">
            <div className="v-field"><label>Doors</label><NumberStepper value={cab.doors} onChange={v => uf('doors', v)}/></div>
            <div className="v-field"><label>Drawers</label><NumberStepper value={cab.drawers} onChange={v => uf('drawers', v)}/></div>
            <div className="v-field"><label>Shelves</label><NumberStepper value={cab.shelves} onChange={v => uf('shelves', v)}/></div>
          </div>

          {/* Drawer layout — only shown when 2+ drawers. Lets the shop
              know if all drawers are equal, the bottom is taller, or
              custom heights apply. The cut sheet uses this to compute
              face-frame openings + drawer-box dimensions. */}
          {parseInt(String(cab.drawers || 0), 10) >= 2 && (
            <div className="v-field full">
              <label>Drawer layout</label>
              <div className="chips">
                {[
                  { v: '', l: 'Equal' },
                  { v: 'deep-bottom', l: 'Deep bottom' },
                  ...(parseInt(String(cab.drawers || 0), 10) === 4 ? [{ v: '2up-2down', l: '2 up + 2 down' }] : []),
                  { v: 'custom', l: 'Custom…' },
                ].map(o => (
                  <button
                    key={o.v}
                    className={'chip' + ((cab.drawerLayout || '') === o.v ? ' on' : '')}
                    onClick={() => uf('drawerLayout', o.v)}
                  >
                    <span className="dot"></span>{o.l}
                  </button>
                ))}
              </div>
              {cab.drawerLayout === 'custom' && (
                <div style={{ marginTop: 8 }}>
                  <input
                    className="input mono"
                    placeholder={`Heights in inches, comma-separated (e.g. 6, 6, 8, 14)`}
                    value={cab.drawerHeights || ''}
                    onChange={e => uf('drawerHeights', e.target.value)}
                  />
                  <div className="hint" style={{ fontSize: 11, marginTop: 4 }}>
                    Sum should match the drawer-bank opening height. Order top → bottom.
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Finished side */}
          <div className="v-fields">
            <div className="v-field">
              <label>Finished side?</label>
              <div className="segmented">{['Yes', 'No'].map(opt => (
                <button key={opt} className={cab.finishedSide === opt ? 'on' : ''} onClick={() => uf('finishedSide', opt)}>{opt}</button>
              ))}</div>
            </div>
            {cab.finishedSide === 'Yes' && (
              <div className="v-field">
                <label>Which side?</label>
                <div className="segmented">{['Left', 'Right', 'Both'].map(opt => (
                  <button key={opt} className={cab.finishedWhich === opt ? 'on' : ''} onClick={() => uf('finishedWhich', opt)}>{opt}</button>
                ))}</div>
              </div>
            )}
          </div>

          {/* Material */}
          <div className="v-fields">
            <div className="v-field">
              <label>Box material</label>
              <select className="select" value={cab.boxMaterial || ''} onChange={e => uf('boxMaterial', e.target.value)}>
                <option value="">Select…</option>
                {BOX_MATERIALS.map(m => <option key={m}>{m}</option>)}
              </select>
            </div>
            <div className="v-field">
              <label>Thickness</label>
              <div className="segmented">{['1/2"', '5/8"', '3/4"'].map(opt => (
                <button key={opt} className={cab.boxThickness === opt ? 'on' : ''} onClick={() => uf('boxThickness', opt)}>{opt}</button>
              ))}</div>
            </div>
          </div>

          {/* Type */}
          <div className="v-field full">
            <label>Cabinet type</label>
            <div className="segmented">{['Standard wall', 'Island', 'Peninsula'].map(opt => (
              <button key={opt} className={cab.cabType === opt ? 'on' : ''} onClick={() => uf('cabType', opt)}>{opt}</button>
            ))}</div>
          </div>

          {/* Under-counter install — base cabinets going under an
              existing countertop need a shorter box plus adjustable
              leveling feet. The shop uses this to deduct counter
              thickness from the box height and add feet to hardware. */}
          <div className="v-field full">
            <label>Installs under existing countertop?</label>
            <div className="segmented">{['No', 'Yes'].map(opt => (
              <button
                key={opt}
                className={(cab.installUnderExisting || 'No') === opt ? 'on' : ''}
                onClick={() => uf('installUnderExisting', opt)}
              >{opt}</button>
            ))}</div>
            {cab.installUnderExisting === 'Yes' && (
              <div className="hint" style={{ fontSize: 11, marginTop: 4 }}>
                Box height is reduced and adjustable feet are added so the cabinet slides under the existing counter.
              </div>
            )}
          </div>

          {/* Notes */}
          <div className="v-field full">
            <label>Notes</label>
            <textarea className="textarea" value={cab.notes || ''} onChange={e => uf('notes', e.target.value)} placeholder="Damage, finish details, hardware…"/>
          </div>

          {total > 1 && (
            <button className="btn ghost danger-hover" style={{ marginTop: 8 }} onClick={onRemove}><Icon.Trash/> Remove cabinet</button>
          )}
        </div>
      )}
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<AppRoot/>);

})();
